export const hu = {
  app: {
    home: 'Otthon',
    playerScout: 'Játékos Felderítő',
    playerComparison: 'Játékos Összehasonlítás',
    playerRecruitment: 'Radar',
    collections: 'Gyűjtemények',
    favoritePlayers: 'Kedvenc Játékosok',
    teamAnalytics: 'Csapat Elemzés',
    gameAnalysis: 'Mérkőzés Elemzés',
    seasonStats: 'Szezon Statisztikák',
    leagueTable: 'Bajnoki Tabella',
    scoresAndFixtures: 'Eredmények és Mérkőzések',
    notifications: 'Értesítések',
    administration: 'Adminisztráció',
    inbox: 'Bejövő üzenetek',
    teamStats: 'Csapat Statisztikák',
    blog: 'Blog',
    leagues: 'Ligák',
    squadBuilder: 'Keret Építő',
    playerAlerts: 'Játékos Értesítések',
    searchAlerts: 'Keresés Értesítések',
    videoUploadTool: 'Videó Feltöltő Eszköz',
    videoPlaylists: 'Lejátszási Listák',
    uploadedGames: 'Feltöltött mérkőzések',
    favoriteTeams: 'Kedvenc Csapatok',
    arrigo: 'Arrigo',
    validateEvents: 'Események érvényesítése'
  },
  playerRecruitment: {
    title: 'Játékos Lap',
    subtitle: 'Mélyedj el a játékos jellemzőiben és statisztikáiban',
    league: 'Liga',
    selectedSeason: 'Kiválasztott Szezon',
    year: 'Év',
    radar: 'Radar',
    positions: 'Pozíciók',
    numberOfPlayers: 'Játékosok száma',
    template: 'Sablon',
    compareWith: 'Összehasonlítás',
    previousPerformance: 'Előző Teljesítmény',
    xGames: '{0} mérkőzés',
    average: 'Átlag',
    leagueAverage: 'Liga Átlag',
    selectSeason: 'Válassz egy szezont',
    positionsPlayed: 'Játszott Pozíciók',
    minMax: 'Min & Max',
    top5Leagues: 'Top 5 Liga',
    infoMessage: 'Jelölj be csak egy szezont a Szezon Min & Max engedélyezéséhez',
    infoMessage2: 'Válassz ugyanazt a szezont mindkét játékosnál',
    dataPer90MinText: 'Adatok 90 percre',
    adjustToPossessionText: '* Possesszióhoz igazítva',
    text: 'Szöveg',
    lollipop: 'Nyalóka',
    polar: 'Poláris',
    noGamesBetweenDates: 'Nem találhatók mérkőzések a kiválasztott dátumok között',
    radarTemplates: {
      Goalkeeper: 'Kapus',
      GoalkeeperCustom: 'Kapus Egyedi',
      GoalkeeperCustom1: 'Kapus Egyedi 1',
      GoalkeeperCustom2: 'Kapus Egyedi 2',
      GoalkeeperCustom3: 'Kapus Egyedi 3',
      GoalkeeperCustom4: 'Kapus Egyedi 4',
      GoalkeeperCustom5: 'Kapus Egyedi 5',
      GoalkeeperCustom6: 'Kapus Egyedi 6',
      Defender: 'Védő',
      DefenderCustom: 'Védő Egyedi',
      DefenderCustom1: 'Védő Egyedi 1',
      DefenderCustom2: 'Védő Egyedi 2',
      DefenderCustom3: 'Védő Egyedi 3',
      DefenderCustom4: 'Védő Egyedi 4',
      DefenderCustom5: 'Védő Egyedi 5',
      DefenderCustom6: 'Védő Egyedi 6',
      FullBack: 'Szélső Védő',
      FullBackCustom: 'Szélső Védő Egyedi',
      FullBackCustom1: 'Szélső Védő Egyedi 1',
      FullBackCustom2: 'Szélső Védő Egyedi 2',
      FullBackCustom3: 'Szélső Védő Egyedi 3',
      FullBackCustom4: 'Szélső Védő Egyedi 4',
      FullBackCustom5: 'Szélső Védő Egyedi 5',
      FullBackCustom6: 'Szélső Védő Egyedi 6',
      FullBackPredictive: 'Szélső Védő',
      Midfielder: 'Középpályás',
      MidfielderCustom: 'Középpályás Egyedi',
      MidfielderCustom1: 'Középpályás Egyedi 1',
      MidfielderCustom2: 'Középpályás Egyedi 2',
      MidfielderCustom3: 'Középpályás Egyedi 3',
      MidfielderCustom4: 'Középpályás Egyedi 4',
      MidfielderCustom5: 'Középpályás Egyedi 5',
      MidfielderCustom6: 'Középpályás Egyedi 6',
      MidfielderPredictive: 'Középpályás',
      MidfielderDefensive: 'Védekező Középpályás',
      MidfielderOffensive: 'Támadó Középpályás',
      AttackingMidfielder: 'Támadó Középpályás',
      MidfielderWing: 'Szélső Középpályás',
      Winger: 'Szélső',
      WingerCustom: 'Szélső Egyedi',
      WingerCustom1: 'Szélső Egyedi 1',
      WingerCustom2: 'Szélső Egyedi 2',
      WingerCustom3: 'Szélső Egyedi 3',
      WingerCustom4: 'Szélső Egyedi 4',
      WingerCustom5: 'Szélső Egyedi 5',
      WingerCustom6: 'Szélső Egyedi 6',
      WingerOffensive: 'Támadó Szélső',
      Forward: 'Csatár',
      ForwardCustom: 'Csatár Egyedi',
      ForwardCustom1: 'Csatár Egyedi 1',
      ForwardCustom2: 'Csatár Egyedi 2',
      ForwardCustom3: 'Csatár Egyedi 3',
      ForwardCustom4: 'Csatár Egyedi 4',
      ForwardCustom5: 'Csatár Egyedi 5',
      ForwardCustom6: 'Csatár Egyedi 6',
      ForwardPredictive: 'Csatár',
      WingBack: 'Szélső Védő',
      WingBackCustom: 'Szélső Védő Egyedi',
      WingBackCustom1: 'Szélső Védő Egyedi 1',
      WingBackCustom2: 'Szélső Védő Egyedi 2',
      WingBackCustom3: 'Szélső Védő Egyedi 3',
      WingBackCustom4: 'Szélső Védő Egyedi 4',
      WingBackCustom5: 'Szélső Védő Egyedi 5',
      WingBackCustom6: 'Szélső Védő Egyedi 6',
      WingBackMedia: 'Szélső Védő (Közösségi Média)',
      FullBackMedia: 'Szélső Védő (Közösségi Média)',
      MidfielderMedia: 'Középpályás (Közösségi Média)',
      WingerMedia: 'Szélső (Közösségi Média)',
      ForwardMedia: 'Csatár (Közösségi Média)',
      PhysicalWingBack: 'Fizikai Szélső Védő',
      PhysicalForward: 'Fizikai Csatár',
      PhysicalWinger: 'Fizikai Szélső',
      PhysicalMidfielder: 'Fizikai Középpályás',
      PhysicalFullBack: 'Fizikai Szélső Védő',
      PhysicalDefender: 'Fizikai Védő',
      PhysicalWingBackLMO: 'Fizikai Szélső Védő',
      PhysicalForwardLMO: 'Fizikai Csatár',
      PhysicalWingerLMO: 'Fizikai Szélső',
      PhysicalMidfielderLMO: 'Fizikai Középpályás',
      PhysicalFullBackLMO: 'Fizikai Szélső Védő',
      PhysicalDefenderLMO: 'Fizikai Védő'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Kapus',
      Defender: 'Védő',
      FullBack: 'Szélső Védő',
      FullBackPredictive: 'Szélső Védő',
      Midfielder: 'Középpályás',
      MidfielderPredictive: 'Középpályás',
      MidfielderDefensive: 'Védekező Középpályás',
      MidfielderOffensive: 'Támadó Középpályás',
      AttackingMidfielder: 'Támadó Középpályás',
      MidfielderWing: 'Szélső Középpályás',
      Winger: 'Szélső',
      WingerOffensive: 'Támadó Szélső',
      Forward: 'Csatár',
      ForwardPredictive: 'Csatár',
      WingBack: 'Szélső Védő',
      WingBackMedia: 'Szélső Védő (Közösségi Média)',
      FullBackMedia: 'Szélső Védő (Közösségi Média)',
      MidfielderMedia: 'Középpályás (Közösségi Média)',
      WingerMedia: 'Szélső (Közösségi Média)',
      ForwardMedia: 'Csatár (Közösségi Média)',
      PhysicalWingBack: 'Fizikai Szélső Védő',
      PhysicalForward: 'Fizikai Csatár',
      PhysicalWinger: 'Fizikai Szélső',
      PhysicalMidfielder: 'Fizikai Középpályás',
      PhysicalFullBack: 'Fizikai Szélső Védő',
      PhysicalDefender: 'Fizikai Védő',
      PhysicalWingBackLMO: 'Fizikai Szélső Védő',
      PhysicalForwardLMO: 'Fizikai Csatár',
      PhysicalWingerLMO: 'Fizikai Szélső',
      PhysicalMidfielderLMO: 'Fizikai Középpályás',
      PhysicalFullBackLMO: 'Fizikai Szélső Védő',
      PhysicalDefenderLMO: 'Fizikai Védő'
    },
    radarDescription: {
      basicStatistics: {
        title: 'ALAP STATISZTIKÁK',
        minutes: 'perc',
        goals: 'gól',
        assists: 'gólpassz',
        redCards: 'piros lap',
        yellowCards: 'sárga lap',
        games: 'mérkőzés',
        goalsReceived: 'kapott gól (büntető nélkül)',
        xGFaced: 'szemben álló xG'
      },
      profiles: {
        3: {
          1: 'Ügyes kapus a labdával a lábánál, hatékony rövid és hosszú passzokkal.',
          2: 'Képes a lábbal játszani, és fontosnak lenni a játék kezdetén, jó passzszázalékkal rövidre és hosszúra egyaránt.',
          3: 'Jó lábmunka teszi ezt a profilt az áthaladási mutatói miatt érdekes opcióvá.',
          4: 'Profil, amely kiemelkedik passzaiból, akár a saját, akár az ellenfél mezőnyében.',
          5: 'Nagy biztonság a labda a lábánál és a magas passzkészség.',
          6: 'Jó lábmunka, biztonságot nyújt a labda indításakor és a rövid és hosszú passzok nagy százalékában.',
          7: 'A teljesített bérletek magas százaléka, mind a rövid, mind a hosszú, minőséget biztosítva a forgalomban.'
        },
        5: {
          1: 'Védő, akit jellemez a jó egyéni játék és a nagy számú szerelés és labdaszerzés.',
          2: 'Nagyon hatékony középső védő egyéni párharcokban, mind felül, mind a tackle-ben, jó olvasmányokkal.',
          3: 'Középső védelem jó teljesítménnyel az egyéni védekező párharcokban, ami nagy mennyiségű visszaszerzést jelent.',
          4: 'Magas védekezési szinttel rendelkező profil, amely nagy mennyiségű labdát képes visszaszerezni a tackle-nek és az interception-nek köszönhetően.',
          5: 'Nagyon hatékony védekezés a tackle-ben és sok interceptionnel, egyéni konfrontációban kiemelkedik.',
          6: 'Középhátvéd, játékonként nagy számú visszaszerzéssel, készségesen olvassa a rivális meccset és vágjon, nagy pontossággal és gyakorisággal a szereléseknél.',
          7: 'Védekező profil, nagy mennyiségű gyógyulási lehetőséggel a támadások hatékonyságának és gyakoriságának, valamint a jó előrejelzésnek köszönhetően.'
        },
        6: {
          1: 'Védekezés, amely nagyban hozzájárul a helyzetek generálásához és jó játéklátással rendelkezik.'
        },
        7: {
          1: 'Játékos kiegyensúlyozott teljesítménnyel a támadó játékban (nagy hozzájárulás az "xG Buildup"-ban) és a védekezésben (magas számú labdaszerzés).'
        },
        8: {
          1: 'Szilárd védekező egyéni játékban és magas számú labdaszerzés, mind szerelés, mind labdaszerzés tekintetében.'
        },
        9: {
          1: 'Játékos nagy támadó hozzájárulással, veszélyes akciókat generálva és helyzeteket teremtve.'
        },
        10: {
          1: 'Komplett játékos, aki képes sok területet lefedni, hozzájárulhat a labdaszerzéshez, valamint releváns százalékos "xG Buildup"-ot produkál a csapat által generált összeshez képest.'
        },
        11: {
          1: 'Középpályás magas védekező teljesítménnyel és nagy hatékonysággal a passzokban, annak ellenére, hogy korlátozott a támadásra gyakorolt befolyása.'
        },
        12: {
          1: 'Komplett középpályás magas hozzájárulással a helyzetek teremtésében és jó légi hatékonysággal, valamint sok labdaszerzéssel és szereléssel.'
        },
        15: {
          1: 'Szélső ügyességgel az egyéni játékban és jó szintű befejezett beadással, több várható gólpasszt generálva, mint lövést.'
        },
        16: {
          1: 'Játékos nagy mennyiségű átadással és labdavitel előrehaladással, helyzeteket is generálva és nagyobb befolyással a középen lévő poszeesszióra, mint egy szélső.'
        },
        17: {
          1: 'Játékos jó dribling képességekkel, gyakran befelé vágva, hogy több lövést (xG) generáljon, mint kulcs passzt (xA).'
        },
        18: {
          1: 'Csatár, aki kiváló munkát végez labda nélkül, jó döntéshozatalt mutatva abban, hogy mikor fejezze be a játékot lövéssel vagy mikor passzoljon.'
        },
        22: {
          1: 'Csatár nagy mobilitással az átadások fogadására, szárnyra húzódásra és magas szintű helyzetteremtésre. Magas százalékos érintések a tizenhatoson kívül a mérkőzésenkénti összes érintéshez viszonyítva.'
        }
      },
      description: 'LEÍRÁS',
      conjuction: ' és ',
      conjuction2: ' és ',
      over: 'felett',
      under: 'alatt',
      respectively: ', illetve',
      Defending1: {
        1: 'A védekező teljesítmény a legrosszabbak között van a top 5 ligában'
      },
      Defending2: {
        1: 'A játékos nem játszik jól védekezőként, mivel a teljesítmény az átlag alatt van'
      },
      Defending3: {
        1: 'A játékos közepes szinten teljesít, kissé over_under_average az átlagot'
      },
      Defending4: {
        1: 'Kiemelkedő munka a védekező feladatokban, az átlag feletti teljesítménnyel'
      },
      Defending5: {
        1: 'Kiemelkedő a védekező feladatokban, olyan teljesítménnyel, amely hasonló a legjobb player_positions teljesítményéhez a top 5 ligában'
      },
      Saving1: {
        1: 'Kapus nagyon alacsony teljesítménnyel, sok nehézséggel a labda hárításában'
      },
      Saving2: {
        1: 'Nem mutat jó teljesítményt kapusként, mivel a szint az átlag alatt van'
      },
      Saving3: {
        1: 'Kapus elfogadható teljesítménnyel, az 5 legjobb liga átlagában van, javítania kell a metric_name-ben'
      },
      Saving4: {
        1: 'Kapus jó szinttel az 5 legjobb liga átlaga felett, különösen kiemelkedik a metric_name-ben'
      },
      Saving5: {
        1: 'A hárítás egy nagyon komplett játékos, olyan metrikákkal, amelyek ezt a profilt a Top 20%-ba helyezik az európai top 5 liga kapusaival összehasonlítva.'
      },
      Passing1: {
        1: 'A labdával a szint a legrosszabb játékosok között van'
      },
      Passing2: {
        1: 'Ami a passzokat illeti, a teljesítmény az átlag alatt van'
      },
      Passing3: {
        1: 'A passzolási szint elfogadható, kissé over_under_average az átlagot'
      },
      Passing4: {
        1: 'Nagyon jó szintű labdapasszolás, jól az átlag felett'
      },
      Passing5: {
        1: 'Nagy hatékonyság a labdapasszolásban, a legtöbb játékosnál magasabb teljesítménnyel'
      },
      Aerial1: {
        1: 'Nagyon gyenge játékos a légi játékban, a legrosszabbak között a pozícióban ebben a tekintetben'
      },
      Aerial2: {
        1: 'Ami a légi labdák megnyerését illeti, a játékos nem teljesít jól, az átlag alatt'
      },
      Aerial3: {
        1: 'Elfogadható szint a légi játékban, kissé over_under_average az átlagot'
      },
      Aerial4: {
        1: 'Nagy teljesítmény a felülről való játékban, magas hatékonysággal ebben a tekintetben'
      },
      Aerial5: {
        1: 'A légi játék metrikái ezt a profilt a legjobbak közé helyezik'
      },
      Shooting1: {
        1: 'Nagyon gyenge statisztikák a kapu előtt, a legrosszabb játékosok között ebben a tekintetben'
      },
      Shooting2: {
        1: 'Nagyon fejleszthető lövési szint, az átlag alatt'
      },
      Shooting3: {
        1: 'Elfogadható teljesítmény a támadó munkában, kissé over_under_average az átlagot'
      },
      Shooting4: {
        1: 'Nagyon jól teljesít a tizenhatosban, a játékosok 60%-a feletti teljesítménnyel'
      },
      Shooting5: {
        1: 'Nagy képességek a támadó feladatokban, látványos teljesítménnyel, ezt a játékost a legjobbak közé helyezve ebben a tekintetben'
      },
      Association1: {
        1: 'A labdával való asszociálás teljesítménye nagyon alacsony, a legrosszabbak között a top 5 ligában'
      },
      Association2: {
        1: 'Sokat kell javítani a labdával a lábánál, mivel a teljesítmény az átlag alatt van ebben a tekintetben'
      },
      Association3: {
        1: 'Jól asszociál a labdával, kissé over_under_average az átlagot'
      },
      Association4: {
        1: 'Nagyon jól asszociál a labdával, nagyon figyelemreméltó szintet mutatva'
      },
      Association5: {
        1: 'Rendkívüli asszociatív képesség a labdával a lábánál, a legjobb játékosok között'
      },
      BallHandling1: {
        1: 'Szörnyű labdakezelési teljesítmény, a legrosszabbak között az 5 legjobb ligához képest'
      },
      BallHandling2: {
        1: 'Ami a labdakezelést illeti, a szintek az átlag alatt vannak'
      },
      BallHandling3: {
        1: 'Elfogadható szintű labdakezelés, kissé over_under_average az átlagot'
      },
      BallHandling4: {
        1: 'Magas szintű labdakezelés, a legjobbakhoz közeli számokkal ebben a tekintetben'
      },
      BallHandling5: {
        1: 'Kivételes labdakezelési képesség, a legjobbak között az 5 legjobb ligában'
      },
      Crosses1: {
        1: 'Alacsony teljesítmény a labda beadásában a tizenhatosba. A legrosszabb játékosok között a beadási metrikákban'
      },
      Crosses2: {
        1: 'Az átlag alatti teljesítmény a veszély teremtésében beadásokkal'
      },
      Crosses3: {
        1: 'Elfogadható szintű beadások a tizenhatosba, kissé over_under_average'
      },
      Crosses4: {
        1: 'Jó statisztikák a labda beadásában, elég az átlag felett'
      },
      Crosses5: {
        1: 'Nagyon magas teljesítmény a labda beadásában a tizenhatosba, konkrétan a leginkább hatékony profilok top 20%-ában ebben a kategóriában'
      },
      Carries1: {
        1: 'A játékosok 20%-a között a legrosszabb számokkal a labdavitel tekintetében'
      },
      Carries2: {
        1: 'A labdavitel teljesítmény távol van az átlagtól ebben a pozícióban lévő játékosoknál'
      },
      Carries3: {
        1: 'Közel az átlagos teljesítményhez, kissé over_under_average, a labdavitel tekintetében'
      },
      Carries4: {
        1: 'Kiemelkedő játékos nagyon jó mélységgel és labdavitel számokkal'
      },
      Carries5: {
        1: 'Nagyon tehetséges a labdavitelben, magas teljesítménnyel a Labdavitel kategória metrikáiban'
      },
      Turnovers1: {
        1: 'A teljesítmény nagyon negatív, magas számú labdavesztéssel, amelyek megkönnyítik az ellenfelek számára a veszély teremtését. A legrosszabbak között ebben a metrikában'
      },
      Turnovers2: {
        1: 'A játékos számos veszélyes labdavesztéssel előnyben részesíti az ellenfeleket; sok fejlesztésre van szükség a csökkentésükhöz'
      },
      Turnovers3: {
        1: 'Ez a játékos kissé over_under_average a labdavesztések tekintetében, így még van hely a teljesítmény javítására'
      },
      Turnovers4: {
        1: 'Figyelemreméltó teljesítmény a labdavesztésekben, a legkevesebb labdát vesztő játékosok 60%-a felett'
      },
      Turnovers5: {
        1: 'Érdemes megjegyezni a kevés labdavesztést, amely ezt a játékost a legjobb játékosok közé helyezi a poszeesszióban a csapat számára'
      },
      SequenceInvolvement1: {
        1: 'A labdabirtoklás tekintetében a számok rosszul szólnak erről a játékosról, aki nagyon ritkán fejezi be az akciókat lövéssel'
      },
      SequenceInvolvement2: {
        1: 'A birtoklások befejezése elég fejleszthető; alig fejeződnek be lövéssel, és ez a teljesítményt jól az átlag alá helyezi'
      },
      SequenceInvolvement3: {
        1: 'Elfogadható szint a birtoklások befejezésekor a kapu előtt, egy kissé over_under_average percentilissel az átlaghoz képest, nagy javítási lehetőséggel'
      },
      SequenceInvolvement4: {
        1: 'Jó képesség a csapat birtoklásainak befejezésére lövésekkel, ezek közül néhány gólban végződik, így figyelemreméltó teljesítményt mutatva ebben a kategóriában'
      },
      SequenceInvolvement5: {
        1: 'A legjobbak között, amikor a csapat birtoklásainak befejezéséről van szó, következetesen veszélyt generáló lövésekkel fejezi be őket'
      },
      OutPlay1: {
        1: 'Megállapítható, hogy a játékos minimális hatást gyakorol a védekező struktúrák megzavarásában'
      },
      OutPlay2: {
        1: 'A hozzájárulás az előrehaladáshoz és a védekezések felbontásához a pozíciós szabványok alatt van'
      },
      OutPlay3: {
        1: 'Képes időnként előnyöket generálni, körülbelül az átlagos szinten teljesítve ebben a pozícióban'
      },
      OutPlay4: {
        1: 'Gyakran hozzájárul a védekező vonalak felbontásához és egyensúlytalanságok teremtéséhez'
      },
      OutPlay5: {
        1: 'A legjobb teljesítők között van a pozícióban az ellenfelek kiküszöbölésében és előrehaladások generálásában'
      },
      LineBreakingPasses1: {
        1: 'Ritkán próbálkozik vagy teljesít passzokkal, amelyek felbontják a védekező vonalakat, nagyon kevés hozzájárulással ezekben az akciókban'
      },
      LineBreakingPasses2: {
        1: 'Nehezen találja meg következetesen a csapattársait a vonalak között vagy a nyomás mögött, olyan hozzájárulással, amely ezt a játékost a pozíció szabványai alá helyezi'
      },
      LineBreakingPasses3: {
        1: 'A játékos időnként vonaltörő passzokat ad, körülbelül az átlagos szinten helyezkedve el ebben a pozícióban ezekben a tekintetekben'
      },
      LineBreakingPasses4: {
        1: 'Megállapítható, hogy a játékos gyakran tör vonalakat passzolással és segít felborítani az ellenfelek blokkjait'
      },
      LineBreakingPasses5: {
        1: 'A liga leghatékonyabb passzolói között van a vonalak törésében és a nyomás feloldásában; ez az egyik fő erősség a játékban'
      },
      PassUnderPressure1: {
        1: 'Látható, hogy a nyugalom és a hatékonyság csökken, amikor az ellenfelek bezárnak'
      },
      PassUnderPressure2: {
        1: 'A játékos nehezen tartja fenn a passzolási pontosságot magas nyomású helyzetekben'
      },
      PassUnderPressure3: {
        1: 'A játékos körülbelül az átlagos szinten helyezkedik el a nyomás alatt való passzolás tekintetében; a nyomást ésszerűen kezeli, bár nincs következetesen tiszta végrehajtás'
      },
      PassUnderPressure4: {
        1: 'Gyakori siker a csapattársak megtalálásában annak ellenére, hogy nyomás alatt van, az átlag feletti teljesítményt mutatva az ilyen passzokban'
      },
      PassUnderPressure5: {
        1: 'Kiemelkedő nyugalom és pontosság intenzív nyomás alatt való passzoláskor, a teljesítményt a legjobbak közé helyezve a pozícióban ebben a tekintetben'
      },
      BallReceived1: {
        1: 'Nagyon kevés passzt kap előrehaladott területeken; nem olyan játékos, aki rendszeresen a vonalak között működik'
      },
      BallReceived2: {
        1: 'Gyűjt néhány jelöletlen fogadást az ellenfél térfelén, de nem túl következetesen'
      },
      BallReceived3: {
        1: 'Közepes mennyiségű ellenállás nélküli fogadást rögzít támadó zónákban'
      },
      BallReceived4: {
        1: 'Gyakran kap a vonalak között és nyomásmentes területeken'
      },
      BallReceived5: {
        1: 'Sok fogadást halmoz fel a vonalak között, védők nélkül és valószínűleg kulcs zónákban'
      },
      OnBallPressure1: {
        1: 'Ritkán nyom, és szinte soha nem teszi ezt a labdahordozó közelében. Nem intenzív játékos'
      },
      OnBallPressure2: {
        1: 'Néhány erős nyomásban vesz részt, de nem gyakran. Az általános intenzitás meglehetősen alacsony'
      },
      OnBallPressure3: {
        1: 'Közepes mennyiségű nyomást rögzít a birtoklásban lévő ellenfél közelében'
      },
      OnBallPressure4: {
        1: 'Fegyelmezett nyomó, aki rendszeresen közel kerül a labdahordozóhoz'
      },
      OnBallPressure5: {
        1: 'Nagyon intenzív labda nélkül, nagyon fegyelmezett és keményen dolgozik az ellenfél nyomás alá helyezésén'
      },
      SpatialCoverage1: {
        1: 'A játékos nagyon korlátozott hozzájárulást mutat a térfoglalásban és kontrollban, minimális részvétellel a csapat felállásában és taktikai struktúrájában. A térbeli lefedettség gyenge mind birtoklásban, mind birtoklás nélkül, kevés befolyást tükrözve a kollektív szervezésre és kompaktságra'
      },
      SpatialCoverage2: {
        1: 'A játékos az átlag alatti térbeli lefedettséget nyújtja, mutatva némi részvételt a pálya foglalásában, de hézagokkal a pozicionális folytonosságban és összetartásban a csapat többi részével. A taktikai struktúrára gyakorolt befolyás szakaszos és kevésbé következetes, mint a magasabb rangú játékosoké'
      },
      SpatialCoverage3: {
        1: 'A játékos átlagos térbeli lefedettséget mutat, következetesen hozzájárulva a térfoglaláshoz és kontrollhoz. A pozicionálás általában helyes és funkcionális, mérsékelt hatással részt vesz a csapat taktikai struktúrájában mind a támadó, mind a védekező fázisokban'
      },
      SpatialCoverage4: {
        1: 'A játékos az átlag feletti térbeli lefedettséget nyújtja, magas részvételt mutatva a pálya foglalásában és a csapat pozicionális struktúrájában. A forma fenntartásának és az átmenetekhez való alkalmazkodásnak a képessége jelentősen hozzájárul a kompaktsághoz és a kulcs területek kontrolljához'
      },
      SpatialCoverage5: {
        1: 'A játékos kiváló szintű térbeli lefedettséget ér el, optimalizálva a pozicionálást, hogy döntően befolyásolja a csapat felállását és taktikai struktúráját. A játékértés és a blokk többi részével való szinkronizáció lehetővé teszi a stratégiai terek foglalásának maximalizálását, mind támadásban, mind védekezésben'
      },
      OffBallPressure1: {
        1: 'A játékos nagyon korlátozott védekező nyomást alkalmaz labda nélkül, ritkán vesz részt az ellenfelek akcióinak megzavarásában vagy hibák kényszerítésében. A hozzájárulás a nyomás alá helyezéshez és a védekező struktúrához minimális'
      },
      OffBallPressure2: {
        1: 'A játékos az átlag alatti labda nélküli védekező nyomást nyújtja, időnként részt vesz az ellenfelek akcióiban, de következetlen időzítéssel vagy pozicionálással. Az erőfeszítések korlátozott hatást gyakorolnak a birtoklás visszaszerzésére vagy az ellenfél felépítésének megzavarására'
      },
      OffBallPressure3: {
        1: 'A játékos átlagos szintű labda nélküli nyomást mutat, következetesen hozzájárulva a csapat védekező erőfeszítéseihez. A pozicionálás és időzítés általában hatékony, megfelelő nyomást alkalmazva az ellenfél opcióinak lassítására vagy korlátozására'
      },
      OffBallPressure4: {
        1: 'A játékos az átlag feletti labda nélküli védekező nyomást nyújtja, gyakran megzavarva az ellenfelek akcióit és csökkentve az idejüket és területeiket. Az erőfeszítések jól időzítettek és koordináltak, segítve a csapatot erős védekező struktúra fenntartásában'
      },
      OffBallPressure5: {
        1: 'A játékos kiemelkedik a labda nélküli védekező nyomás alkalmazásában, következetesen zaklatva az ellenfeleket, kényszerítve labdavesztéseket és korlátozva a passzolási folyosókat. Az intenzitás, pozicionálás és előrelátás jelentősen fokozza a csapat védekező hatékonyságát'
      },
      Distance1: {
        1: 'A játékos jelentősen kevesebb területet fed le, mint az átlag (a mozgás a pályán nagyon korlátozott)'
      },
      Distance2: {
        1: 'A mérkőzésenként lefedett távolság az alatt van, amit általában a top szintű labdarúgásban látni (nem olyan aktív, mint az átlag)'
      },
      Distance3: {
        1: 'A játékos ésszerű mennyiségű területet fed le, a liga átlagához közeli számokkal (a fizikai részvétel kiegyensúlyozott)'
      },
      Distance4: {
        1: 'A játékos következetesen magas távolságokat fed le, olyan számokkal, amelyek erős állóképességet tükröznek (szilárd fizikai teljesítményt mutatva)'
      },
      Distance5: {
        1: 'A fizikai mennyiség kiemelkedő, a legaktívabbak között a top 5 ligában a lefedett terület tekintetében'
      },
      Sprint1: {
        1: 'Nagyon kevés nagysebességű futást végez az átlaghoz képest (a játék minimális sprintelési erőfeszítést tartalmaz a mérkőzések során)'
      },
      Sprint2: {
        1: 'A sprint gyakorisága alacsonyabb, mint a pozíció átlaga (korlátozott robbanékonyság a nagysebességű mozgások tekintetében)'
      },
      Sprint3: {
        1: 'Mérsékelt számú sprintet teljesít mérkőzésenként, a várható átlagon belül (az átlagos liga körüli értékek)'
      },
      Sprint4: {
        1: 'Kiemelkedik a sprint gyakoriságában, jól az átlag felett. Következetes robbanékonyságot mutat, nagysebességű futásokat hozzáadva a mérkőzés során'
      },
      Sprint5: {
        1: 'A legmagasabb sprint mennyiségű játékosok top 20%-ában van 90 percre. Top fizikai teljesítmény az ismételt nagysebességű erőfeszítések tekintetében'
      },
      Acceleration1: {
        1: 'A tempóváltás képessége egyértelműen az átlag alatt van, nagyon kevés robbanékony gyorsulással a mérkőzés során'
      },
      Acceleration2: {
        1: 'A gyorsulási teljesítmény az átlag alatt van hasonló játékosokhoz képest, mert korlátozott a rövid távolságú robbanások gyakorisága'
      },
      Acceleration3: {
        1: 'Ésszerű számú gyorsulást rögzít, közel a liga átlagához. A tempóváltások nem kiemelkednek, de a számok helyesek ebben a metrikában'
      },
      Acceleration4: {
        1: 'Erős képességet mutat a gyors és ismételt gyorsulásban, egyértelműen az átlag feletti gyorsulási rátával és gyakori rövid robbanásokkal'
      },
      Acceleration5: {
        1: 'A legrobbanékonyabb játékosok top 20%-ában van az ismételt gyorsulások tekintetében, jól az átlag feletti számokat tartva a gyors indításokban és tempóváltásokban'
      },
      Speed1: {
        1: 'Valószínűleg fizikailag lassú játékos vagy olyan, aki konzerválja a nagy intenzitású erőfeszítéseket a mérkőzések során'
      },
      Speed2: {
        1: 'A maximális sebességek kissé az átlagos versenyképességi átlag alatt vannak'
      },
      Speed3: {
        1: 'Átlagos maximális sebesség értékeket tart fenn a mérkőzés során'
      },
      Speed4: {
        1: 'Gyakran eléri a magas sebességeket, gyors és erős profilt sugallva'
      },
      Speed5: {
        1: 'Nagyon magas maximális sebességeket ér el. Valószínűleg különbséget tevő a tempó tekintetében'
      },
      LineBreakingCarries1: {
        1: 'Ritkán tör vonalakat labdavitelekkel. Hiányzik az kezdeményezés, amikor a labdával előrehaladásról van szó'
      },
      LineBreakingCarries2: {
        1: 'Néhány vonaltörő labdavitelt teljesít, de nem túl rendszeresen'
      },
      LineBreakingCarries3: {
        1: 'Mérsékelt számú sikeres vonaltörő labdavitelt átlagol'
      },
      LineBreakingCarries4: {
        1: 'Hozzájárul a felépítéshez gyakran vonalakat átlépve labdavitelekkel és támogatva az előrehaladást'
      },
      LineBreakingCarries5: {
        1: 'Egy igazi szakértő a labdavitelben. Következetesen tör vonalakat a labdával és nagy mennyiségben'
      },
      LineBreakingActions1: {
        1: 'Nagyon kevés vonaltörő akciót rögzít (passzok és labdavitelek). Ritkán vállal kockázatot'
      },
      LineBreakingActions2: {
        1: 'Néhány előrehaladó akciót produkál (passzok és labdavitelek), de ritkán. Inkább vízszintesen játszik'
      },
      LineBreakingActions3: {
        1: 'Kombinál passzokat és labdaviteleket, amelyek rendszeresen törnek vonalakat. Hozzájárul az előrehaladáshoz'
      },
      LineBreakingActions4: {
        1: 'Technikailag ügyes és intelligens, hogy sok akciót (passzok és labdavitelek) produkáljon, amelyek felbontják az ellenfél vonalait'
      },
      LineBreakingActions5: {
        1: 'Egy igazi előrehaladási szakértő. Nagy hatást gyakorol a csapatban, folyamatosan törve vonalakat a labdával passzokkal és labdavitelekkel'
      },
      OffBallRuns1: {
        1: 'A játékos nagyon kevés céltudatos mozgást végez labda nélkül, korlátozott támogatást nyújtva a támadó fázishoz. A labda nélküli futások ritkán járulnak hozzá a tér teremtéséhez, a védekező vonalak megzavarásához vagy a csapat koordinációjának javításához birtoklásban'
      },
      OffBallRuns2: {
        1: 'A játékos az átlag alatti labda nélküli mozgást nyújtja, időnként támogatva a támadást, de hiányzik a következetesség az időzítésben, irányban vagy taktikai szándékban. A futások korlátozott hatást gyakorolnak a terek megnyitására vagy a támadó struktúra fokozására'
      },
      OffBallRuns3: {
        1: 'A játékos átlagos szintű céltudatos labda nélküli futásokat mutat, következetesen hozzájárulva a támadó fázishoz. A mozgások általában jól időzítettek és funkcionálisak, teret teremtve és támogatva a csapatjátékot mérsékelt hatással'
      },
      OffBallRuns4: {
        1: 'A játékos az átlag feletti labda nélküli aktivitást mutatja, gyakran céltudatos futásokat végezve, amelyek megzavarják a védekező struktúrákat, passzolási opciókat teremtenek és támadó tereket nyitnak. A mozgási minták jelentősen hozzájárulnak a csapat koordinációjához birtoklásban'
      },
      OffBallRuns5: {
        1: 'A játékos kiemelkedik a céltudatos labda nélküli mozgásokban, következetesen előre látva a játékot és intelligens futásokat végezve, amelyek maximalizálják a támadó lehetőségeket. Az időzítés, pozicionálás és térbeli tudatosság állandó veszélyeket teremt és fokozza a csapat folyékonyságát birtoklásban'
      },
      OverMaxValue: {
        1: 'Rendkívüli képesség van az over_max_metric_name-ben, a maximális érték feletti teljesítménnyel, amely ezt a játékost ebben a tekintetben a top 10%-ba helyezi az 5 legjobb ligában'
      },
      OverAverageSeason: {
        1: 'Ami az over_average_metric_name teljesítményét illeti, a szint a liga átlaga felett van a league_name-ben (over_average_metric_value vs average_metric_value)',
        2: 'A számokat összevetve a league_name liga számaira az over_average_metric_name-ben, a teljesítmény az átlag felett van (over_average_metric_value vs average_metric_value)'
      },
      UnderMinValue: {
        1: 'Ami az under_min_metric_name-et illeti, jelentősen javítania kell a teljesítményét, mivel a legalacsonyabb percent_metric_name-be helyezi a top 5 ligában'
      },
      Over70Percent: {
        1: ', különösen kiemelkedik az over_70_metric_name-ben over_70_metric_value értékkel 90 percre, illetve',
        2: ', 70% felett az over_70_metric_name-ben over_70_metric_value értékkel 90 percre, illetve',
        3: ', több mint figyelemreméltó munkát végezve az over_70_metric_name-ben over_70_metric_value értékkel 90 percre, illetve'
      },
      Under30Percent: {
        1: ', keményebben kell dolgoznia az under_30_metric_name-ben, mert under_30_metric_value értékkel 90 percre, illetve, a teljesítmény alacsony',
        2: ', jelentősen javítania kell az under_30_metric_name-ben, mivel under_30_metric_value értékkel 90 percre, illetve, a teljesítmény az elvárás alatt van',
        3: ', ami az under_30_metric_name-et illeti under_30_metric_value értékkel 90 percre, illetve, szükség van keményebb próbálkozásra a jobb számok eléréséhez'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'Jó kiemelni a liga átlagát meghaladó teljesítményt a league_name-ben '
      },
      OverAverageStats: {
        1: 'over_average_metric_name (over_average_metric_value vs average_metric_value átlagosan)'
      },
      Over70PercentIndividualPressure: {
        1: ', nagyon jó egyéni nyomást gyakorolva a labda visszaszerzéséhez',
        2: ', magas nyomást gyakorolva az ellenfélre a labda visszaszerzéséhez'
      },
      Under30PercentIndividualPressure: {
        1: ', intenzívebb nyomást kell gyakorolnia a labda visszaszerzéséhez',
        2: ', több erőfeszítést kell tennie a nyomás alá helyezés tekintetében az ellenfélre'
      }
    },
    himSelf: 'önmaga',
    ownSeason: 'Saját Szezon',
    minMaxTooltip: 'Illeszd a radar minimális és maximális értékeit',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'Bejelentkezés',
    latestBlogPosts: 'Legfrissebb Blog Bejegyzések',
    signIn: 'Bejelentkezés',
    username: 'Felhasználónév',
    password: 'Jelszó',
    passwordForgotten: 'Elfelejtett jelszó',
    signUp: 'Regisztráció',
    enter: 'Belépés',
    forceTitle: 'Fiók használatban',
    forceMessage: 'A fiók már csatlakoztatva van egy másik eszközön. Ki szeretnéd rúgni onnan és ezen az eszközön csatlakoztatni?',
    forgotMyPassword: 'Elfelejtettem a jelszavam',
    firstLogin: 'Első Bejelentkezés',
    firstLoginMessage: 'Biztonsági okokból új jelszót kell beállítanod az első bejelentkezésedkor. Ezen kívül egy preferált nyelvet is választhatsz az alkalmazás megtekintéséhez',
    firstLoginOverview: 'Itt van az áttekintés a fiókodról, a ligákról és termékekről, amelyekhez hozzáférésed van.',
    passwordConfirmation: 'Jelszó Megerősítés',
    forgotPasswordMessage: 'Add meg az email címedet, ha van érvényes fiók az emailhez kapcsolva, akkor megkapod a bejövő üzeneteidben a következő lépéseket a jelszó visszaállításához',
    resetPassword: 'Jelszó Visszaállítása',
    resetPasswordLinkInvalid: 'Ez a link érvénytelen vagy lejárt. Kérjen új jelszó-visszaállítást a bejelentkezési oldalról.',
    skipSettings: 'Beállítások kihagyása',
    contact: 'Kapcsolat',
    cookiesText: 'Ez az oldal Google sütiket használ szolgáltatásai nyújtásához és a forgalom elemzéséhez a szolgáltatás minőségének biztosítása, használati statisztikák generálása és visszaélések észlelése és kezelése érdekében.',
    contactUs: 'Lépj kapcsolatba velünk',
    newsTitle: 'Újdonság: Fizikai pontszámok!',
    newsText: 'Két új fizikai teljesítménypontszámot adtunk hozzá az eredeti, eseményadatokon alapuló pontszámunk mellé: <b>Állóképességi pontszámot</b> és <b>Sebesség & Erő pontszámot</b>.<br> Az Állóképesség azokat a játékosokat emeli ki, akik folyamatosan nagy területet fednek le és magas terhelést bírnak, míg a Sebesség & Erő a végsebességre, sprintekre és robbanékony gyorsulásokra összpontosít.'
  },
  settings: {
    pageSubtitle: 'Állítsd be az alkalmazás élményt',
    language: 'Nyelv',
    availableLeagues: 'Elérhető Ligák',
    availableSeasons: 'Elérhető Szezonok',
    availableProducts: 'Elérhető Termékek',
    organization: 'Cég',
    changePassword: 'Jelszó Módosítása',
    seasonTemplates: 'Szezon Sablonok',
    seasonTemplatesSubtitle: 'Hozz létre saját szezon sablonokat, amelyek később kiválaszthatók lesznek a Játékos Rangsorban és Játékos Felderítőben',
    templateName: 'Sablon Név',
    selectTemplate: 'Válassz meglévő sablont szerkesztéshez',
    radarDefault: 'Alapértelmezett Radar',
    default: 'Alapértelmezett',
    tabs: {
      options: 'Beállítások',
      templates: 'Sablonok',
      availableLeagues: 'Elérhető Ligák',
      contactData: 'GBE Kapcsolattartási Adatok'
    },
    contactData: {
      userDetails: 'Felhasználó Adatok',
      firstName: 'Keresztnév',
      lastName: 'Vezetéknév',
      contactDetails: 'Kapcsolattartási Adatok GBE-hez',
      name: 'Név',
      phone: 'Telefon',
      mobile: 'Mobil',
      email: 'Email',
      representativeDetails: 'Képviselő Adatok GBE-hez'
    },
    currency: 'Pénznem',
    fieldPreferences: 'Pálya Beállítások',
    visualizationsPreferences: 'Vizualizáció Beállítások',
    fieldColor: 'Pálya Színe',
    fieldColors: {
      green: 'Zöld',
      blue: 'Kék',
      white: 'Fehér',
      black: 'Fekete',
      grey: 'Szürke'
    },
    defaultPlayerVisualization: 'Alapértelmezett Játékos Vizualizáció',
    appPreferences: 'Alkalmazás Beállítások',
    darkMode: 'Sötét Mód',
    showTour: 'Vezetett Körút Mutatása',
    customStats: 'Egyedi Statisztikák',
    radarTemplates: 'Radar Sablonok',
    radarTemplatesSubtitle: 'Hozz létre saját metrika sablonokat, amelyek később kiválaszthatók lesznek a Radarokban és Rangsorban',
    radarCategories: {
      Custom1: 'Egyedi 1',
      Custom2: 'Egyedi 2',
      Custom3: 'Egyedi 3',
      Custom4: 'Egyedi 4',
      Custom5: 'Egyedi 5',
      Custom6: 'Egyedi 6',
      Physical: 'Fizikai',
      CustomPhysical1: 'Egyedi Fizikai 1',
      CustomPhysical2: 'Egyedi Fizikai 2',
      CustomPhysical3: 'Egyedi Fizikai 3',
      CustomPhysical4: 'Egyedi Fizikai 4',
      CustomPhysical5: 'Egyedi Fizikai 5',
      CustomPhysical6: 'Egyedi Fizikai 6'
    },
    templateRemoveTitle: 'Sablon Eltávolítása',
    templateRemoveMsg: 'Biztosan el szeretnéd távolítani ezt a sablont?',
    templateEditTitle: 'Sablon Mentése',
    templateEditMsg: 'Van egy nem mentett sablon, szeretnéd menteni, mielőtt betöltesz egy másik sablont?',
    category: 'Kategória',
    playerRadar: 'Játékos Radar',
    teamRadar: 'Csapat Radar',
    statsAlert: 'Adj meg legalább egy statisztikát a mentéshez',
    recommended: 'Ajánlott',
    warning: 'Vannak pozíciók, amelyek elérték a megengedett radarok maximális számát. Kérlek törölj vagy szerkeszd bármelyik sablont',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Spanyol',
      numeric: 'Numerikus'
    },
    showMediaMode: 'Média Mód Mutatása',
    statTemplates: 'Statisztika Sablonok',
    statTemplatesSubtitle: 'Hozz létre saját statisztika sablont több metrika közül választva',
    ratingFormat: {
      ratingFormat: 'Értékelési formátum',
      numbers: 'Számok',
      letters: 'A-F betűk'
    }
  },
  playerDetail: {
    passport: 'Útlevél',
    secondPassport: 'Második Útlevél',
    age: 'Életkor',
    dateOfBirth: 'Születési Dátum',
    height: 'Magasság',
    weight: 'Súly',
    wage: 'Fizetés',
    history: 'Történet',
    positions: 'Pozíciók',
    injuries: 'Sérülések',
    transfers: 'Átigazolások',
    nationalTeam: 'Válogatott',
    addFavorite: 'Hozzáadás a kedvencekhez',
    removeFavorite: 'Eltávolítás a kedvencekből',
    contractEnd: 'Szerződés Vége',
    yearsOld: ' éves',
    playerAvailability: 'Elérhetőség',
    playerUsage: 'Játszott Percek',
    usage: 'Használat',
    addToCollection: 'Hozzáadás gyűjteményhez',
    performance: 'Teljesítmény',
    info: 'Információ',
    career: 'Karrier',
    playerStyle: 'Játékos Stílus',
    radar: 'Radar',
    finishingMap: 'Lövés Térkép',
    threatMap: 'Veszély Térkép',
    keyPassMap: 'Kulcs Passz Térkép',
    beeswarm: 'Rangsor',
    allGames: 'Összes Mérkőzés',
    eventsMap: 'Események Térkép',
    lbpMap: 'Vonaltörés passzok',
    obpMap: 'A labdanyomáson',
    pupMap: 'Nyomás alatt halad át',
    obrMap: 'Ball bevételek',
    fullName: 'Teljes Név',
    academy: 'Akadémia',
    name: 'Név',
    lastName: 'Vezetéknév',
    playerAvailabilityLong: '% a szezonból sérülés vagy felfüggesztés nélkül',
    playerUsageLong: 'Játszott Percek',
    playerAvailability1: 'mérkőzés sérülés vagy felfüggesztés nélkül',
    playerAvailability2: 'mérkőzés ebben a szezonban',
    playerUsage1: 'játszott perc',
    playerUsage2: 'összes csapat perc',
    notMinutesThisSeason: 'Nem játszott perceket ebben a szezonban',
    seasonPlaceholder: 'Nincs aktív szezon',
    inactivePlayer: 'Inaktív Játékos',
    inactivePlayerMessage: 'Ha több információra van szükséged, kérhetsz egy jelentést',
    goRequest: 'Ugrás a Kéréshez',
    warningMinutes: 'Figyelem: Kevesebb mint 450 perc játszva, az elemzés nem lehet reprezentatív',
    scoreWarningMinutes: 'Játékosok legalább 450 összes játszott perccel',
    pdScoreWarningMinutes: 'Játékosok legalább 450 összes játszott perccel (minimum 60 perc mérkőzésenként)',
    warningSeasonGames: 'A szezonban kevesebb mint 5 mérkőzés játszva, így a Min & Max \'Top 5 Liga\'',
    warningStatsRemoved: 'Néhány statisztika nem jelenik meg, mert nem elérhetők a kiválasztott szezonhoz',
    warningBeeswarm: 'Játékos nem jelenik meg, mert nincs adat ehhez a statisztikához a kiválasztott szezonban',
    warningPlayersZeroValue: 'Nem mutat {x} játékost 0 értékkel ',
    onlyPlayersThatFit: 'Csak azok a játékosok, akik illeszkednek a Radar Sablonhoz',
    gamesPlayedNotEnough: 'Beállítások letiltva, mert nincs elég játszott mérkőzés',
    gbe: 'GBE',
    analysis: 'Elemzés',
    documents: 'Dokumentumok',
    rankDefensive: 'Védekező',
    rankBallHandling: 'Labdakezelés',
    rankGoal: 'Gól Hozzájárulás',
    rankXt: 'Veszély',
    rankIndex: 'Index',
    visitHistory: 'Látogatási Történet',
    placer: 'Pálya',
    touchesMap: 'Érintések térkép',
    heatMap: 'Hőtérkép',
    ageProfile: 'Életkor Profil',
    strongFoot: 'Erős láb',
    player: 'Játékos',
    outOf: 'ből',
    in: 'ben',
    radius: 'Sugár',
    blur: 'Elmosódás',
    careerTable: {
      nationalTeamCareer: 'Válogatott Karrier',
      nationalTeamCompetitions: 'Válogatott Versenyek'
    },
    physicalProgression: 'Fizikai Fejlődés',
    gpi: 'Globális Játékos Index',
    warningGPI: 'Csak azoknak a játékosoknak elérhető, akik aktívak ELO ligákban az elmúlt 30 napban',
    diffGPI: 'Változás az utolsó mérkőzéshez képest',
    rankingInTheWorld: '#{0} a világban',
    rankingInTheLeague: '#{0} a(z) {1}-ben',
    max: 'Max',
    gpiChart: 'Diagram a Globális Játékos Index értéke alapján az utolsó {0} mérkőzésről',
    percentileRange: 'Percentilisek {0} és {1} között',
    months: 'hónap',
    month: 'hónap',
    contractExpOver4Years: 'A szerződés lejár',
    contractExpSoon: 'A szerződés hamarosan lejár',
    contractFinalYear: 'A szerződés utolsó éve',
    freeAgent: 'Szabad ügynök',
    gpiDescription: 'A Global Player Index (GPI) egy szabványos játékosminősítési rendszer, amely a labdarúgókat csapaterő, ellenfél ereje, mérkőzésteljesítménye és elérhetősége alapján értékeli. Az Elo minősítési rendszer ihlette, hogy a játékosok értékelései a tényleges versenykörnyezetet tükrözzék, nem pedig az önkényes alapvonalakat.',
    turnoversMap: 'Forgalmi és megtérülési térkép',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    },
    sucessfulTouch: 'Sikeres érintések',
    unsuccessfulTouch: 'Sikertelen érintések',
    showLegend: 'Mutasd a legendát'
  },
  finishingMap: {
    typesOfShot: 'Lövés Típusok',
    shotStrategy: 'Stratégia',
    strategiesCount: '{count} stratégiák',
    areas: 'Területek',
    bodyPart: 'Testrész',
    more: 'több',
    selectAll: 'Összes Kiválasztása',
    minutes: 'Percek',
    circles: 'Körök',
    boxes: 'Büntetőterület hőtérképe',
    lines: 'Vonalak',
    games: 'Mérkőzések',
    perShot: 'lövésenként',
    goal: 'Gól',
    missedShot: 'Kihagyott Lövés',
    savedShot: 'Hárított Lövés',
    shotOnPost: 'Lövés a Kapufára',
    missedChance: 'Kihagyott Lehetőség',
    openPlay: 'Nyitott Játék',
    regularPlay: 'Rendszeres Játék',
    fastBreak: 'Gyors Támadás',
    individualPlay: 'Egyéni Játék',
    setPiece: 'Rögzített Szituáció',
    fromCorner: 'Szögletből',
    freeKick: 'Szabadrúgás',
    indirectFreeKick: 'Közvetett Szabadrúgás',
    throwInSetPiece: 'Bedobás Rögzített Szituáció',
    inBox: 'Tizenhatosban',
    goalArea: 'Hatosban',
    boxLeft: 'Tizenhatos Bal',
    boxCenter: 'Tizenhatos Közép',
    boxRight: 'Tizenhatos Jobb',
    outOfBox: 'Tizenhatoson Kívül',
    outBoxDeepLeft: 'Tizenhatoson Kívül Mély Bal',
    outBoxDeepRight: 'Tizenhatoson Kívül Mély Jobb',
    outBoxLeft: 'Tizenhatoson Kívül Bal',
    outBoxCentreLeft: 'Tizenhatoson Kívül Közép Bal',
    outBoxCentre: 'Tizenhatoson Kívül Közép',
    outBoxCentreRight: 'Tizenhatoson Kívül Közép Jobb',
    outBoxRight: 'Tizenhatoson Kívül Jobb',
    left35: '+35 Bal',
    centreLeft35: '+35 Közép Bal',
    centre35: '+35 Közép',
    centreRight35: '+35 Közép Jobb',
    right35: '+35 Jobb',
    head: 'Fej',
    rightFooted: 'Jobb Láb',
    leftFooted: 'Bal Láb',
    otherBodyPart: 'Más Testrész',
    chart: {
      shots: 'Lövések',
      xGPerShot: 'xG lövésenként',
      exceptionTextPenaltyGoals: '* Büntető Lövések = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Büntető Lövések = 0.765 xGOT',
      exceptionTextOwnGoals: '* Öngólok nincsenek figyelembe véve',
      og: 'ÖG',
      penaltiesExcluded: 'Büntető Gólok Kizárva',
      ownGoalsExcluded: 'Öngólok Kizárva',
      sumOfxG: 'xG Összege',
      exceptionShotsOutOfRange: '* Nem mutatja a tartományon kívüli lövéseket'
    },
    inGoal: 'Kapuban',
    outOfGoal: 'Kapun Kívül',
    highLeft: 'Magas Bal',
    highCenter: 'Magas Közép',
    highRight: 'Magas Jobb',
    lowLeft: 'Alacsony Bal',
    lowCenter: 'Alacsony Közép',
    lowRight: 'Alacsony Jobb',
    outHighLeft: 'Kívül Magas Bal',
    high: 'Kívül Magas Közép',
    outHighRight: 'Kívül Magas Jobb',
    closeHighLeft: 'Közel Magas Bal',
    closeHigh: 'Közel Magas Közép',
    closeHighRight: 'Közel Magas Jobb',
    closeLeft: 'Közel Alacsony Bal',
    closeRight: 'Közel Alacsony Jobb',
    finishingTable: 'Lövés Táblázat',
    onGoal: 'Kapura',
    distributionFilters: 'Eloszlás Szűrők',
    penalty: 'Büntető',
    penaltyShootout: 'Büntetőpárbaj',
    onlyPercentage: 'Százalék Mutatása',
    showAll: 'Összes Mutatása',
    chanceMissed: 'Kimaradt az esély'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Kulcs Passzok',
      xAPerPass: 'xA passzonként',
      xAOpenPlay: 'xA Nyitott Játék',
      xASetPiece: 'xA Rögzített Szituáció'
    }
  },
  beeswarm: {
    template: 'Sablon',
    templates: {
      Goalkeeper: 'Kapus',
      Defender: 'Védő',
      'Full-Back': 'Szélső Védő',
      FullBack: 'Szélső Védő',
      'Wing-Back': 'Szélső Védő',
      WingBack: 'Szélső Védő',
      Midfielder: 'Középpályás',
      AttackingMidfielder: 'Támadó Középpályás',
      Winger: 'Szélső',
      Forward: 'Csatár',
      Physical: 'Fizikai'
    },
    compareWith: 'Összehasonlítás',
    highlightPlayersOf: 'Játékosok Kiemelése',
    highlightPlayers: 'Játékosok Kiemelése',
    per90: 'Adatok 90 percre',
    highlightTeams: 'Csapatok Kiemelése',
    filterTeams: 'Csapatok Szűrése',
    warningZeros: 'Csak nem fordított statisztikákhoz'
  },
  collections: {
    newCollection: 'Új gyűjtemény',
    editCollection: 'Gyűjtemény szerkesztése',
    name: 'Név',
    visibility: 'Láthatóság',
    privacity: {
      publicTitle: 'Nyilvános',
      publicDescription: 'Látható neked és a klubodnak',
      privateTitle: 'Privát',
      privateDescription: 'Csak neked látható',
      supervisedTitle: 'Felügyelt',
      supervisedDescription: 'Csak neked és a felügyelődnek látható'
    },
    addSuccess: 'Sikeresen hozzáadva',
    createAddSuccess: 'Létrehozva és sikeresen hozzáadva',
    editSuccess: 'Sikeresen frissítve',
    deleteSuccess: 'Sikeresen törölve',
    title: 'Játékos gyűjtemények',
    publics: 'Nyilvánosak',
    privates: 'Privátok',
    supervised: 'Felügyeltek',
    totalMarketValue: 'Összes piaci érték',
    avgMarketValue: 'Átlagos piaci érték',
    avgAge: 'Átlagos életkor',
    searchBarPlaceholder: 'A gyűjteményhez való hozzáadáshoz keress és válassz játékosokat',
    deleteCollection: 'Gyűjtemény törlése',
    deleteCollectionMessage: 'A gyűjtemény el lesz távolítva, biztosan?',
    removePlayer: 'Játékos eltávolítása',
    removePlayerMessage: 'A játékos el lesz távolítva a gyűjteményből, biztosan?',
    subtitle: 'Szervezd a felderítésed',
    notExitingTemplate: 'Még nincsenek sablonok'
  },
  searchbar: {
    placeholder: 'Írj a kereséshez (pl. `david arsenal´)',
    players: 'Játékosok',
    teams: 'Csapatok',
    games: 'Mérkőzések',
    leagues: 'Ligák',
    explore: 'Több eredmény felfedezése',
    placeholderNoResults: 'Nincs eredmény a sablonhoz',
    teamPlaceholder: 'Egy csapat összehasonlításához keress és válassz ki egyet'
  },
  favorites: {
    showOnly: 'Csak mutat',
    selfFavorites: 'Saját kedvencek',
    clubFavorites: 'Klub kedvencek',
    contractExpiration: 'Szerződés lejárata',
    groupBy: 'Csoportosítás',
    noGrouped: 'Nincs',
    maxSelection: 'Csak kiválasztható',
    selectAtleastOne: 'Legalább válassz egyet',
    comparePlayers: 'Játékosok összehasonlítása',
    selectedPlayers: 'kiválasztott játékos',
    subtitle: 'Kezeld a kedvenceidet',
    generateXlsx: 'XLSX generálása',
    generating: 'Generálás...',
    subscribed: 'Feliratkozva',
    subscribedTooltip: 'Feliratkozás email fogadására, amikor egy mérkőzés lejátszódott',
    deleteSelected: 'Kijelölt törlése'
  },
  expiration: {
    summer: 'Nyár',
    winter: 'Tél'
  },
  positions: {
    noposition: 'Nincs Pozíció',
    goalkeeper: 'Kapus',
    goalkeepers: 'Kapusok',
    defender: 'Védő',
    defenders: 'Védők',
    defenses: 'Védők',
    fullback: 'Szélső Védő',
    fullbacks: 'Szélső Védők',
    midfielder: 'Középpályás',
    midfielders: 'Középpályások',
    winger: 'Szélső',
    wingers: 'Szélsők',
    forward: 'Csatár',
    forwards: 'Csatárok',
    wingback: 'Szélső Védő',
    wingbacks: 'Szélső Védők'
  },
  dPos: {
    1: {
      name: 'Kapus',
      alias: ''
    },
    2: {
      name: 'Jobb Szélső Védő',
      alias: 'RFB'
    },
    3: {
      name: 'Jobb Középső Védő',
      alias: 'RCB'
    },
    4: {
      name: 'Bal Középső Védő',
      alias: 'LCB'
    },
    5: {
      name: 'Bal Szélső Védő',
      alias: 'LFB'
    },
    6: {
      name: 'Védekező Középpályás',
      alias: 'DM'
    },
    7: {
      name: 'Jobb Szélső',
      alias: 'RW'
    },
    8: {
      name: 'Középső Középpályás',
      alias: 'CM'
    },
    9: {
      name: 'Csatár',
      alias: 'ST'
    },
    10: {
      name: 'Támadó Középpályás',
      alias: 'AM'
    },
    11: {
      name: 'Bal Szélső',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'Összehasonlítás',
    lastSeasonSelectText: 'Előző Szezon',
    lastAndCurrentSeasonSelectText: 'Előző + Jelenlegi Szezon',
    currentSeasonSelectText: 'Jelenlegi Szezon',
    lastNgamesSelectText: 'Utolsó {x} mérkőzés',
    npgVsXGTitle: 'Büntető Nélküli Gólok VS xG',
    totalXGLabel: 'Összes xG',
    xGLabel: 'xG',
    totalNPGLabel: 'Összes Büntető Nélküli Gól',
    xGAgainstvsNPGAgainstTitle: 'Szemben Álló xG VS Szemben Álló Büntető Nélküli Gólok',
    totalXGAgainstLabel: 'Összes Szemben Álló xG',
    xGAgainstLabel: 'Szemben Álló xG',
    totalNPGAgainstLabel: 'Összes Szemben Álló Büntető Nélküli Gól',
    xGvsxGAgainstTitle: 'xG VS Szemben Álló xG',
    pointsVsXPointsTitle: 'Pontok VS Várható Pontok',
    xTTitle: 'Játék Folyam',
    totalXPoints: 'Összes xPont',
    totalPoints: 'Összes Pont',
    requestedReports: 'Kért Jelentések',
    playersScouted: 'Felderített Játékosok',
    performanceVSAverageChart: 'Teljesítmény VS Átlag',
    perPositions: 'Pozíciók Szerint',
    perLeagues: 'Ligák Szerint',
    perMonths: 'Hónapok Szerint',
    perClients: 'Ügyfelek Szerint',
    ofPreposition: 'a',
    idJChartTitle: 'Játék Kezdeményezés',
    idJChartLabel: 'Index GI',
    vJOChartTitle: 'Támadó Játék Mennyiség',
    vJOChartLabel: 'Index OGV',
    preJOChartTitle: 'Támadó Játék Pontosság',
    preJOChartLabel: 'Index OGPre',
    proJOChartTitle: 'Támadó Játék Előrehaladás',
    proJOChartLabel: 'Index OGPro',
    chart: 'Diagram',
    table: 'Táblázat',
    showLeaguesWithAtLeast: 'Mutasson ligákat legalább',
    playersScoutedSuffix: 'játékosokat becserkészték'
  },
  table: {
    history: {
      season: 'Szezon',
      team: 'Csapat',
      position: 'Pozíció',
      side: 'Oldal',
      games: 'Mérkőzések',
      minutes: 'Perc',
      goals: 'Büntető Nélküli Gól (G)',
      assists: 'G',
      yellowCards: 'SL',
      redCards: 'PL',
      gameLost: 'VM',
      gamesMissed: 'Kihagyott Mérkőzések',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Szezon',
      team: 'Csapat',
      injury: 'Sérülés',
      dateFrom: 'Kezdő Dátum',
      dateTo: 'Befejező Dátum',
      daysLost: 'Elveszett Napok',
      gamesLost: 'Elveszett Mérkőzések',
      allInjuries: 'Összes Sérülés'
    },
    transfers: {
      season: 'Szezon',
      date: 'Dátum',
      teamFrom: 'Honnan Csapat',
      teamTo: 'Hova Csapat',
      marketValue: 'Piaci Érték',
      fee: 'Díj',
      type: 'Típus'
    },
    caps: {
      team: 'Csapat',
      debut: 'Bemutatkozás',
      games: 'Mérkőzések',
      goals: 'Gólok',
      coachDuringDebut: 'Edző a Bemutatkozás Alatt',
      debutAge: 'Bemutatkozás Életkora'
    },
    roster: {
      country: 'Ország',
      player: 'Játékos',
      positions: 'Pozíciók',
      minutes: 'Percek',
      games: 'Mérkőzések',
      goals: 'Gólok',
      assists: 'Gólpasszok',
      cards: 'Lapok',
      gamesExplicit: 'Játszott Mérkőzések'
    },
    league: {
      title: 'Liga Lap',
      subtitle: 'Mélyedj el a liga rangsorában és statisztikáiban',
      team: 'Csapat',
      games: 'JM',
      gamesExplicit: 'Játszott Mérkőzések',
      gamesRanking: 'JM',
      gamesRankingExplicit: 'Játszott Mérkőzések',
      points: 'Pont',
      pointsExplicit: 'Pontok',
      expectedPoints: 'xP',
      expectedPointsExplicit: 'Várható Pontok',
      goalsScored: 'BNG',
      goalsScoredExplicit: 'Büntető Nélküli Gólok',
      xG: 'xG',
      xGExplicit: 'Várható Gólok',
      goalsAgainst: 'Szemben Álló BNG',
      goalsAgainstExplicit: 'Szemben Álló Büntető Nélküli Gólok',
      xGAgainst: 'Szemben Álló xG',
      xGAgainstExplicit: 'Szemben Álló Várható Gólok',
      xGAgainstDiff: 'Szemben Álló xG Különbség',
      xGAgainstDiffExplicit: 'Szemben Álló Várható Gólok Különbsége',
      form: 'Forma',
      sos: 'NvM',
      sosExplicit: 'Mérkőzések Nehézsége',
      sosHfa: 'NvM HFA',
      sosHfaExplicit: 'Hazai Pálya Előny',
      difficultyAboveAvg: 'Nehézség az átlag felett',
      differentGames: '* Különböző Játszott Mérkőzések Száma',
      berth: 'Hely'
    },
    usersOfClient: {
      userName: 'Név',
      userRole: 'Felhasználó',
      devRole: 'Fejlesztő',
      adminRole: 'Admin',
      servicesRole: 'Szolgáltatások',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Rangsor',
      elevenRole: 'Tizenegyek',
      similarityRole: 'Hasonlóság',
      gameAnalysisRole: 'Mérkőzés Elemzés',
      clientStatsRole: 'Ügyfél Statisztikák',
      created: 'Létrehozva',
      type: 'Típus',
      logins: 'Bejelentkezések',
      lastLogin: 'Utolsó Bejelentkezés',
      trialDate: 'Próba Dátum'
    },
    clientLeagues: {
      league: 'Liga',
      area: 'Terület',
      tier: 'Szint',
      seasons: 'Szezonok',
      currentMatchDay: 'Mérkőzésnap',
      regular: 'Rendszeres',
      youthLeague: 'Ifjúsági',
      clientActive: 'Aktív',
      visibleLeagues: 'Látható Ligák',
      male: 'Férfi liga',
      female: 'Női liga'
    },
    connections: {
      title: 'Gyakori Kombinációk',
      playerFrom: 'Játékostól',
      playerTo: 'Játékoshoz',
      passes: 'Passzok',
      passesTooltip: 'Sikeres Passzok Összes Száma',
      passesFinalThird: 'PF ⅓',
      passesFinalThirdTooltip: 'Passzok Harmadik Harmadban'
    },
    playerPassMapData: {
      title: 'Passzolási Statisztikák',
      player: 'Játékos',
      passes: 'Passzok',
      passesPct: '% Passzok',
      xA: 'xA',
      xG: 'xG',
      xT: 'xVeszély',
      playerTooltip: 'Játékos Neve',
      passesTooltip: 'Passzok Összes Száma',
      passesPctTooltip: '% Sikeres Passzok',
      xATooltip: 'Várható Gólpasszok',
      xGTooltip: 'Várható Gólok',
      xTTooltip: 'Várható Veszély'
    },
    playerAllGames: {
      gameDate: 'Dátum',
      game: 'Mérkőzés',
      team: 'Csapat',
      positionsPlayed: 'Pozíciók',
      minsPlayed: 'Percek',
      gameActions: 'Akciók',
      gameDateTooltip: 'Mérkőzés Dátuma',
      gameTooltip: 'Mérkőzés',
      positionsPlayedTooltip: 'Játszott Pozíciók',
      minsPlayedTooltip: 'Játszott Percek',
      gameActionsTooltip: 'Gólok, Gólpasszok, Lapok',
      from: 'Kezdet',
      to: 'Vége',
      goalText: 'Gól',
      assistText: 'Gólpassz',
      penaltyText: 'Büntető',
      ownGoalText: 'Öngól',
      yellowCardText: 'Sárga Lap',
      secondYellowCardText: 'Második Sárga Lap',
      redCardText: 'Piros Lap',
      substitutionIN: 'Be',
      substitutionOUT: 'Ki',
      suspendedText: 'Felfüggesztés',
      Team: 'Felszerelés'
    },
    gameFlow: {
      phase: 'Fázis ',
      mins: 'Percek',
      team: 'Csapat',
      period: 'Időszak',
      possession: '%Birt.',
      possessionTooltip: '% Birtoklás',
      xT: 'xVeszély',
      xTTooltip: 'Várható Veszély',
      pft: 'PF ⅓',
      pftTooltip: 'Passzok Harmadik Harmadban',
      xG: 'xG',
      xGTooltip: 'Várható Gólok'
    }
  },
  game: {
    title: 'Mérkőzés Lap',
    subtitle: 'Mélyedj el a mérkőzés jellemzőiben és statisztikáiban',
    header: {
      gameDetails: 'Részletek',
      gameStats: 'Statisztikák',
      gameFinishingMap: 'Lövés Térkép',
      gameKeyPassMap: 'Kulcs Passz Térkép',
      gamePassMap: 'Passz Térkép',
      gameThreat: 'Mérkőzés Veszély',
      gameFlow: 'Játék Folyam',
      gameAnalysis: 'Mérkőzés Elemzés',
      gamePhysicalStats: 'Fizikai Statisztikák',
      possessions: 'Birtoklások',
      bench: 'Kispad',
      video: 'Videó kiemelések',
      preGame: 'Meccs előtt',
      postGame: 'Meccs után',
      areaCoverage: 'Területi lefedettség'
    },
    passMap: {
      typeOfPlay: 'Játéktípus:',
      passes: 'Passzok:',
      team: 'Csapat',
      minutes: 'Percek:',
      select: 'Választás',
      all: 'Összes',
      attacking: 'Támadó',
      defending: 'Védekező',
      forwards: 'Előre',
      backwards: 'Hátra',
      sideways: 'Oldalra',
      longBall: 'Hosszú Labda',
      successfullPasses: 'Sikeres Passzok',
      homeTeam: 'Hazai',
      awayTeam: 'Vendég',
      passingMatrix: 'Passzolási Mátrix',
      passer: 'Passzoló',
      receiver: 'Fogadó',
      passOutcome: 'Passz Eredménye',
      passDirection: 'Passz Iránya',
      half: 'Fél',
      offensive: 'Támadó',
      defensive: 'Védekező',
      passingConnections: 'Passz kapcsolatok',
      pitchView: 'Pálya',
      passSingular: 'Passz',
      passPlural: 'Passzok',
      playerLocation: 'Játékos helye',
      passLegend: 'Átlagos érintési pozíció',
      minuteRange: 'Perc tartomány'
    },
    stats: {
      summary: 'Összefoglaló',
      attacking: 'Támadó',
      defending: 'Védekező',
      contribution: 'Hozzájárulás',
      possession: 'Birtoklás',
      expectedPoints: 'Várható Pontok',
      directness: 'Közvetlenség',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG Rögzített Szituáció',
      xA: 'xA',
      xASetPiece: 'xA Rögzített Szituáció',
      xT: 'xT',
      xTSetPiece: 'xT Rögzített Szituáció',
      touchesInOppBox: 'Érintések az Ellenfél Tizenhatosában',
      passesFinalThird: 'Passzok Harmadik Harmadban',
      interceptions: 'Labdaszerzések',
      recoveries: 'Labdaszerzések',
      recoveriesOppHalf: 'Labdaszerzések Ellenfél Térfelén',
      tackles: 'Szerelések',
      tacklesWasDribbled: 'Megnyert védekező 1 elleni 1 elleni párharcok',
      fouls: 'Szabálytalanságok',
      yellowCards: 'Sárga Lapok',
      redCards: 'Piros Lapok',
      passes: 'Passzok',
      passing: 'Passzolás %',
      crosses: 'Beadások',
      crossing: 'Beadás %',
      shots: 'Lövések',
      shotsOnTarget: 'Kapura Lövések',
      ppdaExplicit: 'Engedélyezett Passzok Védekező Akciókra',
      xgExplicit: 'Várható Gólok',
      xp: 'xP',
      ExpectedPassing: 'xP %',
      seasonAvg: 'Verseny Átlag',
      winChanceTooltip: 'Győzelem valószínűsége a generált és engedélyezett xG alapján',
      drawChance: 'Döntetlen',
      xgAgainst: 'Szemben Álló xG',
      averagePossession: 'Birtoklás',
      averageShots: 'Lövések',
      averagexG: 'Várható Gólok',
      fieldTilt: 'Pálya Dőlés',
      fieldTiltExplicit: 'Pálya Dőlés',
      recoveriesRate: 'Helyreállítási arány',
      turnoversRate: 'Forgalmi ráta'
    },
    detail: {
      halfTime: 'Félidő',
      overTime: 'Hosszabbítás',
      showStats: 'Statisztikák Mutatása',
      hideStats: 'Statisztikák Elrejtése',
      bench: 'Kispad',
      showShotOptions: 'Lövés Beállítások Mutatása',
      hideShotOptions: 'Lövés Beállítások Elrejtése',
      showPassOptions: 'Passz Beállítások Mutatása',
      hidePassOptions: 'Passz Beállítások Elrejtése',
      endGame: 'Végeredmény',
      penalties: 'Büntetők'
    },
    timeline: {
      events: {
        goal: 'Gól',
        goal_ownGoal: 'Öngól',
        goal_penalty: 'Büntetőből Gól',
        card: 'Lap',
        card_yellowCard: 'Sárga Lap',
        card_secondYellowCard: 'Második Sárga Lap',
        card_redCard: 'Piros Lap',
        formationChange: 'Felállás Változás',
        substitution: 'Cserélés',
        saveShot: 'Hárított Lövés',
        saveShot_penalty: 'Hárított Büntető',
        missedShot: 'Kihagyott Lövés',
        missedShot_penalty: 'Kihagyott Büntető',
        shotOnPost: 'Lövés a Kapufára',
        shotOnPost_penalty: 'Kapufára Lövés Büntetőből',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: 'Gól ',
      redCardTo: 'Piros Lap ',
      missedPenalty: 'Kihagyott büntető'
    },
    gameThreat: {
      typeOfPlay: 'Akció Típusa',
      regularPlay: 'Rendszeres Játék',
      setPiece: 'Rögzített Szituáció',
      setPiecePlay: 'Rögzített Szituáció',
      throwInSetPiecePlay: 'Bedobás Játék',
      throwInPlay: 'Bedobás Játék',
      gkThrow: 'Kapus Dobás',
      gkKick: 'Kapus Rúgás',
      kickOff: 'Kezdőrúgás',
      actionEnding: 'Akció Befejezése',
      pass: 'Passz',
      shot: 'Lövés',
      foul: 'Szabálytalanság',
      other: 'Egyéb',
      threat: 'Veszély',
      legendSumOfXT: 'xT Összege',
      legendPass: 'Passz',
      legendShot: 'Lövés',
      legendCarryAndAction: 'Labdavitel és Akció',
      legendCarryAndPass: 'Labdavitel és Passz',
      legendOnlyShowing: 'Csak egyéni akciók mutatása xT > ',
      legendOnlyShowingPart1: 'Csak egyéni',
      legendOnlyShowingPart2: 'akciók mutatása xT > ',
      legendOnlyShowingSetPiece: 'Csak Rögzített Szituáció akciók mutatása xT > ',
      legendOnlyShowingOpenPlay: 'Csak Nyitott Játék akciók mutatása xT > ',
      legendPlays: 'Akciók',
      legendPerPlay: 'akciónként',
      legendCarry: 'Labdavitel',
      penaltyPlay: 'Büntető',
      freeKickTakenPlay: 'Szabadrúgás Játék',
      cornerTakenPlay: 'Szöglet Játék',
      fromCornerPlay: 'Szöglet Játék',
      keeperThrowPlay: 'Kapus Dobás Játék',
      fastBreakPlay: 'Gyors Támadás Játék',
      indirectPlay: 'Közvetett Játék',
      minutes: 'Percek',
      games: 'Mérkőzések',
      xT: 'xT',
      xTPer90: 'xT 90 percre'
    },
    gameAnalysis: {
      next: 'Következő',
      previous: 'Előző',
      phaseLabel: 'Fázis',
      phasesLabel: 'Fázisok',
      dot: '. ',
      comma: ', ',
      from: 'Tól',
      to: 'Ig',
      and: ' és ',
      steps: {
        finishingMapFullGame: 'Lövés Térkép',
        keyPassMapFullGame: 'Kulcs Passz Térkép',
        gameFlow: 'Játék Folyam',
        finishingMapPerPhases: 'Lövés Térkép Fázisok Szerint',
        keyPassMapPerPhases: 'Kulcs Passz Térkép Fázisok Szerint',
        passMapPerPhases: 'Passz Térkép Fázisok Szerint'
      },
      step1: {
        table: {
          draw: 'Döntetlen',
          win: 'Győzelem',
          lose: 'Vereség',
          possession: 'Birtoklás',
          xP: 'Várható Pontok',
          directness: 'Közvetlenség',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG Nyitott Játék',
          xGSetPiece: 'xG Rögzített Szituáció',
          xA: 'xA',
          xAOpenPlay: 'xA Nyitott Játék'
        },
        text: {
          firstParagraph: {
            1: 'A jobb oldali térkép mutatja a home_team_name és away_team_name által generált várható gólokat. A kitöltött körök azok a lövések, amelyek gólban végződtek. A körök mérete az egyes lövések xG értékétől függ. '
          },
          lastParagraph: {
            1: 'Az eredmény valószínűségi százaléka és a várható pontok száma lövésszimulációval számítódik ki (100 000 szimulációt végeznek a lövésekről, és az eredmények és pontszerzés lehetőségét prediktív módon értékelik). '
          },
          targetHighTeamXG: {
            1: 'target_team_name, valamint rival_team_name is, sikerült nagy mennyiségű várható gólt generálnia'
          },
          targetHighTeamOpenPlayXG: {
            1: 'Ebben a mérkőzésben a target_team_name helyzeteinek legtöbbje nyitott játékból származott'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'Ebben a mérkőzésben a target_team_name helyzeteinek legtöbbje nyitott játékból származott (ellentétben rival_team_name-nel)'
          },
          targetHighTeamSetPieceXG: {
            1: 'Ebben a mérkőzésben a target_team_name helyzeteinek legtöbbje rögzített szituációkból származott'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'Ebben a mérkőzésben a target_team_name helyzeteinek legtöbbje rögzített szituációkból származott (ellentétben rival_team_name-nel)'
          },
          targetHighTeamCornerXG: {
            1: 'Ebben a mérkőzésben a target_team_name helyzeteinek legtöbbje szögletrúgásokból származott'
          },
          targetLowTeamGoalConversion: {
            1: ' de a gólátalakítás alacsony volt'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name nagy mennyiségű várható gólt generált mind nyitott játékban, mind rögzített szituációkban'
          },
          targetHighTeamGoalConversion: {
            1: ' magas gólátalakítási aránnyal is rendelkezve. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', nem tudott gólt szerezni a létrehozott helyzetekből'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' de veszélyt teremtett több gól szerezésére'
          },
          targetHighTeamXGvsGameRival: {
            1: 'Ebben a mérkőzésben target_team_name több veszélyt generált, mint rival_team_name'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' és több gólt szerezhetett volna. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' de nem tudott gólt szerezni a létrehozott helyzetekből. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' team_winning_chance győzelmi esélyt mutatva a mérkőzés utáni szimulációnk szerint. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' A target_team_name helyzeteinek legtöbbje nyitott játékból származott. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' A target_team_name helyzeteinek legtöbbje rögzített szituációkból származott. '
          },
          startTargetHighTeamCornerXG: {
            1: ' A helyzetek legtöbbje szögletrúgásokból származott. '
          },
          targetSimilarTeamXG: {
            1: 'Ebben a mérkőzésben mindkét csapat hasonló mennyiségű veszélyt generált az ellenfélnek xG tekintetében, '
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'de target_team_name jobban teljesített a helyzetek befejezésében. '
          },
          targetLowTeamXGGoalDiff: {
            1: 'Az eredménytől függetlenül target_team_name nem generált sok veszélyt az ellenfélnek Várható Gólok tekintetében. '
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name nem generált elég veszélyt az ellenfélnek Várható Gólok tekintetében a mérkőzés megnyeréséhez'
          },
          rivalHighTeamXG: {
            1: 'és túl sok veszélyt engedélyezett rival_team_name számára. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' Ezzel a teremtéssel ez egy olyan mérkőzés, amelyet target_team_name csak team_winning_chance esetben nyert volna meg a mérkőzés utáni szimulációnk szerint. '
          },
          targetHighTeamGoalConversion2: {
            1: ' magas gólátalakítási aránnyal rendelkezve'
          },
          winningChance: {
            1: 'A lövések száma és xG alapján mindkét csapatnál, target_team_name team_winning_chance esetben nyerte volna meg ezt a mérkőzést. '
          },
          highPlayerXGManyShots: {
            1: 'Érdekes megjegyezni, hogy player_name xg_value xG-t generált shots_value lövéssel'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' xg_value xG-re van szüksége egy gól szerezéséhez. '
          },
          highPlayerXGOneGoal: {
            1: ' a gól szerezéséhez. '
          },
          highPlayerXGAnyGoal: {
            1: ', bár ez nem eredményezett gólt. '
          },
          highPlayerXGNotManyShots: {
            1: 'Érdemes megemlíteni, hogy player_name xg_value xG-t generált néhány lövéssel'
          },
          highManyPlayerXG: {
            1: 'Érdekes megjegyezni, hogy player_name és player_name2 xg_value és xg_value2 <b>xG</b>-t generáltak. '
          },
          highTeamXGPerShot: {
            1: 'A target_team_name által kiválasztott lövések tekintetében nagyon jók voltak a góllá válás valószínűsége szempontjából, xg_per_shot_value átlagos xG-t lövésenként. '
          },
          highTeamXGPerShotVSGameRival: {
            1: 'A target_team_name lövéseinek kiválasztása sokkal jobb volt, mint rival_team_name-é, xg_per_shot_value átlagos xG-t lövésenként. '
          },
          xGTimesNotAfter70xG: {
            1: 'A magas generált xG ellenére target_team_name problémákkal küzdött a veszély teremtésében a mérkőzés végén. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name sok veszélyt teremtett különösen mindkét félidő elején. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name sok veszélyt teremtett különösen mindkét félidő végén. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name a veszély legtöbbjét az első félidő elején teremtette. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name a veszély legtöbbjét az első félidő végén teremtette. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name a veszély legtöbbjét a második félidő elején teremtette. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name a veszély legtöbbjét a második félidő végén teremtette. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name nagyon szilárdan kezdte a mérkőzést xg_value várható gólt generáló helyzetekkel. '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name xg_value várható gólt generáló helyzetekkel fejezte be az első félidőt. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name xg_value várható gólt generáló helyzetekkel jött ki a félidő szünetből. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name xg_value várható gólt generáló helyzetekkel fejezte be a második félidőt. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name sok veszélyt teremtett a második félidő végén. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name sok veszélyt teremtett a második félidő elején. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name sok veszélyt teremtett az első félidő végén. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name sok veszélyt teremtett az első félidő elején. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name a veszély legtöbbjét az első félidőben generálta, míg rival_team_name ugyanezt a második félidőben tette. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name a veszély legtöbbjét a második félidőben generálta, míg rival_team_name ugyanezt az első félidőben tette. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'Ez egy olyan mérkőzés, ahol a veszély legtöbbje Várható Gólok tekintetében az első félidőben generálódott. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'Ez egy olyan mérkőzés, ahol a veszély legtöbbje Várható Gólok tekintetében a második félidőben generálódott. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name sikerült a veszély legtöbbjét az első félidőben teremtenie. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name sikerült a veszély legtöbbjét a második félidőben teremtenie. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name a veszély legtöbbjét engedélyezte Várható Gólok tekintetében az első félidőben. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name a veszély legtöbbjét engedélyezte Várható Gólok tekintetében a második félidőben. '
          },
          highInBoxXG: {
            1: 'A lövés térkép mutatja, hogy a veszély legtöbbje a tizenhatoson belüli lövésekből származott. '
          },
          highOutOfBoxXG: {
            1: 'Megfigyelhető a lövés térképen, hogy ebben a mérkőzésben target_team_name sok veszélyt generált a tizenhatoson kívülről. '
          },
          highInBoxXGRival: {
            1: 'Szeretnénk kiemelni, hogy a target_team_name által engedélyezett veszély legtöbbje a tizenhatoson belüli lövésekből származott. '
          },
          highInBoxXGRival2: {
            1: ' Érdekes kiemelni, hogy a target_team_name által engedélyezett veszély legtöbbje a tizenhatoson belüli lövésekből származott. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name jól teljesített a tizenhatoson belüli veszély elkerülésében. '
          },
          highTeamChancesHighPPDARival: {
            1: 'A target_team_name nyomás hiánya, ppda_value Passzot engedélyezve Védekező Akciókra, az egyik kulcs volt rival_team_name számára a nagy számú helyzet teremtéséhez. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name csak ppda_value Passzot engedélyezett Védekező Akciókra, ez volt az egyik kulcs a győzelemhez. '
          },
          lowPPDA: {
            1: 'target_team_name kiváló munkát végzett rival_team_name játékainak megszakításában, csak ppda_value átlagos Passzot engedélyezve Védekező Akciókra. '
          },
          highPossession: {
            1: 'target_team_name kontrollálta a labdát possession_value birtoklással'
          },
          highPPDARival: {
            1: ' valamint folyékony labdaelosztással'
          },
          chancesCreated: {
            1: ', amely lehetővé tette számukra, hogy nagy számú nyitott játék helyzetük legyen (chances_value). '
          },
          chancesCreatedRival: {
            1: ', bár rival_team_name képes volt nagy számú nyitott játék helyzetet teremteni (chances_value). '
          },
          xGPerShotRival: {
            1: ', bár rival_team_name képes volt veszélyesebb helyzeteket teremteni xg_per_shot_value xG-t lövésenként. '
          },
          winGame: {
            1: ' az egyik kulcs a mérkőzés megnyeréséhez. '
          },
          notEnoughWinGame: {
            1: ' nem volt elég a mérkőzés megnyeréséhez. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'Az első gól player_error_name hibájából származott, amelyet player_name kihasznált'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'Az első és egyetlen gól player_error_name hibájából származott, amelyet player_name kihasznált'
          },
          lastPhaseOfGame: {
            1: ' a mérkőzés utolsó fázisában. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'A végső gól a mérkőzés megnyeréséhez player_error_name hibájából származott, amely player_name góljához vezetett. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'A végső gól a mérkőzés döntetlenhez player_error_name hibájából származott, amely player_name góljához vezetett. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'player_error_name hibája döntetlen lehetőséghez vezetett target_team_name számára. '
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name előnyt szerzett player_error_name hibájának kihasználásával'
          },
          xGChance: {
            1: ' xg_value xG lehetőséggel. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'rival_team_name végső gólja a mérkőzés megnyeréséhez player_error_name hibájából származott, amely player_name góljához vezetett. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'player_error_name hibája döntetlen lehetőséghez vezetett rival_team_name számára. '
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name előnyt szerzett player_error_name hibájának kihasználásával'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name véletlenül megszerezte az egyetlen nagy lehetőséget, amelyet a mérkőzés során teremtett, ez player_name gólja, amelyet az xG térképen látunk xg_value xG értékkel. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name véletlenül megszerezte az összes nagy lehetőséget, amelyet a mérkőzés során teremtett'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name volt az egyetlen nagy lehetősége target_team_name-nek gól szerezésére xg_value xG értékkel. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name nem tudott gólt szerezni a chances_value lehetőségből, amelyek 40%-nál nagyobb valószínűséggel lettek volna gólok. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name nagy lehetősége volt xg_value xG értékkel, hogy előnybe kerüljön az állásban. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name chances_value lehetősége volt 40% feletti xG értékkel, hogy előnybe kerüljön az állásban. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name chances_value lehetősége volt magas xG értékkel, hogy előnybe kerüljön az állásban. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name lehetősége volt xg_value xG értékkel, hogy előnybe kerüljön az állásban, amely a kapufára csapódott. '
          },
          beforeEndOfGame: {
            1: 'A mérkőzés vége előtt, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name lehetősége volt xg_value xG értékkel, hogy megnyerje a mérkőzést. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name chances_value lehetősége volt 40% feletti xG értékkel, hogy megnyerje a mérkőzést. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name chances_value lehetősége volt magas xG értékkel, hogy megnyerje a mérkőzést. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name nagy lehetősége volt xg_value xG értékkel, hogy előnybe kerüljön az állásban. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name chances_value lehetősége volt 40% feletti xG értékkel, hogy előnybe kerüljön az állásban. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name chances_value lehetősége volt magas xG értékkel, hogy előnybe kerüljön az állásban. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name lehetősége volt xg_value xG értékkel, hogy előnybe kerüljön az állásban, amely a kapufára csapódott. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name lehetősége volt xg_value xG értékkel, hogy döntetlent érjen el szerencsétlenül. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name chances_value lehetősége volt, hogy döntetlent érjen el 30% feletti gólszerzési valószínűséggel. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name lehetősége volt xg_value xG értékkel, hogy döntetlent érjen el, amely a kapufára csapódott. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Döntetlen',
          win: 'Győzelem',
          possession: 'Birtoklás',
          xP: 'Várható Pontok',
          directness: 'Közvetlenség',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA Nyitott Játék',
          xASetPiece: 'xA Rögzített Szituáció',
          chancesCreated: 'Teremtett Helyzetek',
          shotsOnTarget: 'Kapura Lövések'
        },
        text: {
          firstParagraph: {
            1: 'Ez a kép mutatja a <b style=\'color:home_color\'>home_team_name</b> és <b>away_team_name</b> várható gólpasszait.'
          },
          xAPerKeyPass: {
            1: ' xA kulcs passzonként. '
          },
          keyPassesGeneratedFrom: {
            1: ', különösen a kulcs passzok '
          },
          highTeamXAvsXG: {
            1: 'Ahogy az xA térkép mutatja, a target_team_name által teremtett veszély legtöbbje kombinációs játékokból származik, nem egyéni akciókból'
          },
          openPlay: {
            1: 'nyitott játék'
          },
          setPiece: {
            1: 'rögzített szituáció játék'
          },
          cornerKicks: {
            1: 'szögletrúgások'
          },
          combinationPlays: {
            1: 'kombinációs játékok'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'Ebben a mérkőzésben target_team_name veszélyt generált mind kombinációs játékokból'
          },
          individualActions: {
            1: ' mind egyéni akciókból. '
          },
          dangerFromIndividualActions: {
            1: 'Ebben a mérkőzésben a target_team_name által generált veszély legtöbbje egyéni akciókból származott.'
          },
          highTeamXAvsXGRival: {
            1: ' A target_team_name által engedélyezett helyzetek kombinációs játékokból származtak, ahogy az xA térkép mutatja.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name erős volt a kulcs passzokban '
          },
          manyPlayerKeyPasses: {
            1: 'Érdekes megjegyezni, hogy player_name xa_value xA-t teremtett key_passes kulcs passzban'
          },
          playerAssists: {
            1: ' xa_per_assist xA-ra van szüksége gólpasszonként.'
          },
          giveAssist: {
            1: ' a gólpassz adásához.'
          },
          noAssists: {
            1: ', bár ezek közül egyik passz sem végződött gólpasszban.'
          },
          highXANotManyShots: {
            1: 'Érdekes megjegyezni, hogy player_name xa_value xA-t teremtett néhány passzban'
          },
          manyPlayersHighXA: {
            1: 'Érdekes megjegyezni, hogy player_name és player_name2 xa_value és xa_value2 xA-t generáltak.'
          },
          xATimes: {
            1: 'target_team_name a veszély legtöbbjét az első félidőben generálta, míg rival_team_name ugyanezt tette a '
          },
          firstHalf: {
            1: ' első félidőben. '
          },
          secondHalf: {
            1: ' második félidőben. '
          },
          left: {
            1: 'bal oldal '
          },
          center: {
            1: 'közép '
          },
          right: {
            1: 'jobb oldal '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'Ez egy olyan mérkőzés, ahol a veszély legtöbbje Várható Gólok tekintetében a '
          },
          xAFirstHalf: {
            1: 'target_team_name sikerült a veszély legtöbbjét a '
          },
          xATimesXARival: {
            1: 'target_team_name túl sok veszélyt engedélyezett Várható Gólok tekintetében a '
          },
          xASides: {
            1: ' A target_team_name veszélyének legtöbbje a side_name oldalról származott (xa_value <b>xA</b>)'
          },
          xASidesRival: {
            1: 'míg rival_team_name többségét a side_name oldalról generálta (xa_value <b>xA</b>)'
          },
          dangerCreationRival: {
            1: 'rival_team_name veszélyének teremtése különösen a side_name oldalról származott (xa_value <b>xA</b>). '
          },
          speciallyEffective: {
            1: 'target_team_name különösen hatékony volt '
          },
          xAPerChanceCreated: {
            1: ' xa_value átlaggal'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name különösen hatékony volt '
          }
        }
      },
      step3: {
        text: {
          chance: ' lehetőség',
          chances: ' lehetőség',
          goal: ' gól',
          goals: ' gól',
          home: 'hazai',
          away: 'vendég',
          last: 'utolsó',
          first: 'első',
          goalScorer: 'gólszerző',
          goalScorers: 'gólszerzők',
          lastPhase: 'A mérkőzés utolsó fázisában, ',
          phase: {
            1: 'A játék phase_position fázisában, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> több Várható Veszélyt generált (<b style=\'color:more_color\'>more_xt_team_value xT</b>), mint <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'és ezt hosszabb ideig tette ebben az időszakban (<b style=\'color:more_color\'>more_time_xt_minutes perc</b> vs <b style=\'color:less_color\'>less_time_xt_minutes perc</b> az ellenfél részéről)'
          },
          rivalTeamMoreMinutes: {
            1: 'azonban az ellenfél volt az, aki hosszabb ideig generált veszélyt (<b style=\'color:more_color\'>more_time_xt_minutes perc</b> vs <b style=\'color:less_color\'>less_time_xt_minutes perc</b> az ellenfél részéről) a játék ebben az időszakában'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> volt az a csapat, amely a legtöbb veszélyt teremtette (<b style=\'color:max_color\'>max_xt_team_value xT</b>) a <b style=\'color:max_color\'>max_xt_team_minute\'</b> percben'
          },
          maxXTValueRival: {
            1: ', míg a <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> a legtöbb veszélyt (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) a <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b> percben generálta'
          },
          bothTeamsScoreButDraw: {
            1: 'Mindkét csapatnak sikerült <b>number_of_goals_each_team</b> gólt szereznie. A hazai csapat <b style=\'color:#3366FF\'>home_player_name_goals</b> révén, a vendég csapat pedig <b>away_player_name_goals</b> révén'
          },
          oneTeamTakesTheLead: {
            1: 'Gólok tekintetében <b style=\'color:replace_color\'>goal_scored_team_name</b> <b style=\'color:replace_color\'>difference_number_of_goals</b> különbséggel felülmúlta az ellenfelet, mivel <b style=\'color:replace_color\'>home_player_name_goals</b> gólszerzőként verte meg a kapust'
          }
        }
      },
      step4: {
        table: {
          team: 'Csapat',
          period: 'Időszak',
          possession: 'Birt.',
          ppda: 'PPDA',
          xGOpenPlay: 'xG NJ',
          tooltip: {
            team: 'Csapat',
            period: 'Időszak',
            possession: 'Birtoklás',
            ppda: 'Engedélyezett Passzok Védekező Akciókra',
            xGOpenPlay: 'xG Nyitott Játék'
          }
        },
        text: {
          clearly: 'egyértelműen',
          very: 'nagyon ',
          haveGotText1: 'csak',
          haveGotText2: 'többet kellett volna elérnie, mint',
          gaveUpPoss: 'feladta a birtoklást',
          lostPoss: 'elvesztette a labda birtoklását',
          too: 'túl ',
          possession: {
            1: 'A játék ezen fázisában <b style=\'color:team_color\'>team_name</b> clearly_text kontrollálta a labda birtoklását'
          },
          equalPossession: {
            1: 'A mérkőzés ezen fázisában senki sem dominált, mivel a labdakezelés meglehetősen kiegyensúlyozott volt, bár a számokat nézve <b style=\'color:team_color\'>team_name</b> kissé felülmúlta az ellenfeleit <b style=\'color:team_color\'>possession_value%</b> birtoklással'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b> rossz labdanyomással engedélyezte <b style=\'color:rival_team_color\'>rival_team_name</b> számára, hogy <b style=\'color:target_team_color\'>ppda_value Passzot adjon Védekező Akciókra</b>'
          },
          lowPossessionLowPPDA: {
            1: ', de <b style=\'color:target_team_color\'>target_team_name</b> jól teljesített a labda nyomás alá helyezésében, amikor rival_team_name birtokolta a labdát, <b>PPDA</b> értékkel <b>ppda_value</b>'
          },
          highPossessionLowPPDA: {
            1: ' és képes volt játszani rival_team_name nagyon_textalacsony nyomás intenzitása miatt'
          },
          highPossessionHighPPDA: {
            1: ' bár rival_team_name nyomás intenzitása nagyon_textmagas volt'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> magas birtoklást szerzett, <b>pft_value</b> <b>Passzot adva a Harmadik Harmadban</b> a pályán. '
          },
          highPossessionMidLowPFT: {
            1: 'A magas birtoklástól függetlenül <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b>Passzot adott a Harmadik Harmadban</b>. '
          },
          lowPossessionHighPFT: {
            1: 'Bár <b style=\'color:target_team_color\'>target_team_name</b> possession_text ebben a fázisban, képes volt <b>pft_value</b> <b>Passzot adni a Harmadik Harmadban</b>. '
          },
          midPossessionHighPFT: {
            1: 'A meglehetősen egyenletes birtoklás ebben a fázisban nem akadályozta <b style=\'color:target_team_color\'>target_team_name</b>-t, hogy <b>pft_value</b> <b>Passzot adjon a Harmadik Harmadban</b>. '
          },
          highPFTHighTouchesIOB: {
            1: ' A harmadik harmadban való játék kontrollálása mellett <b style=\'color:target_team_color\'>target_team_name</b> nagy jelenlétet mutatott az ellenfél tizenhatosában is. '
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> kontrollálta a labdát a harmadik harmadban, de nem tudott sok labdát az ellenfél tizenhatosába juttatni'
          },
          highPFTMidTouchesIOB: {
            1: 'A <b>Harmadik Harmadban Passzok</b> számát figyelembe véve <b style=\'color:target_team_color\'>target_team_name</b> több veszélyt kellett volna teremtsen az ellenfél tizenhatosában'
          },
          lowPFTHighTouchesIOB: {
            1: 'Bár <b style=\'color:target_team_color\'>target_team_name</b> nem teljesített sok passzt a harmadik harmadban, képes volt sokszor elérni az ellenfél tizenhatosát. '
          },
          midPFTHighTouchesIOB: {
            1: 'A harmadik harmadban teljesített passzok számát figyelembe véve <b style=\'color:target_team_color\'>target_team_name</b> sokszor elérte az ellenfél tizenhatosát. '
          },
          maxDirectness: {
            1: 'Érdemes kiemelni, hogy ez az a fázis, amikor <b style=\'color:max_dir_color\'>target_team_name</b> offenzívebben játszott <b>Közvetlenség</b> értékkel <b>directness_value</b>. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> képes volt több xG-t generálni, mint a játék más fázisaiban '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> sikerült nagy mennyiségű Várható Gólt generálnia'
          },
          highXG: {
            1: 'jó mennyiségű Várható Gólt generált'
          },
          highXGLowPossession: {
            1: ' annak ellenére, hogy nem volt a labda kontrollja'
          },
          highXGLowShots: {
            1: ' csak néhány lövéssel, <b>xG lövésenként</b> értékkel <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' bár az xG lövésenként túl_textalacsony volt. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> nem volt képes veszélyt generálni az ellenfélnek'
          },
          lowXGMinXG: {
            1: 'Várható Gólok generálása tekintetében ez egy gyenge szakasz volt <b style=\'color:target_team_color\'>target_team_name</b> számára'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> nagyon alacsony mennyiségű Várható Gólt generált'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> nem volt képes jó mennyiségű Várható Gólt generálni'
          },
          lowXGHighPossession: {
            1: ' annak ellenére, hogy volt a labda kontrollja. '
          },
          lowXGHighShots: {
            1: ' annak ellenére, hogy sokszor lőtt'
          },
          lowXGHighPFT: {
            1: ' annak ellenére, hogy <b>pft_value</b> <b>Passzot teljesített a Harmadik Harmadban</b> a pályán. '
          },
          midXGQuintileMinXG: {
            1: 'Bár az xG generálása nem volt rossz, ez volt a leggyengébb fázis a játékban <b style=\'color:target_team_color\'>target_team_name</b> számára ebben a tekintetben'
          },
          midXGQuintileMaxXG: {
            1: 'Ez volt az a fázis, amely során <b style=\'color:target_team_color\'>target_team_name</b> képes volt a legmagasabb <b>xG (xg_value)</b> generálására'
          }
        }
      },
      step5: {
        table: {
          team: 'Csapat',
          period: 'Időszak',
          possession: 'Birt.',
          directness: 'Köz.',
          passesFinalThird: 'PF ⅓',
          tooltip: {
            team: 'Csapat',
            period: 'Időszak',
            possession: 'Birtoklás',
            directness: 'Közvetlenség',
            passesFinalThird: 'Passzok Harmadik Harmadban'
          }
        },
        text: {
          last: 'utolsó',
          goal: 'gól',
          goals: 'gól',
          chance: 'lehetőség',
          chances: 'lehetőség',
          first: 'első',
          homeTeam: 'hazai csapat',
          awayTeam: 'vendég csapat',
          home: 'hazai',
          away: 'vendég',
          clearly: 'egyértelműen',
          slightly: 'kissé',
          firstOrLastPhase: {
            1: 'A játék phase_position fázisában, ',
            2: 'A mérkőzés phase_position időszakában, '
          },
          phase: {
            1: 'A mérkőzés ezen időszaka alatt, '
          },
          bothZeroGoalsScored: {
            1: 'anélkül, hogy bármelyik csapat képes lett volna megváltoztatni az eredményt.'
          },
          equalGoalsScored: {
            1: '<b>number_goals</b> gólt szerezve'
          },
          differentGoalsScored: {
            1: '<b>number_goals</b> gólt szerezve'
          },
          equalPossesion: {
            1: 'mindkét csapat pontosan <b>poss_value%</b> ideig birtokolta a labdát'
          },
          morePossesion: {
            1: '<b style=\'color:more_color\'>more_poss_team_name</b> hosszabb ideig birtokolta a labdát (<b style=\'color:more_color\'>more_poss_team_value%</b> ideig), mint az ellenfele <b style=\'color:less_color\'>less_poss_team_name</b> (<b style=\'color:less_color\'>less_poss_team_value%</b> ideig)'
          },
          equalDirectness: {
            1: 'mindkét csapat ugyanolyan közvetlenséggel játszott (<b>directness_value</b> mindkettőnél)'
          },
          moreDirectnessSameTeam: {
            1: 'ők is vertikálisabbak voltak, mint az ellenfeleik, <b style=\'color:more_color\'>more_dir_team_value</b> közvetlenséggel játszva vs <b style=\'color:less_color\'>less_dir_team_value</b>'
          },
          moreDirectnessDifferentTeam: {
            1: 'azonban a home_away csapat volt az, aki nagyobb közvetlenséggel játszott (<b style=\'color:more_color\'>more_dir_team_value</b>), mint az ellenfél (<b style=\'color:less_color\'>less_dir_team_value</b>)'
          },
          equalChancesCreated: {
            1: 'Mindkét csapat ugyanannyi helyzetet teremtett, pontosan <b>chances_created_value</b> chance_text.'
          },
          moreChancesCreated: {
            1: '<b style=\'color:less_color\'>less_cc_team_name</b> csak <b style=\'color:less_color\'>less_cc_team_value less_chance_text</b> teremtett és adverb_text felülmúlta az ellenfél (<b style=\'color:more_color\'>more_cc_team_value more_chance_text teremtett</b>). '
          },
          equalXA: {
            1: 'Mindkét csapat egyenlő lehetőségekkel rendelkezett, ahogy az <b>xa_value Várható Gólpassz</b> tükrözi, '
          },
          moreXA: {
            1: 'A home_away csapat <b>diff_xa_team_value Várható Gólpasszt</b> generált (<b style=\'color:more_color\'>more_xa_team_value</b> vs <b style=\'color:less_color\'>less_xa_team_value</b>) többet, mint az ellenfél, '
          },
          xAOpenPlay: {
            1: 'illetve <b style=\'color:more_color\'>more_xa_op_value</b> és <b style=\'color:less_color\'>less_xa_op_value xA Nyitott Játék</b> teremtve.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' mindegyik ',
          respectively: ', illetve',
          with: ' (<b style=\'color:replace_color\'>other_player_name</b>-val)',
          playerWas: 'játékos volt',
          playerWere: 'játékosok voltak',
          firstPhase: {
            1: 'A mérkőzés első részében a legfontosabb player_text ',
            2: 'Ami a játék első részét illeti, aki kiemelkedett az '
          },
          otherPhase: {
            1: 'A <b style=\'color:replace_color\'>min_from\'</b> és <b style=\'color:replace_color\'>min_to\'</b> között érdemes megemlíteni '
          },
          lastPhase: {
            1: 'A játék utolsó részében, említésre méltó ',
            2: 'Ami a mérkőzés utolsó fázisát illeti, '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b>, mivel a legtöbb sikeres passzt teljesítette a csapatuk számára, pontosan <b style=\'color:replace_color\'>successfull_passes_value passzt</b> '
          },
          playerMaxTotalPasses: {
            1: 'ami még értékesebbé válik, amikor a számok mutatják, hogy ők is voltak'
          },
          playerMaxTotalPasses2: {
            1: 'with_text a legtöbb passzt megkísérelő játékos (<b style=\'color:replace_color\'>total_passes_value passz</b>). '
          },
          playerNotMaxTotalPasses: {
            1: 'bár ez a játékos nem kísérelte meg a legtöbb passzt (<b style=\'color:replace_color\'>player_name</b> <b style=\'color:replace_color\'>total_passes_value passzal</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: 'ez idő alatt <b style=\'color:replace_color\'>total_passes_value passzt</b> kísérelve meg mindegyik. '
          },
          playerMaxPctPasses: {
            1: 'Ami a <b style=\'color:replace_color\'>% Befejezett Passzok</b> tekintetében, <b style=\'color:replace_color\'>player_name</b> magas <b style=\'color:replace_color\'>max_pct_passes_value%</b>-ot ért el. ',
            2: 'A passz sikerességi arányra hivatkozva érdemes megemlíteni <b style=\'color:replace_color\'>player_name</b>-t <b style=\'color:replace_color\'>max_pct_passes_value%</b> passz sikerességi aránnyal</b>. '
          },
          playerSumTotalXG: {
            1: 'Ebben az időablakban a csapat összesen <b style=\'color:replace_color\'>sum_xg_value xG</b>-t generált, ',
            2: 'Ebben az időszakban <b style=\'color:replace_color\'>team_name</b> <b style=\'color:replace_color\'>xG</b>-t teremtett <b style=\'color:replace_color\'>sum_xg_value</b> értékkel, '
          },
          ZeroSumXG: {
            1: 'Annak ellenére, hogy a teljes csapat összesen <b style=\'color:replace_color\'>all_team_total_passes</b> passzt teljesített, hiábavaló volt, mivel nem sikerült egyetlen helyzetet sem teremteniük. ',
            2: 'Az ebben az időszakban készült <b style=\'color:replace_color\'>all_team_total_passes</b> passz nem generált egyetlen gólszerzési lehetőséget sem. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: '<b style=\'color:replace_color\'>player_xg_name</b> <b style=\'color:replace_color\'>xg_value xG</b>-val és <b style=\'color:replace_color\'>player_xa_name</b> <b style=\'color:replace_color\'>xa_value xA</b>-val voltak a legveszélyesebb játékosok a helyzetek teremtése tekintetében. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: '<b style=\'color:replace_color\'>player_name</b> <b style=\'color:replace_color\'>xg_value xG</b>-val és <b style=\'color:replace_color\'>xa_value xA</b>-val volt a csapatuk helyzeteinek legtöbbjének kezdeményezője. '
          },
          playersMaxXGMaxXA: {
            1: 'köszönhetően többek között <b style=\'color:replace_color\'>players_name</b>-nek, akik <b style=\'color:replace_color\'>xa_value xA</b>-t generáltak kulcs passzaikkal. '
          },
          playerMaxXGZeroXA: {
            1: '<b style=\'color:replace_color\'>player_xg_name</b> <b style=\'color:replace_color\'>xg_value xG</b>-val volt az, aki a helyzetek teljes súlyát viselte, saját magának kellett teremtenie őket, mivel nem kapott kulcs passzokat. '
          },
          playersMaxXGZeroXA: {
            1: '<b style=\'color:replace_color\'>player_xg_name</b> <b style=\'color:replace_color\'>xg_value xG</b>-val volt az, akinek voltak helyzetei, saját magának kellett teremtenie őket, mivel nem kapott kulcs passzokat. '
          },
          oneMaxConnections: {
            1: 'A pár, amely a legtöbb passzt teljesítette egymás között a mérkőzés ezen szakaszában <b style=\'color:replace_color\'>couple_name</b> volt, összesen <b style=\'color:replace_color\'>connections_value passzal</b>. ',
            2: 'A <b style=\'color:replace_color\'>couple_name</b> által alkotott duó <b style=\'color:replace_color\'>connections_value</b> alkalommal cserélte a labdát. ',
            3: 'A <b style=\'color:replace_color\'>couple_name</b> duó volt az, aki a legtöbbet passzolta a labdát a mérkőzés ezen szakaszában, még <b style=\'color:replace_color\'>connections_value</b> alkalommal is. '
          },
          twoMaxConnections: {
            1: 'A <b style=\'color:replace_color\'>couple_name</b> és <b style=\'color:replace_color\'>couple_name2</b> által alkotott két pár volt a legtöbbször ismétlődő kapcsolat ebben az időszakban, <b style=\'color:replace_color\'>connections_value</b> alkalommal passzolva egymásnak a labdát. '
          },
          moreThanTwoMaxConnections: {
            1: 'A játékospárok, mint például <b style=\'color:replace_color\'>couple_name</b>, <b style=\'color:replace_color\'>connections_value passzt</b> teljesítettek egymásnak. '
          },
          oneMinConnections: {
            1: 'Másrészt <b style=\'color:replace_color\'>couple_name</b> volt az, aki a legkevesebbet passzolta egymásnak a labdát, csak <b style=\'color:replace_color\'>connections_value passzt</b>. ',
            2: 'A másik végén a <b style=\'color:replace_color\'>couple_name</b> által alkotott tandem csak <b style=\'color:replace_color\'>connections_value</b> alkalommal kapcsolódott. '
          },
          twoMinConnections: {
            1: 'Másrészt <b style=\'color:replace_color\'>couple_name</b> és <b style=\'color:replace_color\'>couple_name2</b> alig cseréltek passzokat egymás között (<b style=\'color:replace_color\'>connections_value passz</b>). '
          },
          moreThanTwoMinConnections: {
            1: 'Több kombináció nem kapcsolódott elég jól, mint például a <b style=\'color:replace_color\'>couple_name</b> duó, amely <b style=\'color:replace_color\'>connections_value passzal</b> a legkevésbé gyakori kombinációk közé tartozik. '
          }
        }
      },
      step7: {
        ballPossession: 'Labdabirtoklás',
        gamePossessionDist: 'Labdatartás elosztása'
      }
    },
    gamePossessionMap: {
      of: 'a',
      to: 'a',
      and: 'és',
      endsWith: 'Befejeződik',
      time: 'Idő',
      touches: 'Érintések',
      passes: 'Passzok',
      threat: 'Veszély',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Percek',
      duration: 'Időtartam',
      endsGoal: 'Góllal Végződik',
      endsInBox: 'Tizenhatosban Végződik',
      withShot: 'Lövéssel',
      withCross: 'Beadással',
      possession: 'Birtoklás',
      events: 'Események',
      filters: 'Szűrők',
      filtersWarning: 'A veszély csak lövések nélküli birtoklásokra vonatkozik',
      sumWarning: 'A szűrő a sorozatban lévő összes lövés xG összegére vonatkozik, ezért lehet 1-nél nagyobb',
      show: 'Mutatás',
      sequenceNumbers: 'Sorozat Száma',
      jerseyNumbers: 'Mezszám',
      pass: 'Passz',
      carryAndPass: 'Labdavitel és Passz',
      carryAndAction: 'Labdavitel és Akció',
      carryAndShot: 'Labdavitel és Lövés',
      shotFailed: 'Sikertelen Lövés',
      goal: 'Gól',
      savedShot: 'Hárított Lövés',
      missedShot: 'Kihagyott Lövés',
      shotOnPost: 'Lövés a Kapufára',
      headerGoal: 'Fejes Gól',
      headerFailed: 'Sikertelen Fejes',
      failed: 'sikertelen',
      with: '-vel'
    },
    report: {
      title: 'Mérkőzés Jelentés',
      maps: 'Térképek',
      xGRace: 'xG Verseny',
      lineups: 'Felállások',
      button: 'Teljes PDF jelentés generálása a mérkőzésről',
      mobileButton: 'PDF jelentés',
      most: 'Legtöbb',
      topXPlayers: 'Top {x} Játékos',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'Játék fizikai adatok jelentése'
    },
    avgScoreTooltip: 'Perc átlagpontszám',
    status: {
      scheduled: 'Ütemezett',
      postponed: 'Elhalasztva',
      cancelled: 'Törölve',
      inPlay: 'Élő',
      finished: 'Befejezett',
      awarded: 'Díjazva',
      dataAvailable: 'Az adatok a következő órákban lesznek elérhetők'
    },
    preGameAnalysis: {
      showExpectations: 'Mutasd az elvárásokat',
      hideExpectations: 'Elvárások elrejtése',
      goalsPeriods: 'Gólok periódusai',
      synergyIndex: 'Szinergia Index',
      synergyIndexSubtitle: 'A passer-finiser kapcsolat teljes szilárdsága'
    }
  },
  general: {
    1: 'Egy',
    2: 'Kettő',
    3: 'Három',
    4: 'Négy',
    5: 'Öt',
    8: 'Bal',
    9: 'Mindkettő',
    10: 'Jobb',
    create: 'Létrehozás',
    save: 'Mentés',
    cancel: 'Mégse',
    delete: 'Törlés',
    edit: 'Szerkesztés',
    reset: 'Reset',
    go: 'Ugrás',
    formErrors: {
      required: 'A mező kötelező',
      passwordMatch: 'A jelszavak nem egyeznek',
      minLength: 'Minimum hosszúság',
      maxLength: 'Maximum hosszúság',
      emailValid: 'Az e-mail érvényesnek kell lennie',
      youthAge: 'Az életkornak 10 és 23 között kell lennie',
      seasonYear: 'Az évnek 2016 és 2050 között kell lennie',
      integer: 'A tizedes számok nem megengedettek'
    },
    confirmationTitle: 'Biztos vagy benne?',
    confirmationMessage: 'Kérlek erősítsd meg, ha végre szeretnéd hajtani az akciót',
    yes: 'Igen',
    no: 'Nem',
    search: 'Keresés',
    clearFilters: 'Szűrők törlése',
    minimum: 'Minimum',
    maximum: 'Maximum',
    minimumPercent: '(%)Minimum Százalék',
    period: 'Időszak',
    exclude: 'Kizárás',
    team: 'Csapat',
    clear: 'Törlés',
    all: 'Összes',
    ground1: 'Összes',
    ground2: 'Hazai',
    ground3: 'Vendég',
    filter: 'Szűrő',
    noData: 'Nincs találat',
    noDataGivenFilters: 'Nincs találat a megadott szűrőkkel',
    similarityMinutesWarning: 'Nincs adat, mert kevesebb mint 450 perc játszva',
    templateOnlyEditable: 'A sablont csak a következő személy szerkesztheti ',
    close: 'Bezárás',
    load: 'Betöltés',
    filters: 'Szűrők',
    players: 'játékos',
    teams: 'csapat',
    compare: 'Összehasonlítás',
    seeMore: 'Több mutatása',
    seeLess: 'Kevesebb mutatása',
    request: 'Kérés',
    notes: 'Megjegyzések',
    closeSession: 'Kilépés',
    settings: 'Beállítások',
    player: 'Játékos',
    state: 'Állapot',
    updated: 'Frissítve',
    file: 'Fájl',
    uploadFile: 'Fájl feltöltése',
    reports: 'Jelentések',
    download: 'Letöltés',
    new: 'Új',
    comparison: 'Összehasonlítás',
    scout: 'Felderítő',
    favorites: 'Kedvencek',
    moreOptions: 'Több beállítás',
    lessOptions: 'Kevesebb beállítás',
    today: 'Ma',
    home: 'Hazai',
    away: 'Vendég',
    until: 'ig',
    firstHalf: 'Első Félidő',
    secondHalf: 'Második Félidő',
    firstPeriodOT: 'Első F. H.',
    secondPeriodOT: 'Második F. H.',
    postponed: 'Elhalasztva',
    stats: 'Statisztikák',
    yesterday: 'Tegnap',
    last: 'Utolsó',
    startDate: 'Kezdő Dátum',
    active: 'Aktív',
    playerLimit: 'Játékosok Limite',
    type: 'Típus',
    successMessage: 'A művelet sikeres volt',
    failMessage: 'A művelet sikertelen volt',
    by: 'Által',
    checkYourInbox: 'Nézd meg a bejövő üzeneteidet',
    faq: 'Szótár',
    globalSearch: 'Globális Keresés',
    gamesLost: 'Elveszett Mérkőzések',
    outOf: 'ből',
    avgSeason: 'Szezon Átlag',
    leftDays: 'hátralévő nap',
    notifyError: 'Hiba Értesítés',
    notify: 'Értesítés',
    comments: 'Megjegyzések',
    searches: 'Keresések',
    now: 'Most',
    twoHoursAgo: 'Két órája',
    incomings: 'Érkezések',
    departures: 'Távozások',
    transferLoans: 'Kölcsönök',
    transfers: 'Átigazolások',
    movements: 'Mozgások',
    incomes: 'Bevételek',
    expenditures: 'Kiadások',
    action: 'Akció',
    target: 'Cél',
    uses: 'Használat',
    users: 'Felhasználók',
    since: 'óta',
    mediaMode: 'Média Mód',
    white: 'Fehér',
    enabled: 'Engedélyezve',
    disabled: 'Letiltva',
    left: 'Bal',
    right: 'Jobb',
    both: 'Mindkettő',
    'left-both': 'Bal Mindkettő',
    'right-both': 'Jobb Mindkettő',
    'left foot': 'Bal',
    'right foot': 'Jobb',
    files: 'Fájlok',
    confirm: 'Megerősítés',
    currentStep: 'Jelenlegi Lépés',
    phases: 'Fázisok',
    entries: 'Bejegyzések',
    none: 'Nincs',
    times: 'alkalommal',
    darkMode: 'Sötét Mód',
    client: 'Ügyfél',
    visits: 'Látogatások',
    lastVisit: 'Utolsó Látogatás',
    strong: 'Erős',
    medium: 'Közepes',
    weak: 'Gyenge',
    goal: 'Gól',
    list: 'Lista',
    map: 'Térkép',
    copiedToClipboard: 'Vágólapra másolva',
    division: 'Osztály',
    many: 'Sok',
    few: 'Keves',
    median: 'Medián',
    topRight: 'Jobb Felső',
    topLeft: 'Bal Felső',
    bottomRight: 'Jobb Alsó',
    bottomLeft: 'Bal Alsó',
    library: 'Könyvtár',
    mediaLibrary: 'Média Könyvtár',
    for: 'Számára',
    stat: 'Statisztika',
    position: 'Pozíció',
    order: 'Rendezés',
    add: 'Hozzáadás',
    visualization: 'Vizualizáció',
    basic: 'Alap',
    selectAll: 'Összes Kiválasztása',
    unselectAll: 'Összes Kiválasztásának Törlése',
    distribution: 'Eloszlás',
    end: 'Vég',
    accuracy: 'pontosság',
    opponent: 'Ellenfél',
    ownTeam: 'Saját Csapat',
    center: 'Közép',
    line: 'Vonal',
    live: 'Élő',
    unavailable: 'nem elérhető',
    calendar: 'Naptár',
    activeLeague: 'Folyamatban Lévő Liga',
    similarity: 'Hasonlóság',
    emptyForSelectAll: 'Üres az összes kiválasztásához',
    size: 'Méret',
    selectPlayersRestriction: 'Válassz 1 és {x} játékos között',
    group: 'Csoport',
    alerts: 'Értesítések',
    shortcuts: 'Gyorsbillentyűk',
    share: 'Megosztás',
    dataAvailable: 'Az adatok hamarosan elérhetők lesznek',
    someStatsAvailableSoon: 'Néhány statisztika hamarosan elérhető lesz',
    monthGamesWarning: 'A kiválasztott hónap mérkőzései hamarosan elérhetők lesznek',
    metrics: 'Metrikák',
    competition: 'Verseny',
    code: 'Kód',
    alias: 'Álnév',
    never: 'Soha',
    unlimited: 'Korlátlan',
    user: 'Felhasználó',
    warning: 'Figyelem',
    requests: 'Kérések',
    contactSales: 'Lépj Kapcsolatba az Értékesítéssel',
    comingSoon: 'Hamarosan!',
    firstPost: '1. Poszt',
    secondPost: '2. Poszt',
    dZone: 'V Zóna',
    penaltySpot: 'Büntetőpont',
    secondPlay: '2. Játék',
    otherZone: 'Egyéb Zóna',
    baseline: 'Alapvonal',
    youth: 'Ifjúsági',
    male: 'Férfi',
    direct: 'Közvetlen',
    indirect: 'Közvetett',
    processing: 'Feldolgozás',
    addNew: 'Új Hozzáadása',
    createdBy: 'Létrehozta',
    downloading: 'Letöltés',
    displayType: 'Megjelenítési Típus',
    alreadyExists: 'már létezik',
    aggregation: 'Összesítés',
    unavailableLeagues: 'Nincs hozzáférésed egyik ligához sem, amelyben a játékos játszott',
    meters: 'Méter',
    quantity: 'Mennyiség',
    allTime: 'Minden Idő',
    games: 'Mérkőzések',
    unit: 'Egység',
    categories: 'Kategóriák',
    maintenanceWarning: 'Karbantartás folyamatban',
    maintenanceMessage: 'Néhány frissítést végzünk. A jelenlegi változtatások nem lesznek mentve. Köszönjük a türelmedet!',
    seeAll: 'Összes Mutatása',
    from: 'Től',
    to: 'nak',
    showFilters: 'Szűrők megjelenítése',
    hideFilters: 'Szűrők elrejtése',
    horizontal: 'Vízszintes',
    vertical: 'Függőleges',
    drop: 'Csepp',
    orientation: 'Tájolás',
    goalProbability: 'Cél valószínűsége',
    assistProbability: 'Segédvalószínűség',
    attackingDirection: 'Támadó Irány',
    currentTeam: 'Jelenlegi csapat',
    expectations: 'Várakozások',
    sideBySide: 'Egymás mellett',
    teamValue: 'A csapat értéke',
    fieldLayout: 'Mezőelrendezés',
    searchPlaceholder: 'Type {x} letters at least to search',
    crests: 'Címerek',
    pcts: 'PCT-k'
  },
  playerScout: {
    dlabDatabase: 'Driblab Adatbázis',
    league: 'Liga',
    top5: 'Top 5',
    topCountries: 'Országok',
    tier: 'Szint',
    division1: 'Első Osztály',
    division2: 'Második Osztály',
    division3: 'Harmadik Osztály',
    division4: 'Negyedik Osztály',
    division5: 'Ötödik Osztály',
    division6: 'Hatodik osztály',
    summary: 'Összefoglaló',
    offensive: 'Tám',
    defensive: 'Véd',
    gk: 'Kap',
    all: 'Összes',
    physical: 'Fiz',
    arrigo: 'Arrigo',
    yearTooltip: 'Csak egy év engedélyezett',
    expectedThreat: 'xVeszély',
    expectedThreatTooltip: 'Veszély hozzáadva minden birtokláshoz',
    expectedThreatOP: 'xVeszély NJ',
    expectedThreatOPTooltip: 'Veszély hozzáadva Nyitott Játék birtoklásokhoz',
    expectedThreatInTeam: 'xVeszély Csapatban %',
    expectedThreatInTeamTooltip: 'A játékos által a csapathoz hozzáadott veszély százaléka',
    ballProgression: 'Labda Előrehaladás',
    ballProgressionTooltip: '+10 méteres előrehaladások',
    deepProgression: 'Mély Előrehaladások',
    deepProgressionTooltip: 'Labda Előrehaladások az Utolsó Ötödbe',
    ballRetention: '% Labda Megtartás',
    ballRetentionTooltip: 'Azon akciók százaléka, ahol a labda sikeresen megtartásra került',
    ballRetentionOppHalf: '% Labda Megtartás EH',
    ballRetentionOppHalfExplicit: 'Az idő százaléka, amikor birtoklod a labdát és nem veszíted el az ellenfél térfelén',
    finishing: 'Befejezés',
    finishingTooltip: 'Góllal végződő lövések százaléka',
    scoringContribution: 'Gólszerzési Hozzájárulás',
    scoringContributionTooltip: 'Gólpasszok + Gólok',
    xgPerShot: 'xG lövésenként',
    xgPerGoal: 'xG gólonként',
    headerPerCross: 'Fejes beadásonként',
    completedCrosses: 'Befejezett Beadások',
    crossingPct: '% Beadás',
    crossingEfficiency: 'Beadás Hatékonyság',
    crossingEfficiencyTooltip: 'Beadás Hatékonyság (Minőséget és Mennyiséget méri)',
    longBalls: 'Hosszú Labdák',
    longPassing: '% Hosszú Labda',
    dribblingPct: '% Dribling',
    throughBalls: 'Átadások',
    oppBoxTouches: 'Ell. Tizenhatos Érintések',
    oppBoxTouchesTooltip: 'Érintések az Ellenfél Tizenhatosában',
    openPlayKeyPasses: 'NJ Kulcs Passzok',
    openPlayKeyPassesTooltip: 'Nyitott Játék Passzok, amelyek lövésben végződnek',
    xGBuildup: 'xG Felépítés',
    xGBuildupTooltip: 'xG olyan sorozatokban, amelyek lövésben végződnek, ahol a játékos részt vett (kivéve a lövés és kulcs passz xG-jét)',
    Assists: 'Gólpasszok',
    passPercentage: '% Passz',
    passPerLongBall: 'Passz HL-onként',
    passPerLongBallExplicit: 'Passz Hosszú Labdánként',
    nonPenaltyGoals: 'Nem Büntető Gólok',
    xG: 'xG',
    xGExplicit: 'Várható Gólok',
    shots: 'Lövések',
    xGShot: 'xG lövésenként',
    xGChain: 'xG Lánc',
    xGChainTooltip: 'xG olyan sorozatokban, amelyek lövésben végződnek, ahol a játékos részt vett',
    chancesCreated: 'Lövéshez vezető passzok',
    chances: 'Helyzetek',
    dribbles: 'Driblingek',
    dribblesSuccessfull: 'Sikeres Driblingek',
    touches: 'Érintések az Ellenfél Tizenhatosában',
    xA: 'xA',
    xAExplicit: 'Várható Gólpasszok',
    xAOpenPlay: 'xA NJ',
    xAOpenPlayExplicit: 'Várható Gólpasszok Nyitott Játék',
    passesOpponentBox: 'Passzok az Ellenfél Tizenhatosában',
    passesOB: 'Passzok a Tizenhatosban',
    passesFinalThirdTooltip: 'Passzok Harmadik Harmadban',
    passesSuccessful: 'Sikeres Passzok',
    passesSuccessfulTooltip: 'Sikeres Passzok',
    ballProgressionPassing: 'LE Passzolással',
    ballProgressionPassingTooltip: 'Labda Előrehaladás Passzolással',
    ballProgressionDribbling: 'LE Labdavitel',
    ballProgressionDribblingTooltip: 'Labda Előrehaladás Labdavitel',
    passesTotal: 'Passzok',
    passesTotalTooltip: 'Összes Megkísérelt Passz',
    shortPassesSuccessful: 'Sik. RP',
    shortPassesSuccessfulTooltip: 'Befejezett Rövid Passzok Száma',
    shortPassesTotal: 'Összes RP',
    shortPassesTotalTooltip: 'Megkísérelt Rövid Passzok Száma',
    tackles: 'Tackle-ek *',
    adjustedTackles: 'Birtokláshoz Igazított Tackle-ek',
    interceptions: 'Elsodrások *',
    adjustedInterceptions: 'Birtokláshoz Igazított Elsodrások',
    aerials: 'Légi Párbajok',
    aerialsPercent: '% Légi',
    aerialEfficiency: 'Légi Hat.',
    aerialEfficiencyTooltip: 'Légi Hatékonyság (Minőséget és Mennyiséget méri)',
    twd: 'TwD',
    tacklesWasDribbled: 'Megnyert védekező 1 elleni 1 elleni párharcok',
    fouls: 'Szabálytalanságok',
    indPressure: 'Egyéni Nyomás',
    pressure: 'Nyomás',
    dispossessed: 'Labda Elvesztés',
    recoveries: 'Helyreállítások',
    primary: 'Elsődleges',
    secondary: 'Másodlagos',
    position: 'Pozíció',
    nationality: 'Nemzetiség',
    height: 'Magasság (cm)',
    minHeight: 'Min. Magasság',
    maxHeight: 'Max. Magasság',
    age: 'Életkor',
    minAge: 'Min. Életkor',
    maxAge: 'Max. Életkor',
    games: 'Mérkőzések',
    minGames: 'Min. Mérkőzések',
    maxGames: 'Max. Mérkőzések',
    minutes: 'Percek',
    minMinutes: 'Min. Percek',
    maxMinutes: 'Max. Percek',
    minPercentMinutes: 'Min. Százalék Percek',
    dates: 'Dátumok',
    marketValue: '(€) Piaci Érték',
    teams: 'Csapatok',
    contractEnd: 'Szerződés Vége',
    minValue: 'Min. Érték',
    maxValue: 'Max. Érték',
    excludeTeams: 'Csapatok Kizárása',
    recentSearches: 'Legutóbbi keresések',
    saveSearch: 'Keresés mentése',
    loadSearch: 'Keresés betöltése',
    loadCollection: 'Gyűjtemény Betöltése',
    collection: 'Gyűjtemény',
    search: 'Keresés',
    searchesList: 'Keresési listák',
    mySearches: 'Saját kereséseim',
    mySearchesDescription: 'Azok, amelyeket korábban mentettél',
    recentSearchesDescription: 'Az utolsó 10 keresés, amit végeztél',
    searchToLoad: 'Betöltendő keresés',
    recentSearch: 'Legutóbbi keresés',
    saveSearchSuccess: 'Keresés sikeresen mentve',
    removeSearch: 'Keresés törlése',
    removeSearchMessage: 'Biztosan törölni szeretnéd a keresést?',
    updateSearch: 'Frissítse a keresést',
    updateSearchMessage: 'Biztosan frissíteni szeretné a keresést?',
    deleteSearchSuccess: 'Keresés törölve',
    playersFound: 'talált játékos',
    addToCollection: 'Hozzáadás gyűjteményhez',
    npg: 'NPG',
    goals: 'Gólok',
    value: 'Érték',
    nationalTeams: 'Válogatottak',
    gbeScore: 'GBE',
    dlIndex: 'Pontszám',
    minGbe: 'Min. GBE',
    goalsConceded: 'Kapott Gólok',
    npgConceded: 'Kapott NPG',
    npgConcededTooltip: 'Kapott Nem Büntető Gólok',
    xGOTConceded: 'Kapott xG Kapura',
    xGOTConcededTooltip: 'Kapura érkező lövések xG-je',
    goalsPrevented: 'Megelőzött Gólok',
    xGFacedPerShotOnTarget: 'xG Kapura lövésenként',
    xGFacedPerShotOnTargetTooltip: 'Kapura érkező xG kapott lövésenként',
    xGSavedPerxGFacedOnTarget: 'xG Hárítás',
    xGSavedPerxGFacedOnTargetTooltip: 'Hárítás százaléka xG-t figyelembe véve',
    savesPct: '% Hárítás',
    savesOutOfBoxPct: '% Hárítás Tizenhatoson Kívül',
    savesInBoxPct: '% Hárítás Tizenhatosban',
    xGFacedPerGoal: 'Kapott xG gólonként',
    xGFacedPerGoalTooltip: 'Egy gólhoz szükséges xG',
    catchingPct: '% Fogás',
    catchingTooltip: 'Elkapott hárítások százaléka',
    passingOwnHalfPct: '% Passz Saját Térfél',
    passingOwnHalfPctTooltip: 'Sikeres Passzok Százaléka Saját Térfélen',
    passingOppHalfPct: '% Passz Ell. Térfél',
    passingOppHalfPctTooltip: 'Sikeres Passzok Százaléka Ellenfél Térfélen',
    passingContribution: '% Passz Hozzáj.',
    passingContributionTooltip: 'Veszély Hozzájárulása Passzolással - Átlag Felett',
    shotsPerGoal: 'Lövés gólonként',
    passesFinalThird: 'Passzok Harmadik Harmadban',
    passingFinalThird: '% Passz Harmadik Harmadban',
    claimAccuracy: 'Elfoglalás Pontosság',
    claimAccuracyTooltip: 'Átlag Felett Elfoglalt Labdák',
    highTurnovers: 'Magas Labda Elvesztések',
    highTurnoversTooltip: 'Labda elvesztések 40 méternél közelebb a gólhoz',
    shotEndingHighTurnovers: 'Lövés Végződésű ML',
    shotEndingHighTurnoversTooltip: 'Lövésben Végződő Magas Labda Elvesztések',
    goalEndingHighTurnovers: 'Gól Végződésű ML',
    goalEndingHighTurnoversTooltip: 'Gólban Végződő Magas Labda Elvesztések',
    avgCarriesProgress: 'Átlagos Előrehaladás',
    avgCarriesProgressTooltip: 'Átlagos távolság labda függőleges mozgatása (méter)',
    carriesChance: 'Helyzet Végződés',
    carriesChanceTooltip: 'Kulcs Passzhoz vezető Labdavitelek',
    carriesAssist: 'Gólpassz Végződés',
    carriesAssistTooltip: 'Gólpasszhoz vezető Labdavitelek',
    carriesShot: 'Lövés Végződés',
    carriesShotTooltip: 'Lövéshez vezető Labdavitelek',
    carriesGoal: 'Gól Végződés',
    carriesGoalTooltip: 'Gólhoz vezető Labdavitelek',
    shotEndingSequence: 'Lövés Végződés',
    shotEndingSequenceTooltip: 'Lövésben végződő sorozatok száma, ahol a játékos részt vett',
    goalEndingSequence: 'Gól Végződés',
    goalEndingSequenceTooltip: 'Gólban végződő sorozatok száma, ahol a játékos részt vett',
    gbeScoreTooltip: 'FA Labdarúgás Irányító Testület Jóváhagyása',
    goalsPreventedTooltip: 'Kapus által megmentett Nem Büntető Gólok (Kapott xG - Kapott NPG)',
    freePlayers: 'Szabad Játékosok',
    index: 'Index',
    playerName: 'Név',
    teamName: 'Csapat',
    secondPos: 'Második Poz.',
    side: 'Oldal',
    onlyOnLoan: 'Csak kölcsönben',
    dob: 'Születés',
    countryName: 'Ország',
    secondCountryName: 'Második Ország',
    seasonYear: 'Szezon',
    assists: 'Gólpasszok',
    placeholder: 'Kezdheted liga szűrők hozzáadásával',
    placeholder2: 'Kattints a keresés gombra az eredmények megjelenítéséhez',
    passesPct: '% Passzok',
    passingPct: '% Passzok',
    oppBoxPasses: 'Passzok Ell. Tizenhatosban',
    adjustedClearances: 'Igazított Tisztítások',
    aerialsPct: '% Légi',
    leagueCountryCode: 'Liga Ország Kód',
    shooting: '% Kapura Lövések',
    xtPassing: 'xT Passzolás',
    xtPassingTooltip: 'Passzolással hozzáadott veszély',
    xtDribbling: 'xT Labdavitel',
    xtDribblingTooltip: 'Labdavitel által hozzáadott veszély',
    foot: 'Erős Láb',
    aggressiveActions: 'Agresszív Akciók',
    aggressiveActionsTooltip: 'A birtoklás elvesztése után következő két másodpercben megkísérelt tackle-ek száma',
    tacklesAttempted: 'Összes Megkísérelt Tackle',
    highDefensiveActionPct: '% Magas Védő Akciók',
    highDefensiveActionPctTooltip: 'Az ellenfél góljához 40 méternél közelebb végzett védő akciók százaléka',
    individualPressureOppHalf: 'Nyomás Ell. Térfél',
    individualPressureOppHalfTooltip: 'Metrika, amely méri a sikeres erőfeszítések számát (visszanyert birtoklások) amikor a játékos az ellenfél térfelén nyomást gyakorol',
    xGBuildUp5Pass: 'xG Felépítés 5p',
    xGBuildUp5PassTooltip: 'Az xG mennyisége, amelyben a játékos részt vett, csak az utolsó 5 passz (kivéve lövések és lövéshez vezető passzok)',
    chancesCreatedOpenPlay: 'Teremtett Helyzetek NJ',
    chancesCreatedOpenPlayTooltip: 'Nyitott játékban lövéshez vezető passzok száma',
    fmf: {
      Defender: 'Védő',
      aerial: 'Légi',
      goodDefender: 'Jó Védő',
      goodPresence: 'Jó Jelenlét',
      playmaking: 'Játékvezetés',
      Fullback: 'Szélső Védő',
      defensiveness: 'Védekezés',
      offensiveness: 'Támadás',
      fast: 'Gyors',
      Forward: 'Csatár',
      goalChances: 'Gólhelyzetek',
      goodDecissions: 'Jó Döntések',
      individualTechnique: 'Egyéni Technika',
      Goalkeeper: 'Kapus',
      footWork: 'Lábmunka',
      leadership: 'Vezetés',
      Midfielder: 'Védekező Középpályás',
      balance: 'Egyensúly',
      ballRetention: '% Labda Megtartás',
      offensivePasses: 'Támadó Passzok',
      recoveries: 'Helyreállítások',
      shotToGoal: 'Lövés Gólra',
      'Attacking-Midfielder': 'Támadó Középpályás',
      defensiveGame: 'Védekező Játék',
      offensiveGame: 'Támadó Játék',
      Winger: 'Szélső',
      crossing: 'Beadás',
      deepProgressions: 'Mély Előrehaladások',
      defendingEffort: 'Védekezési Erőfeszítés',
      facing: 'Szembenézés'
    },
    yellowCards: 'Sárga Lapok',
    redCards: 'Piros Lapok',
    alert: 'Értesítés',
    yearOfBirth: 'Születési Év',
    minYearOfBirth: 'Min. Születési Év',
    maxYearOfBirth: 'Max. Születési Év',
    women: 'Női',
    continental: 'Kontinentális',
    countryCup: 'Országos Kupa',
    statsName: 'Statisztika név',
    abbreviation: 'Rövidítés',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: 'Csak az utolsó lejátszott alapszakasz látható',
    gamesWith60PlusMinsTooltip: 'A 60 percnél hosszabb játszmák minimális száma',
    starts: 'Indul',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: 'Összehasonlíts legfeljebb 5 játékost',
    requestReport: 'Jelentés kérése',
    searchBarPlaceholder: 'Játékos vagy csapat keresése',
    allStats: 'Összes Statisztika',
    placeholder: 'Kezdheted játékosok hozzáadásával'
  },
  reports: {
    detailedInsights: 'Részletes Elemzések Kérése',
    features: 'A jelentés funkciói',
    performance: 'Teljesítmény',
    evolution: 'Fejlődés',
    compareWithMyTeam: 'Összehasonlítás a csapatommal',
    similarPlayers: 'Hasonló Játékosok',
    potentialTeams: 'Lehetséges Csapatok',
    requestSuccess: 'Kérés sikeresen elküldve',
    requestAt: 'Kérve',
    reportConversation: 'Jelentés Beszélgetés',
    writeYourMessage: 'Írd meg az üzeneted...',
    you: 'Te'
  },
  state: {
    requested: 'Kérve',
    inProgress: 'Folyamatban',
    delivered: 'Kézbesítve'
  },
  langs: {
    es: 'Spanyol',
    en: 'Angol',
    fr: 'Francia',
    de: 'Német',
    it: 'Olasz',
    pt: 'Portugál',
    tr: 'Török',
    jp: 'Japán',
    cn: 'Kínai',
    sa: 'Arab',
    nl: 'Holland',
    pl: 'Lengyel',
    sv: 'svéd',
    cs: 'cseh',
    ko: 'koreai',
    hu: 'Magyar',
    ru: 'Rus',
    se: 'Svéd',
    cze: 'Cseh',
    kor: 'Koreai'
  },
  langsArea: {
    europe: 'Európa',
    asia: 'Ázsia',
    arabic: 'Arab'
  },
  inbox: {
    subtitle: 'Maradj naprakész',
    new_injury_alert: 'Új Sérülés Értesítés',
    new_contract_alert: 'Új Szerződés Értesítés',
    new_team_alert: 'Új Igazolás Értesítés',
    new_marketValue_alert: 'Új Piaci Érték Értesítés',
    new_game_alert: 'Új Játszott Mérkőzés Értesítés',
    receive_mail: 'E-mail Fogadása',
    receive_mail_subtitle: 'Napi E-mail fogadása a szűrőknek megfelelő játékosokkal',
    receive_notifications: 'Értesítések',
    receive_notifications_subtitle: 'Értesítések fogadása az alkalmazásban a szűrőknek megfelelő játékosokkal',
    changedTo: 'Változott',
    alerts: 'Értesítések',
    includedIn: 'Benne',
    noContract: 'Nincs Szerződés',
    newMessages: 'Új Üzenetek',
    reply: {
      reply: 'Válasz',
      replyTitle: 'Visszajelzés az ügyfélnek:',
      replyPlaceholder: 'A felhasználó megkapja a választ az állapot frissítéssel együtt'
    }
  },
  gameAnalysis: {
    subtitle: 'Elemzések a legutóbbi mérkőzésekről',
    subtitle2: 'Mérkőzések megjelenítése a következő hét napban',
    subtitle3: 'Elemzések a legutóbbi mérkőzésekről és a következők felfedezése',
    seeDetail: 'Részletek megtekintése'
  },
  statsNaming: {
    Possession: 'Birtoklás',
    TimePossession: 'Birtoklás Idő',
    PassesPerShots: 'Passzok Lövésenként',
    PPDA: 'PPDA',
    ExpectedPoints: 'Várható Pontok',
    Points: 'Pontok',
    Directness: 'Közvetlenség',
    PassesPerLongBall: 'Passzok Hosszú Labdánként',
    CrossingPerXG: 'Beadások xG-nként',
    PenaltySavedPenaltyFaced: 'Hárított Büntető/Kapott Büntető',
    Goals: 'Gólok',
    PenaltyShots: 'Büntető Lövések',
    PenaltyGoals: 'Büntető Gólok',
    NonPenaltyGoals: 'Nem Büntető Gólok',
    NPGOpenPlay: 'NPG Nyitott Játék',
    NPGSetPiece: 'NPG Rögzített Szituáció',
    Shooting: 'Lövés',
    Finishing: 'Befejezés',
    xGEfficiency: 'xG Hatékonyság',
    HeaderPerShot: 'Fejes Lövésenként',
    HeaderPerCross: 'Fejes Beadásonként',
    HeadedGoals: 'Fejezett gólok',
    GoalsConceded: 'Kapott gólok',
    SavesInBox: 'Dobozba mentve',
    SavesOutBox: 'Elment a dobozból',
    Assists: 'Gólpasszok',
    ThroughBalls: 'Átadások',
    CrossEfficiency: 'Beadás Hatékonyság',
    ScoringContribution: 'Gólszerzési Hozzájárulás',
    xAssistsOpenPlay: 'xGólpasszok Nyitott Játék',
    xAssistsSetPiece: 'xGólpasszok Rögzített Szituáció',
    xAssistsOpenPlayInTeam: 'xGólpasszok Nyitott Játék Csapatban',
    xAssistsSetPieceInTeam: 'xGólpasszok Rögzített Szituáció Csapatban',
    xGBuildupFinalThird: 'xG Felépítés Harmadik Harmadban',
    xGChainFinalThird: 'xG Lánc Harmadik Harmadban',
    BallProgressionPassing: 'Labda Előrehaladás Passzolással',
    BallProgressionDribbling: 'Labda Előrehaladás Labdavitel',
    TacklesWasDribbled: 'Megnyert védekező 1 elleni 1 elleni párharcok',
    TacklesSuccessful: 'Sikeres Tackle-ek',
    Interceptions: 'Elsodrások',
    Clearances: 'Tisztítások',
    Fouls: 'Szabálytalanságok',
    Recoveries: 'Helyreállítások',
    Shots: 'Lövések',
    ShotsPerGoal: 'Lövés Gólonként',
    ShortPassesSuccessful: 'Sikeres Rövid Passzok',
    PassingSuccessForwardPct: '% Passz Sikeresség Előre',
    PassingSuccessBackwardPct: '% Passz Sikeresség Hátra',
    PassingForwardBackwardPct: '% Passz Előre Hátra',
    LongBallPerPassesPct: '% Hosszú Labda Passzok',
    LongBallReceived: 'Fogadott Hosszú Labdák',
    LongBallReceivedOppHalf: 'Fogadott Hosszú Labdák Ell. Térfél',
    OffensiveActions: 'Támadó Akciók',
    DribblesAttempted: 'Megkísérelt Driblingek',
    SuccessfulDribblesPct: '% Sikeres Driblingek',
    OffensiveTouchesOutBoxPct: '% Támadó Érintések Tizenhatoson Kívül',
    BallRetention: '% Labda Megtartás',
    PassingPct: '% Passz',
    PassingOwnHalfPct: '% Passz Saját Térfél',
    PassingOppHalfPct: '% Passz Ell. Térfél',
    PassingFinalThird: 'Passzok Harmadik Harmadba',
    PassesFinalThirdTotal: 'Összes Pass Final ⅓',
    PassingFinalThirdPct: '% Passz Harmadik Harmadba',
    LongBallSuccessful: 'Befejezett Hosszú Labdák',
    LongBallPct: '% Hosszú Labdák',
    LongBallTotal: 'Total Long Balls',
    SavesPct: '% Hárítások',
    SavesInBoxPct: '% Hárítások Tizenhatosban',
    SavesOutOfBoxPct: '% Hárítások Tizenhatoson Kívül',
    xGSavedPerXGFacedOnTarget: 'Mentett xG/Kapott xG Kapura',
    xGFacedOnTargetPerGoalReceived: 'Kapott xG Gólonként',
    xGFacedOnTargetEfficiency: 'Megelőzött Gólok',
    xGFacedOnTarget: 'Kapott xG Kapura',
    IndividualPressure: 'Egyéni Nyomás',
    AerialEfficiency: 'Légi Hatékonyság',
    AerialWins: 'Légi Győzelmek',
    AerialWinsPct: '% Légi Győzelmek',
    xG: 'Várható Gólok',
    xGDiff: 'xG Különbség',
    xGOpenPlay: 'xG Nyitott Játék',
    xGSetPiece: 'xG Rögzített Szituáció',
    xGPerShot: 'xG Lövésenként',
    ChancesCreated: 'Teremtett Helyzetek',
    CompletedCrosses: 'Befejezett Beadások',
    Crossing: '% Beadás',
    OpenPlayKeyPasses: 'Nyitott Játék Kulcs Passzok',
    OpenPlayKeyPassesInTeam: '% Nyitott Játék Kulcs Passzok Csapatban',
    OpenPlayPassesIntoOpponentBox: 'Összes NJ Passz Tizenhatosba',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'NJ Passzok Tizenhatosba',
    xAssists: 'Várható Gólpasszok',
    xGChain: 'xG Lánc',
    xGBuildup: 'xG Felépítés',
    xGBuildupInTeam: 'xG Felépítés Csapatban',
    BallProgression: 'Labda Előrehaladás',
    SuccessfulDribbles: 'Sikeres Driblingek',
    Dispossessed: 'Labda Elvesztés',
    TouchesInOpponentBox: 'Érintések Ellenfél Tizenhatosában',
    xGSavedPerShot: 'Mentett xG Lövésenként',
    BallRetentionOppHalf: '% Labda Megtartás Ell. Térfélen',
    DeepProgression: 'Mély Előrehaladás',
    DeepProgressionFinalThird: 'Mély Előrehaladás Harmadik Harmadba',
    FoulsTaken: 'Kapott Szabálytalanságok',
    PenaltiesTaken: 'Kapott Büntetők',
    BlockedCrosses: 'Blokkolt Beadások',
    BlockedShots: 'Blokkolt Lövések',
    Blocks: 'Blokkok',
    NonPenaltyGoalsAgainst: 'Kapott Nem Büntető Gólok',
    Headers: 'Fejesek',
    AveragePassDistance: 'Átlagos Passz Távolság',
    ProgressiveRuns: 'Előrehaladó Labdavitelek',
    xT: 'Várható Veszély (xT)',
    xTOpenPlay: 'xT Nyitott Játék',
    xTSetPiece: 'xT Rögzített Szituáció',
    xGOT: 'Várható Gólok Kapura',
    BadActions: 'Rossz Akciók',
    BadActionsOwnHalf: 'Rossz Akciók Saját Térfél',
    AerialsWonOwnBox: 'Légi Győzelmek Saját Tizenhatosban',
    AerialsWonOppBox: 'Légi Győzelmek Ell. Tizenhatosban',
    AerialsTotalOppBox: 'Összes Légi Ell. Tizenhatosban',
    AerialsTotalOwnBox: 'Összes Légi Saját Tizenhatosban',
    FoulsOwnHalfPct: '% Szabálytalanságok Saját Térfél',
    RecoveriesOppHalf: 'Helyreállítások Ell. Térfél',
    DuelsPct: '% Sikeres Párbajok',
    TacklesUnsuccessful: 'Sikertelen Tackle-ek',
    TacklesWasDribbledFirstThird: 'Megnyert védekező 1 elleni 1 elleni párharcok⅓',
    TacklesWasDribbledSecondThird: 'Megnyert védekező 1 elleni 1 elleni párharcok ⅔',
    TacklesWasDribbledFinalThird: 'Megnyert védekező 1 elleni 1 elleni párharcok Harmadik Harmadban',
    BallProgressionFinalThird: 'Labda Előrehaladás Harmadik Harmadban',
    DuelsTotal: 'Párbajok',
    QuickRecoveries: 'Gyors Helyreállítások',
    ShotsPerNPG: 'Lövés NPG-nként',
    ShotsOutBox: 'Lövések Tizenhatoson Kívül',
    GoalsOutBox: 'Gólok Tizenhatoson Kívül',
    ShootingOutBox: '% Lövés Tizenhatoson Kívül',
    HandPassing: '% Kéz Passzolás',
    Catching: '% Fogás',
    Caught: 'Caught Saves',
    ClaimAccuracy: 'Elfoglalás Pontosság',
    HighTurnovers: 'Magas Labda Elvesztések',
    ShotEndingHighTurnovers: 'Lövés Végződésű Magas Labda Elvesztések',
    GoalEndingHighTurnovers: 'Gól Végződésű Magas Labda Elvesztések',
    AverageCarriesProgress: 'Átlagos Labdavitel Előrehaladás',
    ChanceEndingCarries: 'Helyzet Végződésű Labdavitelek',
    AssistEndingCarries: 'Gólpassz Végződésű Labdavitelek',
    ShotEndingCarries: 'Lövés Végződésű Labdavitelek',
    GoalEndingCarries: 'Gól Végződésű Labdavitelek',
    ShotEndingSequence: 'Lövés Végződésű Sorozatok',
    GoalEndingSequence: 'Gól Végződésű Sorozatok',
    xGPerNPG: 'xG NPG-nként',
    AerialWonOffensive: 'Légi Győzelmek Támadásban',
    AerialWonDefensive: 'Légi Győzelmek Védekezésben',
    xGAgainst: 'Kapott xG',
    xGDiffAgainst: 'Kapott xG Különbség',
    xGPerNPGAgainst: 'Kapott xG NPG-nként',
    xGSetPieceAgainst: 'Kapott xG Rögzített Szituáció',
    xGOpenPlayAgainst: 'Kapott xG Nyitott Játék',
    xGPerShotAgainst: 'Kapott xG Lövésenként',
    ShotsAgainst: 'Kapott Lövések',
    ShotsOnTargetAgainst: 'Kapott Kapura Lövések',
    ShotsOnTargetInBoxAgainst: 'Lövés a célpontra dobozban Conceded',
    ShotsOnTargetOutBoxAgainst: 'Lövés a célpontra a dobozból kiengedve',
    RivalPossession: 'Ellenfél Birtoklás',
    AerialDefensivePct: '% Légi Védekezés',
    HighRecoveries: 'Magas Helyreállítások',
    HighDefensiveActions: 'Magas Védő Akciók',
    HighDefensiveActionPct: '% Magas Védő Akciók',
    HighDefensiveDistance: 'Magas Védő Távolság',
    PassesPerPossession: 'Passzok Birtoklásonként',
    LengthPerPossession: 'Távolság Birtoklásonként',
    xTNet: 'Nettó xT',
    AvgCarriesDistance: 'Átlagos Labdavitel Távolság',
    PassesForwardPct: '% Passzok Előre',
    PassesForwardSuccessful: 'Sikeres előrepasszok',
    PassesForwardTotal: 'Összes előrepassz',
    TacklesAttempted: 'Megkísérelt Tackle-ek',
    DuelsLost: 'Elvesztett Párbajok',
    Carries: 'Labdavitelek',
    CarriesPct: '% Labdavitelek',
    Aerials: 'Légi Párbajok',
    ProgressivePassesReceivedIntoBox: 'Előrehaladó Passzok Fogadva Tizenhatosba',
    PassesOppHalf: 'Passzok Ell. Térfél',
    ShotsOnTarget: 'Kapura Lövések',
    AggressiveActions: 'Agresszív Akciók',
    Crosses: 'Beadások',
    xGBuildup5pass: 'xG Felépítés 5 passz',
    SpeedSequence: 'Sorozat Sebessége',
    Touches: 'Érintések',
    AerialsTotalOppHalf: 'Összes Légi Ell. Térfél',
    AerialsWonOppHalf: 'Antenna nyert Opp. Fél',
    AerialsWonOppHalfPct: '% Légi Győzelmek Ell. Térfél',
    AerialsPctOppBox: '% Légi Győzelmek Ell. Tizenhatosban',
    AerialsPctOwnBox: '% Légi Győzelmek Saját Tizenhatosban',
    AerialDefensive: 'Légi Védekezés',
    AerialOffensive: 'Légi Támadás',
    AerialOffensivePct: '% Légi Támadás',
    IndividualPressureOppHalf: 'Egyéni Nyomás Ell. Térfél',
    ChancesCreatedOP: 'Teremtett Helyzetek Nyitott Játék',
    TouchesPerShot: 'Érintések Lövésenként',
    PassesFinalThirdTotalPct: '% Passzok Harmadik Harmadban',
    xACrosses: 'xA Beadásokból',
    Passes: 'Passzok',
    PassesSuccessful: 'Sikeres Passzok',
    TacklesWasDribbledFouls: '% Földi Párbajok',
    OffsidesCaught: 'Lesben Fogott',
    ProgressivePassesReceivedFinalThird: 'Előrehaladó Passzok Fogadva Harmadik Harmadban',
    ProgressivePassesReceived: 'Előrehaladó Passzok Fogadva',
    Breadth: 'Szélesség',
    DuelsDefTotal: 'Védő Párbajok',
    DefensiveActions: 'Védő Akciók',
    ProgressivePassesReceivedOppHalf: 'Előrehaladó Passzok Fogadva Ell. Térfél',
    CompletedCrossesOP: 'Befejezett Beadások Nyitott Játék',
    CrossingOP: '% Beadás Nyitott Játék',
    CrossesOP: 'Total Crosses Open Play',
    PassingContribution: '% Passz Hozzájárulás',
    BallProgressionOppHalfInTeam: '% Labda Előrehaladás Ell. Térfél Csapatban',
    PassesOPIntoBoxInTeam: '% Passzok Nyitott Játék Tizenhatosba Csapatban',
    TouchesOppBoxInTeam: '% Érintések Ell. Tizenhatosban Csapatban',
    xGOPInTeam: '% xG Nyitott Játék Csapatban',
    DeepPasses: 'Mély Passzok',
    DeepPassesTotal: 'Deep Pass',
    DefensiveDuelsPct: '% Védő Párbajok',
    DefensiveDistance: 'Védő Távolság',
    QuickRecoveriesPct: '% Gyors Helyreállítások',
    DiffDefensiveDistanceTeam: 'Védő Távolság Különbség Csapat',
    xTPassing: 'xT Passzolás',
    xTPassing100Passes: 'xT Passzolás 100 Passz',
    ProgressivePassesAccurate: 'Előrehaladó Passzok',
    PassAbility: 'Passz Képesség',
    OPPassesIntoOppBoxPct: '% Nyitott Játék Passzok Ell. Tizenhatosba',
    EntriesOppBox: 'Belépések Ell. Tizenhatosba',
    Crosses6yardBox: 'Beadások Hat Yardosba',
    Cutbacks: 'Visszavágások',
    xTDribbling: 'xT Dribling',
    AvgShotDistance: 'Átlagos Lövés Távolság',
    xGOnTarget: 'xG Kapura',
    FinishingxGOT: 'Befejezés xGOT',
    DribblesWonOwnHalf: 'Sikeres Driblingek Saját Térfél',
    DribblesOwnHalf: 'Driblingek Saját Térfél',
    DribblesOwnHalfPct: '% Driblingek Saját Térfél',
    DribblesWonOppHalf: 'Sikeres Driblingek Ell. Térfél',
    DribblesOppHalf: 'Driblingek Ell. Térfél',
    DribblesOppHalfPct: '% Driblingek Ell. Térfél',
    DribblesWonFinalThird: 'Sikeres Driblingek Harmadik Harmadban',
    DribblesFinalThird: 'Driblingek Harmadik Harmadban',
    DribblesFinalThirdPct: '% Driblingek Harmadik Harmadban',
    ShotEndingHighRecoveries: 'Lövés Végződésű Magas Helyreállítások',
    PassingFinalThirdAgainst: 'Kapott Passzok Harmadik Harmadban',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Összes Kapott NJ Passz Tizenhatosba',
    EntriesOppBoxAgainst: 'Kapott Belépések Ell. Tizenhatosba',
    DeepProgressionAgainst: 'Kapott Mély Előrehaladás',
    TouchesInOpponentBoxAgainst: 'Kapott Érintések Ell. Tizenhatosban',
    Score: 'Pontszám',
    PDScore: 'Fizikai Pontszám',
    OrlegiScore: 'Orlegi Pontszám',
    SirScore: 'Sirius Pontszám',
    ExcScore: 'Excelsior Pontszám',
    xTOPInTeam: 'xT NJ Csapatban',
    YellowCards: 'Sárga Lapok',
    RedCards: 'Piros Lapok',
    xTOpenPlayAgainst: 'Kapott xT Nyitott Játék',
    xTSetPieceAgainst: 'Kapott xT Rögzített Szituáció',
    NPGOpenPlayAgainst: 'Kapott NPG Nyitott Játék',
    NPGSetPieceAgainst: 'Kapott NPG Rögzített Szituáció',
    PassesOppHalfPerPossession: 'Passzok Ell. Térfél Birtoklásonként',
    AverageTimeRecovery: 'Átlagos Helyreállítási Idő',
    ExpectedPassing: '% Várható Passz',
    NumPossession10Passes: 'Birtoklások 10 Passz',
    PassesReceived: 'Fogadott Passzok',
    PassesReceivedFinalThird: 'Fogadott Passzok Harmadik Harmadban',
    ProgressivePassesTotalPct: '% Előrehaladó Passzok',
    ShortPassesPct: '% Rövid Passzok',
    TouchesOppBoxOppTeam: 'Érintések Ell. Tizenhatosban Ell. Csapat',
    ShotsOnTargetOppTeam: 'Kapura Lövések Ell. Csapat',
    NPGOppTeam: 'NPG Ell. Csapat',
    ShotsOpenPlay: 'Lövések Nyitott Játék',
    xGSetPiecePerxG: 'xG Rögzített Szituáció xG-nként',
    ShotsOpenPlayAgainst: 'Kapott Lövések Nyitott Játék',
    ShotsFromDribble: 'Lövések Csel után',
    GoalsFromDribble: 'Gólok Csel után',
    PassesIntoFinalThird: 'Passzok a Támadó Harmadba',
    PassesIntoFinalThirdTotal: 'Összes továbbjutás az utolsó harmadba',
    PassesInsideFinalThird: 'Passzok a Támadó Harmadon Belül',
    PassesInsideFinalThirdTotal: 'Összes passz a döntőn belül ⅓',
    PassesFinalThirdNoArea: 'Passzol az utolsó harmadon (W/O Box)',
    PassesIntoOppBox: 'Passzok az Ellenfél Tizenhatosába',
    CarriesFinalThird: 'Labdavezetések a Támadó Harmadba',
    CarriesInsideFinalThird: 'Labdavezetések a Támadó Harmadon Belül',
    CarriesFinalThirdNoBox: 'Utolsó harmadot hordoz (W/O Box)',
    CarriesIntoOppBox: 'Labdavezetések az Ellenfél Tizenhatosába',
    TimePossessionAgainst: 'Ellenfél Labdabirtoklása',
    TimePossessionTotal: 'Teljes Labdabirtoklás',
    PassesInBox: 'Passzok a Saját Tizenhatoson Belül',
    LongThrowInSuccessful: 'Sikeres Hosszú Bedobás',
    LongThrowInTotal: 'Összes Hosszú Bedobás',
    LongThrowInPct: 'Sikeres Hosszú Bedobások Százaléka',
    Games: 'Játszott játékok',
    PointsPerGame: 'Pontok játékonként',
    ExpectedPointsDiff: 'Várható pontkülönbség',
    PassesTotalOwnHalf: 'Összesen saját félidőt passzol',
    PassesOwnHalf: 'Passzolja a saját felét',
    PassesTotalOppHalf: 'Passzolja a Total Opp Félidőt',
    ProgressivePassesTotal: 'Összes progresszív passzok',
    DuelsWon: 'Nyert párbaj',
    NonPenaltySaves: 'Nem büntető megtakarítások',
    BadActionsOppHalf: 'Rossz akciók Opp Half',
    CarriesSuccessful: 'Sikeresen hordoz',
    ShotsOnTargetOutBox: 'Célba lőtt lövések a dobozból',
    TotalDistance: 'Összes Távolság',
    DistanceIP: 'Távolság TIP',
    DistanceOOP: 'Távolság OTIP',
    SprintsNumber: 'Sprint Mennyiség',
    SprintsDistance: 'Sprint Távolság',
    WalkingDistance: 'Sétálás Távolság',
    JoggingDistance: 'Kocogás Távolság',
    RunningDistance: 'Futás Távolság',
    ExtremeAccelerations: 'Extrém Gyorsulások',
    NumberOfRuns: 'Futás Mennyiség',
    HsrNumber: 'HSR Mennyiség',
    HsrDistance: 'HSR Távolság',
    SprintNumberDeclinePct: '% Sprint Mennyiség Csökkenés',
    SprintDistanceDeclinePct: '% Sprint Távolság Csökkenés',
    SprintNumberDecline: 'Sprint Mennyiség Csökkenés',
    SprintDistanceDecline: 'Sprint Távolság Csökkenés',
    HsrDistancePct: '% HSR Távolság',
    SprintDistancePct: '% Sprint Távolság',
    Accelerations: 'Gyorsulások',
    ExplosiveDistance: 'Robbanásos Távolság',
    MaxSpeed: 'Max. Sebesség',
    AvgMaxSpeed: 'Átlagos Max. Sebesség',
    MaxAccelerations: 'Max. Gyorsulások',
    BypassedPlayersByPasses: 'Megkerült Játékosok Passzokkal',
    BypassedDefendersByPasses: 'Megkerült Védők Passzokkal',
    PassesBypassingPlayers: 'Játékosokat Megkerülő Passzok',
    PassesBypassingDefenders: 'Védőket Megkerülő Passzok',
    BypassedPlayersPerPass: 'Megkerült Játékosok Passzonként',
    BypassedDefendersPerPass: 'Megkerült Védők Passzonként',
    LineBreakingPasses: 'Vonalat Átszakító Passzok',
    LineBreakingPassesMD: 'Vonalat Átszakító Passzok MD',
    LineBreakingPassesM: 'Vonalat Átszakító Passzok M',
    LineBreakingThroughBalls: 'Vonalat Átszakító Átadások',
    LineBreakingPassesPerPass: '% Vonalat Átszakító Passzok Passzonként',
    TotalPassesUnderStrongPressure: 'Összes Passz Erős Nyomás Alatt',
    TotalPassesUnderLightPressure: 'Összes Passz Nyomás Alatt',
    SuccessfulPassesUnderStrongPressure: 'Sikeres Passzok Erős Nyomás Alatt',
    SuccessfulPassesUnderLightPressure: 'Sikeres Passzok Nyomás Alatt',
    PassingUnderStrongPressure: '% Passzolás Erős Nyomás Alatt',
    PassingUnderLightPressure: '% Passzolás Nyomás Alatt',
    PassReceiptsInSpaceCompleted: 'Befejezett Passz Fogadások Térben',
    PassReceiptsInSpace: 'Passz Fogadások Térben',
    PassReceiptsInSpaceCompletedFirstThird: 'Labdaátvétel Térben - Első Harmad',
    PassReceiptsInSpaceCompletedSecondThird: 'Labdaátvétel Térben - Második Harmad',
    PassReceiptsInSpaceCompletedFinalThird: 'Labdaátvétel Térben - Támadó Harmad',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Térben Átvett Passz - Ellenfél Jobb Oldal',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Térben Átvett Passz - Ellenfél Közép',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Térben Átvett Passz - Ellenfél Bal Oldal',
    PassReceiptsInSpaceFirstThird: 'Átvett Passz Térben - Első Harmad',
    PassReceiptsInSpaceSecondThird: 'Átvett Passz Térben - Második Harmad',
    PassReceiptsInSpaceFinalThird: 'Átvett Passz Térben - Támadó Harmad',
    PassReceiptsInSpaceOppHalfRight: 'Átvett Passz - Ellenfél Jobb Oldal',
    PassReceiptsInSpaceOppHalfCenter: 'Átvett Passz - Ellenfél Közép',
    PassReceiptsInSpaceOppHalfLeft: 'Átvett Passz - Ellenfél Bal Oldal',
    TotalStrongOnBallPressures: 'Összes Erős Labdanyomás',
    TotalLightOnBallPressures: 'Összes Labdanyomás',
    SuccessfulStrongOnBallPressures: 'Sikeres Erős Labdanyomások',
    SuccessfulLightOnBallPressures: 'Sikeres Labdanyomások',
    StrongOnBallPressuresPct: '% Erős Labdanyomások',
    LightOnBallPressuresPct: '% Labdanyomások',
    TimesBypassedByPasses: 'Megkerülve Passzokkal',
    TimesBypassedByCarries: 'Megkerülve Labdavitelekkel',
    TimesBypassedByActions: 'Megkerülve Akciókkal',
    BypassedPlayersByCarries: 'Megkerült Játékosok Labdavitelekkel',
    BypassedDefendersByCarries: 'Megkerült Védők Labdavitelekkel',
    BypassedPlayersByActions: 'Megkerült Játékosok Akciókkal',
    BypassedDefendersByActions: 'Megkerült Védők Akciókkal',
    CarriesBypassingPlayers: 'Játékosokat Megkerülő Labdavitelek',
    CarriesBypassingDefenders: 'Védőket Megkerülő Labdavitelek',
    BypassedPlayersPerCarry: 'Megkerült Játékosok Labdavitelenként',
    BypassedDefendersPerCarry: 'Megkerült Védők Labdavitelenként',
    LineBreakingCarries: 'Vonalat Átszakító Labdavitelek',
    LineBreakingCarriesMD: 'Vonalat Átszakító Labdavitelek MD',
    LineBreakingCarriesM: 'Vonalat Átszakító Labdavitelek M',
    LineBreakingCarriesD: 'Vonalat Átszakító Labdavitelek D',
    LineBreakingCarriesPerCarry: '% Vonalat Átszakító Labdavitelek Labdavitelenként',
    LineBreakingActions: 'Vonalat Átszakító Akciók',
    LineBreakingActionsMD: 'Vonalat Átszakító Akciók MD',
    LineBreakingActionsM: 'Vonalat Átszakító Akciók M',
    LineBreakingActionsD: 'Vonalat Átszakító Akciók D',
    PassesPerLineBreakingPass: 'Passzok Vonalat Átszakító Passzonként',
    CarriesPerLineBreakingCarry: 'Labdavitelek Vonalat Átszakító Labdavitelenként',
    LinesBrokenByPasses: 'Átszakított Vonalak Passzokkal',
    LinesBrokenByCarries: 'Átszakított Vonalak Labdavitelekkel',
    LinesBrokenByActions: 'Átszakított Vonalak Akciókkal',
    LinesBrokenPerPass: 'Átszakított Vonalak Passzonként',
    LinesBrokenPerCarry: 'Átszakított Vonalak Labdavitelenként',
    AvgLastDefenderDistanceIP: 'Utolsó Védő Távolság IP',
    AvgLastDefenderDistanceOOP: 'Utolsó Védő Távolság OOP',
    AvgDefensiveLineDistanceIP: 'Védő Vonal Távolság IP',
    AvgDefensiveLineDistanceOOP: 'Védő Vonal Távolság OOP',
    AvgRBDistanceIP: 'Jobb Szélső Védő Távolság IP',
    AvgRBDistanceOOP: 'Jobb Szélső Védő Távolság OOP',
    AvgLBDistanceIP: 'Bal Szélső Védő Távolság IP',
    AvgLBDistanceOOP: 'Bal Szélső Védő Távolság OOP',
    AvgBlockDistanceIP: 'Blokk Távolság IP',
    AvgBlockDistanceOOP: 'Blokk Távolság OOP',
    AvgBlockAreaIP: 'Blokk Terület IP',
    AvgBlockAreaOOP: 'Blokk Terület OOP',
    AvgDefensiveLineWidthOOP: 'Védő Vonal Szélesség OOP',
    AvgOffensiveLineLastThirdWidthIP: 'Támadó Vonal Utolsó Harmad Szélesség IP',
    AvgLByIP: 'Bal Szélső Védő Pozíció IP',
    AvgRByIP: 'Jobb Szélső Védő Pozíció IP',
    AvgOffensiveLineDistanceIP: 'Támadó Vonal Távolság IP',
    AvgOffensiveLineLastThirdDistanceIP: 'Támadó Vonal Utolsó Harmad Távolság IP',
    AvgOffensiveLineWidthIP: 'Támadó Vonal Szélesség IP',
    OffBallRuns: 'Összes Labda Nélküli Futás',
    OffBallRunsOverlap: 'Labda Nélküli Futások Átfedés',
    OffBallRunsUnderlap: 'Labda Nélküli Futások Alul Átfedés',
    OffBallRunsRunAhead: 'Labda Nélküli Futások Előre',
    OffBallRunsRunBehind: 'Labda Nélküli Futások Hátra',
    OffBallRunsCrossReceiver: 'Labda Nélküli Futások Beadás Fogadó',
    OffBallRunsSupport: 'Labda Nélküli Futások Támogatás',
    OffBallRunsComingShort: 'Labda Nélküli Futások Rövid',
    description: {
      Possession: 'A csapat labda birtoklásának százaléka',
      TimePossession: 'A csapat labda birtoklásának ideje',
      PassesPerShots: 'Átlagos passzok száma lövésenként',
      PPDA: 'Engedélyezett Passzok Védekező Akciókra. A PPDA méri a nyomást, amit a csapat az ellenfél játékosaira gyakorol, amikor birtokukban van a labda. Az érték megfelel az átlagos passzok számának, amelyet az ellenfél sorban képes volt teljesíteni megszakítás előtt. Minél magasabb az érték, annál több passzt engedélyezett az ellenfélnek',
      Directness: 'Méri, mennyire közvetlen egy csapat. A közvetlenség magas értéke nagyobb mennyiségű előre irányuló passzokhoz kapcsolódik az oldalirányú passzokhoz képest',
      ExpectedPoints: 'Egy csapat által várható pontok száma, a generált és engedélyezett Várható Gólok alapján számítva. Ez a metrika lehetővé teszi, hogy jobban értékeljük egy csapat teljesítményét egy mérkőzésen (vagy mérkőzések során) az ténylegesen elért pontok számához képest',
      PassesPerLongBall: 'Sikeres hosszú passzok százaléka az összes befejezett passzból',
      CrossingPerXG: 'Beadásokból származó Várható Gólok százaléka',
      PenaltySavedPenaltyFaced: 'Hárított Büntető Lövések százaléka az összes Kapott Büntető Lövésből',
      Goals: 'szerzett gólok száma',
      PenaltyShots: 'Büntetőrúgásokból készült összes lövés száma',
      PenaltyGoals: 'Büntetőrúgásokból szerzett összes gól száma',
      NonPenaltyGoals: 'szerzett gólok száma büntető gólok nélkül',
      NPGOpenPlay: 'szerzett gólok száma nyitott játék akciókkal büntető gólok nélkül',
      NPGSetPiece: 'szerzett gólok száma rögzített szituáció akciókkal büntető gólok nélkül',
      Shooting: 'Kapura lövések százaléka',
      Finishing: 'Góllal végződő lövések százaléka',
      xGEfficiency: 'Egy játékos számára szükséges várható gólok mennyisége egy gól eléréséhez',
      HeaderPerShot: 'készült fejesek száma',
      HeaderPerCross: 'A játékos által fejelt beadások százaléka a csapat által befejezett összes beadásból',
      Assists: 'készült gólpasszok száma',
      ThroughBalls: 'átadott labdák száma támadó futást végző játékosnak gólhelyzet teremtéséhez',
      CrossEfficiency: 'Metrika, amely kombinálja a sikeres beadások százalékát a készült sikeres beadások mennyiségével',
      ScoringContribution: 'készült gólpasszok és gólok száma',
      xAssistsOpenPlay: 'generált várható gólpasszok száma nyitott játékból',
      xAssistsSetPiece: 'generált várható gólpasszok száma rögzített szituációból',
      xAssistsOpenPlayInTeam: 'Nyitott játékból generált várható gólpasszok száma csapatban',
      xAssistsSetPieceInTeam: 'Rögzített szituációból generált várható gólpasszok száma csapatban',
      xGChainFinalThird: 'A harmadik harmadban részt vett xG mennyisége',
      xGBuildupFinalThird: 'A harmadik harmadban részt vett xG mennyisége (kivéve lövések és lövéshez vezető passzok)',
      BallProgressionPassing: 'A játékos által passzolással 10 méter vagy több előrehaladás alkalmainak száma',
      BallProgressionDribbling: 'A játékos által labdavitel 10 méter vagy több előrehaladás alkalmainak száma',
      TacklesWasDribbled: 'Metrika, amely figyelembe veszi a játékos által tackle-en keresztül visszanyert labdák százalékát a passzolt/futott alkalmakkal szemben. Minél magasabb az indikátor, annál jobb',
      TacklesSuccessful: 'A játékos által végzett sikeres tackle-ek száma',
      Interceptions: 'a játékos által elsodrott passzok száma, hogy megakadályozza a labda célba érkezését',
      Clearances: 'a játékos által védő zónából tisztított labdák száma',
      Fouls: 'a játékos által elkövetett szabálytalanságok száma',
      Recoveries: 'egy játékos által visszanyert labdák száma',
      Shots: 'készült összes lövés száma',
      ShotsPerGoal: 'Kapura lövések száma egy nem büntető gól eléréséhez a kapushoz',
      ShortPassesSuccessful: 'befejezett rövid passzok (12 méter alatt)',
      PassingSuccessForwardPct: 'Sikeres passzok százaléka előre irányban',
      PassingSuccessBackwardPct: 'Sikeres passzok százaléka hátra',
      PassingForwardBackwardPct: 'Előre irányú passzok aránya a hátra irányú passzokkal szemben',
      LongBallPerPassesPct: 'Befejezett hosszú passzok százaléka (>32 méter) a játékos által befejezett összes passzból.',
      LongBallReceived: 'A játékos által fogadott hosszú passzok (>32 méter)',
      LongBallReceivedOppHalf: 'A játékos által ellenfél térfélen fogadott hosszú passzok (>32 méter)',
      OffensiveActions: 'Támadó Akciók',
      DribblesAttempted: 'megkísérelt driblingek száma',
      SuccessfulDribblesPct: 'Sikeres driblingek/összes dribling kísérlet',
      OffensiveTouchesOutBoxPct: '% Támadó Érintések Tizenhatoson Kívül',
      BallRetention: 'Az idő százaléka, amikor birtoklod a labdát és nem veszíted el',
      PassingPct: 'Befejezett passzok százaléka a játékos által adott összes passzból',
      PassingOwnHalfPct: 'Befejezett passzok százaléka a játékos által adott összes passzból (csak saját térfélen lévő passzok)',
      PassingOppHalfPct: 'Befejezett passzok százaléka a játékos által adott összes passzból (csak ellenfél térfélen lévő passzok)',
      PassingFinalThird: 'a harmadik harmadba sikeres passzok',
      PassesFinalThirdTotal: 'Az utolsó harmadban végződő passzkísérletek száma, keresztrúgások, szettlabdák, szögletek és bedobások nélkül',
      PassingFinalThirdPct: 'Befejezett passzok százaléka a játékos által adott összes passzból (csak harmadik harmadba lévő passzok)',
      LongBallSuccessful: '32 méter felett befejezett passzok',
      LongBallPct: '32 méter felett befejezett passzok/ 32 méter felett megkísérelt összes passz.',
      LongBallTotal: '32 méter feletti áthaladások teljes száma',
      SavesPct: 'Hárítások százaléka az összes kapott lövésből',
      SavesInBoxPct: 'Mentett lövések százaléka, amelyek tizenhatosban érkeztek',
      SavesOutOfBoxPct: 'Mentett lövések százaléka, amelyek tizenhatoson kívül érkeztek',
      xGSavedPerXGFacedOnTarget: 'Együttható, amely a kapus által mentett várható xG százalékát jelzi. Az 1 érték ebben a metrikában azt jelentené, hogy a kapus minden várható gólt megment a csapat által engedélyezett lövésekből, míg a 0 érték azt jelentené, hogy az ellenfél által generált összes várható gól gólba kerül',
      xGFacedOnTargetPerGoalReceived: 'Metrika, amely jelzi, hány Várható Gólra van szükség egy gól eléréséhez egy bizonyos kapushoz. Magas érték ebben a metrikában azt jelenti, hogy egy gól eléréséhez ehhez a kapushoz nagy mennyiségű xG-t kell generálni',
      xGFacedOnTargetEfficiency: 'A kapus által megelőzött Nem Büntető Gólok száma. Ez a kapus által kapott Várható Gólok Kapura száma mínusz az engedélyezett (nem büntető) gólok száma. Jelzi az ellenfél által nem szerzett gólok számát a kapusnak köszönhetően',
      xGFacedOnTarget: 'A kapus által kapott összes xG (mentett és szerzett)',
      IndividualPressure: 'Metrika, amely méri a sikeres erőfeszítések számát (visszanyert birtoklások) amikor a játékos az ellenfelet nyomja',
      AerialEfficiency: 'Metrika, amely kombinálja a sikeres légi párbajok százalékát a légi párbaj győzelmek mennyiségével',
      AerialWins: 'a játékos által megnyert légi párbajok száma',
      AerialWinsPct: 'A játékos által megnyert légi párbajok száma az összes légi párbajból, ahol a játékos részt vett',
      xG: 'generált Várható Gólok. Ez a metrika méri egy lövés gólba végződésének valószínűségét különböző változók alapján (távolság, szög, játék típusa, testrész, ...) az ilyen akció.',
      xGDiff: 'Különbség xG és Gólok között',
      xGOpenPlay: 'Nyitott Játék által generált Várható Gólok',
      xGSetPiece: 'Rögzített Szituáció által generált Várható Gólok',
      xGPerShot: 'Egy játékos által készült lövések átlagos xG-je. Ez a metrika méri a készült lövések átlagos veszélyességét. Minél magasabb, annál valószínűbb, hogy a lövéseid gólba kerülnek. Magas xG lövésenként azt jelenti, hogy a játékos jól választja a lövéseit.',
      ChancesCreated: 'Lövéshez vezető passzok száma',
      CompletedCrosses: 'befejezett beadások száma',
      Crossing: 'Befejezett beadások százaléka a megkísérelt beadásokból',
      OpenPlayKeyPasses: 'nyitott játékban befejezett passzok száma',
      OpenPlayKeyPassesInTeam: 'Nyitott játékban befejezett passzok százaléka csapatban',
      OpenPlayPassesIntoOpponentBox: 'nyitott játékban ellenfél tizenhatosba megkísérelt passzok összes száma',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'nyitott játékban ellenfél tizenhatosba befejezett passzok száma',
      xAssists: 'Metrika, amely elemzi egy mérkőzésen létrejött helyzetek minőségét. Minden lövéshez vezető gólpassz értéke a lövés gólba kerülésének valószínűségén alapul. Ez az érték a passz helye, típusa (beadás átadás rögzített szituáció…), játék állapota stb. szerint van hozzárendelve. Az xG-től eltérően az xA egy metrika, amely ideálisan magasabb lenne egy játékosnál, mint a gólpassz száma, mivel egy alkotó csak a minőségi passzait (xA) tudja irányítani, míg a gólpassz száma a befejezőtől függ',
      xGChain: 'Egy játékos által részt vett xG mennyisége',
      xGBuildup: 'Hasonló az xG Lánchoz, de nem veszi figyelembe a sorozat utolsó 2 játékosát (kivéve lövések és lövéshez vezető passzok)',
      xGBuildupInTeam: 'Hasonló az xG Lánchoz, de nem veszi figyelembe a sorozat utolsó 2 játékosát (kivéve lövések és lövéshez vezető passzok) csapatban',
      BallProgression: 'A játékos által 10 méter vagy több előrehaladás alkalmainak száma akár passzolással, akár labdavitel, akár mindkettő kombinációjával',
      SuccessfulDribbles: 'sikeresen befejezett driblingek száma',
      Dispossessed: 'egy játékos tackle-elés és labda elvesztés alkalmainak száma',
      TouchesInOpponentBox: 'a labda birtoklásának alkalmainak száma az ellenfél tizenhatosában',
      xGSavedPerShot: 'Kapott kapura lövések átlagos gól valószínűsége',
      BallRetentionOppHalf: 'Az idő százaléka, amikor birtoklod a labdát és nem veszíted el az ellenfél térfelén',
      DeepProgression: 'A pálya utolsó ötödéhez labdavitel által elért alkalmak száma, plusz a labda birtoklásának alkalmainak száma az utolsó ötödben',
      DeepProgressionFinalThird: 'A pálya harmadik harmadához labdavitel által elért alkalmak száma, plusz a labda birtoklásának alkalmainak száma a harmadik harmadban',
      FoulsTaken: 'a játékos által kapott szabálytalanságok száma',
      PenaltiesTaken: 'a játékos által ellenfél tizenhatosban kapott szabálytalanságok száma',
      BlockedCrosses: 'blokkolt beadások száma',
      BlockedShots: 'blokkolt lövések száma',
      NonPenaltyGoalsAgainst: 'engedélyezett nem büntető gólok száma',
      GoalsConceded: 'játékpercenként kapott gólok száma',
      Headers: 'Fejjel készült lövések száma',
      HeadedGoals: 'Fejjel szerzett gólok száma',
      Points: 'A csapat által elért pontok száma',
      SavesInBox: 'A tizenhatoson belüli lövésekből származó védések száma',
      SavesOutBox: 'A tizenhatoson kívüli lövésekből származó védések száma',
      ShotsOnTargetInBoxAgainst: 'A tizenhatoson belülről kapura kapott lövések száma',
      ShotsOnTargetOutBoxAgainst: 'A tizenhatoson kívülről kapura kapott lövések száma',
      AveragePassDistance: 'Passzok átlagos távolsága méterben',
      ProgressiveRuns: 'Sikeres labdavitelek, amelyek a birtoklást 20%-kal közelebb hozzák az ellenfél góljához',
      xT: 'Várható Veszély (xT) egy metrika, amely méri a játékos által az ellenfélnek teremtett veszélyt labdavitel vagy passzolás által olyan területekre, ahol a birtoklás gólba végződésének valószínűsége magasabb.',
      xTOpenPlay: 'nyitott játékban generált Várható Veszély',
      xTSetPiece: 'rögzített szituációból generált Várható Veszély',
      xGOT: 'Várható Gólok Kapura. A kapus által kapott Várható Gólok száma. Ez a metrika csak a kapura érkező lövéseket veszi figyelembe (A kihagyott lövések és a kapufára érkező lövések kizárva)',
      BadActions: 'Összes elkövetett rossz akció összege (sikertelen passz, sikertelen megkísérelt dribling, labda elvesztés, les passz, sikertelen labda érintés)',
      BadActionsOwnHalf: 'Saját térfélen elkövetett összes rossz akció összege (sikertelen passz, sikertelen megkísérelt dribling, labda elvesztés, les passz, sikertelen labda érintés)',
      AerialsWonOwnBox: 'Légi Párbaj Győzelmek Saját Tizenhatosban',
      AerialsWonOppBox: 'Légi Párbaj Győzelmek Ell. Tizenhatosban',
      AerialsTotalOppBox: 'Összes Légi Párbaj Ell. Tizenhatosban',
      AerialsTotalOwnBox: 'Összes Légi Párbaj Saját Tizenhatosban',
      FoulsOwnHalfPct: 'Saját térfélen elkövetett Szabálytalanságok százaléka',
      RecoveriesOppHalf: 'egy játékos által ellenfél térfélen visszanyert labdák száma',
      DuelsPct: 'Sikeres Párbajok százaléka',
      TacklesUnsuccessful: 'Alkalmak száma, amikor egy játékos nem sikerül megnyernie a labdát, mivel az ellenfél sikeresen driblingel el mellette',
      TacklesWasDribbledFirstThird: 'A játékos által visszanyert labdák százaléka, amikor a harmadik harmadban szembesül',
      TacklesWasDribbledSecondThird: 'Megnyert védekező 1 elleni 1 elleni párharcok ⅔',
      TacklesWasDribbledFinalThird: 'Megnyert védekező 1 elleni 1 elleni párharcok Harmadik Harmadban',
      BallProgressionFinalThird: 'Labda Előrehaladás Harmadik Harmadban',
      DuelsTotal: 'elkövetett Tackle-ek, Légi Párbajok, Labda Érintések, Driblingek és Szabálytalanságok összes száma',
      QuickRecoveries: '40 méter vagy több távolságra a saját góltól történt helyreállítások 8 másodperccel a labda birtoklásának elvesztése után',
      ShotsPerNPG: 'Átlagos lövések száma egy Nem Büntető Gól eléréséhez',
      ShotsOutBox: 'tizenhatoson kívülről készült lövések száma',
      GoalsOutBox: 'tizenhatoson kívülről szerzett gólok száma',
      ShootingOutBox: 'Tizenhatoson kívülről készült kapura lövések százaléka',
      HandPassing: 'Kéz Passzolás Pontosság',
      Catching: 'Hárítások százaléka, amelyekben a kapus elkapja a labdát',
      Caught: 'Ment, ahol a kapus elkapja és tartja a labdát, megakadályozva a második játékot',
      ClaimAccuracy: 'Méri, mennyire jó egy kapus a légi labdák elkapásában/blokkolásában. Az 1 feletti szám azt jelzi, hogy a kapus több légi labdát kap el, mint várható',
      HighTurnovers: 'Labda elvesztések 40 méternél közelebb a saját góltól',
      ShotEndingHighTurnovers: 'Magas labda elvesztések (40 méternél közelebb a saját góltól) lövésben végződve az ellenfél csapat részéről',
      GoalEndingHighTurnovers: 'Magas labda elvesztések (40 méternél közelebb a saját góltól) gólban végződve az ellenfél csapat részéről',
      AverageCarriesProgress: 'Átlagos távolság, amit egy játékos függőlegesen mozgat a labdát labdavitelenként (méter)',
      ChanceEndingCarries: 'Legalább 7 méteres labdavitelek, amelyek passzban végződnek, amit lövés követ',
      AssistEndingCarries: 'Legalább 7 méteres labdavitelek, amelyek passzban végződnek, amit gól követ',
      ShotEndingCarries: 'Legalább 7 méteres labdavitelek, amelyek lövésben végződnek',
      GoalEndingCarries: 'Legalább 7 méteres labdavitelek, amelyek gólban végződnek',
      ShotEndingSequence: 'Lövésben végződő sorozatok száma, ahol a játékos részt vett',
      GoalEndingSequence: 'Gólban végződő sorozatok száma, ahol a játékos részt vett',
      xGPerNPG: 'Egy nem büntető gól eléréséhez szükséges Várható Gólok',
      AerialWonOffensive: 'Támadó Légi Párbaj Győzelmek',
      AerialWonDefensive: 'Védekező Légi Párbaj Győzelmek',
      xGAgainst: 'Kapott Várható Gólok',
      xGDiffAgainst: 'Különbség Kapott Várható Gólok és Kapott Gólok között',
      xGPerNPGAgainst: 'Kapott Várható Gólok Nem Büntető Gólonként',
      xGSetPieceAgainst: 'Rögzített Szituáció által generált Kapott Várható Gólok',
      xGOpenPlayAgainst: 'Nyitott Játék által generált Kapott Várható Gólok',
      xGPerShotAgainst: 'Kapott Várható Gólok Kapott Lövésenként',
      ShotsAgainst: 'kapott lövések száma',
      ShotsOnTargetAgainst: 'kapott kapura lövések száma',
      RivalPossession: 'Ellenfél birtoklása',
      AerialDefensivePct: 'Légi győzelmek százaléka labda birtoklás nélkül',
      HighRecoveries: '40 méter vagy közelebb az ellenfél góljához történt helyreállítások',
      HighDefensiveActions: 'Védő Akciók (Tackle-ek, Elsodrások, Blokkok, Szabálytalanságok és 1vs1) 40 méter felett a saját alapvonal felett',
      HighDefensiveActionPct: 'Védő Akciók százaléka (Tackle-ek, Elsodrások, Blokkok, Szabálytalanságok és 1vs1) 40 méter felett a saját alapvonal felett',
      HighDefensiveDistance: 'Összes Védő Akció átlagos távolsága a saját góltól',
      PassesPerPossession: 'Passzok száma Birtoklásonként',
      LengthPerPossession: 'Távolság Birtoklásonként',
      xTNet: 'Nettó xT',
      AvgCarriesDistance: 'Átlagos Labdavitel Távolság',
      PassesForwardPct: '% Passzok Előre',
      PassesForwardSuccessful: 'Sikeres előrepasszok',
      PassesForwardTotal: 'Összes előrepassz',
      TacklesAttempted: 'Megkísérelt Tackle-ek',
      DuelsLost: 'Elvesztett Párbajok',
      Carries: 'Labdavitelek',
      CarriesPct: '% Labdavitelek',
      Aerials: 'Légi Párbajok összes száma',
      ProgressivePassesReceivedIntoBox: 'Előrehaladó Passzok Fogadva Tizenhatosba',
      PassesOppHalf: 'Ellenfél térfélen végződő sikeres passzok',
      ShotsOnTarget: 'kapura készült lövések',
      AggressiveActions: 'A birtoklás elvesztése után következő két másodpercben megkísérelt Tackle-ek száma',
      Crosses: 'összes Beadások száma',
      xGBuildup5pass: 'Egy játékos által részt vett xG mennyisége, csak az utolsó 5 passz (kivéve lövések és lövéshez vezető passzok)',
      DefensiveDistance: 'Végzett védő párbajok átlagos távolsága a saját góltól',
      SpeedSequence: 'Egy csapat összes birtoklásának átlagos sebessége (méter/idő)',
      Touches: 'egy játékos által birtokolt labda alkalmainak száma',
      AerialsTotalOppHalf: 'ellenfél térfélen összes légi párbaj',
      AerialsWonOppHalf: 'Légi párbajok sikeresek az ellenfél felén',
      AerialsWonOppHalfPct: 'Ellenfél térfélen légi párbaj győzelmek százaléka',
      AerialsPctOppBox: 'Ellenfél tizenhatosban légi párbaj győzelmek százaléka',
      AerialsPctOwnBox: 'Saját tizenhatosban légi párbaj győzelmek százaléka',
      AerialDefensive: 'Összes Légi Párbaj, amikor az ellenfél csapat birtoklása van',
      AerialOffensive: 'Összes Légi Párbaj, amikor a saját csapat birtoklása van',
      AerialOffensivePct: 'Légi győzelmek százaléka, amikor a saját csapat birtoklása van',
      IndividualPressureOppHalf: 'Metrika, amely méri a sikeres erőfeszítések számát (visszanyert birtoklások) amikor a játékos az ellenfél térfelén nyomást gyakorol az ellenfelekre',
      ChancesCreatedOP: 'nyitott játékban lövéshez vezető passzok száma',
      TouchesPerShot: 'Alkalmak száma, amikor a játékosok érintik a labdát lövésenként',
      PassesFinalThirdTotalPct: 'Passzok százaléka (sikeres és sikertelen) harmadik harmadba',
      xACrosses: 'beadásokból generált várható gólpasszok',
      Passes: 'összes passzok száma',
      PassesSuccessful: 'befejezett passzok száma',
      TacklesWasDribbledFouls: 'Megnyert tackle-ek százaléka az összes tackle és elkövetett szabálytalanságokhoz képest',
      OffsidesCaught: 'Lesben Fogott',
      ProgressivePassesReceivedFinalThird: 'Előrehaladó Passzok Fogadva Harmadik Harmadban',
      ProgressivePassesReceived: 'Előrehaladó Passzok Fogadva',
      Breadth: 'Tackle-ek, Kihívások, Elsodrások és Elkövetett Szabálytalanságok összege a pálya oldalain',
      DuelsDefTotal: 'Összes Tackle-ek, Védekező Légi Párbajok és Elkövetett Szabálytalanságok összege',
      DefensiveActions: 'Védő Akciók, amikor egy ellenfél driblinget próbál (Tackle-ek, Kihívások és Szabálytalanságok)',
      ProgressivePassesReceivedOppHalf: 'Előrehaladó Passzok Fogadva Ell. Térfél',
      CompletedCrossesOP: 'Befejezett Beadások Nyitott Játék',
      CrossingOP: 'Befejezett beadások százaléka az összes megkísérelt nyitott játék beadásból',
      CrossesOP: 'Keresztek teljes száma nyílt játék közben',
      PassingContribution: 'Százalék, amely méri a passzok veszélyét figyelembe véve a fogadó pozícióját',
      BallProgressionOppHalfInTeam: '% Labda Előrehaladás Ell. Térfél Csapatban',
      PassesOPIntoBoxInTeam: '% Passzok Nyitott Játék Tizenhatosba Csapatban',
      TouchesOppBoxInTeam: '% Érintések Ell. Tizenhatosban Csapatban',
      xGOPInTeam: '% xG Nyitott Játék Csapatban',
      DeepPasses: 'Passzok az ellenfél góljától 20 méteres sugáron kívülről, amelyek abban a területen belül végződnek',
      DeepPassesTotal: 'Az ellenfél kapujának 20 méteres körzetén kívülről megkísérelt beadások összesen, amelyek ezen a területen belül végződnek',
      DefensiveDuelsPct: 'Megnyert védő párbajok százaléka az összes védő párbajból',
      QuickRecoveriesPct: 'Gyors helyreállítások százaléka az elsodrásokhoz és megkísérelt tackle-ekhez',
      DiffDefensiveDistanceTeam: 'Különbség a játékos védő távolsága és a csapat védő távolsága között',
      xTPassing: 'Csak passzokból generált várható veszély',
      xTPassing100Passes: 'Csak passzokból generált várható veszély és 100 passzonként',
      ProgressivePassesAccurate: '10 méter vagy több befejezett passzok X tengelyen',
      PassAbility: 'Befejezett passzok aránya a várható passzokhoz (xP)',
      OPPassesIntoOppBoxPct: 'Nyitott játék befejezett passzok százaléka ellenfél tizenhatosba és nyitott játék megkísérelt passzok ellenfél tizenhatosba',
      EntriesOppBox: 'Passzok és labdavitelek száma ellenfél tizenhatosba',
      Crosses6yardBox: 'Hat yardosban végződő beadások összes száma',
      Cutbacks: 'Passzolás alapvonaltól hátra és ellenfél tizenhatosban belül',
      xTDribbling: 'Csak driblingekből generált várható veszély',
      AvgShotDistance: 'Készült összes lövés átlagos távolsága',
      xGOnTarget: 'Kapura készült lövésekből származó várható gólok. Méri egy lövés gólba végződésének valószínűségét a lövés véghelyzetét használva',
      FinishingxGOT: 'Átlag feletti gólba végződő kapura lövések százaléka. Ez a metrika méri, mennyi értéket ad hozzá a csatár a lövéseinek minőségével',
      DribblesWonOwnHalf: 'Saját térfélen készült sikeres driblingek',
      DribblesOwnHalf: 'Saját térfélen megkísérelt driblingek száma',
      DribblesOwnHalfPct: 'Saját térfélen készült sikeres és megkísérelt driblingek százaléka',
      DribblesWonOppHalf: 'Ellenfél térfélen készült sikeres driblingek',
      DribblesOppHalf: 'Ellenfél térfélen megkísérelt driblingek száma',
      DribblesOppHalfPct: 'Ellenfél térfélen készült sikeres és megkísérelt driblingek százaléka',
      DribblesWonFinalThird: 'Harmadik harmadban készült sikeres driblingek',
      DribblesFinalThird: 'Harmadik harmadban megkísérelt driblingek száma',
      DribblesFinalThirdPct: 'Harmadik harmadban készült sikeres és megkísérelt driblingek százaléka',
      ShotEndingHighRecoveries: 'Magas helyreállítások (40 méter vagy közelebb az ellenfél góljához történt helyreállítások) lövésben végződve',
      PassingFinalThirdAgainst: 'Ellenfelektől a harmadik harmadba sikeres passzok',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Ellenfelektől saját tizenhatosba megkísérelt passzok összes száma nyitott játékban',
      EntriesOppBoxAgainst: 'Ellenfelektől saját tizenhatosba passzok és labdavitelek száma',
      DeepProgressionAgainst: 'Alkalmak száma, amikor az ellenfél eléri a pálya utolsó ötödét labdavitel által, plusz a labda birtoklásának alkalmainak száma az első ötödben',
      TouchesInOpponentBoxAgainst: 'Alkalmak száma, amikor az ellenfél birtoklása van a labdának a mi tizenhatosunkban',
      Score: 'Játékos teljesítmény különböző metrikák alapján',
      PDScore: 'Játékos fizikai teljesítmény különböző fizikai metrikák alapján',
      OrlegiScore: 'Játékos teljesítmény különböző metrikák alapján',
      SirScore: 'Játékos teljesítmény különböző metrikák alapján',
      ExcScore: 'Játékos teljesítmény különböző metrikák alapján',
      xTOPInTeam: 'Nyitott játékban generált várható veszély csapatban',
      YellowCards: 'Kapott sárga lapok',
      RedCards: 'Kapott piros lapok',
      xTOpenPlayAgainst: 'Nyitott játékban engedélyezett Várható Veszély',
      xTSetPieceAgainst: 'Rögzített szituáció által engedélyezett Várható Veszély',
      NPGOpenPlayAgainst: 'Nyitott játék akciókkal engedélyezett gólok száma büntető gólok nélkül',
      NPGSetPieceAgainst: 'Rögzített szituáció akciókkal engedélyezett gólok száma büntető gólok nélkül',
      PassesOppHalfPerPossession: 'Passzok Ell. Térfél Birtoklásonként',
      AverageTimeRecovery: 'Átlagos Helyreállítási Idő',
      ExpectedPassing: 'Passzok százaléka, amelyeket be kellett volna fejezni',
      NumPossession10Passes: '10 vagy több passz által generált birtoklások',
      PassesReceived: 'Fogadott Passzok',
      PassesReceivedFinalThird: 'Fogadott Passzok Harmadik Harmadban',
      ProgressivePassesTotalPct: 'Előrehaladó Passzok százaléka',
      ShortPassesPct: 'Rövid Passzok százaléka',
      TouchesOppBoxOppTeam: 'Ellenfél akciók száma, amelyeket saját tizenhatosban engedélyeztek, amíg a játékos a pályán van',
      ShotsOnTargetOppTeam: 'Kapura lövések, amelyeket engedélyeztek, amíg a játékos a pályán van',
      NPGOppTeam: 'Nem büntető gólok, amelyeket engedélyeztek, amíg a játékos a pályán van',
      xGSetPiecePerxG: 'Rögzített szituáció által generált Várható Gólok egy várható gól generálásához',
      ShotsOpenPlay: 'Nyitott játék által generált lövések száma',
      ShotsOpenPlayAgainst: 'Nyitott játék által kapott lövések száma',
      ShotsFromDribble: 'Lövés, miután a játékos kicselezett egy ellenfelet',
      GoalsFromDribble: 'Gól, miután a játékos kicselezett egy ellenfelet',
      PassesIntoFinalThird: 'Sikeres passzok a támadó harmadba',
      PassesIntoFinalThirdTotal: 'Az összes passz megkísérelte, hogy kívülről kezdődjön és az utolsó harmadban belül végződjön',
      PassesInsideFinalThird: 'Sikeres passzok a támadó harmadon belül (kezdete és vége is ott)',
      PassesInsideFinalThirdTotal: 'Az utolsó harmadban megkísérelt passzok összesen (kezdete és vége az utolsó harmadban)',
      PassesFinalThirdNoArea: 'Passzol az utolsó harmadon (W/O Box)',
      PassesIntoOppBox: 'Sikeres passzok, melyek az ellenfél tizenhatosában végződnek',
      CarriesFinalThird: 'Legalább 7 méteres labdavezetések, amelyek a támadó harmadban végződnek',
      CarriesInsideFinalThird: 'Legalább 7 méteres labdavezetések a támadó harmadon belül',
      CarriesFinalThirdNoBox: 'Utolsó harmadot hordoz (W/O Box)',
      CarriesIntoOppBox: 'Legalább 7 méteres labdavezetések, amelyek az ellenfél tizenhatosában végződnek',
      TimePossessionAgainst: 'Az ellenfél labdabirtoklásának ideje',
      TimePossessionTotal: 'A két csapat összesített labdabirtoklása',
      PassesInBox: 'Sikeres passzok a saját tizenhatoson belül',
      LongThrowInSuccessful: 'Sikeres hosszú bedobás, amely meghaladja a 20 métert',
      LongThrowInTotal: '20 méternél hosszabb bedobások összes száma',
      LongThrowInPct: 'Sikeres hosszú bedobások aránya (20+ méter)',
      Games: 'Játszott játékok',
      PointsPerGame: 'Pontok játékonként',
      ExpectedPointsDiff: 'Várható pontkülönbség',
      PassesTotalOwnHalf: 'Saját térfélből leadott összes passzok száma',
      PassesOwnHalf: 'A saját térfélből leadott sikeres passzok száma',
      PassesTotalOppHalf: 'Az ellenfél feléről adott összes passzok száma',
      ProgressivePassesTotal: 'A 10 méteres vagy annál nagyobb áthaladások teljes száma az X-tengelyen',
      DuelsWon: 'Sikeres párharcok (Tackle-ek, Lövések, Labdaérintések, Csepelések és elkövetett szabálytalanságok)',
      NonPenaltySaves: 'Ment a büntetőlövések nélkül',
      BadActionsOppHalf: 'Az ellenfél térfelén elkövetett rossz akciók összege (sikertelen passz, sikertelen beadás, kidobott, les-passz, sikertelen labdaérintés)',
      CarriesSuccessful: 'Sikeres eseménnyel végződő legalább 7 méteres szállítások száma',
      ShotsOnTargetOutBox: 'A dobozon kívülről célba kapott lövések',
      TotalDistance: 'Összes távolság, amit a játékos egy mérkőzésen megtett',
      WalkingDistance: 'Összes távolság, amit a játékos egy mérkőzésen 2 m/s (7.2 km/h) alatti sebességgel tett meg',
      JoggingDistance: 'Összes távolság, amit a játékos egy mérkőzésen 2 m/s (7.2 km/h) és 4 m/s (14.4 km/h) közötti sebességgel tett meg',
      RunningDistance: 'Összes távolság, amit a játékos egy mérkőzésen 4 m/s (14.4 km/h) és 5.5 m/s (19.8 km/h) közötti sebességgel tett meg',
      ExtremeAccelerations: 'Alkalmak száma, amikor a játékos 3 m/s<sup>2</sup> felett gyorsul',
      NumberOfRuns: '4 m/s (14.4 km/h) és 5.5 m/s (19.8 km/h) közötti sebességgel befejezett futások száma',
      DistanceIP: 'Távolság (Csapat Birtoklásban) amit a játékos egy mérkőzésen birtoklással tett meg',
      DistanceOOP: 'Távolság OTIP (Ellenfél Csapat Birtoklásban) amit a játékos egy mérkőzésen birtoklás nélkül tett meg',
      HsrNumber: 'Alkalmak száma, amikor a játékos 5.5 m/s (19.8 km/h) vagy nagyobb, de 7 m/s (25.2 km/h) alatti sebességgel mozog legalább 1 másodpercig',
      HsrDistance: 'Összes távolság, amit a játékos egy mérkőzésen 5.5 m/s (19.8 km/h) vagy nagyobb, de 7 m/s (25.2 km/h) alatti sebességgel tett meg',
      HsrDistancePct: 'HSR (Magas Sebességű Futás) Távolság százaléka az összes megtett távolsághoz képest',
      SprintsNumber: 'Alkalmak száma, amikor a játékos 7 m/s (25.2 km/h) vagy nagyobb sebességgel mozog legalább 1 másodpercig',
      SprintsDistance: 'Összes távolság, amit a játékos egy mérkőzésen 7 m/s (25.2 km/h) vagy nagyobb sebességgel tett meg',
      SprintNumberDeclinePct: 'Sprint számának százalékos csökkenése a második félidőhöz képest',
      SprintDistanceDeclinePct: 'Sprint közben futott távolság százalékos csökkenése a második félidőhöz képest',
      SprintNumberDecline: 'Sprint számának csökkenése a második félidőhöz képest',
      SprintDistanceDecline: 'Sprint közben futott távolság csökkenése a második félidőhöz képest',
      SprintDistancePct: 'Sprint Távolság százaléka az összes megtett távolsághoz képest',
      Accelerations: 'Alkalmak száma, amikor a játékos 1.5 m/s<sup>2</sup> és 3 m/s<sup>2</sup> között gyorsul',
      ExplosiveDistance: 'Robbanásos Távolság',
      MaxSpeed: 'A játékos által elért maximális sebesség',
      AvgMaxSpeed: 'A játékos által elért maximális sebesség átlaga',
      MaxAccelerations: 'A játékos által elért maximális méter/másodperc<sup>2</sup>',
      BypassedPlayersByPasses: 'Összes megkerült ellenfél (védők és középpályások) passzokkal',
      BypassedDefendersByPasses: 'Összes megkerült ellenfél (védők) passzokkal',
      PassesBypassingPlayers: 'Játékosokat megkerülő passzok száma',
      PassesBypassingDefenders: 'Védőket megkerülő passzok száma',
      BypassedPlayersPerPass: 'Összes megkerült játékos passzonként',
      BypassedDefendersPerPass: 'Összes megkerült védő passzonként',
      LineBreakingPasses: 'Befejezett passzok száma, amelyek sikeresen átszakítanak egy vagy több védő vonalat',
      LineBreakingPassesMD: 'Befejezett passzok száma, amelyek sikeresen átszakítanak középpályás és védő vonalakat',
      LineBreakingPassesM: 'Befejezett passzok száma, amelyek sikeresen átszakítanak középpályás vonalat',
      LineBreakingThroughBalls: 'Befejezett passzok száma, amelyek sikeresen átszakítanak védő vonalat',
      LineBreakingPassesPerPass: 'Vonalat átszakító passzok százaléka passzonként',
      TotalPassesUnderStrongPressure: 'Összes passz erős nyomás alatt (legközelebbi ellenfél 0-2 méteren belül)',
      TotalPassesUnderLightPressure: 'Összes passz nyomás alatt (legközelebbi ellenfél 2-4 méteren belül)',
      SuccessfulPassesUnderStrongPressure: 'Sikeres passzok száma erős nyomás alatt (legközelebbi ellenfél 0-2 méteren belül)',
      SuccessfulPassesUnderLightPressure: 'Sikeres passzok száma nyomás alatt (legközelebbi ellenfél 2-4 méteren belül)',
      PassingUnderStrongPressure: 'Sikeres passzok és összes passz százaléka erős nyomás alatt (legközelebbi ellenfél 0-2 méteren belül)',
      PassingUnderLightPressure: 'Sikeres passzok és összes passz százaléka nyomás alatt (legközelebbi ellenfél 2-4 méteren belül)',
      PassReceiptsInSpaceCompleted: 'Passzok, ahol a fogadó a támadó térfélen van és nincs védő 5 méteres sugárban a gól iránya felé',
      PassReceiptsInSpace: 'Fogadott passzok a támadó térfélen, ahol nincs védő 5 méteres sugárban a gól iránya felé',
      PassReceiptsInSpaceCompletedFirstThird: 'Passzok, ahol az átvevő az első harmadban van, és nincs védő 5 méteren belül a kapu irányába',
      PassReceiptsInSpaceCompletedSecondThird: 'Passzok, ahol az átvevő a középső harmadban van, és nincs védő 5 méteren belül',
      PassReceiptsInSpaceCompletedFinalThird: 'Passzok, ahol az átvevő a támadó harmadban van, és nincs védő 5 méteren belül',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Passzok, ahol az átvevő az ellenfél jobb oldalán van, védő nélkül 5 méteren belül',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Passzok, ahol az átvevő az ellenfél közepén van, védő nélkül 5 méteren belül',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Passzok, ahol az átvevő az ellenfél bal oldalán van, védő nélkül 5 méteren belül',
      PassReceiptsInSpaceFirstThird: 'Passzok, amelyeket az első harmadban vettek át védő nélkül 5 méteren belül',
      PassReceiptsInSpaceSecondThird: 'Passzok, amelyeket a középső harmadban vettek át védő nélkül',
      PassReceiptsInSpaceFinalThird: 'Passzok, amelyeket a támadó harmadban vettek át védő nélkül',
      PassReceiptsInSpaceOppHalfRight: 'Passzok, amelyeket az ellenfél jobb oldalán vettek át védő nélkül',
      PassReceiptsInSpaceOppHalfCenter: 'Passzok, amelyeket az ellenfél közepén vettek át védő nélkül',
      PassReceiptsInSpaceOppHalfLeft: 'Passzok, amelyeket az ellenfél bal oldalán vettek át védő nélkül',
      TotalStrongOnBallPressures: 'Erős labdanyomások száma (labdavitel 0-2 méteren belül)',
      TotalLightOnBallPressures: 'Labdanyomások száma (labdavitel 2-4 méteren belül)',
      SuccessfulStrongOnBallPressures: 'Sikeres erős labdanyomások száma (0-2 méteren belül)',
      SuccessfulLightOnBallPressures: 'Sikeres labdanyomások száma (2-4 méteren belül)',
      StrongOnBallPressuresPct: 'Sikeres és összes erős labdanyomások százaléka (legközelebbi ellenfél 0-2 méteren belül)',
      LightOnBallPressuresPct: 'Sikeres és összes labdanyomások százaléka (legközelebbi ellenfél 2-4 méteren belül)',
      TimesBypassedByPasses: 'Összes alkalom, amikor passzokkal megkerülték',
      TimesBypassedByCarries: 'Összes alkalom, amikor labdavitelekkel megkerülték',
      TimesBypassedByActions: 'Összes alkalom, amikor passzokkal és labdavitelekkel kombinálva megkerülték',
      BypassedPlayersByCarries: 'Összes megkerült ellenfél (védők és középpályások) labdavitelekkel',
      BypassedDefendersByCarries: 'Összes megkerült ellenfél (védők) labdavitelekkel',
      BypassedPlayersByActions: 'Összes megkerült ellenfél (védők és középpályások) passzokkal és labdavitelekkel kombinálva',
      BypassedDefendersByActions: 'Összes megkerült ellenfél (védők) passzokkal és labdavitelekkel kombinálva',
      CarriesBypassingPlayers: 'Játékosokat megkerülő labdavitelek száma',
      CarriesBypassingDefenders: 'Védőket megkerülő labdavitelek száma',
      BypassedPlayersPerCarry: 'Átlagos megkerült ellenfelek száma labdavitelenként',
      BypassedDefendersPerCarry: 'Átlagos megkerült védők száma labdavitelenként',
      LineBreakingCarries: 'Labdavitelek száma, amelyek sikeresen átszakítanak egy vagy több védő vonalat',
      LineBreakingCarriesMD: 'Labdavitelek száma, amelyek sikeresen átszakítanak középpályás és védő vonalakat',
      LineBreakingCarriesM: 'Labdavitelek száma, amelyek sikeresen átszakítanak középpályás vonalat',
      LineBreakingCarriesD: 'Labdavitelek száma, amelyek sikeresen átszakítanak védő vonalat',
      LineBreakingCarriesPerCarry: 'Vonalat átszakító labdavitelek százaléka labdavitelenként',
      LineBreakingActions: 'Passzok és labdavitelek kombinált száma, amelyek sikeresen átszakítanak egy vagy több védő vonalat',
      LineBreakingActionsMD: 'Passzok és labdavitelek kombinált száma, amelyek sikeresen átszakítanak középpályás és védő vonalakat',
      LineBreakingActionsM: 'Passzok és labdavitelek kombinált száma, amelyek sikeresen átszakítanak középpályás vonalat',
      LineBreakingActionsD: 'Passzok és labdavitelek kombinált száma, amelyek sikeresen átszakítanak védő vonalat',
      PassesPerLineBreakingPass: 'Arány az összes passz és vonalat átszakító passz között',
      CarriesPerLineBreakingCarry: 'Arány az összes labdavitel és vonalat átszakító labdavitel között',
      LinesBrokenByPasses: 'Összes átszakított vonal passzokkal',
      LinesBrokenByCarries: 'Összes átszakított vonal labdavitelekkel',
      LinesBrokenByActions: 'Összes átszakított vonal passzokkal és labdavitelekkel kombinálva',
      LinesBrokenPerPass: 'Arány az összes átszakított vonal és passz között',
      LinesBrokenPerCarry: 'Arány az összes átszakított vonal és labdavitel között',
      AvgLastDefenderDistanceIP: 'Távolság az utolsó védő (legközelebb a saját gólhoz) és a gólvonal között birtoklásban',
      AvgLastDefenderDistanceOOP: 'Távolság az utolsó védő (legközelebb a saját gólhoz) és a gólvonal között birtoklás nélkül',
      AvgDefensiveLineDistanceIP: 'Távolság a legmélyebb védő vonal pozíciója és a gól között birtoklásban',
      AvgDefensiveLineDistanceOOP: 'Távolság a legmélyebb védő vonal pozíciója és a gól között birtoklás nélkül',
      AvgRBDistanceIP: 'Távolság a jobb szélső védőtől a saját góljához birtoklásban',
      AvgRBDistanceOOP: 'Távolság a jobb szélső védőtől a saját góljához birtoklás nélkül',
      AvgLBDistanceIP: 'Távolság a bal szélső védőtől a saját góljához birtoklásban',
      AvgLBDistanceOOP: 'Távolság a bal szélső védőtől a saját góljához birtoklás nélkül',
      AvgBlockDistanceIP: 'Távolság a legmélyebb és legelőrehaladottabb mezőnyi játékos között birtoklásban',
      AvgBlockDistanceOOP: 'Távolság a legmélyebb és legelőrehaladottabb mezőnyi játékos között birtoklás nélkül',
      AvgBlockAreaIP: 'Az összes mezőnyi játékost körülvevő határoló doboz területe (a csapat által elfoglalt tér mértéke) birtoklásban',
      AvgBlockAreaOOP: 'Az összes mezőnyi játékost körülvevő határoló doboz területe (a csapat által elfoglalt tér mértéke) birtoklás nélkül',
      AvgDefensiveLineWidthOOP: 'A játékosok leghátsó vonalának szélessége (legtávolabb a saját góljuktól) birtoklás nélkül',
      AvgOffensiveLineLastThirdWidthIP: 'A támadó vonal vízszintes szélessége az utolsó harmadban birtoklásban',
      AvgLByIP: 'A bal szélső védő pozíciója birtoklásban',
      AvgRByIP: 'A jobb szélső védő pozíciója birtoklásban',
      AvgOffensiveLineDistanceIP: 'Távolság a saját gól és a támadó vonal között birtoklásban',
      AvgOffensiveLineLastThirdDistanceIP: 'Távolság a saját gól és a támadó vonal között az utolsó harmadban birtoklásban',
      AvgOffensiveLineWidthIP: 'A támadó vonal vízszintes szélessége birtoklásban',
      OffBallRuns: 'Szándékos labda nélküli mozgások (futások) a támadó fázis támogatásához',
      OffBallRunsOverlap: 'Futások, ahol a játékos egy csapattársa külső oldalán mozog (közelebb a partvonalhoz), amíg az a csapattárs birtokában van a labda',
      OffBallRunsUnderlap: 'Futások, ahol a játékos egy csapattársa belsejében mozog, belső útvonalat követve (közelebb a pálya közepéhez)',
      OffBallRunsRunAhead: 'Előre futás, amely túlhaladja a labdavitelet, de az utolsó védő előtt marad',
      OffBallRunsRunBehind: 'Előre futás, amely behatol az utolsó védő vonalba, a védők és a kapus közé kerülve',
      OffBallRunsCrossReceiver: 'Egy játékos a tizenhatosba fut és pozícionálódik, hogy fogadjon egy beadást egy csapattársától',
      OffBallRunsSupport: 'A játékos a labdavitel mellé fut, közelben passzolási lehetőséget kínálva a támadásban',
      OffBallRunsComingShort: 'A játékos a labdavitel felé mozog, hogy közeli támogatást vagy passzolási lehetőséget kínáljon a góltól távol',
      AerialsOppHalf: 'ellenfél térfélen sikeres légi párbaj',
      CarriesIntoFinalThird: 'Legalább 7 méteres csővezetékek kívülről befelé az utolsó harmadban',
      SpeedScore: 'A játékos fizikai teljesítménye különböző sebességmérők alapján',
      EnduranceScore: 'Játékos állóképességi fizikai teljesítmény különböző mérőszámok alapján',
      SwitchPlaySuccessful: 'Olyan befejezett passzok száma 32 méter felett, ahol a labda oldalirányú elmozdulása nagyobb, mint az ellenfél kapuja felé történő elmozdulása',
      SwitchPlayTotal: 'A 32 méter feletti passzkísérletek száma, ahol a labda oldalirányú elmozdulása nagyobb, mint az ellenfél kapuja felé történő elmozdulása',
      PassesInsideOppHalf: 'Azok a passzok száma, amelyek az ellenfél térfelén kezdődnek és végződnek',
      PassesInsideOppHalfSuccessful: 'Azok a teljesített passzok száma, amelyek az ellenfél térfelén kezdődnek és végződnek',
      TacklesAttemptedFirstThird: 'A pálya első harmadában megkísérelt szerelések teljes száma',
      TacklesAttemptedSecondThird: 'Az összes szerelési kísérlet a pálya második harmadában',
      TacklesFirstThird: 'Sikeres szerelések száma a pálya első harmadában',
      TacklesSecondThird: 'Sikeres szerelések száma a pálya második harmadában',
      FoulsOwnHalf: 'A játékos saját térfelén elkövetett szabálytalanságok száma',
      TouchesOppHalf: 'Labdaérintések száma az ellenfél térfelén',
      TacklesAttemptedNotAdjusted: 'A megkísérelt ütések teljes száma, labdabirtoklás módosítása nélkül',
      TacklesSuccessfulNotAdjusted: 'Sikeres tackle-ek teljes száma labdabirtoklás-korrekció nélkül',
      AvgTop5MaxSpeed: 'A játékos öt legnagyobb maximális sebességének átlaga',
      LBPReceived: 'A kapott sorbontó passzok száma. Ezek olyan befejezett passzok, amelyek legalább 10%-kal közelebb viszik a labdát az ellenfél kapujához, és kereszteznek egy védőpárt a közelben, vagy túllépnek a védővonalon.',
      LBPMReceived: 'Number of passes received that break through the opposition midfield line',
      LBPMDReceived: 'Azok a passzok száma, amelyek áttörik az ellenfél középpályáját és a védővonalat',
      ThroughBallReceived: 'Azok a passzok száma, amelyek áttörték az ellenfél utolsó védővonalát',
      HsrDistanceIP: 'Sprinttáv >21 km/h birtokban',
      HsrDistanceOOP: 'Sprint távolság >21 km/h birtokon kívül',
      JoggingDistanceIP: 'Kocogási távolság birtokában',
      JoggingDistanceOOP: 'Kocogási távolság birtokon kívül',
      RunningDistanceIP: 'Futótáv birtokában',
      RunningDistanceOOP: 'Futótáv a birtokból',
      SprintsDistanceIP: 'Sprinttáv >24 km/h birtokban',
      SprintsDistanceOOP: 'Sprint távolság >24 km/h birtokon kívül',
      WalkingDistanceIP: 'Gyalogos távolság birtokban',
      WalkingDistanceOOP: 'Séta távolságra a birtokon kívül',
      RunningNumberIP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second with possession',
      RunningNumberOOP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second without possession',
      RunningDistancePctIP: 'Percentage of Running Distance with respect to total distance travelled with possession',
      RunningDistancePctOOP: 'Percentage of Running Distance with respect to total distance travelled without possession',
      RunningDistancePct: 'Percentage of Running Distance with respect to total distance travelled',
      HsrNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      HsrNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      SprintsNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsDistancePctIP: 'Percentage of Sprint Distance with respect to total distance travelled with possession',
      SprintsDistancePctOOP: 'Percentage of Sprint Distance with respect to total distance travelled without possession',
      SprintsDistancePct: 'Percentage of Sprint Distance with respect to total distance travelled',
      PossessionRegain: 'Ahányszor kényszeríted az ellenfelet a labdaszerzés elvesztésére',
      HandPassesSuccessful: 'Kézzel adott sikeres passzok (kapusok vagy bedobás szettlabdában)',
      HandPassesTotal: 'Kézzel adott passzok teljes száma (kapusok vagy bedobott labdák)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player'
    },
    subtitles: {
      Possession: 'A csapat labda birtoklásának százaléka',
      TimePossession: 'A csapat labda birtoklásának ideje',
      PassesPerShots: 'Átlagos passzok száma lövésenként',
      PPDA: 'A csapat által az ellenfél játékosaira gyakorolt nyomás, amikor birtokukban van a labda',
      Directness: 'Nagyobb mennyiségű előre irányuló passzok az oldalirányú passzokhoz képest',
      ExpectedPoints: 'Egy csapat által várható pontok száma, a Várható Gólok alapján számítva',
      PassesPerLongBall: 'Sikeres hosszú passzok százaléka az összes befejezett passzból',
      CrossingPerXG: 'Beadásokból származó Várható Gólok százaléka',
      PenaltySavedPenaltyFaced: 'Hárított büntető lövések százaléka az összes kapott büntető lövésből',
      Goals: 'szerzett gólok száma',
      PenaltyShots: 'Büntetőrúgásokból készült összes lövés száma',
      PenaltyGoals: 'Büntetőrúgásokból szerzett összes gól száma',
      NonPenaltyGoals: 'Gólok (büntetők nélkül)',
      AerialWins: 'Légi párbaj győzelmek',
      AerialEfficiency: 'Metrika, amely kombinálja a légi párbaj győzelmeket a légi párbajok összesével',
      AerialWinsPct: 'Légi párbaj győzelmek százaléka',
      Assists: 'Gólpasszok',
      Catching: 'Hárítások százaléka, amelyekben a kapus elkapja a labdát',
      Caught: 'Ment, ahol a kapus elkapja és tartja a labdát, megakadályozva a második játékot',
      ChancesCreated: 'Lövéshez vezető passzok száma',
      ClaimAccuracy: 'Átlag feletti elkapott labdák',
      CompletedCrosses: 'Sikeresen befejezett beadások',
      Crossing: 'Sikeres beadások százaléka',
      Dispossessed: 'Labda elvesztések',
      Finishing: 'Góllal végződő lövések százaléka',
      xGEfficiency: 'Egy játékos számára szükséges várható gólok mennyisége egy gól eléréséhez',
      Fouls: 'Elkövetett szabálytalanságok',
      DeepProgression: 'Alkalmak száma, amikor a pálya utolsó ötödéhez labdavitel által elérnek, plusz a labda birtoklásának alkalmainak száma az utolsó ötödben',
      DeepProgressionFinalThird: 'Alkalmak száma, amikor a játékos birtoklása van a harmadik harmadban',
      FoulsTaken: 'Kapott szabálytalanságok',
      IndividualPressure: 'Sikeres erőfeszítések (visszanyert birtoklások)',
      Interceptions: 'Labda Elsodrások',
      LongBallPct: 'Legalább 32 méteres Befejezett Passzok százaléka',
      LongBallTotal: '32 méter feletti áthaladások teljes száma',
      LongBallSuccessful: 'Legalább 32 méteres Befejezett Passzok',
      NPGOpenPlay: 'Gólok (büntetők nélkül) nyitott játék akciókkal',
      NPGSetPiece: 'Gólok (büntetők nélkül) rögzített szituáció akciókkal',
      OpenPlayKeyPasses: 'Lövésben végződő passzok (gólpasszok nélkül) Nyitott Játékban',
      OpenPlayKeyPassesInTeam: 'Lövésben végződő passzok százaléka (gólpasszok nélkül) nyitott játékban Csapatban',
      PassingFinalThird: 'Sikeres passzok a harmadik harmadba',
      PassesFinalThirdTotal: 'Az utolsó harmadban végződő passzkísérletek száma, keresztrúgások, szettlabdák, szögletek és bedobások nélkül',
      PassingFinalThirdPct: 'Sikeres Passzok százaléka Harmadik Harmadban',
      PassingOppHalfPct: 'Sikeres Passzok százaléka Ellenfél Térfélbe',
      PassingOwnHalfPct: 'Sikeres Passzok százaléka Saját Térfélbe',
      PassingPct: 'Sikeres Passzok százaléka',
      Recoveries: 'Labda Helyreállítások (Tackle-ek vagy Elsodrások által)',
      SavesInBoxPct: 'Hárítások százaléka Tizenhatosban lévő Lövésekből',
      SavesOutOfBoxPct: 'Hárítások százaléka Tizenhatoson Kívüli Lövésekből',
      SavesPct: 'Hárítások százaléka',
      ScoringContribution: 'Gólpasszok és gólok száma',
      xAssistsOpenPlay: 'nyitott játékból generált várható gólpasszok száma',
      xAssistsSetPiece: 'rögzített szituációból generált várható gólpasszok száma',
      xAssistsOpenPlayInTeam: 'nyitott játékból generált várható gólpasszok száma csapatban',
      xAssistsSetPieceInTeam: 'rögzített szituációból generált várható gólpasszok száma csapatban',
      xGChainFinalThird: 'A harmadik harmadban részt vett xG mennyisége',
      xGBuildupFinalThird: 'A harmadik harmadban részt vett xG mennyisége (kivéve lövések és lövéshez vezető passzok)',
      BallProgressionPassing: 'Alkalmak száma, amikor a játékos passzolással 10 méter vagy több előrehalad',
      BallProgressionDribbling: 'Alkalmak száma, amikor a játékos labdavitel 10 méter vagy több előrehalad',
      Shooting: 'Kapura Lövések százaléka (büntetők nélkül)',
      Shots: 'Készült Lövések száma',
      ShotsPerGoal: 'Átlagos Lövések száma egy Gól eléréséhez',
      SuccessfulDribbles: 'Sikeres Driblingek',
      TacklesSuccessful: 'Összes Tackle-ek száma',
      TacklesWasDribbled: 'Tackle-en keresztül megnyert Párbajok százaléka',
      ThroughBalls: 'Védő vonalat átszakító Passzok száma',
      TouchesInOpponentBox: 'Labda irányítások száma az ellenfél tizenhatosában',
      xAssists: 'generált Várható Gólpasszok',
      xG: 'generált Várható Gólok',
      xGDiff: 'Különbség xG és Gólok között',
      xGOpenPlay: 'Nyitott játék által generált várható gólok',
      xGSetPiece: 'Rögzített szituáció által generált várható gólok',
      xGBuildup: 'Részvétel xG Felépítésben',
      xGBuildupInTeam: 'Részvétel xG Felépítésben csapatban',
      BallProgression: 'Előrehaladások passzolással vagy labdavitel legalább 10 méter',
      xGChain: 'Részvétel xG Láncban',
      xGPerNPG: 'Egy nem büntető gól eléréséhez szükséges várható gólok',
      xGPerShot: 'Átlagos xG Lövésenként',
      xGSavedPerShot: 'Átlagos Mentett xG Kapott Lövésenként',
      xGSavedPerXGFacedOnTarget: 'Átlagos mentett xG kapott xG kapura',
      xGFacedOnTargetPerGoalReceived: 'Várható Gólokra van szükség egy gól eléréséhez egy bizonyos Kapushoz',
      xGFacedOnTargetEfficiency: 'A kapus által megelőzött Nem Büntető Gólok száma',
      xGFacedOnTarget: 'A kapus által kapott összes xG (mentett és szerzett)',
      HighTurnovers: 'Labda elvesztések 40 méternél közelebb a saját góltól',
      OpenPlayPassesIntoOpponentBox: 'Összes nyitott játék passzok ellenfél tizenhatosba',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Nyitott játék befejezett passzok ellenfél tizenhatosba',
      ChancesCreatedOP: 'nyitott játékban lövéshez vezető passzok száma',
      PenaltiesTaken: 'a játékos által ellenfél tizenhatosban kapott szabálytalanságok száma',
      BlockedCrosses: 'Blokkolt beadások',
      BlockedShots: 'Blokkolt lövések',
      NonPenaltyGoalsAgainst: 'engedélyezett nem büntető gólok száma',
      Headers: 'Fejjel készült lövések száma',
      AveragePassDistance: 'Passzok átlagos távolsága méterben',
      ProgressiveRuns: 'Sikeres labdavitelek, amelyek a birtoklást 20%-kal közelebb hozzák az ellenfél góljához',
      xT: 'Veszély generálása a labda veszélyes területekre mozgatásával',
      xTOpenPlay: 'nyitott játékban generált Várható Veszély',
      xTSetPiece: 'rögzített szituációból generált Várható Veszély',
      xGOT: 'A kapus által kapott várható gólok száma',
      BadActions: 'Összes elkövetett rossz akció összege',
      BadActionsOwnHalf: 'Saját térfélen elkövetett összes rossz akció összege',
      AerialsWonOwnBox: 'Légi Párbaj Győzelmek Saját Tizenhatosban',
      AerialsWonOppBox: 'Légi Párbaj Győzelmek Ell. Tizenhatosban',
      AerialsTotalOppBox: 'Összes Légi Párbaj Ell. Tizenhatosban',
      AerialsTotalOwnBox: 'Összes Légi Párbaj Saját Tizenhatosban',
      FoulsOwnHalfPct: 'Saját Térfélen Elkövetett Szabálytalanságok százaléka',
      RecoveriesOppHalf: 'egy játékos által ellenfél térfélen visszanyert labdák száma',
      DuelsPct: 'Sikeres Párbajok százaléka',
      TacklesUnsuccessful: 'Alkalmak száma, amikor egy játékos nem sikerül megnyernie a labdát, mivel az ellenfél sikeresen driblingel el mellette',
      TacklesWasDribbledFirstThird: 'A játékos által visszanyert labdák százaléka, amikor a harmadik harmadban szembesül',
      TacklesWasDribbledSecondThird: 'Megnyert védekező 1 elleni 1 elleni párharcok ⅔',
      TacklesWasDribbledFinalThird: 'Megnyert védekező 1 elleni 1 elleni párharcokHarmadik Harmadban',
      BallProgressionFinalThird: 'Alkalmak száma, amikor egy játékos 10 vagy több méter előrehalad a harmadik harmadban',
      DuelsTotal: 'elkövetett tackle-ek, légi párbajok, labda érintések, driblingek és szabálytalanságok összes száma',
      QuickRecoveries: '40 méter vagy több távolságra a saját góltól történt helyreállítások 8 másodperccel a labda birtoklásának elvesztése után',
      ShotsPerNPG: 'Átlagos lövések száma egy Nem Büntető Gól eléréséhez',
      ShotsOutBox: 'tizenhatoson kívülről készült lövések száma',
      GoalsOutBox: 'tizenhatoson kívülről szerzett gólok száma',
      ShootingOutBox: 'Tizenhatoson kívülről készült kapura lövések százaléka',
      HandPassing: 'Kéz Passzolás Pontosság',
      ShotEndingHighTurnovers: 'Magas Labda Elvesztések (40 méternél közelebb a saját góltól) lövésben végződve az ellenfél csapat részéről',
      GoalEndingHighTurnovers: 'Magas Labda Elvesztések (40 méternél közelebb a saját góltól) gólban végződve az ellenfél csapat részéről',
      AverageCarriesProgress: 'Átlagos távolság, amit egy játékos függőlegesen mozgat a labdát labdavitelenként (méter)',
      ChanceEndingCarries: 'Legalább 7 méteres labdavitelek, amelyek passzban végződnek, amit lövés követ',
      AssistEndingCarries: 'Legalább 7 méteres labdavitelek, amelyek passzban végződnek, amit gól követ',
      ShotEndingCarries: 'Legalább 7 méteres labdavitelek, amelyek lövésben végződnek',
      GoalEndingCarries: 'Legalább 7 méteres labdavitelek, amelyek gólban végződnek',
      ShotEndingSequence: 'Lövésben végződő sorozatok száma, ahol a játékos részt vett',
      GoalEndingSequence: 'Gólban végződő sorozatok száma, ahol a játékos részt vett',
      AerialWonOffensive: 'Támadó légi párbaj győzelmek',
      AerialWonDefensive: 'Védekező légi párbaj győzelmek',
      xGAgainst: 'Kapott várható gólok',
      xGDiffAgainst: 'Különbség Kapott Várható Gólok és Kapott Gólok között',
      xGPerNPGAgainst: 'Kapott várható gólok nem büntető gólonként',
      xGOpenPlayAgainst: 'Nyitott játék által generált kapott várható gólok',
      xGSetPieceAgainst: 'Rögzített szituáció által generált kapott várható gólok',
      xGPerShotAgainst: 'Kapott várható gólok kapott lövésenként',
      ShotsAgainst: 'Kapott lövések',
      ShotsOnTargetAgainst: 'Kapott kapura lövések',
      RivalPossession: 'Ellenfél birtoklása',
      AerialDefensivePct: 'Légi győzelmek százaléka labda birtoklás nélkül',
      HighRecoveries: '40 méter közelében az ellenfél góljához történt helyreállítások',
      HighDefensiveActions: 'Védő Akciók (Tackle-ek, Elsodrások, Blokkok, Szabálytalanságok és 1vs1) 40 méter felett a saját alapvonal felett',
      HighDefensiveActionPct: 'Védő Akciók százaléka (Tackle-ek, Elsodrások, Blokkok, Szabálytalanságok és 1vs1) 40 méter felett a saját alapvonal felett',
      HighDefensiveDistance: 'Összes Védő Akció átlagos távolsága a saját góltól',
      PassesPerPossession: 'Passzok száma birtoklásonként',
      LengthPerPossession: 'Távolság birtoklásonként',
      xTNet: 'Nettó xT',
      AvgCarriesDistance: 'Átlagos Labdavitel Távolság',
      PassesForwardPct: '% Passzok Előre',
      PassesForwardSuccessful: 'Sikeres előrepasszok',
      PassesForwardTotal: 'Összes előrepassz',
      TacklesAttempted: 'Megkísérelt Tackle-ek',
      DuelsLost: 'Elvesztett Párbajok',
      Carries: 'Labdavitelek',
      CarriesPct: '% Labdavitelek',
      Aerials: 'légi párbajok összes száma',
      ProgressivePassesReceivedIntoBox: 'Előrehaladó Passzok Fogadva Tizenhatosba',
      PassesOppHalf: 'Ellenfél térfélen végződő sikeres passzok',
      LongBallReceived: 'Fogadott Hosszú Passzok száma (>32 méter)',
      ShotsOnTarget: 'kapura készült lövések',
      AggressiveActions: 'A birtoklás elvesztése után következő két másodpercben megkísérelt Tackle-ek száma',
      Crosses: 'összes Beadások száma',
      xGBuildup5pass: 'Egy játékos által részt vett xG mennyisége, csak az utolsó 5 passz (kivéve lövések és lövéshez vezető passzok)',
      DefensiveDistance: 'Végzett védő párbajok átlagos távolsága a saját góltól',
      SpeedSequence: 'Egy csapat összes birtoklásának átlagos sebessége (méter/idő)',
      Touches: 'egy játékos által birtokolt labda alkalmainak száma',
      AerialsTotalOppHalf: 'ellenfél térfélen összes légi párbaj',
      AerialsWonOppHalf: 'Légi párbajok sikeresek az ellenfél felén',
      AerialsWonOppHalfPct: 'Ellenfél térfélen légi párbaj győzelmek százaléka',
      AerialsPctOppBox: 'Ellenfél tizenhatosban légi párbaj győzelmek százaléka',
      AerialsPctOwnBox: 'Saját tizenhatosban légi párbaj győzelmek százaléka',
      AerialDefensive: 'Összes légi párbaj, amikor az ellenfél csapat birtoklása van',
      AerialOffensive: 'Összes légi párbaj, amikor a saját csapat birtoklása van',
      AerialOffensivePct: 'Légi győzelmek százaléka, amikor a saját csapat birtoklása van',
      IndividualPressureOppHalf: 'Egy játékos által visszanyert birtoklások, amikor az ellenfél térfelén nyomást gyakorol az ellenfelekre',
      TouchesPerShot: 'Alkalmak száma, amikor a játékosok érintik a labdát lövésenként',
      PassesFinalThirdTotalPct: 'Passzok százaléka (sikeres és sikertelen) harmadik harmadba',
      xACrosses: 'beadásokból generált várható gólpasszok',
      Passes: 'összes passzok száma',
      PassesSuccessful: 'befejezett passzok száma',
      TacklesWasDribbledFouls: 'Megnyert tackle-ek százaléka az összes tackle és elkövetett szabálytalanságokhoz képest',
      OffsidesCaught: 'Lesben Fogott',
      ProgressivePassesReceivedFinalThird: 'Előrehaladó Passzok Fogadva Harmadik Harmadban',
      ProgressivePassesReceived: 'Előrehaladó Passzok Fogadva',
      Breadth: 'Tackle-ek, kihívások, elsodrások és elkövetett szabálytalanságok összege a pálya oldalain',
      DuelsDefTotal: 'Összes tackle-ek, védekező légi párbajok és elkövetett szabálytalanságok összege',
      DefensiveActions: 'Védő Akciók, amikor egy ellenfél driblinget próbál (Tackle-ek, Kihívások és Szabálytalanságok)',
      ProgressivePassesReceivedOppHalf: 'Előrehaladó Passzok Fogadva Ell. Térfél',
      CompletedCrossesOP: 'Befejezett Beadások Nyitott Játék',
      CrossingOP: 'Befejezett beadások százaléka az összes megkísérelt nyitott játék beadásból',
      CrossesOP: 'Keresztek teljes száma nyílt játék közben',
      PassingContribution: 'Százalék, amely méri a passzok veszélyét figyelembe véve a fogadó pozícióját',
      BallProgressionOppHalfInTeam: '% Labda előrehaladás ellenfél térfél csapatban',
      PassesOPIntoBoxInTeam: '% Passzok nyitott játék tizenhatosba csapatban',
      TouchesOppBoxInTeam: '% Érintések ellenfél tizenhatosban csapatban',
      xGOPInTeam: '% xG nyitott játék csapatban',
      DeepPasses: 'Passzok az ellenfél góljától 20 méteres sugáron kívülről, amelyek abban a területen belül végződnek',
      DeepPassesTotal: 'Az ellenfél kapujának 20 méteres körzetén kívülről megkísérelt beadások összesen, amelyek ezen a területen belül végződnek',
      DefensiveDuelsPct: 'Megnyert védő párbajok százaléka az összes védő párbajból',
      QuickRecoveriesPct: 'Gyors helyreállítások százaléka az elsodrásokhoz és megkísérelt tackle-ekhez',
      DiffDefensiveDistanceTeam: 'Különbség a játékos védő távolsága és a csapat védő távolsága között',
      xTPassing: 'Csak passzokból generált várható veszély',
      xTPassing100Passes: 'Csak passzokból generált várható veszély és 100 passzonként',
      ProgressivePassesAccurate: '10 méter vagy több befejezett passzok X tengelyen',
      PassAbility: 'Befejezett passzok aránya a várható passzokhoz (xP)',
      OPPassesIntoOppBoxPct: 'Nyitott játék befejezett passzok százaléka ellenfél tizenhatosba és nyitott játék megkísérelt passzok ellenfél tizenhatosba',
      EntriesOppBox: 'Passzok és labdavitelek száma ellenfél tizenhatosba',
      Crosses6yardBox: 'Hat yardosban végződő beadások összes száma',
      Cutbacks: 'Passzolás alapvonaltól hátra és ellenfél tizenhatosban belül',
      xTDribbling: 'Csak driblingekből generált várható veszély',
      AvgShotDistance: 'Készült összes lövés átlagos távolsága',
      xGOnTarget: 'Kapura készült lövésekből származó várható gólok',
      FinishingxGOT: 'Átlag feletti gólba végződő kapura lövések százaléka',
      DribblesWonOwnHalf: 'Saját térfélen készült sikeres driblingek',
      DribblesOwnHalf: 'Saját térfélen megkísérelt driblingek száma',
      DribblesOwnHalfPct: 'Saját térfélen készült sikeres és megkísérelt driblingek százaléka',
      DribblesWonOppHalf: 'Ellenfél térfélen készült sikeres driblingek',
      DribblesOppHalf: 'Ellenfél térfélen megkísérelt driblingek száma',
      DribblesOppHalfPct: 'Ellenfél térfélen készült sikeres és megkísérelt driblingek százaléka',
      DribblesWonFinalThird: 'Harmadik harmadban készült sikeres driblingek',
      DribblesFinalThird: 'Harmadik harmadban megkísérelt driblingek száma',
      DribblesFinalThirdPct: 'Harmadik harmadban készült sikeres és megkísérelt driblingek százaléka',
      ShotEndingHighRecoveries: 'Magas helyreállítások (40 méter vagy közelebb az ellenfél góljához történt helyreállítások) lövésben végződve',
      PassingFinalThirdAgainst: 'Ellenfelektől a harmadik harmadba sikeres passzok',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Ellenfelektől saját tizenhatosba megkísérelt passzok összes száma nyitott játékban',
      EntriesOppBoxAgainst: 'Ellenfelektől saját tizenhatosba passzok és labdavitelek száma',
      DeepProgressionAgainst: 'Alkalmak száma, amikor az ellenfél eléri a pálya utolsó ötödét labdavitel által, plusz a labda birtoklásának alkalmainak száma az első ötödben',
      TouchesInOpponentBoxAgainst: 'Alkalmak száma, amikor az ellenfél birtoklása van a labdának a mi tizenhatosunkban',
      Score: 'Játékos teljesítmény különböző metrikák alapján',
      PDScore: 'Játékos fizikai teljesítmény különböző fizikai metrikák alapján',
      OrlegiScore: 'Játékos teljesítmény különböző metrikák alapján',
      SirScore: 'Játékos teljesítmény különböző metrikák alapján',
      ExcScore: 'Játékos teljesítmény különböző metrikák alapján',
      xTOPInTeam: 'Nyitott játékban generált várható veszély csapatban',
      YellowCards: 'kapott sárga lapok',
      RedCards: 'kapott piros lapok',
      xTOpenPlayAgainst: 'nyitott játékban engedélyezett Várható Veszély',
      xTSetPieceAgainst: 'rögzített szituáció által engedélyezett Várható Veszély',
      NPGOpenPlayAgainst: 'nyitott játék akciókkal engedélyezett nem büntető gólok száma',
      NPGSetPieceAgainst: 'rögzített szituáció akciókkal engedélyezett nem büntető gólok száma',
      PassesOppHalfPerPossession: 'Passzok Ell. Térfél Birtoklásonként',
      AverageTimeRecovery: 'Átlagos Helyreállítási Idő',
      ExpectedPassing: 'Passzok százaléka, amelyeket be kellett volna fejezni',
      NumPossession10Passes: '10 vagy több passz által generált birtoklások',
      PassesReceived: 'Fogadott Passzok',
      PassesReceivedFinalThird: 'Fogadott Passzok Harmadik Harmadban',
      ProgressivePassesTotalPct: 'Előrehaladó Passzok százaléka',
      ShortPassesPct: 'Rövid Passzok százaléka',
      TouchesOppBoxOppTeam: 'Ellenfél akciók száma, amelyeket saját tizenhatosban engedélyeztek, amíg a játékos a pályán van',
      ShotsOnTargetOppTeam: 'Kapura lövések, amelyeket engedélyeztek, amíg a játékos a pályán van',
      NPGOppTeam: 'Nem büntető gólok, amelyeket engedélyeztek, amíg a játékos a pályán van',
      xGSetPiecePerxG: 'Rögzített szituáció által generált Várható Gólok egy várható gól generálásához',
      ShotsOpenPlay: 'Nyitott játék által generált lövések száma',
      ShotsOpenPlayAgainst: 'Nyitott játék által kapott lövések száma',
      ShotsFromDribble: 'Lövés, miután a játékos kicselezett egy ellenfelet',
      GoalsFromDribble: 'Gól, miután a játékos kicselezett egy ellenfelet',
      PassesIntoFinalThird: 'Sikeres passzok a támadó harmadba',
      PassesIntoFinalThirdTotal: 'Az összes passz megkísérelte, hogy kívülről kezdődjön és az utolsó harmadban belül végződjön',
      PassesInsideFinalThird: 'Sikeres passzok a támadó harmadon belül (kezdete és vége is ott)',
      PassesInsideFinalThirdTotal: 'Az utolsó harmadban megkísérelt passzok összesen (kezdete és vége az utolsó harmadban)',
      PassesFinalThirdNoArea: 'Passzol az utolsó harmadon (W/O Box)',
      PassesIntoOppBox: 'Sikeres passzok, melyek az ellenfél tizenhatosában végződnek',
      CarriesFinalThird: 'Legalább 7 méteres labdavezetések, amelyek a támadó harmadban végződnek',
      CarriesInsideFinalThird: 'Legalább 7 méteres labdavezetések a támadó harmadon belül',
      CarriesFinalThirdNoBox: 'Utolsó harmadot hordoz (W/O Box)',
      CarriesIntoOppBox: 'Legalább 7 méteres labdavezetések, amelyek az ellenfél tizenhatosában végződnek',
      TimePossessionAgainst: 'Az ellenfél labdabirtoklásának ideje',
      TimePossessionTotal: 'A két csapat összesített labdabirtoklása',
      PassesInBox: 'Sikeres passzok a saját tizenhatoson belül',
      LongThrowInSuccessful: 'Sikeres hosszú bedobás, amely meghaladja a 20 métert',
      LongThrowInTotal: '20 méternél hosszabb bedobások összes száma',
      LongThrowInPct: 'Sikeres hosszú bedobások aránya (20+ méter)',
      Games: 'Játszott játékok',
      PointsPerGame: 'Pontok játékonként',
      ExpectedPointsDiff: 'Várható pontkülönbség',
      PassesTotalOwnHalf: 'Saját térfélből leadott összes passzok száma',
      PassesOwnHalf: 'A saját térfélből leadott sikeres passzok száma',
      PassesTotalOppHalf: 'Az ellenfél feléről adott összes passzok száma',
      ProgressivePassesTotal: 'A 10 méteres vagy annál nagyobb áthaladások teljes száma az X-tengelyen',
      DuelsWon: 'Sikeres párharcok (Tackle-ek, Lövések, Labdaérintések, Csepelések és elkövetett szabálytalanságok)',
      NonPenaltySaves: 'Ment a büntetőlövések nélkül',
      BadActionsOppHalf: 'Az ellenfél térfelén elkövetett rossz cselekedetek összege',
      CarriesSuccessful: 'Sikeres eseménnyel végződő legalább 7 méteres szállítások száma',
      ShotsOnTargetOutBox: 'A dobozon kívülről célba kapott lövések',
      TotalDistance: 'Összes Távolság',
      WalkingDistance: 'Összes távolság, amit a játékos egy mérkőzésen 2 m/s (7.2 km/h) alatti sebességgel tett meg',
      JoggingDistance: 'Összes távolság, amit a játékos egy mérkőzésen 2 m/s (7.2 km/h) és 4 m/s (14.4 km/h) közötti sebességgel tett meg',
      RunningDistance: 'Összes távolság, amit a játékos egy mérkőzésen 4 m/s (14.4 km/h) és 5.5 m/s (19.8 km/h) közötti sebességgel tett meg',
      ExtremeAccelerations: 'Alkalmak száma, amikor a játékos 3 m/s<sup>2</sup> felett gyorsul',
      NumberOfRuns: '14.4 km/h és 19.8 km/h közötti sebességgel befejezett futások száma',
      HsrDistance: 'Magas Sebességű Futás Távolság > 19.8 km/h',
      HsrNumber: 'Magas Sebességű Futás Mennyiség > 19.8 km/h',
      HsrDistancePct: '% HSR Távolság',
      SprintsNumber: 'Sprint Mennyiség > 25.2 km/h',
      SprintsDistance: 'Sprint Távolság > 25.2 km/h',
      SprintNumberDeclinePct: '% Sprint Mennyiség Csökkenés',
      SprintDistanceDeclinePct: '% Sprint Távolság Csökkenés',
      SprintNumberDecline: 'Sprint számának csökkenése a második félidőhöz képest',
      SprintDistanceDecline: 'Sprint közben futott távolság csökkenése a második félidőhöz képest',
      SprintDistancePct: '% Sprint Távolság',
      Accelerations: 'Gyorsulások Mennyisége',
      MaxSpeed: 'Max. Sebesség',
      AvgMaxSpeed: 'A játékos által elért maximális sebesség átlaga',
      MaxAccelerations: 'A játékos által elért maximális méter/másodperc<sup>2</sup>',
      BypassedPlayersByPasses: 'Összes megkerült ellenfél (védők és középpályások) passzokkal',
      BypassedDefendersByPasses: 'Összes megkerült ellenfél (védők) passzokkal',
      PassesBypassingPlayers: 'Játékosokat megkerülő passzok száma',
      PassesBypassingDefenders: 'Védőket megkerülő passzok száma',
      BypassedPlayersPerPass: 'Összes megkerült játékos passzonként',
      BypassedDefendersPerPass: 'Összes megkerült védő passzonként',
      LineBreakingPasses: 'Passzok száma, amelyek sikeresen átszakítanak egy vagy több védő vonalat',
      LineBreakingPassesMD: 'Passzok száma, amelyek sikeresen átszakítanak középpályás és védő vonalakat',
      LineBreakingPassesM: 'Passzok száma, amelyek sikeresen átszakítanak középpályás vonalat',
      LineBreakingThroughBalls: 'Passzok száma, amelyek sikeresen átszakítanak védő vonalat',
      LineBreakingPassesPerPass: 'Vonalat átszakító passzok százaléka passzonként',
      TotalPassesUnderStrongPressure: 'Összes passz erős nyomás alatt (legközelebbi ellenfél 0-2 méteren belül)',
      TotalPassesUnderLightPressure: 'Összes passz nyomás alatt (legközelebbi ellenfél 2-4 méteren belül)',
      SuccessfulPassesUnderStrongPressure: 'Sikeres passzok száma erős nyomás alatt (legközelebbi ellenfél 0-2 méteren belül)',
      SuccessfulPassesUnderLightPressure: 'Sikeres passzok száma nyomás alatt (legközelebbi ellenfél 2-4 méteren belül)',
      PassingUnderStrongPressure: 'Sikeres passzok és összes passz százaléka erős nyomás alatt (legközelebbi ellenfél 0-2 méteren belül)',
      PassingUnderLightPressure: 'Sikeres passzok és összes passz százaléka nyomás alatt (legközelebbi ellenfél 2-4 méteren belül)',
      PassReceiptsInSpaceCompleted: 'Passzok, ahol a fogadó a támadó térfélen van és nincs védő 5 méteres sugárban a gól iránya felé',
      PassReceiptsInSpace: 'Fogadott passzok a támadó térfélen, ahol nincs védő 5 méteres sugárban a gól iránya felé',
      PassReceiptsInSpaceCompletedFirstThird: 'Passzok, ahol az átvevő az első harmadban van, és nincs védő 5 méteren belül a kapu irányába',
      PassReceiptsInSpaceCompletedSecondThird: 'Passzok, ahol az átvevő a középső harmadban van, és nincs védő 5 méteren belül',
      PassReceiptsInSpaceCompletedFinalThird: 'Passzok, ahol az átvevő a támadó harmadban van, és nincs védő 5 méteren belül',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Passzok, ahol az átvevő az ellenfél jobb oldalán van, védő nélkül 5 méteren belül',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Passzok, ahol az átvevő az ellenfél közepén van, védő nélkül 5 méteren belül',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Passzok, ahol az átvevő az ellenfél bal oldalán van, védő nélkül 5 méteren belül',
      PassReceiptsInSpaceFirstThird: 'Passzok, amelyeket az első harmadban vettek át védő nélkül 5 méteren belül',
      PassReceiptsInSpaceSecondThird: 'Passzok, amelyeket a középső harmadban vettek át védő nélkül',
      PassReceiptsInSpaceFinalThird: 'Passzok, amelyeket a támadó harmadban vettek át védő nélkül',
      PassReceiptsInSpaceOppHalfRight: 'Passzok, amelyeket az ellenfél jobb oldalán vettek át védő nélkül',
      PassReceiptsInSpaceOppHalfCenter: 'Passzok, amelyeket az ellenfél közepén vettek át védő nélkül',
      PassReceiptsInSpaceOppHalfLeft: 'Passzok, amelyeket az ellenfél bal oldalán vettek át védő nélkül',
      TotalStrongOnBallPressures: 'Erős labdanyomások száma (labdavitel 0-2 méteren belül)',
      TotalLightOnBallPressures: 'Labdanyomások száma (labdavitel 2-4 méteren belül)',
      SuccessfulStrongOnBallPressures: 'Sikeres erős labdanyomások száma (0-2 méteren belül)',
      SuccessfulLightOnBallPressures: 'Sikeres labdanyomások száma (2-4 méteren belül)',
      StrongOnBallPressuresPct: 'Sikeres és összes erős labdanyomások százaléka (legközelebbi ellenfél 0-2 méteren belül)',
      LightOnBallPressuresPct: 'Sikeres és összes labdanyomások százaléka (legközelebbi ellenfél 2-4 méteren belül)',
      TimesBypassedByPasses: 'Összes alkalom, amikor passzokkal megkerülték',
      TimesBypassedByCarries: 'Összes alkalom, amikor labdavitelekkel megkerülték',
      TimesBypassedByActions: 'Összes alkalom, amikor passzokkal és labdavitelekkel kombinálva megkerülték',
      BypassedPlayersByCarries: 'Összes megkerült ellenfél (védők és középpályások) labdavitelekkel',
      BypassedDefendersByCarries: 'Összes megkerült ellenfél (védők) labdavitelekkel',
      BypassedPlayersByActions: 'Összes megkerült ellenfél (védők és középpályások) passzokkal és labdavitelekkel kombinálva',
      BypassedDefendersByActions: 'Összes megkerült ellenfél (védők) passzokkal és labdavitelekkel kombinálva',
      CarriesBypassingPlayers: 'Játékosokat megkerülő labdavitelek száma',
      CarriesBypassingDefenders: 'Védőket megkerülő labdavitelek száma',
      BypassedPlayersPerCarry: 'Átlagos megkerült ellenfelek száma labdavitelenként (legalább 7 méter)',
      BypassedDefendersPerCarry: 'Átlagos megkerült védők száma labdavitelenként (legalább 7 méter)',
      LineBreakingCarries: 'Labdavitelek száma, amelyek sikeresen átszakítanak egy vagy több védő vonalat',
      LineBreakingCarriesMD: 'Labdavitelek száma, amelyek sikeresen átszakítanak középpályás és védő vonalakat',
      LineBreakingCarriesM: 'Labdavitelek száma, amelyek sikeresen átszakítanak középpályás vonalat',
      LineBreakingCarriesD: 'Labdavitelek száma, amelyek sikeresen átszakítanak védő vonalat',
      LineBreakingCarriesPerCarry: 'Vonalat átszakító labdavitelek százaléka labdavitelenként',
      LineBreakingActions: 'Passzok és labdavitelek kombinált száma, amelyek sikeresen átszakítanak egy vagy több védő vonalat',
      LineBreakingActionsMD: 'Passzok és labdavitelek kombinált száma, amelyek sikeresen átszakítanak középpályás és védő vonalakat',
      LineBreakingActionsM: 'Passzok és labdavitelek kombinált száma, amelyek sikeresen átszakítanak középpályás vonalat',
      LineBreakingActionsD: 'Passzok és labdavitelek kombinált száma, amelyek sikeresen átszakítanak védő vonalat',
      PassesPerLineBreakingPass: 'Arány az összes passz és vonalat átszakító passz között',
      CarriesPerLineBreakingCarry: 'Arány az összes labdavitel és vonalat átszakító labdavitel között',
      LinesBrokenByPasses: 'Összes átszakított vonal passzokkal',
      LinesBrokenByCarries: 'Összes átszakított vonal labdavitelekkel',
      LinesBrokenByActions: 'Összes átszakított vonal passzokkal és labdavitelekkel kombinálva',
      LinesBrokenPerPass: 'Arány az összes átszakított vonal és passz között',
      LinesBrokenPerCarry: 'Arány az összes átszakított vonal és labdavitel között',
      AvgLastDefenderDistanceIP: 'Távolság az utolsó védő (legközelebb a saját gólhoz) és a gólvonal között birtoklásban',
      AvgLastDefenderDistanceOOP: 'Távolság az utolsó védő (legközelebb a saját gólhoz) és a gólvonal között birtoklás nélkül',
      AvgDefensiveLineDistanceIP: 'Távolság a legmélyebb védő vonal pozíciója és a gól között birtoklásban',
      AvgDefensiveLineDistanceOOP: 'Távolság a legmélyebb védő vonal pozíciója és a gól között birtoklás nélkül',
      AvgRBDistanceIP: 'Távolság a jobb szélső védőtől a saját góljához birtoklásban',
      AvgRBDistanceOOP: 'Távolság a jobb szélső védőtől a saját góljához birtoklás nélkül',
      AvgLBDistanceIP: 'Távolság a bal szélső védőtől a saját góljához birtoklásban',
      AvgLBDistanceOOP: 'Távolság a bal szélső védőtől a saját góljához birtoklás nélkül',
      AvgBlockDistanceIP: 'Távolság a legmélyebb és legelőrehaladottabb mezőnyi játékos között birtoklásban',
      AvgBlockDistanceOOP: 'Távolság a legmélyebb és legelőrehaladottabb mezőnyi játékos között birtoklás nélkül',
      AvgBlockAreaIP: 'Az összes mezőnyi játékost körülvevő határoló doboz területe (a csapat által elfoglalt tér mértéke) birtoklásban',
      AvgBlockAreaOOP: 'Az összes mezőnyi játékost körülvevő határoló doboz területe (a csapat által elfoglalt tér mértéke) birtoklás nélkül',
      AvgDefensiveLineWidthOOP: 'A játékosok leghátsó vonalának szélessége (legtávolabb a saját góljuktól) birtoklás nélkül',
      AvgOffensiveLineLastThirdWidthIP: 'A támadó vonal vízszintes szélessége az utolsó harmadban birtoklásban',
      AvgLByIP: 'A bal szélső védő pozíciója birtoklásban',
      AvgRByIP: 'A jobb szélső védő pozíciója birtoklásban',
      AvgOffensiveLineDistanceIP: 'Távolság a saját gól és a támadó vonal között birtoklásban',
      AvgOffensiveLineLastThirdDistanceIP: 'Távolság a saját gól és a támadó vonal között az utolsó harmadban birtoklásban',
      AvgOffensiveLineWidthIP: 'A támadó vonal vízszintes szélessége birtoklásban',
      OffBallRuns: 'Szándékos labda nélküli mozgások (futások) a támadó fázis támogatásához',
      OffBallRunsOverlap: 'Futások, ahol a játékos egy csapattársa külső oldalán mozog (közelebb a partvonalhoz), amíg az a csapattárs birtokában van a labda',
      OffBallRunsUnderlap: 'Futások, ahol a játékos egy csapattársa belsejében mozog, belső útvonalat követve (közelebb a pálya közepéhez)',
      OffBallRunsRunAhead: 'Előre futás, amely túlhaladja a labdavitelet, de az utolsó védő előtt marad',
      OffBallRunsRunBehind: 'Előre futás, amely behatol az utolsó védő vonalba, a védők és a kapus közé kerülve',
      OffBallRunsCrossReceiver: 'Egy játékos a tizenhatosba fut és pozícionálódik, hogy fogadjon egy beadást egy csapattársától',
      OffBallRunsSupport: 'A játékos a labdavitel mellé fut, közelben passzolási lehetőséget kínálva a támadásban',
      OffBallRunsComingShort: 'A játékos a labdavitel felé mozog, hogy közeli támogatást vagy passzolási lehetőséget kínáljon a góltól távol',
      AerialsOppHalf: 'ellenfél térfélen sikeres légi párbaj',
      CarriesIntoFinalThird: 'Legalább 7 méteres csővezetékek kívülről befelé az utolsó harmadban',
      DribblesAttempted: 'A kísérletek száma',
      SpeedScore: 'A játékos fizikai teljesítménye különböző sebességmérők alapján',
      EnduranceScore: 'Játékos állóképességi fizikai teljesítmény különböző mérőszámok alapján',
      GoalsConceded: 'Kapott gólok száma',
      HeadedGoals: 'A fejjel szerzett gólok száma',
      SavesInBox: 'A dobozon belüli lövésekből származó mentések száma',
      SavesOutBox: 'A dobozon kívüli lövésekből származó mentések száma',
      ShotsOnTargetInBoxAgainst: 'A tizenhatoson belülről leadott lövések száma',
      ShotsOnTargetOutBoxAgainst: 'A tizenhatoson kívülről leadott lövések száma',
      SwitchPlaySuccessful: 'Olyan befejezett passzok száma 32 méter felett, ahol a labda oldalirányú elmozdulása nagyobb, mint az ellenfél kapuja felé történő elmozdulása',
      SwitchPlayTotal: 'A 32 méter feletti passzkísérletek száma, ahol a labda oldalirányú elmozdulása nagyobb, mint az ellenfél kapuja felé történő elmozdulása',
      PassesInsideOppHalf: 'Azok a passzok száma, amelyek az ellenfél térfelén kezdődnek és végződnek',
      PassesInsideOppHalfSuccessful: 'Azok a teljesített passzok száma, amelyek az ellenfél térfelén kezdődnek és végződnek',
      TacklesAttemptedFirstThird: 'A pálya első harmadában megkísérelt szerelések teljes száma',
      TacklesAttemptedSecondThird: 'Az összes szerelési kísérlet a pálya második harmadában',
      TacklesFirstThird: 'Sikeres szerelések száma a pálya első harmadában',
      TacklesSecondThird: 'Sikeres szerelések száma a pálya második harmadában',
      FoulsOwnHalf: 'A játékos saját térfelén elkövetett szabálytalanságok száma',
      TouchesOppHalf: 'Labdaérintések száma az ellenfél térfelén',
      TacklesAttemptedNotAdjusted: 'A megkísérelt ütések teljes száma, labdabirtoklás módosítása nélkül',
      TacklesSuccessfulNotAdjusted: 'Sikeres tackle-ek teljes száma labdabirtoklás-korrekció nélkül',
      AvgTop5MaxSpeed: 'A játékos öt legnagyobb maximális sebességének átlaga',
      LBPReceived: 'A kapott sorbontó passzok száma',
      LBPMReceived: 'Azok a passzok száma, amelyek áttörik az ellenfél középpályás vonalát',
      LBPMDReceived: 'Azok a passzok száma, amelyek áttörik az ellenfél középpályáját és a védővonalat',
      ThroughBallReceived: 'Azok a passzok száma, amelyek áttörték az ellenfél utolsó védővonalát',
      ShortPassesSuccessful: 'A teljesített rövid (12 méternél kisebb) áthaladások száma',
      PassingSuccessForwardPct: 'Sikeres előrepasszok százalékos aránya',
      PassingSuccessBackwardPct: 'A sikeres hátrapasszok százalékos aránya',
      PassingForwardBackwardPct: 'Az előre passzok és a hátra passzok aránya',
      LongBallPerPassesPct: 'A hosszú labdák százalékos aránya az összes passzokhoz viszonyítva',
      LongBallReceivedOppHalf: 'A rivális mezőnyben kapott hosszú labdák száma',
      OffensiveActions: 'Támadó akciók',
      SuccessfulDribblesPct: 'Sikeres dribbelés/csöpögtetési kísérletek száma',
      OffensiveTouchesOutBoxPct: '%-a támadó érintések a dobozon kívül',
      HsrDistanceIP: 'Sprinttáv >21 km/h birtokban',
      HsrDistanceOOP: 'Sprint távolság >21 km/h birtokon kívül',
      JoggingDistanceIP: 'Kocogási távolság birtokában',
      JoggingDistanceOOP: 'Kocogási távolság birtokon kívül',
      RunningDistanceIP: 'Futótáv birtokában',
      RunningDistanceOOP: 'Futótáv a birtokból',
      SprintsDistanceIP: 'Sprinttáv >24 km/h birtokban',
      SprintsDistanceOOP: 'Sprint távolság >24 km/h birtokon kívül',
      WalkingDistanceIP: 'Gyalogos távolság birtokban',
      WalkingDistanceOOP: 'Séta távolságra a birtokon kívül',
      PossessionRegain: 'Ahányszor kényszeríted az ellenfelet a labdaszerzés elvesztésére',
      HandPassesSuccessful: 'Kézzel adott sikeres passzok (kapusok vagy bedobás szettlabdában)',
      HandPassesTotal: 'Kézzel adott passzok teljes száma (kapusok vagy bedobott labdák)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances: 'Number of times the player hits the ball clear of the defensive zone',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player (via Tackles or Interceptions)'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'BAOPPH',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'SOTOB',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'ZOKOGÁS',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP%',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRSC',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      HeadedXG: 'xG fejjel',
      HeadedSetPieceTooltip: 'Csak azok a játékosok láthatók, akiknek van fejléce a szettlabdákból',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
      DistanceIP: 'DST IP',
      WalkingDistanceIP: 'WLKD IP',
      JoggingDistanceIP: 'JOGD IP',
      RunningDistanceIP: 'RUND IP',
      HsrDistanceIP: 'HSRD IP',
      SprintsDistanceIP: 'SPRD IP',
      RunningNumberIP: 'RUNQ IP',
      HsrNumberIP: 'HSRQ IP',
      SprintsNumberIP: 'SPRQ IP',
      DistanceOOP: 'DST OOP',
      WalkingDistanceOOP: 'WLKD OOP',
      JoggingDistanceOOP: 'JOGD OOP',
      RunningDistanceOOP: 'RUND OOP',
      HsrDistanceOOP: 'HSRD OOP',
      SprintsDistanceOOP: 'SPRD OOP',
      RunningNumberOOP: 'RUNQ OOP',
      HsrNumberOOP: 'HSRQ OOP',
      SprintsNumberOOP: 'SPRQ OOP',
      PossessionRegain: 'PR',
      HandPassesSuccessful: 'SHP',
      HandPassesTotal: 'THP',
      InterceptionsNotAdjusted: 'INT',
      ClearancesNotAdjusted: 'CLE',
      RecoveriesNotAdjusted: 'REC'
    },
    AerialsOppHalf: 'Légi Ell. Térfél',
    CarriesIntoFinalThird: 'Az utolsó ⅓-ig hajt',
    scoreDifference: 'Pontkülönbség: Megmutatja, hogy a játék teljesítménye a szezon átlaga feletti vagy alatti volt',
    SpeedScore: 'Speed ​​Power Score',
    EnduranceScore: 'Kitartási pontszám',
    SwitchPlaySuccessful: 'A lejátszás váltása sikeres',
    SwitchPlayTotal: 'Switch Play Total',
    PassesInsideOppHalf: 'Passzol az Opp Half-on belül',
    PassesInsideOppHalfSuccessful: 'Sikeresen passzol az Opp-on belül',
    TacklesAttemptedFirstThird: 'Az első kísérlet ⅓',
    TacklesAttemptedSecondThird: 'Második ⅓ megkísérli',
    TacklesFirstThird: 'Először ⅓ sikeres',
    TacklesSecondThird: 'Sikeres második ⅓',
    FoulsOwnHalf: 'Faults saját félidőben',
    TouchesOppHalf: 'Megérinti az Opp Felet',
    TacklesAttemptedNotAdjusted: 'Megpróbált kezelni, nem igazítva',
    TacklesSuccessfulNotAdjusted: 'Sikeres, nem korrigált megoldások',
    AvgTop5MaxSpeed: 'Átl. Top5 MaxSpeed',
    LBPReceived: 'Vonaltörési passz érkezett',
    LBPMReceived: 'Vonaltörés passzok (M vonal) érkezett',
    LBPMDReceived: 'Vonaltörési jelek (MD vonal) érkezett',
    ThroughBallReceived: 'A kapott labdákon keresztül',
    recoveriesRate: 'Megtérülési arány',
    turnoversRate: 'Veszteségarány',
    HeadedShots: 'Fejlécek',
    HeadedXG: 'xG fejjel',
    HeadedSetPieceTooltip: 'Csak azok a játékosok láthatók, akiknek van fejléce a szettlabdákból',
    HsrDistanceIP: 'HSR távolság IP',
    HsrDistanceOOP: 'HSR távolság OOP',
    JoggingDistanceIP: 'Kocogási távolság IP',
    JoggingDistanceOOP: 'Jogging Distance OOP',
    RunningDistanceIP: 'Futótávolság IP',
    RunningDistanceOOP: 'Futótáv OOP',
    SprintsDistanceIP: 'Sprint távolság IP',
    SprintsDistanceOOP: 'Sprint távolság OOP',
    WalkingDistanceIP: 'Gyalogtávolság IP',
    WalkingDistanceOOP: 'Gyalog távolság OOP',
    PossessionRegain: 'Birtoklás visszaszerzése',
    HandPassesSuccessful: 'Sikeres kézpasszok',
    HandPassesTotal: 'Kéz Pass',
    SprintsNumberIP: 'Sprint Mennyiség IP',
    SprintsNumberOOP: 'Sprint Mennyiség OOP',
    RunningNumberIP: 'Futómennyiség IP',
    RunningNumberOOP: 'Futó mennyiség OOP',
    HsrNumberIP: 'HSR Mennyiség IP',
    HsrNumberOOP: 'HSR Mennyiség OOP',
    InterceptionsNotAdjusted: 'Interceptions',
    ClearancesNotAdjusted: '',
    RecoveriesNotAdjusted: 'Recoveries'
  },
  team: {
    title: 'Csapat Lap',
    subtitle: 'Merüljön el mélyebben a csapat jellemzőiben és statisztikáiban',
    averageAge: 'Átlagos életkor',
    transferBalance: 'Átigazolási Egyenleg',
    roster: 'Keret',
    stadium: 'Stadion',
    coach: 'Edző',
    transfers: 'Átigazolások',
    trends: 'Trendek',
    loans: 'Kölcsönzések',
    loanFrom: 'Kölcsön innen',
    loanTo: 'Kölcsön ide',
    latestGames: 'Legutóbbi Mérkőzések',
    latestXGames: 'Legutóbbi {0} Mérkőzés',
    playingFor: 'Játszik',
    overview: 'Áttekintés',
    visualization: 'Vizualizáció',
    location: 'Helyszín',
    outcome: 'Eredmény',
    beeswarm: 'Rangsor',
    parentTeam: 'Főcsapat',
    childTeam: 'Ifjúsági Csapat',
    preferredFormation: 'Előnyben Részesített Felállás',
    mostFrecuentFormations: 'Leggyakoribb felállások',
    viewType: 'Nézet Típusa',
    overviewTab: {
      axisXTotal: 'Összes',
      axisXper90: '90 perc alatt',
      dataPerGameText: 'Adatok mérkőzésenként',
      season: 'Szezon',
      last: 'Előző',
      current: 'Jelenlegi',
      TeamStyle: 'Stílus',
      TeamDefensive: 'Védekező',
      TeamOffensive: 'Támadó',
      TeamCustom1: 'Egyedi 1',
      TeamCustom2: 'Egyedi 2',
      TeamCustom3: 'Egyedi 3',
      TeamCustom4: 'Egyedi 4',
      coach: 'Edző',
      groups: {
        Goals: {
          name: 'Gólok',
          desc: 'Büntető Gólokat és Nem Büntető Gólokat mutat (Nyitott Játék és Rögzített Szituáció).'
        },
        Assists: {
          name: 'Gólpasszok',
          desc: 'Játékosok több Gólpasszal (Nyitott Játék és Rögzített Szituáció) ebben a szezonban.'
        },
        xG: {
          name: 'Várható Gólok',
          desc: 'Várható Gólok Nyitott Játékból és Rögzített Szituációból'
        },
        xA: {
          name: 'Várható Gólpasszok',
          desc: 'Várható Gólpasszok Nyitott Játékból és Rögzített Szituációból.'
        },
        Finishing: {
          name: 'Befejezés',
          desc: 'Góllal végződő lövések százaléka.'
        },
        ScoringContribution: {
          name: 'Gólszerzési Hozzájárulás',
          desc: 'A csapat Gólpasszainak és Góljainak száma.'
        },
        xT: {
          name: 'Várható Veszély',
          desc: 'Várható Veszély generálva Nyitott Játékból, Rögzített Szituációból és negatív xT-ből.'
        }
      },
      stats: {
        openPlay: 'Nyitott Játék',
        setPiece: 'Rögzített Szituáció',
        negative: 'Negatív',
        npg: 'Nem Büntető Gólok',
        goalsPenalty: 'Büntető Gólok',
        npgOpenPlay: 'NPG Nyitott Játék',
        npgSetPiece: 'NPG Rögzített Szituáció',
        assists: 'Gólpasszok',
        assistsConceded: 'Kapott Gólpasszok',
        assistsOpenPlay: 'Gólpasszok Nyitott Játék',
        assistsSetPiece: 'Gólpasszok Rögzített Szituáció',
        xGOpenPlay: 'xG Nyitott Játék',
        xGSetPiece: 'xG Rögzített Szituáció',
        xAOpenPlay: 'xA Nyitott Játék',
        xASetPiece: 'xA Rögzített Szituáció',
        xAConceded: 'Kapott xA',
        nonPenaltyShots: 'Nem Büntető Lövések',
        penaltyShots: 'Büntető Lövések',
        xT: 'Várható Veszély',
        xTOpenPlay: 'xT Nyitott Játék',
        xTSetPiece: 'xT Rögzített Szituáció',
        xTNeg: 'Negatív xT',
        totalFinishing: 'Befejezés',
        nonPenaltyFinishing: 'Nem Büntető Befejezés',
        goalsPenaltyFinishing: 'Büntető Befejezés',
        goal: 'Gól',
        notGoal: 'Nem Gól',
        chance: 'Helyzet',
        finished: 'Befejezett',
        notFinished: 'Nem Befejezett',
        walkingDistance: 'Sétálás',
        joggingDistance: 'Kocogás ',
        runningDistance: 'Futás ',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprint',
        runningNumber: 'Futások',
        hsrNumber: 'HSR Sprint',
        sprintsNumber: 'Sprint',
        maxSpeed: 'Max. Sebesség',
        accelerations: 'Gyorsulások',
        extremeAccelerations: 'Extrém gyorsulások',
        maxAcceleration: 'Maximális gyorsulás'
      }
    },
    teamAnalysis: 'Csapat Elemzés',
    agentView: {
      positions: {
        gk: 'GK',
        leftFullback: 'Bal Szélső Védő',
        centralDefender: 'Középső Védő',
        rightFullback: 'Jobb Szélső Védő',
        midfielder: 'Középpályás',
        attackingMidfielder: 'Támadó Középpályás',
        leftWinger: 'Bal Szélső',
        rightWinger: 'Jobb Szélső',
        fw: 'Csatár'
      },
      groups: {
        contractEnd: 'Hónapok',
        age: 'Éves',
        availability: 'Elérhetőség'
      },
      placer: {
        legend: 'Erősség életkor, szerződés, elérhetőség és teljesítmény alapján'
      }
    },
    transfersTab: {
      valueMovements: 'Mozgások Értéke',
      valueTransfers: 'Átigazolások Értéke',
      valueLoans: 'Kölcsönzések Értéke',
      avgAgeMovements: 'Mozgások Átlagos Életkora',
      avgAgeTransfers: 'Átigazolások Átlagos Életkora',
      avgAgeLoans: 'Kölcsönzések Átlagos Életkora',
      operations: {
        buys: {
          buy: 'Vétel',
          loan: 'Kölcsön',
          'end of loan': 'Kölcsön Vége',
          'free transfer': 'Ingyenes',
          free: 'Ingyenes',
          'loan transfer': 'Kölcsön',
          other: 'Egyéb'
        },
        sells: {
          buy: 'Eladás',
          loan: 'Kölcsön',
          'end of loan': 'Kölcsön Vége',
          'free transfer': 'Ingyenes',
          free: 'Ingyenes',
          'loan transfer': 'Kölcsön',
          other: 'Egyéb',
          retired: 'Visszavonult'
        }
      }
    },
    trendsTab: {
      streaks: 'Sorozatok',
      wins: 'Győzelmek',
      cleanSheets: 'Kapott Gól Nélküli Mérkőzések',
      goalPeriods: 'Szerzett Gól Időszakok',
      concededGoalPeriods: 'Kapott Gól Időszakok',
      comebacks: 'Visszavágások',
      avgTime: 'Átlagos Idő',
      kindOfGoals: 'Gól Típusok',
      percentWinning: '% Győzelem',
      percentDrawing: '% Döntetlen',
      percentLosing: '% Vereség',
      totalOf: 'Összesen',
      minutes: 'perc',
      before: 'Előtte',
      after: 'Utána',
      playedOn: 'Játszott',
      scored: 'Szerzett',
      conceded: 'Kapott',
      ownGoals: 'Öngólok',
      phasesOfGame: 'Játék Fázisok',
      intensityLabel: 'Zóna intenzitás',
      intensityByTeam: 'Csapat szerint %',
      intensityByLeagueAvg: 'Liga átlag szerint %',
      buildup: 'Felépítés',
      midfieldProgression: 'Középpálya Előrehaladás',
      attackOpposition: 'Ellenfél Támadás',
      attackingTransition: 'Támadó Átmenet',
      highPress: 'Magas Nyomás',
      midBlock: 'Középső Blokk',
      lowBlock: 'Alacsony Blokk',
      defensiveTransition: 'Védekező Átmenet',
      draws: 'Döntetlenek',
      losts: 'Vesztesek',
      chokes: 'Fogyasztások',
      zoneTooltip: 'Meghatározza az egyes blokkok színátmenetéhez használt feltételeket:',
      teamPctTooltip: 'Az egyes zónákban a csapat által lejátszott teljes idő százalékos aránya alapján.',
      leagueAvgPctTooltip: 'Összehasonlítja a csapat százalékos arányát az egyes zónák ligaátlagával.',
      leagueAvgMinsTooltip: 'Ugyanazokat az összehasonlítási kritériumokat alkalmazza a bajnoksággal szemben, de a teljes időt percekben, nem pedig százalékokban értékeli.',
      losses: 'Veszteség',
      results: 'Eredmények',
      kindOfConcededGoals: 'Megadott góltípusok',
      showMinutes: 'Mutasd a perceket'
    },
    onOff: 'Bekapcsolva/Kikapcsolva',
    dragUpToXPlayers: 'Húzzon legfeljebb {x} játékost',
    selectUpToXPlayers: 'Válasszon legfeljebb {x} játékost',
    onOffTab: {
      G90: 'Gólok 90',
      GA90: 'Kapott Gólok 90',
      diffG90: 'Gól Különbség 90',
      XG90: 'xG 90',
      XGA90: 'Kapott xG 90',
      diffXG90: 'xG Különbség 90',
      playersOn: 'Kombináció BE',
      playersOff: 'Kombináció KI',
      ground: 'Pálya',
      playersOnThePitch: 'Játékosok a pályán',
      playersOffThePitch: 'Játékosok a pályán kívül',
      attackTitle: 'Támadás',
      attackSubTitle: 'Támadó Statisztikák',
      defenseTitle: 'Védekezés',
      defenseSubTitle: 'Védő Statisztikák',
      associationTitle: 'Kapcsolat',
      associationSubTitle: 'Kapcsolati Statisztikák',
      comboOn: 'Aktív Kombináció',
      comboOff: 'Bármi más',
      diffGoals90: 'G Különbség 90',
      goals90: 'Nem Büntető Gólok 90',
      goalsAgainst90: 'Kapott Nem Büntető Gólok 90',
      xgAgainstPer90: 'Kapott xG 90',
      xgDiffPer90: 'xG Különbség 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Kapura Lövések 90',
      touchesOppBox90: 'Érintések Ell. Tizenhatosban 90',
      shotsOnTargetAgainst90: 'Kapott Kapura Lövések 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Közvetlenség 90',
      possession: 'Birtoklás %',
      pctPasses: 'Passzok %',
      pctPassesFinalThird: 'Passzok Harmadik Harmadban %',
      placeholder: 'Kezdje egy csapat kiválasztásával',
      subtitle: 'Optimalizálja a csapat metrikáit játékosok hozzáadásával vagy eltávolításával a felállásból'
    },
    terms: {
      short: 'Rövid Távú',
      mid: 'Középtávú',
      long: 'Hosszú Távú'
    },
    report: {
      title: 'Csapat Jelentés',
      selectedPeriod: 'Kiválasztott Időszak',
      stackedCharts: 'Összevont Diagramok',
      radars: 'Radarok',
      generalData: 'Általános Adatok',
      scoringChances: 'Gólszerzési Helyzetek',
      areasReport: 'Területek Jelentés',
      setPieceReport: 'Rögzített Szituáció Jelentés',
      corners: 'Szögletek',
      cornersAgainst: 'Kapott Szögletek',
      indirectFreeKicks: 'Közvetett Szabadrúgások',
      indirectFreeKicksAgainst: 'Kapott Közvetett Szabadrúgások',
      freeKicks: 'Szabadrúgások',
      freeKicksAgainst: 'Kapott Szabadrúgások',
      penaltys: 'Büntetők',
      freeKicksContribution: 'Szabadrúgások Hozzájárulás',
      shotsContribution: 'Lövések Hozzájárulás',
      topXPlayersByStats: 'Top {x} Játékos Statisztikák Szerint',
      lastShotZone: 'Utolsó Zóna Lövés',
      throwSide: 'Bedobás Oldal',
      kindOfThrow: 'Bedobás Típusa',
      scored: 'Szerzett',
      against: 'Ellen',
      perGame: 'mérkőzésenként',
      total: 'Összes',
      efficiency: 'Hatékonyság',
      organizedAttack: 'Szervezett Támadás',
      offTransition: 'Támadó Átmenet',
      chances: 'Helyzetek',
      chancesScored: 'Szerzett Helyzetek',
      chancesAgainst: 'Kapott Helyzetek',
      goalsScored: 'Szerzett Gólok',
      goalsAgainst: 'Kapott Gólok',
      goalsOrganizedAttack: 'Szervezett Támadás Gólok',
      goalsOffTransition: 'Támadó Átmenet Gólok',
      goalsSetPiece: 'Rögzített Szituáció Gólok',
      goalsOrganizedAttackScored: 'Szervezett Támadás Szerzett Gólok',
      goalsOrganizedAttackAgainst: 'Szervezett Támadás Kapott Gólok',
      goalsOffTransitionScored: 'Támadó Átmenet Szerzett Gólok',
      goalsOffTransitionAgainst: 'Támadó Átmenet Kapott Gólok',
      goalsSetPieceScored: 'Rögzített Szituáció Szerzett Gólok',
      goalsSetPieceAgainst: 'Rögzített Szituáció Kapott Gólok',
      crossSide: 'Beadás Oldal',
      externalShot: 'Külső Lövés',
      innerPlay: 'Belső Játék',
      throwIn: 'Bedobás',
      box: 'Tizenhatos',
      zone2: 'Zóna 2',
      goalsPerPhases: 'Gólok Fázisonként'
    },
    minutesAlert: '*Csak 450 vagy több percet játszott játékosok láthatók',
    minutesException: 'Nincsenek 450 vagy több percet játszott játékosok. Minden játékos megjelenítése',
    analysis: 'Elemzés',
    substitutions: 'Cserék',
    attackZones: 'Támadó Zónák',
    formations: 'Felállások',
    shotZones: 'Lövés Zónák',
    crossings: 'Beadások',
    byTime: 'Idő Szerint',
    byPosition: 'Pozíció Szerint',
    byPlayer: 'Játékos Szerint',
    W: 'Győzelem',
    D: 'Döntetlen',
    L: 'Vereség',
    substitutionsByGame: 'Cserék mérkőzésenként',
    substitutionsShort: 'Cs.',
    avgSeasonShort: 'Átlag. Szezon',
    startingAt: 'Kezdés',
    endingAt: 'Végződés',
    startingAtInfo: 'Birtoklások arányát mutatja az első esemény helye alapján',
    endingAtInfo: 'Birtoklások arányát mutatja az utolsó esemény helye alapján',
    endingWithShot: 'Lövésben végződő',
    endingInBox: 'Tizenhatosban végződő',
    pfX: 'PF {x}',
    bySide: 'Oldal Szerint',
    cornerKicks: 'Szögletek',
    included: 'Beleértve',
    excluded: 'Kizárva',
    onlyCorner: 'Csak Szöglet',
    sizeByMarketValue: 'Méret Piaci Érték Szerint',
    timeInTeam: 'Szezonok Csapatban',
    newSignings: 'Új Igazolások',
    sizeBy: 'Méret Szerint',
    connections: 'Kapcsolatok',
    assistant: 'Passzoló',
    finisher: 'Befejező',
    playersMinutesAlert: 'Csak a kiválasztott szezonban játszott percet tartalmazó játékosok láthatók',
    strategyFilterTooltip: 'Mutasd meg azokat az eseményeket, amelyek a díszletdarabok vagy a nyílt játék során történtek',
    sideFilterTooltip: 'Csak azokat a beállított darabokat jelenítse meg, amelyek a kiválasztott oldalon kezdődnek (bal vagy jobb)',
    teamMinutesAlert: '*Csak a 450 vagy több játékperccel rendelkező csapatok megjelenítése',
    homeCoach: 'Otthoni edző',
    awayCoach: 'Távol edző'
  },
  leagueTable: {
    subtitle: 'Nézd meg, hogyan alakulnak a ligák'
  },
  leagueMatchdays: {
    byRound: 'Forduló Szerint',
    byDate: 'Dátum Szerint',
    byTeam: 'Csapat Szerint'
  },
  teamStats: {
    subtitle: 'Hasonlítsa össze a csapatok teljesítményét',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Különbség Várható Gólok és Gólok között',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Különbség Várható Pontok és Pontok között',
    games: 'JÁT',
    gamesExplicit: 'Játszott mérkőzések',
    pointsPerGame: 'PM',
    pointsPerGameExplicit: 'Pontok Mérkőzésenként'
  },
  roles: {
    ROLE_USER: 'Felhasználó',
    ROLE_ADMIN: 'Admin',
    ROLE_REPORTS: 'Driblab Jelentések',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Driblab Fizikai Adatok',
    ROLE_VIDEO: 'Rögzítés',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Követés',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'Könnyedén kinyerheti a játékos, csapat, mérkőzés és liga információkat JSON formátumban.',
    ROLE_EVENTING_DATA_description: 'Merüljön el mélyen a statisztikákban Radar Diagramokkal, Játékos Rangsorokkal, térképekkel és még sok mással 100+ teljesítmény metrika alapján.',
    ROLE_PHYSICAL_DATA_description: 'Hozzáférhet a fitnesz adatokhoz és szűrhet játékosokat különböző teljesítmény metrikák szerint (távolság, sebesség, sprint, gyorsulás…).',
    ROLE_VIDEO_description: 'Adjon meg videókat és felállásokat, és kapjon mérkőzéseket eseményekkel és statisztikákkal címkézve mélyreható elemzéshez.',
    ROLE_DRIBLAB_HUB_description: 'Hatékonyan követheti és kezelheti a felderítési feladatokat naptárakkal, jegyzetekkel, riasztásokkal és dokumentum megosztással.',
    ROLE_TRACKING_description: 'Kapjon pozíciós adatokat minden játékosról egy mérkőzésen API-nkön keresztül átfogó elemzéshez.',
    ROLE_ARRIGO_description: 'Kombinálja az esemény és követési adatokat innovatív metrikákba, amelyek túlmutatnak a hagyományosakon és értéket adnak minden akcióhoz.',
    ROLE_REPORTS_description: 'Kérjen részletes felderítési jelentéseket elemzőink csapatától, hogy megtalálja a tökéletes csapatot vagy játékost.',
    ROLE_RAW_EVENTING: 'Raw Evening'
  },
  administration: {
    pageSubtitle: 'Kezelje az alkalmazás működését',
    newClient: 'Új Ügyfél',
    clientDuplicateName: 'Már létezik ügyfél ezzel a névvel. Válassza ki a listából, és az „Új Felhasználó” gombbal adjon hozzá felhasználókat ehhez az ügyfélhez.',
    newUser: 'Új Felhasználó',
    editClient: 'Ügyfél Szerkesztése',
    editUser: 'Felhasználó Szerkesztése',
    clientName: 'Név',
    permissions: 'Jogosultságok',
    releaseUser: 'Felhasználó Kiadása',
    connectAsUser: 'Kapcsolódás Felhasználóként',
    releaseModalTitle: 'Felhasználó Kiadás Megerősítés',
    releaseModalMessage: 'A felhasználó emailt fog kapni az új fiókjáról. Biztosan értesíteni szeretné?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Csapat',
      Brand: 'Márka',
      Federation: 'Szövetség',
      Media: 'Média',
      Agency: 'Ügynökség',
      Individual: 'Egyéni'
    },
    userType: {
      Ownership: 'Tulajdonos',
      SportingDirector: 'Sportigazgató',
      Brand: 'Márka',
      Federation: 'Szövetség',
      Media: 'Média',
      Agency: 'Ügynökség',
      Individual: 'Egyéni',
      Scout: 'Felderítő',
      Coach: 'Edző',
      supervision: {
        title: 'Felügyeleti hierarchia',
        subtitle: 'A felügyelet csak lefelé folyik. Az azonos szintű felügyelet nem megengedett.',
        supervisesLowerLevels: 'Felügyeli az összes alábbi szerepet',
        ruleNoSameLevel: 'Az azonos szintű szerepek nem felügyelhetik egymást.',
        ruleOnlyDownwards: 'Felügyelet csak magasabb szerepköröktől alacsonyabb pozícióig megengedett.',
        ruleLevel3NoSupervision: 'A legalacsonyabb szintnek nincs felügyeleti engedélye.',
        currentUserType: 'Jelenlegi felhasználói típusa'
      }
    },
    visibleYears: 'Látható Évek',
    areaModalTitle: 'Ligák Aktiválása/Deaktiválása Megerősítés',
    areaModalMessage: 'Biztosan aktiválja/deaktiválja az összes ligát a kiválasztott területről?',
    countStats: 'Statisztikák Számlálása',
    userClientModalTitle: 'A felhasználó már létezik egy másik ügyfélben',
    eventing: 'Esemény',
    hub: 'Hub',
    contract: 'Szerződés',
    contracts: 'Szerződések',
    invoiceName: 'Számla Név',
    contractFee: 'Szerződési Díj',
    renewal: 'Megújítás',
    consultancy: 'Tanácsadás',
    deleteContract: 'Ügyfél Szerződés Törlése',
    deleteContractMessage: 'A szerződés véglegesen eltávolításra kerül. Biztos benne?',
    activeVsHired: 'Aktív vs Felvett',
    requestedVsHired: 'Kért vs Felvett',
    activeVsHiredWithPlaceholder: '{0} Aktív vs {1} Felvett',
    requestedVsHiredWithPlaceholder: '{0} Igényelt vs {1} Felvettek',
    salesRepresentative: 'Értékesítési Képviselő',
    periodicities: {
      periodicity: 'Periodicitás',
      annual: 'Éves',
      biannual: 'Féléves',
      quarterly: 'Negyedéves',
      monthly: 'Havi',
      bimonthly: 'Kéthavi',
      onePayment: 'Egyszeri fizetés',
      fourmonthly: 'Négyhavonta'
    },
    paymentMethods: {
      payment: 'Fizetés',
      method: 'Módszer',
      transfer: 'Átutalás',
      mandate: 'Megbízás'
    },
    marketingOptions: {
      marketing: 'Marketing',
      socialMediaAdd: 'Közösségi Média Hirdetés',
      videoWithFeedback: 'Videó Visszajelzéssel'
    },
    status: {
      status: 'Státusz',
      pending: 'Függőben',
      active: 'Aktív',
      expiringSoon: 'Hamarosan lejár',
      expired: 'Lejárt',
      expiringSoonWithDays: 'A szerződés hamarosan lejár: {0} nap van hátra'
    },
    updates: {
      roleAdded: '<b>{0}</b> hozzáadta a <b>{1}</b> szerepkört <b>{2}</b>-hoz.',
      roleRemoved: '<b>{0}</b> eltávolította a <b>{1}</b> szerepkört <b>{2}</b>-tól.',
      leagueAdded: '<b>{0}</b> hozzáadta <b>{1}</b>-t a <b>{2}</b> ligához.',
      leagueRemoved: '<b>{0}</b> eltávolította <b>{1}</b>-t a <b>{2}</b> ligából.',
      seasonAdded: '<b>{0}</b> hozzáadta <b>{1}</b>-t a <b>{2}</b> szezonhoz.',
      seasonRemoved: '<b>{0}</b> eltávolította <b>{1}</b>-t a <b>{2}</b> szezonból.',
      updateNotesPlaceholder: 'Kérjük, adjon hozzá némi kontextust a változáshoz vagy adjon hozzá releváns jegyzeteket ide...',
      updates: 'Frissítések',
      products: 'Termékek'
    },
    clients: 'Ügyfelek',
    trials: 'Próbák',
    activeClients: 'Aktív ügyfelek',
    activeTrials: 'Aktív próbák',
    activeTrialUsers: 'Aktív próbafelhasználók',
    activeContracts: 'Aktív szerződések',
    expiration: 'Lejárat',
    clientWarnings: {
      activeContractInactiveClient: 'Aktív szerződéssel rendelkező, de engedélyezett felhasználók nélküli ügyfelek',
      activeContractTrialUsers: 'Próbafelhasználókkal rendelkező ügyfelek, amíg a szerződés aktív',
      activeUsersWithoutContract: 'Aktív, nem próbaidőszakos felhasználókkal rendelkező ügyfelek, de nincs aktív szerződés',
      upcomingExpirations: 'Közelgő lejáratok',
      renewedContracts: 'Megújított szerződéssel rendelkező ügyfelek',
      clientsWithWarnings: 'Figyelmet igénylő ügyfelek',
      enabledUsersWithoutContract: '„Engedélyezett, nem próbaverziós felhasználók aktív szerződés nélkül”',
      trialUsersWithContract: 'Próba módban lévő felhasználók az aktív szerződés ellenére',
      activeContractInactiveUsers: 'Az ügyfélnek aktív szerződése van minden inaktív felhasználóval',
      activeContract: 'Ennek az ügyfélnek aktív szerződése van',
      noEnabledUsers: 'Ennek az ügyfélnek nincs engedélyezett felhasználója',
      ongoingTrialInactiveUsers: 'Folyamatban lévő próbaverzióval rendelkező, de engedélyezett felhasználók nélküli ügyfelek',
      neverLoggedIn: 'Olyan ügyfelek, akik még soha nem jelentkeztek be'
    },
    daysLeft: 'Napok vannak hátra',
    expiringSoon: 'Hamarosan lejár',
    loggedThisWeek: 'Ezen a héten bejelentkezve',
    withWarnings: 'Figyelmeztetésekkel',
    ofActiveClients: 'aktív ügyfelek',
    endingIn30Days: '30 nap múlva ér véget',
    neverLogged: 'soha nem jelentkezett be',
    ofActiveTrials: 'aktív próbák',
    activeClientsWithoutTrial: 'aktív ügyfelek (kivéve próba)',
    renewals: 'Megújítások',
    ofActiveContracts: 'aktív szerződések'
  },
  dashboards: {
    lastGame: 'Utolsó mérkőzés elemzése',
    lastGameSimple: 'Utolsó mérkőzés',
    seeAllGameInfo: 'Összes mérkőzés információ',
    nextGame: 'Következő Mérkőzés Előnézet',
    myTeam: 'Saját Csapatom',
    lastMatchdayGames: 'Utolsó Forduló',
    lastAdded: 'Utoljára Hozzáadva',
    myFavorites: 'Kedvenceim',
    seeAllFavorites: 'Összes kedvenc megtekintése',
    placeholderFavorites: 'Hozzáadhat kedvenceket a játékos részletek oldalról',
    placeholderTeamFavorites: 'Hozzáadhat kedvenceket a csapat részletek oldalról',
    placeholderLeagueFavorites: 'Hozzáadhat kedvenceket a ligáról',
    myCollections: 'Gyűjteményeim',
    placeholderCollections: 'Még nincs gyűjteménye',
    lastCreated: 'Utoljára Létrehozva',
    seeAllCollections: 'Összes gyűjtemény megtekintése',
    seeRival: 'Ellenfél Megtekintése',
    seeMyTeam: 'Saját Csapatom Megtekintése',
    title: 'Irányítópult Áttekintés',
    subtitle: 'Üdvözöljük vissza',
    recentPlayers: 'Legutóbbi játékosok',
    lastScouted: 'Utoljára felderítve',
    scout: 'Felderítő',
    reportsRequested: 'Jelentések',
    lastRequested: 'Utoljára kérve',
    goInbox: 'Ugrás Beérkezett Üzenetekhez',
    placeholderLastScouted: 'Kereshet játékosokat a bal oldali sávban vagy a felderítő eszközben',
    placeholderReports: 'Kérhet jelentéseket a játékos részletek oldalról',
    nationalPlayers: 'Legértékesebb nemzeti játékosok más országokban',
    lastGames: 'Utolsó Mérkőzések',
    nationalPlayersShort: 'Nemzeti játékosok más országokban',
    nextMatchdayGames: 'Következő Forduló',
    injuredPlayers: 'Sérült Játékosok',
    atPresent: 'Jelenleg',
    seeAllPlayers: 'Összes játékos megtekintése',
    suspendedPlayers: 'Felfüggesztett Játékosok',
    placeholderInjured: 'Nincsenek sérült játékosok',
    teamValueImpacted: 'Csapat Érték Érintett',
    placeholderSuspended: 'Nincsenek felfüggesztett játékosok',
    placeholderNextGame: 'Nincs elérhető mérkőzés',
    placeholderNoGames: 'Még nincsenek elérhető mérkőzések',
    placeholderLastMatchDayNotFound: 'Utolsó forduló nem elérhető',
    placeholderNextMatchDayNotFound: 'Következő forduló nem elérhető',
    usersMostSearch: 'Legtöbbet kereső felhasználók',
    lastTwoDays: 'Utolsó két nap',
    searchesHistory: 'Keresési Előzmények',
    dayByDay: 'Naponta',
    activeUsersTitle: 'Aktív Felhasználók',
    activeUsersSubtitle: 'Legalább egyszer bejelentkeztek az elmúlt hónapban',
    onlineUsersTitle: 'Online Felhasználók',
    onlineUsersSubtitle: 'Keresett valamit az elmúlt órában',
    searchesPerformed: 'Végrehajtott Keresések',
    onlyClients: 'Csak ügyfelek',
    activeClientsTitle: 'Aktív Ügyfelek',
    activeClientsSubtitle: 'Van legalább egy aktív felhasználó',
    last24Hours: 'Utolsó 24 Óra',
    activityHistory: 'Tevékenység Előzmények',
    loginHistory: 'Bejelentkezési Előzmények',
    failLogins: 'Sikertelen Bejelentkezés',
    successLogins: 'Sikeres Bejelentkezés',
    clientStats: 'Ügyfél Statisztikák',
    playersMostSearch: 'Legtöbbet keresett játékosok',
    toolsMoreUsed: 'Legtöbbet használt eszközök',
    hotPlayers: 'Népszerű Játékosok',
    last_month: 'Előző Hónap',
    last_week: 'Előző Hét',
    last_day: 'Előző Nap',
    nClients: 'Ügyfelek Száma',
    userDashboard: 'Felhasználó Irányítópult',
    userDashboardSubtitle: 'Fiók tevékenység összefoglaló',
    offlineDaysOfClient: 'Offline napok ügyfelenként',
    hideNoConnected: 'Kapcsolat nélküliek elrejtése',
    onlyTrial: 'Csak próbaverziós ügyfelek',
    daysWithoutLogin: 'Bejelentkezés nélküli napok',
    trialDays: 'Próbaverziós napok'
  },
  faq: {
    subtitle: 'Tudjon meg többet arról, hogy mi a Driblab PRO',
    categories: {
      playerMetrics: 'Játékos Metrikák',
      teamMetrics: 'Csapat Metrikák',
      positions: 'Csapat Pozíciók',
      tools: 'Eszközök',
      api: 'API',
      videos: 'Oktatóanyagok',
      playerPositions: 'Játékos Pozíciók',
      userTypes: 'Felhasználói típusok'
    },
    positions: {
      GK: 'Kapus',
      DR: 'Jobb Védő / Jobb Szélső Védő (RB)',
      DC: 'Középső Védő / Középső Hátvéd (CB)',
      DL: 'Bal Védő / Bal Szélső Védő (LB)',
      DMR: 'Jobb Szélső Védő (RWB)',
      DMC: 'Középső Védő Középpályás (CDM)',
      DML: 'Bal Szélső Védő (LWB)',
      MR: 'Jobb Középpályás (RM)',
      MC: 'Középső Középpályás (CM)',
      ML: 'Bal Középpályás (LM)',
      AMR: 'Támadó Középpályás Jobb / Jobb Szélső (RW)',
      AMC: 'Támadó Középpályás Középső / Előre Toló Középpályás',
      AML: 'Támadó Középpályás Bal / Bal Szélső (LW)',
      FWR: 'Jobb Csatár / Jobb Támadó (RS)',
      FW: 'Csatár / Támadó (ST)',
      FWL: 'Bal Csatár / Bal Támadó (LS)'
    },
    metrics: {
      categories: {
        Association: 'Kapcsolat',
        Saving: 'Védés',
        Shooting: 'Lövés',
        Defending: 'Védekezés',
        Passing: 'Passzolás',
        BallHandling: 'Labdakezelés',
        Aerial: 'Légi',
        Physical: 'Fizikai',
        Predictive: 'Prediktív',
        Arrigo: 'Arrigo',
        Score: 'Pontszám',
        Turnovers: 'Labdavesztések',
        Carries: 'Labdavitelek',
        SequenceInvolvement: 'Szekvencia Részvétele',
        Crosses: 'Beadások',
        Distance: 'Távolság',
        Sprint: 'Sprint',
        Acceleration: 'Gyorsulás',
        MaxAcceleration: 'Max Gyorsulás',
        Speed: 'Sebesség',
        OutPlay: 'Kijátszás',
        LineBreakingPasses: 'Vonal Átörlő Passzok',
        LineBreakingCarries: 'Vonal Átörlő Labdavitelek',
        LineBreakingActions: 'Vonal Átörlő Akciók',
        PassUnderPressure: 'Passz Nyomás Alatt',
        BallReceived: 'Labda Fogadás',
        PassesUnderPressure: 'Nyomás Alatt Halad Át',
        OnBallPressureReceived: 'Labdán Lévő Nyomás Fogadva',
        OnBallPressure: 'Labdán Lévő Nyomás',
        BallReceiptsInSpace: 'Labda Foglalás Térben',
        SpatialCoverage: 'Térbeli Lefedés',
        OffBallPressure: 'Labda Nélküli Nyomás',
        OffBallRuns: 'Labda Nélküli Futások',
        NoCategory: 'Egyéb',
        subcategories: {
          Quality: 'Minőség',
          Quantity: 'Mennyiség',
          TeamComparison: 'Csapat Összehasonlítás',
          Receptions: 'Fogadások',
          LongBalls: 'Hosszú Labdák',
          Efficiency: 'Hatékonyság',
          Ratio: 'Arány',
          Defensive: 'Védekező',
          Offensive: 'Támadó',
          Foot: 'Láb',
          Progression: 'Előrehaladás',
          TopValue: 'Top Érték',
          Predictive: 'Prediktív',
          Distance: 'Távolság',
          Aerial: 'Légi',
          Crosses: 'Beadások',
          NoCategory: 'Egyéb'
        },
        desc: {
          Association: 'Kapcsolat',
          Saving: 'Védés',
          Shooting: 'Lövés',
          Defending: 'Védekezés',
          Passing: 'Passzolás',
          BallHandling: 'Labdakezelés',
          Aerial: 'Légi',
          Physical: 'Fizikai',
          Predictive: 'Prediktív',
          Arrigo: 'Arrigo',
          Score: 'Pontszám',
          Turnovers: 'Labdavesztések',
          Carries: 'Labdavitelek',
          SequenceInvolvement: 'Szekvencia Részvétele',
          Crosses: 'Beadások',
          Distance: 'Különböző sebességeken megtett távolság',
          Sprint: 'Különböző sebességeken végzett sprint',
          Acceleration: 'Gyorsulás',
          Speed: 'A játékosok által a mérkőzés során elért sebesség',
          OutPlay: 'Kijátszás',
          LineBreakingPasses: 'Vonal Átörlő Passzok',
          LineBreakingCarries: 'Vonal Átörlő Labdavitelek',
          LineBreakingActions: 'Vonal Átörlő Akciók',
          PassUnderPressure: 'Passz Nyomás Alatt',
          BallReceived: 'Labda Fogadás',
          OnBallPressureReceived: 'Labdán Lévő Nyomás Fogadva',
          OnBallPressure: 'Labdán Lévő Nyomás',
          BallReceiptsInSpace: 'Labda Foglalás Térben',
          SpatialCoverage: 'Térbeli Lefedés',
          OffBallPressure: 'Labda Nélküli Nyomás',
          OffBallRuns: 'Labda Nélküli Futások',
          HandPassing: 'A kapusok kézzel adott átadásai vagy bedobása szettben'
        },
        abbr: {
          Association: 'Kapcsolat',
          Saving: 'Védés',
          Shooting: 'Lövés',
          Defending: 'Védekezés',
          Passing: 'Passzolás',
          BallHandling: 'Labda K.',
          Aerial: 'Légi',
          Physical: 'Fizikai',
          Predictive: 'Prediktív',
          Arrigo: 'Arrigo',
          Score: 'Pontszám',
          Turnovers: 'TOV',
          Carries: 'Labdavitelek',
          SequenceInvolvement: 'Szekv. Részv.',
          Crosses: 'Beadások',
          Distance: 'Távolság',
          Sprint: 'Sprint',
          Acceleration: 'Gyorsulás',
          MaxAcceleration: 'Max. Gyorsulás',
          Speed: 'Sebesség',
          OutPlay: 'Kijátszás',
          LineBreakingPasses: 'Vonal Átörlő Passzok',
          LineBreakingCarries: 'Vonal Átörlő Labdavitelek',
          LineBreakingActions: 'Vonal Átörlő Akciók',
          PassUnderPressure: 'Passz Nyomás Alatt',
          BallReceived: 'Labda Fogadás',
          OnBallPressureReceived: 'Labdán Lévő Nyomás Fogadva',
          OnBallPressure: 'Labdán Lévő Nyomás',
          BallReceiptsInSpace: 'Labda Foglalás Térben',
          SpatialCoverage: 'Térbeli Lefedés',
          OffBallPressure: 'Labda Nélküli Nyomás',
          OffBallRuns: 'Labda Nélküli Futások',
          HandPassing: 'Kéz passzálás'
        },
        HandPassing: 'Kéz passzálás'
      },
      types: {
        1: '90 perc alatt',
        2: 'Százalék',
        3: 'Arány',
        4: 'Hatékonyság',
        5: 'Átlag',
        6: 'Mérkőzésenként',
        7: 'Különbség',
        8: 'Max'
      },
      moreInfo: 'További információt itt olvashat'
    },
    api: {
      subtitle: 'Adatok lekérése különböző kérésekből',
      resourcesTitle: 'Erőforrások',
      authentication: 'Hitelesítés',
      authText: 'Az API hívásához minden kérésben tartalmaznia kell az `Authorization` fejlécet `Bearer {API_TOKEN}` értékkel',
      generate: 'Generálás',
      tokenPlaceholder: 'Ha nincs tokenje vagy lejárt, kattintson a \'Generálás\' gombra',
      pathParameters: 'Útvonal Paraméterek',
      queryParameters: 'Lekérdezési Paraméterek',
      responseModel: 'Válasz Modell',
      tokenWarning: '* Generáljon egy tokent az API használatához',
      pathParamsWarning: '* Vannak kitöltetlen Útvonal Paraméterek',
      genericDescription: 'Az API (Application Programming Interface) lehetővé teszi a fejlesztők számára, hogy hozzáférjenek és integrálják az adatokat vagy funkcionalitást saját alkalmazásaikba. Labdarúgó statisztikai API-nk átfogó hozzáférést biztosít különböző adatpontokhoz országokról, versenyekről, csapatokról, játékosokról, mérkőzésekről és még sok másról. Ezen API használatával olyan alkalmazásokat építhet, amelyek kihasználják gazdag labdarúgó adatainkat elemzésekhez, vizualizációkhoz vagy más innovatív megoldásokhoz.',
      methods: {
        getAllCountries: 'Ez a metódus lekéri az API-ban elérhető összes ország teljes listáját, kulcsfontosságú részleteket biztosítva, mint például minden ország egyedi azonosítóját és nevét. Ez az endpoint ideális olyan alkalmazásokhoz, amelyek földrajzi labdarúgó adatokat igényelnek, lehetővé téve olyan funkciókat, mint az ország kiválasztása, szűrés és elemzés. Alapvető erőforrásként is szolgál más endpointokkal való interakcióhoz, amelyek `countryId` paramétert igényelnek, biztosítva a zökkenőmentes navigációt és integrációt az API szélesebb adatkészletével.',
        getCountryDetail: 'Ez a metódus részletes információkat nyújt egy adott országról, amely elérhető az API-ban. Ezen endpoint használatával lekérheti az adatokat, mint például az ország nevét, kódját és minden releváns metaadatot, amely hozzá kapcsolódik. Ez a metódus különösen hasznos olyan alkalmazásokhoz, amelyek ország-specifikus részleteket igényelnek a felhasználói élmény javításához, mint például kontextuális információk megjelenítése vagy testreszabott betekintések létrehozása földrajzi adatok alapján. Kiegészíti más endpointokat azáltal, hogy lehetővé teszi egy kiválasztott ország mélyebb feltárását.',
        getCountryCompetitions: 'Ez a metódus lekéri egy adott országon belül elérhető összes verseny listáját. Értékes erőforrás olyan funkciók építéséhez, amelyek lehetővé teszik a felhasználók számára, hogy régió szerint böngésszenek versenyeket, zökkenőmentes módon összekapcsolva az ország adatait a kapcsolódó tornákkal. Ez az endpoint elengedhetetlen olyan alkalmazásokhoz, amelyek lokalizált labdarúgó tartalomra vagy regionális elemzésre összpontosítanak.',
        getAllCompetitionTypes: 'Ez a metódus visszaadja az API-ban elérhető összes versenytípus listáját, mint például ligák, kupák és nemzetközi tornák. Ez az endpoint ideális a versenyek kategorizálásához és a felhasználók számára szervezett nézet biztosításához a különböző típusú eseményekről. Különösen hasznos olyan funkciók építéséhez, mint szűrők vagy legördülő menük, amelyek lehetővé teszik a felhasználók számára, hogy a verseny jellege alapján böngésszenek labdarúgó adatokat.',
        getAllCompetitions: 'Ez a metódus lekéri az API-ban elérhető összes verseny átfogó listáját, típustól vagy helyszíntől függetlenül. Ez az endpoint hasznos olyan alkalmazásokhoz, amelyeknek széles körű labdarúgó versenyeket kell megjeleníteniük vagy elemezniük, lehetővé téve a felhasználók számára, hogy felfedezzék és kiválasszák az érdeklődésüket felkeltő eseményeket.',
        getCompetitionAvailable: 'Ez a metódus lekéri az API-ban jelenleg elérhetőként jelölt versenyek listáját. Ez biztosítja, hogy a visszaadott adatok naprakészek és készen állnak az alkalmazásokban való használatra. Különösen hasznos fejlesztők számára, akik olyan funkciókat építenek, amelyek aktív vagy elérhető versenyekre támaszkodnak, lehetővé téve a felhasználók számára, hogy releváns eseményeket fedezzenek fel elavult vagy hiányos adatokkal való találkozás nélkül.',
        getCompetitionDetail: 'Ez a metódus részletes információkat nyújt egy adott versenyről, amely elérhető az API-ban. Különösen hasznos olyan alkalmazásokhoz, amelyek mélyreható információkat igényelnek egy versenyről, lehetővé téve olyan funkciókat, mint részletes nézetek, kontextuális betekintések vagy szűrési lehetőségek verseny jellemzői alapján.',
        getCompetitionSeasons: 'Ez a metódus lekéri egy adott versenyhez kapcsolódó összes szezon listáját. Ez az endpoint elengedhetetlen olyan alkalmazásokhoz, amelyek egy verseny történetének vagy jelenlegi állapotának átfogó lefedését célozzák, lehetővé téve a felhasználók számára, hogy szezononként böngésszenek adatokat.',
        getSeasonAvailable: 'Ez a metódus az API-ban jelenleg elérhetőként jelölt szezonok listáját nyújtja. Különösen hasznos olyan alkalmazásokhoz, amelyek élő vagy folyamatban lévő labdarúgó eseményekre összpontosítanak, lehetővé téve a felhasználók számára, hogy releváns és aktuális szezon adatokkal lépjenek kapcsolatba.',
        getSeasonDetail: 'Ez a metódus lekéri egy adott szezon részletes információit, beleértve az idővonalát, kapcsolódó versenyt és kulcsfontosságú metaadatokat. Ez az endpoint elengedhetetlen olyan alkalmazásokhoz, amelyek mélyreható betekintést igényelnek egy adott szezonba, lehetővé téve olyan funkciókat, mint szezon áttekintések, verseny szerinti szűrés vagy részletes idővonalak megjelenítése felhasználói interakcióhoz.',
        getSeasonTeams: 'Ez a metódus egy adott szezonban részt vevő összes csapat listáját nyújtja. Ideális olyan funkciókhoz, mint a keretkezelés, csapat teljesítmény elemzés vagy szezon-specifikus szűrők létrehozása a felhasználók számára.',
        getSeasonPlayer: 'Ez a metódus lekéri egy adott szezonban regisztrált összes játékos listáját. Ideális olyan funkciók építéséhez, mint játékos keretek, teljesítmény követés vagy játékosok szűrése a kiválasztott szezon alapján.',
        getSeasonPlayerStats: 'Ez a metódus részletes statisztikákat nyújt egy adott szezonban lévő összes játékoshoz. Különösen hasznos olyan alkalmazásokhoz, amelyek elemzésre, játékos összehasonlításokra vagy szezon hosszú játékos teljesítmények dinamikus vizualizációinak létrehozására összpontosítanak.',
        getSeasonArrigoMetrics: 'Ez a metódus kombinált statisztikákat nyújt egy adott szezonban lévő összes játékoshoz. Különösen hasznos olyan alkalmazásokhoz, amelyek elemzésre, játékos összehasonlításokra vagy szezon hosszú játékos teljesítmények dinamikus vizualizációinak létrehozására összpontosítanak.',
        getSeasonTeamStats: 'Ez a metódus átfogó statisztikákat nyújt egy adott szezonban részt vevő összes csapathoz. Különösen hasznos olyan alkalmazásokhoz, amelyek csapat elemzésre, szezon összefoglalókra vagy csapat teljesítmény összehasonlításokra összpontosítanak a szezon során.',
        getSeasonCoaches: 'Ez a metódus lekéri az összes edző listáját, akik egy adott szezonban csapatokat irányítottak. Különösen hasznos olyan alkalmazásokhoz, amelyek szezon betekintésekre, edzői elemzésre vagy csapat irányítási változások követésére összpontosítanak egy szezon során.',
        getSeasonGames: 'Ez a metódus egy adott szezonban játszott összes mérkőzés listáját nyújtja. Ideális olyan alkalmazásokhoz, amelyeknek teljes szezon menetrendet kell megjeleníteniük, mérkőzés eredményeket elemezniük vagy a felhasználók számára átfogó szezon mérkőzés adatokhoz való hozzáférést biztosítaniuk.',
        getSeasonGamesMatchday: 'Ez a metódus lekéri az összes mérkőzést egy adott fordulóhoz egy adott szezonon belül. Különösen hasznos olyan alkalmazásokhoz, amelyek forduló menetrendeket jelenítenek meg, konkrét fordulókat elemeznek vagy fókuszált betekintéseket nyújtanak egy adott mérkőzéskészlethez a szezon során.',
        getSeasonLeagueTable: 'Ez a metódus egy adott szezon liga táblázatát nyújtja, beleértve a rangsorokat, pontokat, győzelmeket, döntetleneket, vereségeket és egyéb releváns statisztikákat minden csapathoz. Ez az endpoint elengedhetetlen olyan alkalmazásokhoz, amelyek csapat helyezéseket követnek, liga előrehaladást elemeznek vagy naprakész rangsorokat mutatnak a felhasználóknak a szezon során.',
        getTeamDetail: 'Ez a metódus részletes információkat nyújt egy adott csapatról, beleértve a nevét, alapítási évét, stadionját és egyéb metaadatokat. Ez az endpoint ideális olyan alkalmazásokhoz, amelyek csapat-specifikus betekintéseket igényelnek, lehetővé téve olyan funkciókat, mint részletes csapat profilok, történelmi kontextus vagy fokozott felhasználói élmények gazdag csapat-kapcsolatos adatokkal.',
        getTeamLoans: 'Ez a metódus lekéri az információkat egy adott csapatot érintő kölcsön tranzakciókról. Ez az endpoint különösen hasznos olyan alkalmazásokhoz, amelyek átigazolási elemzésre, csapat keretkezelésre vagy játékos mozgások követésére összpontosítanak egy szezon során.',
        getTeamRoster: 'Ez a metódus egy adott csapat keretében lévő játékosok teljes listáját nyújtja. Ideális olyan alkalmazásokhoz, amelyeknek csapat felállásokat kell megjeleníteniük, játékos szerepeket elemezniük vagy keret-kapcsolatos funkcionalitásokat kezelniük egy csapat számára.',
        getTeamGames: 'Ez a metódus lekéri az összes mérkőzés listáját, amelyet egy adott csapat játszott. Különösen hasznos olyan alkalmazásokhoz, amelyek csapat teljesítményre, menetrend követésre vagy a felhasználók számára egy csapat teljes mérkőzés előzményeihez való hozzáférésre összpontosítanak.',
        getTeamGameStats: 'Ez a metódus részletes statisztikákat nyújt egy adott csapat számára egy adott mérkőzésen. Különösen hasznos olyan alkalmazásokhoz, amelyek mérkőzés elemzésre, teljesítmény értékelésre vagy egy csapat teljesítményének mélyreható bontására összpontosítanak egyedi mérkőzéseken.',
        getTeamTransfers: 'Ez a metódus lekéri az információkat egy adott csapatot érintő átigazolási tranzakciókról. Különösen hasznos olyan alkalmazásokhoz, amelyek átigazolási piac elemzésre, csapat keret változásokra vagy játékos mozgások követésére összpontosítanak időben.',
        getGameStatus: 'Ez a metódus az API-ban elérhető összes lehetséges mérkőzés státusz listáját nyújtja, mint például ütemezett, folyamatban, befejezett, elhalasztott vagy törölt. Ez az endpoint különösen hasznos olyan alkalmazásokhoz, amelyek valós idejű mérkőzés követést igényelnek, mérkőzéseket státusz szerint szűrnek vagy egyértelmű frissítéseket nyújtanak a felhasználóknak egy mérkőzés előrehaladásáról vagy állapotáról.',
        getPlayerPositions: 'Ez a metódus visszaadja az összes lehetséges játékos pozíció listáját, mint például kapus, védő, középpályás és csatár. Ez az endpoint különösen hasznos olyan alkalmazásokhoz, amelyek játékosokat kategorizálnak, pozíciós adatokat elemeznek vagy lehetővé teszik a felhasználók számára, hogy játékosokat szűrjenek a pályán betöltött szerepük alapján.',
        getGameDetail: 'Ez a metódus átfogó információkat nyújt egy adott mérkőzésről, beleértve olyan részleteket, mint a részt vevő csapatok, dátum és idő, helyszín, eredmény és egyéb kulcsfontosságú metaadatok. Ez az endpoint ideális olyan alkalmazásokhoz, amelyek mélyreható mérkőzés betekintéseket igényelnek, lehetővé téve olyan funkciókat, mint részletes mérkőzés előnézetek, jelentések vagy elemzések.',
        getGameStats: 'Ez a metódus részletes statisztikákat nyújt egy adott mérkőzéshez, beleértve olyan metrikákat, mint gólok, lövések, birtoklás százalékok, passzok és védő akciók. Ez az endpoint különösen hasznos olyan alkalmazásokhoz, amelyek mérkőzés elemzésre, utólagos mérkőzés jelentésekre vagy csapat teljesítmény vizualizációkra összpontosítanak egy mérkőzés során.',
        getGamePlayerStats: 'Ez a metódus lekéri a részletes teljesítmény statisztikákat minden játékoshoz, aki részt vett egy adott mérkőzésen. Különösen hasznos olyan alkalmazásokhoz, amelyek egyedi játékos teljesítményeket elemeznek, mérkőzés jelentéseket generálnak vagy játékosokat hasonlítanak össze egyetlen mérkőzés kontextusában.',
        getGamePlayerPhysicalStats: 'Ez a metódus részletes fizikai teljesítmény metrikákat nyújt játékosokhoz egy adott mérkőzésen. Különösen hasznos olyan alkalmazásokhoz, amelyek játékos fitnesz elemzésre, fizikai teljesítmény követésre vagy részletes mérkőzés betekintések generálására összpontosítanak egyedi játékosokhoz.',
        getGameTeamPhysicalStats: 'Ez a metódus részletes fizikai teljesítmény metrikákat nyújt csapatokhoz egy adott mérkőzésen. Ez tartalmazza olyan adatokat, mint a megtett összes távolság, sprintek száma, nagy intenzitású futások és egyéb fizikai attribútumok. Különösen hasznos olyan alkalmazásokhoz, amelyek csapat fitnesz elemzésre, fizikai erőfeszítések összehasonlítására csapatok között vagy összességében teljesítmény értékelésre összpontosítanak egy mérkőzésen.',
        getGamePlayerArrigoMetrics: 'Ez a metódus részletes arrigo metrikákat nyújt játékosokhoz egy adott mérkőzésen. Különösen hasznos olyan alkalmazásokhoz, amelyek elemzésre és részletes betekintések generálására összpontosítanak játékosokhoz egy mérkőzésen.',
        getGameTeamArrigoMetrics: 'Ez a metódus részletes arrigo metrikákat nyújt csapatokhoz egy adott mérkőzésen. Ez tartalmazza olyan adatokat, mint a megelőzött játékosok és egyéb attribútumok. Különösen hasznos olyan alkalmazásokhoz, amelyek elemzésre és összességében teljesítmény értékelésre összpontosítanak egy mérkőzésen.',
        getGameLineup: 'Ez a metódus lekéri a felállást egy adott mérkőzéshez, beleértve a kezdő játékosokat, csereket és azok megfelelő pozícióit. Ez az endpoint különösen hasznos olyan alkalmazásokhoz, amelyek előmérkőzés információkat jelenítenek meg, csapat felállásokat elemeznek vagy betekintéseket nyújtanak a taktikai döntésekről, amelyeket a csapatok hoztak egy adott mérkőzéshez.',
        getGameTimeline: 'Ez a metódus kronológiai listát nyújt az eseményekről, amelyek egy adott mérkőzés során történtek. Különösen hasznos olyan alkalmazásokhoz, amelyek élő mérkőzés frissítéseket, utólagos mérkőzés összefoglalókat vagy részletes elemzéseket nyújtanak mérkőzés eseményekről.',
        getGameTracking: 'Ez a metódus linket nyújt egy adott mérkőzés követési adatfájljának letöltéséhez. Ez a fájl részletes mozgási és pozíciós adatokat tartalmaz játékosokhoz és a labdához a mérkőzés során. Különösen hasznos olyan alkalmazásokhoz, amelyek fejlett elemzésre, taktikai elemzésre vagy vizualizációk létrehozására összpontosítanak játékos és labda mozgásokról a mérkőzés során.',
        getTrackingStatus: 'Ez a metódus visszaadja az összes állapot teljes listáját, amely elérhető a követésben, kulcsfontosságú részleteket biztosítva, mint például az egyedi azonosító és az egyes állapot neve. Ez az endpoint ideális olyan alkalmazásokhoz, amelyek mérkőzés követést igényelnek, lehetővé téve olyan funkciókat, mint állapot kiválasztás, szűrés és elemzés. Kritikus erőforrásként is szolgál más endpointokkal való interakcióhoz, amelyek `statusId` paramétert igényelnek, biztosítva a zökkenőmentes navigációt és integrációt az API szélesebb adatkészletével.',
        getPlayerTransfersTypes: 'Ez a metódus lekéri a lehetséges játékos átigazolási típusok listáját, mint például végleges átigazolás, kölcsön, ingyenes átigazolás vagy csere. Ez az endpoint különösen hasznos olyan alkalmazásokhoz, amelyek átigazolási piac trendeket elemeznek, játékos mozgásokat kategorizálnak vagy részletes betekintéseket nyújtanak a felhasználóknak a játékosokat érintő tranzakciók típusaiba.',
        getPlayerDetail: 'Ez a metódus részletes információkat nyújt egy adott játékosról, beleértve személyes részleteket, karrier statisztikákat és jelenlegi csapat hovatartozást. Ez az endpoint ideális olyan alkalmazásokhoz, amelyek játékos profilokat, történelmi betekintéseket vagy elemzéseket nyújtanak egyedi játékos teljesítményekről és karrier pályákról.',
        getPlayerGames: 'Ez a metódus lekéri az összes mérkőzés listáját, amelyen egy adott játékos részt vett. Különösen hasznos olyan alkalmazásokhoz, amelyek játékos teljesítmény követésre, mérkőzés előzmény elemzésre vagy átfogó mérkőzés naplók biztosítására összpontosítanak egyedi játékosokhoz.',
        getPlayerInjuries: 'Ez a metódus részletes nyilvántartást nyújt egy adott játékos által elszenvedett sérülésekről. Különösen hasznos olyan alkalmazásokhoz, amelyek játékos egészség elemzésre, karrier hatás értékelésre vagy felépülés idővonalak követésére összpontosítanak.',
        getPlayerNationalTeam: 'Ez a metódus lekéri a részletes információkat egy játékos nemzeti válogatott mérkőzésekben való részvételéről. Különösen hasznos olyan alkalmazásokhoz, amelyek játékos teljesítményre a nemzeti szinten, nemzetközi karrier követésre vagy betekintésekre összpontosítanak a hozzájárulásokról tornák és barátságos mérkőzések során.',
        getPlayerSeasons: 'Ez a metódus egy adott játékos által részt vett összes szezon listáját nyújtja. Különösen hasznos olyan alkalmazásokhoz, amelyek játékos karrier előrehaladást követnek, teljesítményt elemeznek szezonok között vagy történelmi kontextust nyújtanak az eredményeikhez.',
        getPlayerTransfers: 'Ez a metódus lekéri a részletes előzményt egy adott játékost érintő átigazolási tranzakciókról. Különösen hasznos olyan alkalmazásokhoz, amelyek játékos karrier elemzésre, átigazolási piac betekintésekre vagy játékos mozgások követésére összpontosítanak csapatok között időben.',
        getPlayerSeasonTeamStats: 'Ez a metódus részletes teljesítmény statisztikákat nyújt egy adott játékoshoz egy adott szezonban egy csapattal. Különösen hasznos olyan alkalmazásokhoz, amelyek szezon hosszú játékos elemzésre, összehasonlításokra csapatok vagy szezonok között és egyedi hozzájárulások követésére összpontosítanak csapat sikerhez.',
        getPlayerSeasonPhysicalStats: 'Ez a metódus részletes fizikai teljesítmény metrikákat nyújt egy adott játékoshoz egy szezon során. Különösen hasznos olyan alkalmazásokhoz, amelyek játékos fitnesz követésre, fizikai teljesítmény elemzésre vagy játékos munkaterhelés értékelésre összpontosítanak egy szezon során.',
        getPlayerSeasonGamePhysicalStats: 'Ez a metódus részletes fizikai teljesítmény metrikákat nyújt egy adott játékoshoz mérkőzésenként egy szezonon belül. Különösen hasznos olyan alkalmazásokhoz, amelyek mérkőzés-specifikus fitnesz elemzésre, játékos munkaterhelés követésre vagy fizikai teljesítmény összehasonlításra összpontosítanak különböző mérkőzések között.',
        getPlayerSeasonGameStats: 'Ez a metódus lekéri a részletes teljesítmény statisztikákat egy adott játékoshoz mérkőzésenként egy szezonon belül. Különösen hasznos olyan alkalmazásokhoz, amelyek mérkőzés-specifikus játékos elemzésre, teljesítmény trendekre vagy részletes összehasonlításokra összpontosítanak mérkőzések között egy szezonon belül.',
        getCoachDetail: 'Ez a metódus részletes információkat nyújt egy adott edzőről, beleértve a nevét, karrier előzményét, irányított csapatokat és jelentős eredményeket. Ez az endpoint különösen hasznos olyan alkalmazásokhoz, amelyek edzői profilokat kiemelnek, vezetői karriereket követnek vagy elemeznek az edzők hatását csapat teljesítményre.',
        getCoachHistory: 'Ez a metódus lekéri egy adott edző karrierének átfogó előzményét, beleértve az irányított csapatokat, részt vett versenyeket és a hivatali időtartamokat. Ez az endpoint különösen hasznos olyan alkalmazásokhoz, amelyek edzői karrierek elemzésére, vezetői változások követésére vagy betekintésekre összpontosítanak egy edző szakmai útjába és eredményeibe.',
        getGameEventing: 'Ez a módszer biztosítja az összes eseményt',
        getLinkStream: 'Ez a módszer lekéri a linket a játékvideó megtekintéséhez',
        getLinkDownload: 'Ez a módszer lekéri a linket a játékvideó letöltéséhez',
        getGameTs: 'Ez a módszer az utolsó időbélyeget adja meg egy adott mérkőzésen',
        getGameFileTypes: 'Ez a módszer biztosítja a megfelelő fájltípusokat',
        deletePlayer: 'This method delete a player',
        getGeneralPositions: 'Ez a módszer a lehetséges általános pozíciók listáját adja vissza, például kapus, védő, középpályás és csatár.',
        getPercentiles: 'Ez a módszer biztosítja az összes rendelkezésre álló százalékos értéket',
        getPlayerPercentilesEventing: 'Ez a módszer minden statisztikát biztosít egy adott százalékponthoz és pozícióhoz'
      },
      responseCodes: 'Válasz Kódok',
      furtherInformation: 'További információkért kérjük, olvassa el API dokumentációnkat',
      clipboard: 'Vágólapra másolva!',
      limit50: 'Csak az első 50 eredmény jelenik meg'
    }
  },
  globalSearch: {
    subtitle: 'Mély Szűrés'
  },
  global: {
    teamElos: {
      title: 'CSAPAT ELO-K',
      subtitle: 'Globális csapat ranglisták és elemzések',
      team: 'Csapat',
      teams: 'Csapatok',
      dates: 'Dátumok',
      excludeInternational: 'Nemzetközi csapatok kizárása',
      elo: 'ELO',
      selectButton: 'Válassza a Top lehetőséget',
      selectTeamFromTable: 'Válasszon csapatot a táblából, hogy megjelenítse az ELO trendet.',
      showingTeamAveragesLastSeason: 'Csak a csapat átlagai jelennek meg a legutóbbi szezonban',
      showingTeamStatsLastSeason: 'Csak a csapat statisztikái jelennek meg a legutóbbi aktív szezonban',
      searchToolTip: 'Tipp: Nyomja meg a Ctrl + B billentyűket a keresősáv közvetlen eléréséhez',
      selectTopTooltip: 'További csapatok megjelenítése a diagramon összehasonlítás céljából',
      loadingPage: 'Az adatok előkészítése...'
    },
    leagueElos: {
      title: 'LIGA ELO-K',
      subtitle: 'Globális liga rangsorok és elemzések',
      rankings: 'RANGLISTÁK',
      insights: 'ELEMZÉSEK',
      filters: 'SZŰRŐK',
      leagues: 'Ligák',
      from: 'Tól',
      to: 'Ig',
      elo: 'ELO',
      change: 'Változás',
      league: 'Liga',
      excludeContinental: 'Nemzetközi versenyek kizárása',
      eloTrend: 'ELO trend',
      eloRanking: 'ELO rangsor',
      currentELOLabel: '(jelenlegi ELO)',
      allTime: 'Összes idő',
      average: 'Átlag',
      noChartData: 'Nincs diagramadat a kiválasztott szűrőkhöz.',
      selectLeagueFromTable: 'Válasszon ligát a táblából, hogy megjelenítse az ELO trendet.',
      noInsightsData: 'Nincs elérhető elemzési adat a kiválasztott ligákhoz. Kérjük, győződjön meg róla, hogy a ligákhoz elérhető szezonok és csapat-elemzési adatok vannak.',
      showingLeagueAveragesLastSeason: 'Csak a ligák utolsó aktív szezonjának átlagai jelennek meg',
      selectTopTooltip: 'További ligák megjelenítése a diagramon összehasonlítás céljából',
      confederations: {
        world: 'Világ',
        top5: 'TOP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Ligák száma',
      minimumElo: 'Minimális ELO'
    },
    players: {
      title: 'A játékos GPI-je',
      subtitle: 'Globális játékos rangsorok és betekintések',
      gpiRanking: 'GPI rangsor',
      rankTooltip: 'Mutasson rá az egérrel a globális rangsor megjelenítéséhez',
      globalRanking: 'Globális rangsor',
      player: 'Játékos',
      players: 'Játékosok',
      gpiTrend: 'GPI Trend',
      currentGPILabel: '(Jelenlegi GPI)',
      nationality: 'Születési ország',
      position: 'Pozíció',
      marketValue: 'Piaci érték',
      apply: 'Alkalmazni',
      marketValueAndAgeTooltip: 'Adjon meg egy tartományt, majd kattintson az Alkalmaz gombra, vagy nyomja meg az Enter billentyűt.',
      searchPlaceholder: 'Játékos keresése...',
      selectTopTooltip: 'További játékosok megjelenítése a diagramon összehasonlítás céljából',
      gpi: 'GPI',
      numberOfPlayers: 'A játékosok száma',
      showingPlayerStatsLastSeason: 'Csak a játékosok átlagos statisztikáit jeleníti meg az utolsó aktív szezonban',
      date: 'DÁTUM',
      showChartLabels: 'Címkék megjelenítése',
      marketValueTooltip: 'Adjon meg egy tartományt, majd kattintson az Alkalmaz gombra, vagy nyomja meg az Enter billentyűt.',
      freeAgents: 'Szabad ügynökök',
      selectPlayerFromTable: 'Válasszon ki egy játékost a táblázatból a GPI trend megtekintéséhez.'
    }
  },
  iso: {
    AF: 'Afghanistan',
    DZ: 'Algeria',
    AO: 'Angola',
    AR: 'Argentina',
    AU: 'Australia',
    AZ: 'Azerbaijan',
    BH: 'Bahrain',
    BB: 'Barbados',
    BE: 'Belgium',
    BJ: 'Benin',
    BO: 'Bolivia',
    BW: 'Botswana',
    BN: 'Brunei',
    BF: 'Burkina Faso',
    KH: 'Cambodia',
    CA: 'Canada',
    CF: 'Central African Rep.',
    CL: 'Chile',
    CO: 'Colombia',
    CD: 'Congo DR',
    CG: 'Congo',
    CI: 'Cote d\'Ivoire',
    CU: 'Cuba',
    CZ: 'Czech Republic',
    DJ: 'Djibouti',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    SV: 'El Salvador',
    ER: 'Eritrea',
    ET: 'Ethiopia',
    FI: 'Finland',
    PF: 'French Polynesia',
    GM: 'Gambia',
    DE: 'Germany',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GP: 'Guadeloupe',
    GN: 'Guinea',
    GY: 'Guyana',
    HN: 'Honduras',
    HU: 'Hungary',
    IN: 'India',
    IR: 'Iran',
    IE: 'Ireland',
    IT: 'Italy',
    JP: 'Japón',
    KZ: 'Kazakhstan',
    KI: 'Kiribati',
    KR: 'Korea, South',
    KG: 'Kyrgyzstan',
    LV: 'Latvia',
    LS: 'Lesotho',
    LY: 'Libia',
    LT: 'Lithuania',
    MO: 'Macau SAR',
    MG: 'Madagascar',
    MY: 'Malaysia',
    ML: 'Mali',
    MH: 'Marshall Islands',
    MR: 'Mauritania',
    MX: 'Mexico',
    MD: 'Moldova',
    MN: 'Mongolia',
    MA: 'Morocco',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Netherlands',
    NZ: 'New Zealand',
    NE: 'Niger',
    MP: 'Northern Mariana Islands',
    OM: 'Oman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Philippines',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Romania',
    RW: 'Rwanda',
    LC: 'Saint Lucia',
    SM: 'San Marino',
    SA: 'Saudi Arabia',
    RS: 'Serbia',
    SL: 'Sierra Leone',
    SK: 'Slovakia',
    SB: 'Solomon Islands',
    ZA: 'South Africa',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Swaziland',
    CH: 'Switzerland',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    TG: 'Togo',
    TT: 'Trinidad and Tobago',
    TR: 'Turkey',
    TV: 'Tuvalu',
    UA: 'Ukraine',
    GB: 'United Kingdom',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Virgin Islands, British',
    EH: 'Western Sahara',
    ZM: 'Zambia',
    AL: 'Albania',
    AD: 'Andorra',
    AG: 'Antigua and Barbuda',
    AM: 'Armenia',
    AT: 'Austria',
    BS: 'Bahamas',
    BD: 'Bangladesh',
    BY: 'Belarus',
    BZ: 'Belize',
    BT: 'Bhutan',
    BA: 'Bosnia and Herz.',
    BR: 'Brazil',
    BG: 'Bulgaria',
    BI: 'Burundi',
    CM: 'Cameroon',
    CV: 'Cape Verde',
    TD: 'Chad',
    CN: 'China',
    KM: 'Comoras',
    CR: 'Costa Rica',
    HR: 'Croatia',
    CY: 'Cyprus',
    DK: 'Denmark',
    DM: 'Dominica',
    TL: 'East Timor',
    EG: 'Egypt',
    GQ: 'Equatorial Guinea',
    EE: 'Estonia',
    FJ: 'Fiji',
    FR: 'France',
    GA: 'Gabon',
    GE: 'Georgia',
    GH: 'Ghana',
    GR: 'Greece',
    GD: 'Grenada',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    HT: 'Haiti',
    HK: 'Hong Kong SAR',
    IS: 'Iceland',
    ID: 'Indonesia',
    IQ: 'Iraq',
    IL: 'Israel',
    JM: 'Jamaica',
    JO: 'Jordan',
    KE: 'Kenya',
    KP: 'Korea, North',
    KW: 'Kuwait',
    LA: 'Laos',
    LB: 'Lebanon',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LU: 'Luxembourg',
    MK: 'Macedonia',
    MW: 'Malawi',
    MV: 'Maldives',
    MT: 'Malta',
    MQ: 'Martinica',
    MU: 'Mauritius',
    FM: 'Micronesia',
    MC: 'Monaco',
    ME: 'Montenegro',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NP: 'Nepal',
    NC: 'New Caledonia',
    NI: 'Nicaragua',
    NG: 'Nigeria',
    NO: 'Norway',
    PK: 'Pakistan',
    PS: 'Palestinian Territories',
    PG: 'Papua New Guinea',
    PE: 'Peru',
    PL: 'Poland',
    PR: 'Puerto Rico',
    RE: 'Reunion',
    RU: 'Russian Federation',
    KN: 'Saint Kitts and Nevis',
    WS: 'Samoa',
    ST: 'Sao Tome and Princ.',
    SN: 'Senegal',
    SC: 'Seychelles',
    SG: 'Singapore',
    SI: 'Slovenia',
    SO: 'Somalia',
    ES: 'Spain',
    VC: 'St Vincent and Gren.',
    SR: 'Suriname',
    SE: 'Sweden',
    SY: 'Syria',
    TJ: 'Tajikistan',
    TH: 'Thailandia',
    TO: 'Tonga',
    TN: 'Tunisia',
    TM: 'Turkmenistan',
    UG: 'Uganda',
    AE: 'United Arab Emirates',
    US: 'United States',
    UZ: 'Uzbekistan',
    VA: 'Vatican City',
    VN: 'Vietnam',
    VI: 'Virgin Islands, U.S.',
    YE: 'Yemen',
    ZW: 'Zimbabue',
    EU: 'Europe',
    INT: 'International',
    CW: 'Curaçao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'England',
    'GB-WLS': 'Wales',
    'GB-SCT': 'Scotland',
    LATAM: 'South America',
    CAF: 'CAF',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Netherlands Antilles',
    AS: 'American Samoa',
    AW: 'Aruba',
    BM: 'Bermuda',
    BQ: 'Bonaire, SE and Saba',
    CK: 'The Cook Islands',
    FO: 'The Faroe Islands',
    GF: 'Guyane',
    GG: 'The Bailiwick of Guernsey',
    GU: 'The Territory of Guam',
    IM: 'The Isle of Man',
    JE: 'The Bailiwick of Jersey',
    KY: 'The Cayman Islands',
    MF: 'The Collectivity of Saint-Martin',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceania',
    RI: 'Indonesia',
    SS: 'The Republic of South Sudan',
    TC: 'The Turks and Caicos Islands',
    YT: 'The Department of Mayotte',
    SX: 'Sint Maarten'
  },
  loadingMessages: {
    players: 'Játékosok Előkészítése',
    teams: 'Csapatok Rendezés',
    games: 'Mérkőzések Lekérése',
    stats: 'Metrikák Számítása',
    graphs: 'Grafikonok Rajzolása',
    gettingReady: 'Felkészülés',
    placeholder: 'Készüljön Fel'
  },
  requestReport: {
    subtitle: 'Szerezzen mély jelentést mindennel, amire szüksége van',
    categories: {
      scouting: {
        title: 'Felderítés',
        subtitle: 'Kik a legjobb játékosok egy adott ligában? És több liga kombinációjából? Kérjen egy testreszabott jelentést bármilyen szűrővel (életkor, magasság, szerződés vége, stb.) és derítse ki, mely játékosok illeszkednek legjobban'
      },
      coaches: {
        title: 'Edzők',
        subtitle: 'Hogyan illeszkedne egy edző a csapat rendszerébe? Szerezzen részletes információt vagy egy adott profil alapján ismerje meg, mely edzők illeszkednek legjobban'
      },
      'team analysis': {
        title: 'Csapat',
        subtitle: 'Adjon meg egy csapatot és kapjon szezon összefoglalót értékes betekintésekkel a stílusról, védő és támadó teljesítményről, gyenge pontokról, legjobb játékosokról, stb...'
      },
      'game analysis': {
        title: 'Mérkőzés Elemzés',
        subtitle: 'Egy adott mérkőzéshez kapjon mély előmérkőzés és utómérkőzés elemzést részletes információkkal'
      },
      'special projects': {
        title: 'Speciális Projektek',
        subtitle: 'Hogyan teljesít egy játékos idegenbeli mérkőzéseken? Hogyan változnak a játékosok ligáról ligára? Mely játékosok elérhetők kölcsönzésre? Kérdezzen bármit, ami eszébe jut'
      },
      conversation: {
        title: 'Beszélgetés',
        subtitle: 'Kezdjen beszélgetést csapatunkkal'
      }
    },
    notesPlaceholder: 'Tudassa velünk a ligát, profilt, statisztikákat, edzőt, csapatot vagy mérkőzést, amiről többet szeretne tudni',
    chooseType: 'Válasszon jelentés típust',
    requestSummary: 'Kérés Összefoglaló',
    reportType: 'Jelentés Típusa',
    reportLanguage: 'Jelentés Nyelve',
    detailTitle: 'Jelentés követés',
    detailSubtitle: 'Minden információ a kért jelentésről'
  },
  bugReport: {
    modalSubtitle: 'Segítsen nekünk fejlődni',
    about: 'Névjegy',
    sendSuccess: 'Sikeresen értesítve. Ellenőrizze a frissítéseket a Beérkezett Üzenetekben',
    bugs: 'Hibák'
  },
  gbe: {
    autopass: 'Automatikus Passz',
    bandX: 'Sáv {0}',
    bandXCont: 'Sáv {0} Kontinentális Verseny',
    points: 'Pontok',
    titleWinner: 'Bajnok',
    qualifiedGroupsBandX: 'Jogosult egy Sáv {0} Kontinentális Verseny csoportkörébe',
    qualifiedQualifiersBandX: 'Jogosult egy Sáv {0} Kontinentális Verseny selejtezőjébe',
    midTable: 'Középmezőny',
    relegation: 'Kiesés',
    promotion: 'Feljutás',
    final: 'Döntő',
    semifinal: 'Elődöntő',
    quarterfinal: 'Negyeddöntő',
    round16: 'Nyolcaddöntő',
    round32: 'Harmincketted döntő',
    groupstage: 'Csoportkör',
    firstRound: '1. Forduló',
    secondRound: '2. Forduló',
    thirdRound: '3. Forduló',
    fourthRound: '4. Forduló',
    preliminaryRound: 'Előselejtező',
    other: 'Egyéb',
    score: 'Pontszám',
    totalSummary: 'Összesített Összefoglaló',
    currentlyPlayingInUK: 'A játékos az Egyesült Királyság vagy Írország állampolgára, vagy a játékos az Egyesült Királyságban állandó lakos',
    bandsAlert: 'Több mint egy sávban játszott percek vannak, az összes a maximális érték',
    bandsAlertMax: 'Több mint egy sávban játszott percek vannak, az összes a maximális érték',
    bandsAlertAvg: 'Több mint egy sávban játszott percek vannak, az összes az átlagos érték',
    generate: 'GBE Pályázati Űrlap',
    debutYouthPlayer: 'Ifjúsági Játékos Bemutatkozása',
    table1: {
      name: 'Játékos Nemzetközi Pályára Lépései',
      title1: 'A Játékos Nemzeti Szövetségének Összesített FIFA Világrangsora',
      title2: 'Játékos Nemzetközi Pályára Lépései'
    },
    table2: {
      name: 'Játékos Hazai Percei',
      title1: 'Játékos Hazai Percei'
    },
    table3: {
      name: 'Játékos Kontinentális Percei',
      title1: 'Játékos Kontinentális Percei'
    },
    table4: {
      name: 'Játékos Utolsó Klubjának Végső Liga Pozíciója',
      title1: 'Utolsó Klub Végső Liga Pozíciója'
    },
    table5: {
      name: 'Játékos Utolsó Klubjának Kontinentális Előrehaladása',
      title1: 'Kontinentális Előrehaladás'
    },
    table6: {
      name: 'Játékos Jelenlegi Klubjának Liga Minősége',
      title1: 'Játékos Jelenlegi Klubjának Sávja'
    },
    table7: {
      name: 'Ifjúsági - Bemutatkozás',
      title1: 'Sáv'
    },
    table8: {
      name: 'Ifjúsági - Végső Liga Pozíció',
      title1: 'Utolsó Klub Végső Liga Pozíciója'
    },
    table9: {
      name: 'Ifjúsági - Kontinentális Előrehaladás',
      title1: 'Kontinentális Előrehaladás'
    },
    table10: {
      name: 'Ifjúsági - Játékos Jelenlegi Liga Minősége',
      title1: 'Játékos Jelenlegi Klubjának Sávja'
    },
    table11: {
      name: 'Ifjúsági - Játékos Jelenlegi Liga Minősége',
      title1: 'Játékos Jelenlegi Klubjának Sávja'
    },
    table12: {
      name: 'Ifjúsági - Nemzetközi Pályára Lépések',
      title1: 'Játékos Nemzetközi Pályára Lépései'
    }
  },
  mediaMode: {
    borderColor: 'Szegély Színe',
    fillColor: 'Kitöltés Színe',
    bgColor: 'Háttér Színe',
    upperText: 'Felső Szöveg',
    lowerText: 'Alsó Szöveg',
    socialMedia: 'Közösségi Média',
    textColor: 'Szöveg Színe',
    axisColor: 'Tengely Színe',
    logo: 'Logó',
    comparisonBorderColor: 'Összehasonlítás Szegély Színe',
    comparisonFillColor: 'Összehasonlítás Kitöltés Színe',
    comparisonUpperText: 'Összehasonlítás Felső Szöveg',
    comparisonLowerText: 'Összehasonlítás Alsó Szöveg',
    homeFillColor: 'Otthon Kitöltés Színe',
    homeBorderColor: 'Otthon Szegély Színe',
    awayFillColor: 'Idegenben Kitöltés Színe',
    awayBorderColor: 'Idegenben Szegély Színe',
    face: 'Arc',
    nationalTeam: 'Nemzeti Válogatott',
    comparisonFace: 'Összehasonlítás Arc',
    upperTextX: 'Felső Szöveg {0}',
    lowerTextX: 'Alsó Szöveg {0}',
    borderColorX: 'Szegély Színe {0}',
    fillColorX: 'Kitöltés Színe {0}',
    homeFillColorX: 'Kitöltés Színe (Otthon) {0}',
    homeBorderColorX: 'Szegély Színe (Otthon) {0}',
    awayFillColorX: 'Kitöltés Színe (Idegenben) {0}',
    awayBorderColorX: 'Szegély Színe (Idegenben) {0}',
    faceX: 'Arc {0}',
    selectField: 'Válasszon egy tulajdonságot',
    orientationX: 'Tájolás {0}',
    searchBarPlaceholder: 'Keresés Játékosok és/vagy Mérkőzések...',
    title: 'Média Irányítópult',
    pageSubtitle: 'Fedezze fel és töltse le a térképeket és grafikákat',
    chooseChart: 'Válasszon diagramot...',
    headerTextX: 'Fejléc Szöveg {0}',
    avatarLineLength: 'Avatar Vonal Hossza',
    avatarLineWeight: 'Avatar Vonal Vastagsága',
    avatarSize: 'Avatar Mérete',
    chartX: 'Diagram {0}',
    chartHeaderFontSize: 'Diagramok Fejléc Betűmérete',
    chartHeaderFontWeight: 'Diagramok Fejléc Betűvastagsága',
    upperTextFontSize: 'Felső Szöveg Betűmérete',
    upperTextFontWeight: 'Felső Szöveg Betűvastagsága',
    lowerTextFontSize: 'Alsó Szöveg Betűmérete',
    lowerTextFontWeight: 'Alsó Szöveg Betűvastagsága',
    socialMediaFontSize: 'Közösségi Média Betűmérete',
    socialMediaFontWeight: 'Közösségi Média Betűvastagsága',
    subtitle: 'Alcím',
    subtitleFontSize: 'Alcím Betűmérete',
    subtitleFontWeight: 'Alcím Betűvastagsága',
    subtitleX: 'Alcím {0}',
    subtitleFontSizeX: 'Alcím ${0} Betűmérete',
    subtitleFontWeightX: 'Alcím ${0} Betűvastagsága',
    titleX: 'Cím {0}',
    titleFontSize: 'Cím Betűmérete',
    titleFontWeight: 'Cím Betűvastagsága',
    sponsor: 'Szponzor',
    fontFamily: 'Betűtípus'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Felderítési Jelentések',
      GAME_REPORT: 'Mérkőzés Jelentések',
      MEDICAL_REPORT: 'Orvosi Jelentések',
      PHYSICAL_REPORT: 'Fizikai Jelentések',
      PSYCHOLOGICAL_REPORT: 'Pszichológiai Jelentések',
      OTHER: 'Egyéb',
      QUICK_NOTES: 'Gyors Jegyzetek',
      PLAYER_REPORT: 'Játékos Jelentések',
      GENERAL_COMMENTS: 'Általános Megjegyzések',
      PLAYER_ANALYSIS: 'Játékos Elemzés'
    },
    uploadDocument: 'Dokumentum Feltöltése',
    notesPlaceholder: 'Írjon leíró jegyzeteket vagy megjegyzéseket a dokumentumhoz kapcsolódóan',
    notesPlaceholderAlt: 'Írjon leíró jegyzeteket vagy megjegyzéseket a játékoshoz kapcsolódóan',
    uploadedBy: 'Feltöltötte',
    updatedBy: 'Frissítette',
    seeNotes: 'Jegyzetek Megtekintése',
    addNote: 'Jegyzet Hozzáadása',
    rating: 'Értékelés',
    position: 'Legjobb pozíció',
    physical: 'Fizikai',
    onBall: 'Labdán',
    offBall: 'Labda Nélkül',
    mental: 'Mentális',
    potential: 'Potenciál',
    conclusion: 'Következtetés',
    recommendation: {
      1: 'Aláírás',
      2: 'Figyelés',
      3: 'Elvetés',
      4: 'Érdekes',
      label: 'Ajánlás'
    },
    match: 'Mérkőzés',
    deleteQuickNote: 'Jegyzet Törlése',
    deleteQuickNoteMessage: 'A jegyzet véglegesen eltávolításra kerül. Biztos benne?',
    noQuickNotes: 'Nincs adat. Kezdje néhány gyors jegyzet hozzáadásával!',
    deleteDocument: 'Dokumentum Törlése',
    deleteDocumentMessage: 'A dokumentum véglegesen eltávolításra kerül. Biztos benne?',
    noDocuments: 'Nincs adat. Kezdje néhány dokumentum hozzáadásával!'
  },
  notifications: {
    newReportMessage: 'Új üzenet van egy jelentésben'
  },
  blog: {
    subtitle: 'Legfrissebb cikkek, frissítések és hírek',
    newEntry: 'Új Bejegyzés',
    title: 'Cím',
    text: 'Szöveg',
    link: 'Link',
    image: 'Kép',
    author: 'Szerző',
    date: 'Kiadás dátuma',
    deleteEntry: 'Bejegyzés Törlése',
    deleteEntryMessage: 'Biztosan törölni szeretné ezt a bejegyzést?',
    readMore: 'Tovább olvasom'
  },
  positionsOrlegi: {
    GK: 'Kapus',
    DC: 'Védő',
    DR: 'Szélső Védő',
    MC: 'Középpályás',
    AMC: 'Támadó Középpályás',
    FW: 'Csatár',
    FWR: 'Szélső'
  },
  library: {
    subtitle: 'Feltöltött dokumentumok megtekintése és megosztása',
    mediaSubtitle: 'Exportált diagramok megtekintése és megosztása',
    charts: 'Diagramok',
    goToLibrary: 'Ugrás a könyvtárhoz'
  },
  scatterPlot: {
    bubbleSize: 'Buborék Mérete',
    byMinutes: 'Percek Szerint',
    byAge: 'Életkor Szerint',
    byMarketValue: 'Piaci Érték Szerint'
  },
  eventChart: {
    successfulEvent: 'Sikeres',
    unsuccessfulEvent: 'Sikertelen',
    possessionLost: 'Sikeres, nem sikerült helyreállítani',
    successfulPass: 'Sikeres Passz',
    unsuccessfulPass: 'Sikertelen Passz',
    successfulCarry: 'Sikeres Labdavitel',
    unsuccessfulCarry: 'Sikertelen Labdavitel',
    carryAndKeyPass: 'Labdavitel & Kulcs Passz',
    carryAndAssist: 'Labdavitel & Gólpassz',
    carryAndShot: 'Labdavitel & Lövés',
    ballProgressionAndPass: 'Labda Előrehaladás & Passz',
    ballProgression: 'Labda Előrehaladás',
    ballProgressionAndKeyPass: 'Labda Előrehaladás & Kulcs Passz',
    ballProgressionAndAssist: 'Labda Előrehaladás & Gólpassz',
    ballProgressionAndShot: 'Labda Előrehaladás & Lövés',
    ballProgressionAndGoal: 'Labda Előrehaladás & Gól',
    pass: 'Passz',
    carryAndPass: 'Labdavitel & Passz',
    carryAndGoal: 'Labdavitel & Gól',
    totalTouches: 'Összes Érintés',
    totalPasses: 'Összes Passz',
    successful: 'Sikeres',
    unsuccessful: 'Sikertelen',
    tacklePossessionLost: 'Sikeres – elveszett birtoklás',
    gamesSelected: '{count} mérkőzés kiválasztva',
    allGamesOfSeason: 'Szezon összes mérkőzése',
    allGamesOfSeasons: 'Szezonok összes mérkőzése',
    allEvents: 'Minden esemény',
    eventTypesCount: '{count} eseménytípus',
    totalEvents: 'Összes események',
    zoneDominanceNote: 'Az egyes csapatok által mutatott érintések az egyes zónákban csak a sikeres érintéseket jelentik',
    selectedEvents: 'Válogatott események'
  },
  event: {
    Pass: 'Passz',
    TakeOn: 'Dribling',
    Takeon: 'Dribling',
    Foul: 'Szabálytalanság',
    Error: 'Hiba',
    Tackle: 'Labdavétel',
    Interception: 'Labdaszerzés',
    Clearance: 'Tisztítás',
    MissedShot: 'Kihagyott Lövés',
    ShotOnPost: 'Kapufa Lövés',
    SavedShot: 'Védett Lövés',
    Goal: 'Gól',
    Aerial: 'Légi',
    BallRecovery: 'Labda Visszaszerzés',
    Dispossessed: 'Labdavesztés',
    ChanceMissed: 'Kihagyott Helyzet',
    BallTouch: 'Labda Érintés',
    BlockedPass: 'Blokkolt Passz',
    Challenge: 'Kihívás',
    lossPossession: 'Birtoklás Vesztés',
    OffsidePass: 'Les Passz',
    groundDuelsLost: 'Földi Párbajok Elvesztve',
    'Ball touch': 'Labda Érintés',
    Smother: 'Elfojtás',
    'Keeper pickup': 'Kapus Felvétel',
    'Good skill': 'Jó Készség',
    Punch: 'Ütés',
    'Saved shot': 'Védett Lövés',
    'Shot on post': 'Kapufa Lövés',
    'Missed shot': 'Kihagyott Lövés',
    Save: 'Védés',
    'Take on': 'Dribling',
    'Offside pass': 'Les Passz',
    Claim: 'Igénylés',
    'Blocked pass': 'Blokkolt Passz',
    KeeperPickup: 'Keeper Pickup',
    'Ball recovery': 'Labdahelyreállítás',
    'Ball Recovery': 'Labdahelyreállítás',
    'Chance missed': 'Kimaradt az esély',
    'Loss possession': 'Birtokvesztés',
    Carries: 'Visz',
    BallProgression: 'Labdahaladás',
    MissedChance: 'Elszalasztott esély',
    Event: 'Esemény',
    Shot: 'Lövés',
    Assist: 'Segít',
    KeyPass: 'Kulcs Passz',
    'Foul taken': 'Szabálytalanság érkezett'
  },
  leagueTab: {
    leagueTable: 'Liga Táblázat',
    matchdays: 'Fordulók',
    playerInsights: 'Játékos Elemzések',
    onlyLocalPlayers: 'Csak helyi játékosok',
    teamInsights: 'Csapat Elemzések',
    head2head: 'Versenytárs',
    addNewChart: 'Új diagram hozzáadása',
    rounds: {
      16: 'Nyolcaddöntő',
      32: 'Harmincketted döntő',
      W: 'Győztes',
      F: 'Döntő',
      SF: 'Elődöntő',
      QF: 'Negyeddöntő',
      GR: 'Csoportkör',
      '4R': 'Negyedik Forduló',
      '3R': 'Harmadik Forduló',
      '2R': 'Második Forduló',
      '1R': 'Első Forduló',
      PR: 'Előselejtező',
      QPO1: '32-es Döntő Szint Alatt',
      QPO2: 'Selejtező Nyolcaddöntő',
      QPO3: 'Selejtező 32. forduló'
    },
    positions: 'Pozíciók',
    prediction: 'Előrejelzések',
    predicted: 'Előrejelzés',
    groups: 'Csoportok',
    ranking: 'Rangsor',
    numberOfTeams: 'Csapatok száma',
    statsWithMinimum: {
      message: 'Csak azok a játékosok láthatók, akiknek több mint {0} {1} van a kiválasztott szezonban',
      dribblesTotal90: 'dribling 90 perc alatt',
      crosses90: 'beadás 90 perc alatt',
      tacklesAttempted90: 'kísérlet tackle 90 perc alatt',
      aerialsTotal90: 'légi párbaj 90 perc alatt'
    },
    numberOfLeagues: 'Ligák száma',
    position: {
      titleWinner: 'A cím nyertese',
      championsLeague: 'Bajnokok Ligája',
      qualifierChampionsLeague: 'Selejtező Bajnokok Ligája',
      europeLeague: 'Európa Liga',
      qualifierEuropeLeague: 'Selejtező Európa Liga',
      conferenceLeague: 'Konferencia Liga',
      qualifierConferenceLeague: 'Selejtező Konferencia Liga',
      midTable: 'Középső asztal',
      relegation: 'Kiesés',
      promotion: 'Promóció',
      relegationPlayoff: 'Kieső rájátszás',
      promotionPlayoff: 'Promóciós rájátszás',
      championshipGroup: 'Bajnokság csoportja',
      relegationGroup: 'Kieső csoport',
      championshipPlayoffs: 'Bajnoki rájátszás',
      preChampionshipPlayoffs2: 'A bajnokság előtti rájátszás 2',
      preChampionshipPlayoffs3: 'A bajnokság előtti rájátszás 3',
      playoffsQualifierBand3: 'Rájátszás selejtező együttes 3',
      continentalGroup: 'Kontinentális csoport'
    },
    group: {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'én',
      10: 'J',
      11: 'K',
      12: 'L'
    }
  },
  similarity: {
    subtitle: 'Hasonló játékosok keresése',
    searchBarPlaceholder: 'Keresés és játékos kiválasztása hasonlók kereséséhez',
    radarFilters: 'Radar szűrők',
    similarityFilters: 'Hasonlóság szűrők',
    playersFilters: 'Játékos szűrők',
    similarPlayers: 'Hasonló Játékosok',
    seasonWarning: 'Csak azok a szezonok elérhetők a Hasonlóság eszközben, amelyekben a játékos több mint 450 percet játszott'
  },
  squadBuilder: {
    subtitle: 'Vázolja fel egyedi tizenegyét',
    playerSelector: 'Játékos választó',
    loadSquad: 'Keret betöltése',
    yearsOld: 'éves',
    playersPerPosition: 'Játékosok pozíciónként',
    custom: 'Egyedi',
    removeSquad: 'Keret törlése',
    removeSquadMessage: 'Biztosan törölni szeretné a keretet?',
    deleteSquadSuccess: 'A keret sikeresen törölve lett',
    playerDetails: 'Játékos részletek láthatósága',
    ageFormat: 'Életkor formátum',
    mainPlayer: 'Fő játékos',
    showDetails: 'Részletek megjelenítése',
    all: 'Összes',
    squadPosition: 'Keret pozíció',
    noData: 'Nincs adat. Kezdje néhány játékos hozzáadásával a pályán!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'Ne Mutassa Újra',
      skipTour: 'Irányított Túra Kihagyása',
      previous: 'Előző',
      next: 'Következő',
      finish: 'Befejezés'
    },
    playerRadar: {
      step1: {
        title: 'SZEMÉLYES DOSSIÉ',
        message: 'Ellenőrizze az alapvető játékos adatokat: életkor, magasság vagy szerződés dátuma'
      },
      step2: {
        title: 'GBE SZŰRŐ',
        message: 'Funkcionalitás, amely lehetővé teszi, hogy megtudja, van-e egy játékosnak elég GBE pontja az Egyesült Királyságban való játékhoz'
      },
      step3: {
        title: 'ELÉRHETŐSÉG',
        message: 'Elérhető percek százaléka és játszott percek százaléka'
      },
      step4: {
        title: 'POZÍCIÓK',
        message: 'Tudja meg, mely pozíciókban játszott a játékos és hány percet játszott minden pozícióban'
      },
      step5: {
        title: 'MEGJELENÍTÉSI FORMÁTUMOK',
        message: 'Mérje a teljesítményt 4 különböző vizualizációval, Radar, Polar, Lollipop és Szöveg, hogy összehasonlítsa a pozíciójában lévő játékosokkal'
      },
      step6: {
        title: 'TELJESÍTMÉNY RADAR',
        message: 'Itt a teljesítmény vizuálisan tükröződik. A panel interaktív, rámutatva minden metrikára megkaphatja annak definícióját'
      },
      step7: {
        title: 'SZEZON KIVÁLASZTÁS',
        message: 'Válasszon vagy adjon hozzá szezonokat a teljesítmény méréséhez'
      },
      step8: {
        title: 'EGYEDI SABLON KIVÁLASZTÁS',
        message: 'Használja a létrehozott egyedi sablonokat, hogy különböző metrikákkal mérje a játékost, mint a standard radar'
      },
      step9: {
        title: 'JÁTSZOTT POZÍCIÓK KIVÁLASZTÁSA',
        message: 'Jelölje be és törölje a különböző pozíciókat, hogy a kívánt pozícióban mérje'
      },
      step10: {
        title: 'MINIMUM ÉS MAXIMUM KIVÁLASZTÁS',
        message: 'Mérje a játékost szezonjának magas és alacsony értékeivel, az öt legjobb liga értékeivel vagy a felhasználói fiók saját és alapértelmezett szezonjának értékeivel'
      },
      step11: {
        title: 'ÖSSZEHASONLÍTÁSOK',
        message: 'Összehasonlítja a játékost korábbi teljesítményével, pozíciójában lévő más játékosokkal, a pozíció átlagával'
      },
      step12: {
        title: 'KÉP LETÖLTÉSI FORMÁTUMOK',
        message: 'Három letöltési formátum érhető el: png, svg és embed'
      }
    },
    playerRanking: {
      step1: {
        title: 'SZEZON, KERET ÉS POZÍCIÓ',
        message: 'Válassza ki a szezont, keretet és pozíciót, amellyel össze szeretné hasonlítani a játékost'
      },
      step2: {
        title: 'ALAPVETŐ SZŰRŐK',
        message: 'Szűrje a játékosokat életkor, játszott percek vagy magasság szerint'
      },
      step3: {
        title: 'KIEMELÉS ÉS KIZÁRÁS',
        message: 'Emelje ki a kívánt játékosokat és zárja ki a csapatokat a megjelenítésből'
      },
      step4: {
        title: 'SZŰRÉS KATEGÓRIA SZERINT',
        message: 'Szűrje a statisztikákat kategória szerint: Kapcsolat, Védekezés, Passzolás, Labdakezelés, stb'
      },
      step5: {
        title: 'KÉP LETÖLTÉSI FORMÁTUMOK',
        message: 'Három letöltési formátum érhető el: png, svg és embed'
      }
    },
    playerFinishing: {
      step1: {
        title: 'MEGJELENÍTÉS KIVÁLASZTÁSA',
        message: 'Láthatja a befejezés térképet fő nézetben, gól nézetben és egy eloszlási táblázatban'
      },
      step2: {
        title: 'SZEZONOK KIVÁLASZTÁSA',
        message: 'Adjon hozzá szezonokat a lövési hatékonyság méréséhez'
      },
      step3: {
        title: 'LÖVÉS HELYSZÍNE',
        message: 'Válassza ki a lehetőséget a lövés pontos helyének megtekintésére (körök) vagy a tizenhatos és pálya területei szerint (területek)'
      },
      step4: {
        title: 'xG KAPURA',
        message: 'Jelölje be az xG gólhoz és xG befejezéshez tartozó dobozokat, hogy lássa, milyen hozzáadott értéket adott a játékos a lövés után'
      },
      step5: {
        title: 'LÖVÉS TÍPUSA',
        message: 'Szűrés lövés típus, stratégia, terület vagy testrész szerint'
      },
      step6: {
        title: 'PERCEK SZŰRÉSE',
        message: 'Percek sáv a lövéseket és gólokat kiválasztani konkrét mérkőzés időszakok szerint'
      },
      step7: {
        title: 'KÉP LETÖLTÉSI FORMÁTUMOK',
        message: 'Három letöltési formátum érhető el: png, svg és embed'
      },
      step8: {
        title: 'LÖVÉS TÉRKÉP',
        message: 'A térkép interaktív. Rámutatva minden körre megtudhatja az xG-t minden lövéshez'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'SZEZON KIVÁLASZTÁS',
        message: 'Adjon hozzá szezonokat a lövési hatékonyság méréséhez'
      },
      step2: {
        title: 'KULCS PASSZ HELYSZÍNE',
        message: 'Válassza ki a lehetőséget a kulcs passz pontos helyének megtekintésére (kör) vagy a terület és pálya zónái szerint (területek)'
      },
      step3: {
        title: 'BEFEJEZÉS TÍPUSA KULCS PASSZ UTÁN',
        message: 'Szűrés lövés típus, stratégia, terület vagy testrész szerint, amelyet kulcs passz után végeztek'
      },
      step4: {
        title: 'PERCEK SZŰRÉSE',
        message: 'Percek sáv a lövéseket és gólokat kiválasztani konkrét mérkőzés időszakok szerint'
      },
      step5: {
        title: 'KÉP LETÖLTÉSI FORMÁTUMOK',
        message: 'Három letöltési formátum érhető el: png, svg és embed'
      },
      step6: {
        title: 'KULCS PASSZ TÉRKÉP',
        message: 'A térkép interaktív. Rámutatva minden körre megtudhatja az xA-t minden passzhoz'
      }
    },
    playerThreat: {
      step1: {
        title: 'SZEZON KIVÁLASZTÁS',
        message: 'Adjon hozzá szezonokat a lövési hatékonyság méréséhez'
      },
      step2: {
        title: 'VESZÉLY HELYSZÍNE',
        message: 'Válassza ki a lehetőséget a kulcs passz pontos helyének megtekintésére (kör) vagy terület és pálya zónák szerint (területek)'
      },
      step3: {
        title: 'AKCIÓ ÉS BEFEJEZÉS',
        message: 'Jelölje be és törölje az akció és befejezés típusa szerint, amit meg szeretne jeleníteni a térképen'
      },
      step4: {
        title: 'PERCEK ÉS VESZÉLY',
        message: 'Szűrés időszak, percek és akciók veszély értéke szerint'
      },
      step5: {
        title: 'KÉP LETÖLTÉSI FORMÁTUMOK',
        message: 'Három letöltési formátum érhető el: png, svg és embed'
      },
      step6: {
        title: 'VESZÉLY TÉRKÉP',
        message: 'A térkép interaktív. Rámutatva minden körre megtudhatja az egyes passzok egyes xT játékában generált veszélyt'
      }
    },
    playerTouches: {
      step1: {
        title: 'MÉRKŐZÉS ÉS ESEMÉNY KIVÁLASZTÁS',
        message: 'Válassza ki a mérkőzést és eseményeket, amelyeket meg szeretne jeleníteni a térképen'
      },
      step2: {
        title: 'ESEMÉNY TÍPUSA',
        message: 'Jelölje be és törölje a játékos eseményének védő vagy támadó jellege szerint a mérkőzés során'
      },
      step3: {
        title: 'MEGJELENÍTÉSI SZŰRŐ',
        message: 'Szűrés térkép alapvető akciók, hőtérkép, körök vagy dobozok szerint'
      },
      step4: {
        title: 'KÉP LETÖLTÉSI FORMÁTUMOK',
        message: 'Három letöltési formátum érhető el: png, svg és embed'
      },
      step5: {
        title: 'ÉRINTÉSEK TÉRKÉP',
        message: 'A térkép interaktív. Minden eseményt megtekinthet, ha rákattint az egyes eseményekre'
      }
    },
    playerAllGames: {
      step1: {
        title: 'ELÉRHETŐSÉG',
        message: 'Ellenőrizze az elérhetőséget és játszott perceket mérkőzésenként'
      },
      step2: {
        title: 'POZÍCIÓK',
        message: 'Tekintse meg a pozíciókat, amelyekben játszott minden mérkőzésen'
      }
    },
    playerInjuries: {
      step1: {
        title: 'ELŐZMÉNY ÉS ELVESZTETT NAPOK',
        message: 'Tekintse meg az elmúlt év sérüléseit vagy a teljes előzményt és sérülések tartományát napokban kifejezett időtartamuk szerint'
      },
      step2: {
        title: 'SÉRÜLÉSEK KLUB SZERINT',
        message: 'Tekintse meg a sérüléseket szezon és/vagy klub szerint elkülönítve pályafutása során'
      }
    },
    playerInfo: {
      step1: {
        title: 'KARRIER ÉS ÁTIGAZOLÁSOK',
        message: 'Megtekintheti a perceket, pozíciót vagy elérhetőség előzményt klubjával, nemzeti válogatottjával és a játékos átigazolásait karrierje során'
      }
    },
    teamOverview: {
      step1: {
        title: 'CSAPAT LAP',
        message: 'Tekintse meg a csapat alapvető adatait: átlagos életkor, alap felállás, ELO vagy átigazolási egyenleg'
      },
      step2: {
        title: 'ALAPVETŐ STATISZTIKÁK',
        message: 'Tekintse meg a birtoklást, xG-t, Lövéseket, PPDA-t vagy Vertikalitást'
      },
      step3: {
        title: 'RADAR ÉS SZEZON',
        message: 'Válassza ki a radart, szezont és otthoni vagy idegenbeli mérkőzéseket a csapat teljesítményének méréséhez'
      },
      step4: {
        title: 'SZŰRÉS EDZŐ ÉS MÉRKŐZÉSEK SZERINT',
        message: 'Válassza ki a teljesítményt szakasz szerint minden edzőhöz'
      },
      step5: {
        title: 'TELJESÍTMÉNY RADAR',
        message: 'A panel interaktív, rámutatva minden metrikára megkaphatja annak definícióját'
      },
      step6: {
        title: 'KÉP LETÖLTÉSI FORMÁTUMOK',
        message: 'Két letöltési formátum érhető el: png és svg'
      },
      step7: {
        title: 'NAPTÁR',
        message: 'Tekintse meg a csapat mérkőzés menetrendjét'
      },
      step8: {
        title: 'LEGJOBB JÁTÉKOSOK METRIKÁK SZERINT',
        message: 'Ebben a panelben különböző metrikákat választhat és láthatja, mely játékosok a legfontosabbak'
      },
      step9: {
        title: 'KÖVETKEZŐ MÉRKŐZÉS ÉS SÉRÜLÉSEK',
        message: 'Ellenőrizze a következő ellenfelet és a csapat sérült és felfüggesztett játékosait'
      },
      step10: {
        title: 'GRAFIKONOK ÉS TRENDEK',
        message: 'Tekintse meg a különböző grafikonokat az utolsó 10 vagy 20 mérkőzéshez'
      }
    },
    teamRoster: {
      step1: {
        title: 'NÉZET TÍPUSA',
        message: 'Tekintse meg a keretet 6 különböző kategóriából: pozíció, szerződés vége, életkor, elérhetőség, életkor profil és pálya szerint'
      }
    },
    teamLoans: {
      step1: {
        title: 'KÖLCSÖNZÖTT JÁTÉKOSOK',
        message: 'Tekintse meg a más csapatokhoz kölcsönzött játékosokat és milyen pozícióban játszanak'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'SZEZON ÉS KERET',
        message: 'Szűrés szezon, radar keret szerint és összehasonlítás a választott ligákkal'
      },
      step2: {
        title: 'TELJESÍTMÉNY METRIKÁK SZERINT',
        message: 'Lássa, hol van a csapat minden metrikában az összes csapathoz képest a korábban kiválasztott ligákban'
      },
      step3: {
        title: 'KÉP LETÖLTÉSI FORMÁTUMOK',
        message: 'Három letöltési formátum érhető el: png, svg és embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'SZEZON KIVÁLASZTÁS',
        message: 'Adjon hozzá szezonokat a lövési hatékonyság méréséhez'
      },
      step2: {
        title: 'SAJÁT VAGY ELLENFÉL BEFEJEZÉSE',
        message: 'Válassza ki, hogy a csapat vagy az összes ellenfele befejezés térképét szeretné-e látni'
      },
      step3: {
        title: 'LÖVÉS ELHELYEZÉS',
        message: 'Válassza ki, hogyan szeretné látni a csapat lövéseit, körök vagy zónák (dobozok) szerint'
      },
      step4: {
        title: 'LÖVÉS TÍPUSA',
        message: 'Szűrés lövés típus, stratégia, terület vagy testrész szerint'
      },
      step5: {
        title: 'PERCEK SZŰRÉSE',
        message: 'Percek sáv a lövéseket és gólokat kiválasztani konkrét mérkőzés időszakok szerint'
      },
      step6: {
        title: 'KÉP LETÖLTÉSI FORMÁTUMOK',
        message: 'Három letöltési formátum érhető el: png, svg és embed'
      },
      step7: {
        title: 'LÖVÉSEK TÉRKÉP',
        message: 'A térkép interaktív. Rámutatva minden körre megtudhatja az xG-t minden lövéshez'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'SZEZON KIVÁLASZTÁS',
        message: 'Adjon hozzá szezonokat a lövési hatékonyság méréséhez'
      },
      step2: {
        title: 'SAJÁT VAGY RIVÁLIS KULCS PASSZOK',
        message: 'Válassza ki, hogy a csapat vagy az összes riválisa kulcs passz térképét szeretné-e látni'
      },
      step3: {
        title: 'KULCS PASSZ HELYSZÍNE',
        message: 'Válassza ki, hogy a kulcs passz pontos helyét (kör) vagy terület és pálya szerint (dobozok) szeretné-e látni'
      },
      step4: {
        title: 'BEFEJEZÉS TÍPUSA PASSZ UTÁN',
        message: 'Szűrés lövés típus, stratégia, terület vagy testrész szerint, amelyet kulcs passz után végeztek'
      },
      step5: {
        title: 'PERCEK SZŰRÉSE',
        message: 'Percek sáv a lövéseket és gólokat kiválasztani konkrét mérkőzés időszakok szerint'
      },
      step6: {
        title: 'KÉP LETÖLTÉSI FORMÁTUMOK',
        message: 'Három letöltési formátum érhető el: png, svg és embed'
      },
      step7: {
        title: 'LÖVÉSEK TÉRKÉP',
        message: 'A térkép interaktív. Rámutatva minden körre megtudhatja az xA-t minden passzhoz'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'LEGUTÓBBI MÉRKŐZÉSEK',
        message: 'Tekintse meg az eredményeket, birtoklást, xG-t és győzelem %-ot a csapat összes mérkőzésén'
      }
    },
    teamTransfers: {
      step1: {
        title: 'ÉRKEZÉSEK',
        message: 'Tekintse meg az összes érkezést (vásárlások + átigazolások) naptári év szerint'
      },
      step2: {
        title: 'TÁVOZÁSOK',
        message: 'Tekintse meg az összes távozást (eladások + átigazolások) naptári év szerint'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'TRENDEK',
        message: 'Kérdezze le a csapat formáját sorozatok, győzelmek, kapott gól nélküli mérkőzések, visszavágások, gólos időszakok vagy gól típusok szerint'
      },
      step2: {
        title: 'RÖGZÍTETT SZITUÁCIÓ',
        message: 'Hasonlítsa össze a Csapat Teljesítményét Rögzített Szituáció Játékok és Nyitott Játékok között és kapjon részletes áttekintést a Rögzített Szituációkról'
      },
      step3: {
        title: 'CSERÉK',
        message: 'Lássa, mikor cserél a csapat és mely játékosokat cserélik le legtöbbször'
      },
      step4: {
        title: 'KAPCSOLATOK',
        message: 'Tekintse meg a leggyakoribb kapcsolatokat játékosok között. Szűrés szezon és játék típus szerint'
      },
      step5: {
        title: 'TÁMADÓ ZÓNÁK',
        message: 'Fedezze fel a csapat támadó zónáit és szűrés szezon vagy támadás típus szerint'
      },
      step6: {
        title: 'FELÁLLÁSOK',
        message: 'Ellenőrizze a leggyakrabban használt felállásokat és azok győzelem, döntetlen és vereség %-át mindegyikkel'
      },
      step7: {
        title: 'LÖVÉS ZÓNÁK',
        message: 'Szűrés szezon, csapat vagy ellenfél, térkép vizualizálási mód, lövés típusok vagy percek szerint'
      },
      step8: {
        title: 'BEADÁSOK',
        message: 'Kérdezze le és szűrje szezon, megjelenítés típus, sikeres vagy sikertelen, honnan indulnak és végződnek vagy szögleteket is beleértve szerint'
      },
      step9: {
        title: 'JÁTÉKOSOK',
        message: 'Szűrés szezon, megjelenítés típus, sikeres vagy sikertelen, honnan indulnak és végződnek vagy szögleteket is beleértve szerint'
      }
    },
    teamOnOff: {
      step1: {
        title: 'SZEZONOK ÉS MÉRKŐZÉSEK',
        message: 'Szűrés szezon, mérkőzések vagy otthoni vagy idegenbeli mérkőzések szerint'
      },
      step2: {
        title: 'JÁTÉKOSOK',
        message: 'Tekintse meg az összes játékos teljesítményét a keretben számtalan metrika szerint'
      }
    }
  },
  alerts: {
    numPlayers: 'Játékosok száma',
    newPlayersLastWeek: 'Új játékosok az elmúlt héten',
    subtitle: 'Kapjon riasztásokat, amikor új játékosok megfelelnek a keresési feltételeinek',
    generalSubtitle: 'Kapjon riasztásokat új játékosokról feltételei alapján és híreket kedvenc játékosairól',
    subtitlePlayer: 'Kapjon riasztásokat, amikor híreink vannak kedvenc játékosairól',
    subtitleSearch: 'Kapjon riasztásokat, amikor új játékosok megfelelnek a keresési feltételeinek',
    favorite: 'Kedvenc',
    newEventCalendar: 'Új Esemény',
    updatedEventCalendar: 'Frissített Esemény',
    newShareFrom: 'Új megosztás tőle',
    injuryAlert: 'Sérülés Riasztás',
    contractAlert: 'Szerződés Riasztás',
    teamAlert: 'Igazolás Riasztás',
    marketValueAlert: 'Piaci Érték Riasztás',
    gameAlert: 'Játszott Mérkőzés Riasztás'
  },
  videoEvents: {
    highlights: 'Kiemelkedő Pillanatok',
    fullGame: 'Teljes mérkőzés',
    autoplay: 'Automatikus lejátszás',
    searchBarPlaceholder: 'Keresés játékos, mérkőzés vagy csapat...',
    subtitle: 'Események elemzése videón keresztül',
    successful: 'Siker',
    unsuccessful: 'Sikertelen',
    playing: 'Játszás',
    games: 'Mérkőzések',
    moreFilters: 'További szűrők...',
    startArea: 'Kezdő terület',
    endArea: 'Végső terület',
    select: 'Kiválasztás',
    selectLastXGames: 'Válassza ki az utolsó {0} mérkőzést',
    advancedFilters: 'Haladó Szűrők',
    freeKicks: 'Szabadrúgások',
    cornerKicks: 'Szögletek',
    allShots: 'Összes Lövés',
    generateZip: 'Videók Letöltése',
    zippedModalMessage: 'Most készítjük a videó listáját és hamarosan elküldjük email címére',
    clickToSeeVideo: 'Kattintson a videó megtekintéséhez'
  },
  videoUpload: {
    subtitle: 'Videó feltöltése és új mérkőzés létrehozása',
    uploadVideo: 'Videó feltöltése',
    selectPeriod: 'Időszak kiválasztása',
    gameData: 'Mérkőzés Adatok',
    venue: 'Helyszín',
    matchType: 'Mérkőzés típusa',
    matchGroup: 'Mérkőzés csoport',
    roundType: 'Forduló típusa',
    roundNumber: 'Forduló száma',
    offsetFh: 'Első Félidő Eltolás',
    offsetSh: 'Második Félidő Eltolás',
    offsetFhOT: 'Hosszabbítás Első Félidő Eltolás',
    offsetShOT: 'Hosszabbítás Második Félidő Eltolás',
    homeLineup: 'Otthoni Felállás',
    awayLineup: 'Idegenbeli Felállás',
    existingPlayer: 'Meglévő játékos',
    newPlayer: 'Új játékos',
    startingTeam: 'Kezdő',
    saveAndUpload: 'Mentés és feltöltés',
    existingGame: 'A mérkőzés már létezik',
    sendToKora: 'Küldés',
    invalidForm: 'Érvénytelen űrlap',
    warningModalTitle: 'Anomáliák észlelve',
    noScoreSheetWarning: 'Nincs eredménylap csatolva',
    onlyOnePartUploadedWarning: 'Csak egy félidő csatolva',
    continueQuestion: 'folytatja?',
    slaLimit: 'Feltöltött {0} mérkőzést {1}-vel. A limitje {2}',
    requestedGames: 'Kért mérkőzések',
    limitClose: 'Már csak {0} mérkőzés maradt kérésre',
    limitReached: 'Elérte a videó feltöltési limitjét. További mérkőzések feltöltése további költségeket eredményezhet.',
    seasonFinishedWarning: 'Ez egy mérkőzést hoz létre egy már befejezett szezonban. Kérjük, ellenőrizze, hogy ez helyes-e.',
    teamCountryWarning: 'Ez a csapat más országból származik, mint a kiválasztott liga. Kérjük, ellenőrizze, hogy ez helyes-e.',
    uploading: 'Feltöltés',
    doNotNavigateAway: 'Kérjük, ne zárja be ezt a lapot, ne frissítse az oldalt, és ne navigáljon el, amíg a feltöltés folyamatban van.',
    severalMinutes: 'Ez a folyamat több percig is eltarthat.'
  },
  videoPlaylists: {
    subtitle: 'Videó kiemelkedő pillanatok szűrők gyűjteményei',
    savePlaylist: 'Lejátszási Lista Mentése',
    seeAllPlaylists: 'Összes lejátszási lista megtekintése'
  },
  videoHighlights: {
    recap: 'Összefoglaló',
    homeCondensed: 'Otthoni Összefoglaló Mérkőzés',
    awayCondensed: 'Idegenbeli Összefoglaló Mérkőzés',
    selectedActions: 'Kiválasztott akciók',
    noActions: 'Nincsenek akciók, amelyek megfelelnek a megadott szűrő feltételeknek',
    noGames: 'Még nincsenek feltöltött mérkőzések',
    attackingActions: 'Támadó Akciók',
    defensiveActions: 'Védő Akciók',
    groundDuels: 'Földi Párbajok',
    penaltiesProvoked: 'Kiváltott Büntetők',
    goalkeeperActions: 'Kapus Akciók',
    addSomeGames: 'Kezdje néhány mérkőzés hozzáadásával!',
    goToVideoUploadTool: 'Ugrás a Videó Feltöltő Eszközhöz',
    ballInPlay: 'Labda játékban',
    filterSeasons: 'Szezonok Szűrése',
    streaming: 'Streaming',
    clips: 'Klip',
    qualifiers: {
      Pass: 'Passz',
      Save: 'Védés',
      'Saved Shot': 'Védett Lövés',
      Shot: 'Lövés',
      Goal: 'Gól',
      'Missed Shot': 'Kihagyott Lövés',
      'Shot on Post': 'Kapufa Lövés',
      Error: 'Hiba',
      Clearance: 'Tisztítás',
      Aerial: 'Légi',
      Challenge: 'Földi Párbaj Elvesztve',
      Dispossessed: 'Labdavesztés',
      Foul: 'Szabálytalanság',
      Card: 'Kártya',
      'Offside Pass': 'Les Passz',
      Claim: 'Beadás Igénylés',
      'Keeper Pickup': 'Kapus Felvétel',
      'Ball Touch': 'Labda Érintés',
      Dribble: 'Dribling',
      Interception: 'Labdaszerzés',
      Tackle: 'Labdavétel',
      'Ball Recovery': 'Labda Visszaszerzés',
      Takeon: 'Dribling'
    },
    qualifierIds: {
      1: 'Hosszú labda',
      2: 'Beadás',
      5: 'Szabadrúgás elvégezve',
      6: 'Szöglet elvégezve',
      9: 'Büntető',
      15: 'Fej',
      20: 'Jobb lábbal',
      21: 'Más testrész',
      22: 'Rendszeres játék',
      23: 'Gyors támadás',
      24: 'Rögzített szituáció',
      25: 'Szögletből',
      26: 'Szabadrúgás',
      28: 'Öngól',
      29: 'Gólpassz',
      31: 'Sárga kártya',
      32: 'Második sárga kártya',
      33: 'Piros kártya',
      72: 'Bal lábbal',
      73: 'Bal',
      82: 'Védett lövés (kapus nélkül)',
      94: 'Védő blokk',
      123: 'Kapus bedobás',
      124: 'Kapura rúgás',
      160: 'Bedobás rögzített szituáció',
      170: 'Gólhoz vezető',
      173: 'Biztonságosan hárítva',
      174: 'Veszélyesen hárítva',
      177: 'Elkapva',
      178: 'Állva',
      179: 'Ugrás',
      182: 'Kezek',
      183: 'Lábak',
      185: 'Blokkolt beadás',
      210: 'Gólpassz',
      215: 'Egyéni játék',
      279: 'Kezdőrúgás',
      285: 'Védekező',
      286: 'Támadó'
    },
    areas: {
      goalArea: 'Kapu Terület',
      boxLeft: 'Tizenhatos Bal',
      boxCenter: 'Tizenhatos Középső',
      boxRight: 'Tizenhatos Jobb',
      outBoxDeepLeft: 'Tizenhatoson Kívül Mély Bal',
      outBoxDeepRight: 'Tizenhatoson Kívül Mély Jobb',
      outBoxLeft: 'Tizenhatoson Kívül Bal',
      outBoxCentreLeft: 'Tizenhatoson Kívül Középső Bal',
      outBoxCentre: 'Tizenhatoson Kívül Középső',
      outBoxCentreRight: 'Tizenhatoson Kívül Középső Jobb',
      outBoxRight: 'Tizenhatoson Kívül Jobb',
      midfieldLeft35: 'Középpálya Bal',
      midfieldCentreLeft35: 'Középpálya Középső Bal',
      midfieldCentre35: 'Középpálya Középső',
      midfieldCentreRight35: 'Középpálya Középső Jobb',
      midfieldRight35: 'Középpálya Jobb',
      ownGoalArea: 'Saját Kapu Terület',
      ownBoxLeft: 'Saját Tizenhatos Bal',
      ownBoxCenter: 'Saját Tizenhatos Középső',
      ownBoxRight: 'Saját Tizenhatos Jobb',
      ownFieldOutOfBoxDeepLeft: 'Saját Pálya Tizenhatoson Kívül Mély Bal',
      ownFieldOutOfBoxDeepRight: 'Saját Pálya Tizenhatoson Kívül Mély Jobb',
      ownFieldOutOfBoxLeft: 'Saját Pálya Tizenhatoson Kívül Bal',
      ownFieldOutOfBoxCentreLeft: 'Saját Pálya Tizenhatoson Kívül Középső Bal',
      ownFieldOutOfBoxCentre: 'Saját Pálya Tizenhatoson Kívül Középső',
      ownFieldOutOfBoxCentreRight: 'Saját Pálya Tizenhatoson Kívül Középső Jobb',
      ownFieldOutOfBoxRight: 'Saját Pálya Tizenhatoson Kívül Jobb',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: 'Siker',
      fail: 'Sikertelen',
      possessionWon: 'Birtoklás Megszerzve',
      possessionNotWon: 'Birtoklás Nem Szerzett',
      received: 'Fogadva',
      provoked: 'Kiváltva'
    },
    homePlayerHighlights: 'A hazai játékos kiemelései',
    awayPlayerHighlights: 'Vendégjátékos kiemelések'
  },
  share: {
    shareTo: 'Küldés',
    viaApp: 'Alkalmazás (Driblab Üzenet)',
    viaEmail: 'Email',
    description: 'Leírás',
    titleTab: 'Megosztások',
    toMe: 'Fogadott',
    fromMe: 'Küldött',
    typeInternal: 'Belső',
    typeExternal: 'Külső',
    title: 'Megosztva',
    subtitle: 'Áttekintés a megosztási listában lévő elemekről és megosztásairól',
    selectUser: 'Felhasználó kiválasztása',
    expired: 'Lejárt',
    limitReached: 'A link elérte a használati limitet'
  },
  homeStats: {
    data: 'Elérhető Adatok',
    players: 'játékos',
    totalPlayers: 'összes játékos',
    teams: 'csapat',
    totalTeams: 'összes csapat',
    leagues: 'liga',
    totalLeagues: 'összes liga',
    seasons: 'szezon',
    totalSeasons: 'összes szezon',
    games: 'mérkőzés',
    totalGames: 'összes mérkőzés'
  },
  scoutingCalendar: {
    subtitle: 'Hozza létre és szervezze felderítési feladatait',
    myCalendars: 'Privát naptár',
    publicCalendars: 'Nyilvános naptárak',
    otherCalendars: 'Egyéb naptárak',
    calendarSettings: 'Naptár beállítások',
    moreInfo: 'További információ',
    individualScouting: 'Egyéni Felderítés',
    matchScouting: 'Mérkőzés Felderítés',
    calendarView: {
      type: 'Naptár típusa',
      month: 'Hónap',
      week: 'Hét',
      day: 'Nap'
    },
    weekView: {
      type: 'Hét Típusa',
      monSun: 'Hétfő - Vasárnap',
      sunSat: 'Vasárnap - Szombat',
      monFri: 'Hétfő - Péntek'
    },
    tasks: {
      addNew: 'Új feladat hozzáadása',
      myTasks: 'Feladataim',
      filterTasks: 'Feladatok szűrése',
      sharedWithMe: 'Velem megosztva',
      createTask: 'Feladat létrehozása',
      newTask: 'Új feladat',
      taskName: 'Feladat neve',
      allDay: 'Egész nap',
      startDate: 'Kezdés dátuma',
      endDate: 'Befejezés dátuma',
      startHour: 'Kezdés órája',
      endHour: 'Befejezés órája',
      assignedTo: 'Hozzárendelve',
      assignedToMe: 'Hozzárendelve hozzám',
      color: 'Szín',
      scoutingType: 'Felderítés típusa',
      taskLocation: 'Feladat helyszíne',
      selectLeague: 'Liga kiválasztása',
      selectMatch: 'Mérkőzés kiválasztása',
      useMatchdate: 'Használja a mérkőzés dátumát dátumként',
      stadium: 'Stadion',
      travel: 'Utazás',
      hotel: 'Szálloda',
      tickets: 'Jegyek',
      taskNotes: 'Írjon leíró jegyzeteket vagy megjegyzéseket a feladathoz kapcsolódóan',
      states: {
        toDo: 'Tennivaló',
        inProgress: 'Folyamatban',
        done: 'Kész'
      },
      type: {
        player: 'Játékos Értékelés',
        team: 'Csapat Értékelés',
        other: 'Egyéb'
      },
      location: {
        stadium: 'Stadionban',
        video: 'Videó'
      },
      accommodation: {
        accommodationDetails: 'Szállás Részletek',
        ownArrangement: 'Saját Előkészítés',
        required: 'Szükséges',
        notRequired: 'Nem szükséges',
        booked: 'Lefoglalva'
      },
      assignToMe: 'Hozzárendelés hozzám',
      addOther: 'Más hozzáadása',
      deleteTask: 'Feladat törlése',
      deleteTaskMessage: 'A feladat eltávolításra kerül, biztos benne?',
      cancelUpdate: 'Frissítés megszakítása',
      cancelUpdateMessage: 'A változások nem lesznek mentve, biztos benne?',
      selectGame: 'Kérjük, válasszon egy mérkőzést fájlok hozzáadásához',
      noData: 'Nincs adat. Kezdje néhány feladat hozzáadásával!',
      widgetSubtitle: 'Tekintse meg következő feladatait',
      scoutingDetails: 'Felderítés részletek',
      taskDetails: 'Feladat részletek',
      playerDocuments: 'Játékos dokumentumok',
      teamDocuments: 'Csapat dokumentumok',
      gameDocuments: 'Mérkőzés dokumentumok',
      taskDocuments: 'Feladat dokumentumok',
      task: 'Feladat'
    },
    nextGames: 'Következő mérkőzések'
  },
  scoutingTasksBoard: {
    period: {
      week: 'Ez a hét',
      month: 'Ez a hónap',
      year: 'Ez az év'
    },
    noTasks: 'Hozzon létre új feladatokat vagy húzzon ide egyet!',
    goToBoard: 'Ugrás a táblához'
  },
  profile: {
    title: 'Profil',
    subtitle: 'Testreszabja fiókját és előfizetési részleteit'
  },
  hub: {
    onlyHub: 'Csak a Driblab Hub-ban elérhető',
    blue: 'kék',
    purple: 'lila',
    orange: 'narancs',
    grey: 'szürke',
    indigo: 'indigó',
    teal: 'böjti réce',
    lightBlue: 'világoskék',
    brown: 'barna'
  },
  uploadedGames: {
    subtitle: 'Összes feltöltött mérkőzés',
    timeRequested: 'Kérés ideje',
    timeReceived: 'Fogadás ideje',
    diffHours: 'Órákban kifejezett különbség',
    collectionCompleted: 'Gyűjtemény befejezve',
    dateFrom: 'Dátumtól',
    dateTo: 'Dátumig',
    goToUploadedGames: 'Ugrás a Feltöltött Mérkőzésekhez',
    sla: 'Szerver Szintű Megállapodás',
    matchDate: 'Mérkőzés Dátuma',
    rejectedGame: 'Elutasítva',
    reviewed: 'Áttekintve',
    requested: 'Kérve',
    koraStatus: 'Kora Státusz',
    aws: 'AWS',
    fullVideo: 'Teljes Videó',
    offset: 'Eltolás',
    updateFullVideo: 'Teljes Videó Frissítése?'
  },
  gameMap: {
    title: 'Mérkőzések Térképe',
    subtitle: 'Fedezze fel a következő napok mérkőzéseit',
    warning: 'Az idő és hely nem biztos, hogy helyes. Kérjük, erősítse meg ezt az információt.',
    taskAdded: 'Feladat sikeresen létrehozva. Ellenőrizze a Felderítési Naptárat.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Sikeresen értesítve',
    notPermissions: 'Nincs jogosultsága megtekinteni',
    notPermissionsLeague: 'Nincs jogosultsága ezt a ligát megtekinteni',
    notPermissionsGame: 'Nincs jogosultsága ezt a mérkőzést megtekinteni',
    requestAccessTo: 'Hozzáférés kérése',
    sendRequest: 'Kérés Küldése'
  },
  videoTeams: {
    subtitle: 'Keresse meg a legfrissebb mérkőzéseket csapat szerint címkézve',
    noGamesUploaded: 'Még nincsenek feltöltött mérkőzések'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Felderítési Elemzés',
    scoutingAnalyses: 'Felderítési Elemzések',
    playerScoutingAnalyses: 'Játékos Felderítési Elemzések',
    gameScoutingAnalyses: 'Mérkőzés Felderítési Elemzések',
    analyses: 'Elemzések',
    addReport: 'Elemzés hozzáadása',
    technical: 'Technikai',
    tactical: 'Taktikai',
    physical: 'Fizikai',
    mental: 'Mentális',
    technicalNotes: 'Technikai jegyzetek',
    tacticalNotes: 'Taktikai jegyzetek',
    physicalNotes: 'Fizikai jegyzetek',
    mentalNotes: 'Mentális jegyzetek',
    conclusion: 'Következtetés',
    charactersMax: 'Maximum 1000 karakter',
    globalRating: 'Globális értékelés',
    noData: 'Nincs adat. Kezdje néhány felderítési elemzés hozzáadásával!',
    deleteAnalysis: 'Felderítési Elemzés Törlése',
    deleteAnalysisMessage: 'Az elemzés véglegesen eltávolításra kerül. Biztos benne?',
    avgTooltip: 'Átlag az Ön számára látható elemzések végső értékelései alapján',
    avgOverallScoreTooltip: 'Átlag a játékos Ön számára látható összességében pontszámai alapján',
    scouter: 'Felderítő',
    lastEdited: 'Utoljára szerkesztve',
    analysisFilters: 'Elemzés Szűrők',
    generalFilters: 'Általános Szűrők',
    widgetSubtitle: 'Legutóbb hozzáadott elemzések',
    addPlayerReport: 'Játékos Felderítési Elemzés Hozzáadása',
    seeReports: 'Jelentések megtekintése',
    addGameReport: 'Mérkőzés Felderítési Elemzés Hozzáadása',
    keyPlayers: 'Kulcs játékosok',
    formation: 'Felállás',
    inPossession: 'Birtoklásban',
    notesIP: 'Birtoklásban jegyzetek',
    outOfPossession: 'Birtoklás nélkül',
    notesOP: 'Birtoklás nélkül jegyzetek',
    transitions: 'Átmenetek',
    notesTransitions: 'Átmenetek jegyzetek',
    notesSP: 'Rögzített Szituáció jegyzetek',
    finalRating: 'Végső értékelés',
    gameNotesPlaceholder: 'Írjon leíró jegyzeteket vagy megjegyzéseket a mérkőzéshez kapcsolódóan',
    avgPotentialTooltip: 'Átlag az Ön számára látható elemzési lehetőségek alapján',
    potential: 'Potenciális',
    tags: 'Címkék',
    tagsPlaceholder: 'Adjon hozzá néhány címkét',
    tagsHint: 'Címke hozzáadásához írja be, és nyomja meg az Enter billentyűt',
    exampleTags: {
      leadership: 'Vezetés',
      resilience: 'Rugalmasság',
      competitiveMindset: 'Versenyképes gondolkodásmód',
      calmUnderPressure: 'Nyugalom nyomás alatt',
      focus: 'Fókusz',
      discipline: 'Fegyelem',
      coachability: 'Edzőképesség',
      poorBodyLanguage: 'Gyenge testbeszéd',
      lowConfidence: 'Alacsony önbizalom',
      easilyFrustrated: 'Könnyen frusztrált'
    },
    totals: 'Totals',
    byPossession: 'By Possession'
  },
  addPlayerForm: {
    noLeague: 'Egy csapat liga nélküli létrehozása negatív hatással lehet az indexelésére és a későbbi keresésre az alkalmazáson belül.'
  },
  expenses: {
    expense: 'Költség',
    expenses: 'Költségek',
    addExpense: 'Költség hozzáadása',
    transportation: 'Közlekedés',
    accommodation: 'Szállás',
    dietary: 'Étkezés',
    eventTicket: 'Esemény jegy',
    expenseType: 'Költség típusa',
    amount: 'Összeg',
    expenseDate: 'Költség dátuma',
    expenseFilters: 'Költség szűrők',
    noData: 'Nincs adat. Kezdje néhány költség hozzáadásával!',
    deleteExpense: 'Költség Törlése',
    deleteExpenseMessage: 'A költség véglegesen eltávolításra kerül. Biztos benne?'
  },
  disabledTooltips: {
    general: 'Ez a funkció jelenleg letiltva',
    youth: 'Ifjúsági kell legyen az életkor beállításához',
    unit: 'A statisztikának Runs, HSR vagy SPR-nek kell lennie',
    seasonsWithout60MinsGames: 'A játékos nem játszott több mint 60 percet egyetlen mérkőzésen a kiválasztott szezon(ok)ban',
    notEditable: 'Ez nem szerkeszthető',
    noMatchdate: 'Mérkőzés dátum nem elérhető',
    selectGame: 'Először válasszon egy mérkőzést',
    selectPlayer: 'Először válasszon egy játékost',
    selectTeam: 'Először válasszon egy csapatot',
    selectBoxes: 'A dobozok vizualizációt ki kell választani',
    selectYear: 'Először válasszon egy évet',
    pdScoreNotAvailable: 'Pontszám nem elérhető azoknak a játékosoknak, akik nem értek el 60 percet egy mérkőzésen belül',
    pdSeasonNotAvailable: 'Fizikai adatok nem elérhetők erre a szezonra',
    pdGameNotAvailable: 'Fizikai adatok nem elérhetők erre a mérkőzésre'
  },
  leagueTypes: {
    regular: 'Rendszeres',
    continental: 'Kontinentális',
    nationalTeam: 'Nemzeti Válogatott',
    countryCup: 'Országos Kupa',
    qualifier: 'Selejtező',
    playOff: 'Rájátszás',
    regionalLeague: 'Regionális Liga',
    friendly: 'Barátságos',
    nationalFriendly: 'Nemzeti Barátságos',
    nationaQualifier: 'Nemzeti Selejtező'
  },
  playerSides: {
    'Left/Right': 'Bal/Jobb',
    'Left/Centre/Right': 'Bal/Középső/Jobb',
    Right: 'Jobb',
    Centre: 'Középső',
    'Centre/Right': 'Középső/Jobb',
    Left: 'Bal',
    'Left/Centre': 'Bal/Középső'
  },
  areaSelector: {
    selectAreas: 'Területek kiválasztása',
    filterAreas: 'Területek szűrése'
  },
  spatialCoverage: {
    lastDefenderDist: 'Utolsó védő távolsága',
    defensiveLineDist: 'Védő vonal távolsága',
    fullBackAvgDist: 'Szélső védő átlagos távolsága',
    offensiveLineDist: 'Támadó vonal távolsága',
    distanceToGoal: 'Távolság a gólig',
    avgLineWidth: 'Átl. vonal szélesség',
    leagueAvgDistanceToGoal: 'Átl. liga távolság gólig',
    leagueAvgLineWidth: 'Átl. liga vonal szélesség',
    avgShort: 'Átl.',
    meters: 'méter',
    leagueAvgDist: 'Átlagos liga távolság',
    distance: 'Távolság',
    avgPositionYAxis: 'Átl. távolság a pályán (Y)',
    leagueAvgPositionYAxis: 'Átl. liga távolság a pályán (Y)',
    lbRbDistanceSeparation: 'LB–RB távolság',
    leagueAvgLbRbDistanceSeparation: 'Átl. liga LB–RB távolság',
    legendTeam: 'Csapat',
    legendLeagueAvg: 'Átl. liga',
    maxLength: 'Max hossz',
    maxWidth: 'Max szélesség',
    avgBlockDistance: 'Átl. blokk távolság'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Intelligens Adatok',
    passesUnderPressureSubtitle: 'Elemezze a védekező nyomás alatt leadott passzok sikerarányát',
    onBallPressureSubtitle: 'Elemzés a védőnyomási események és sikerességük a pálya zónái szerint',
    ballReceiptsInSpaceSubtitle: 'Elemezze a térben kapott passzokat mezőzónánként',
    ballReceipts: 'nyugták',
    totalBallReceipts: 'Összes Labdafelvételezés',
    totalBallReceiptsCompleted: 'Összes Labdafelvételezés Befejezve',
    completed: 'Befejezve',
    lineBreakingPassesSubtitle: 'Elemezd a vonalakat áttörő és előnyt teremtő passzokat',
    bypassed: 'Kijátszás',
    oppsBypassed: 'Kijátszott Ellenfelek',
    passer: 'Passzoló',
    passedTo: 'Passzol',
    receivedFrom: 'Fogadva',
    distanceToNearestDefender: 'Legközelebbi védő távolsága',
    lineBreaking: 'Vonal Átörlő {0}',
    keyPass: 'Kulcs Passz',
    receiver: 'Fogadó',
    dynamicTracking: 'Dinamikus követés',
    eventLockTooltip: 'Néhány játékos nem volt látható a játék során',
    bypassedPlayers: '{0} kicselezett játékos',
    playersCount: '{0} játékos',
    bothTeams: 'Mindkét csapat',
    matchesCount: '{0} mérkőzés',
    lbpType: {
      F: 'Támadóvonal',
      M: 'Középpályás vonal',
      B: 'Védelmi vonal',
      MF: 'Középpályás és támadóvonal',
      BM: 'Védelmi és középpályás vonal',
      BF: 'Védelmi és támadóvonal',
      BMF: 'Védelmi, középpályás és támadóvonal'
    },
    lbpCategory: {
      'G-IN-T': 'Lapos belül (áttöri a védelmi vonalat)',
      'G-IN-NT': 'Lapos belül (nem töri át a védelmi vonalat)',
      'G-OUT-T': 'Lapos kívül (áttöri a védelmi vonalat)',
      'G-OUT-NT': 'Lapos kívül (nem töri át a védelmi vonalat)',
      'O-IN-T': 'Magas belül (áttöri a védelmi vonalat)',
      'O-IN-NT': 'Magas belül (nem töri át a védelmi vonalat)',
      'O-OUT-T': 'Magas kívül (áttöri a védelmi vonalat)',
      'O-OUT-NT': 'Magas kívül (nem töri át a védelmi vonalat)',
      ground: 'Lapos',
      over: 'Felhívott',
      inside: 'Belső',
      outside: 'Külső',
      through: 'Áttöri a védelmi vonalat',
      notThrough: 'Nem töri át a védelmi vonalat',
      throughAbbr: 'Breaking def. vonal',
      notThroughAbbr: 'Nem törik def. vonal'
    },
    lbpCategorySplit: {
      G: 'Föld: A hágót ledarálták',
      O: 'Vége: A labda a levegőbe került',
      OUT: 'Kívül: A hágó kifelé ment',
      IN: 'Belül: A passz bement',
      T: 'Áttöri a védelmi vonalat: az átadás belülről töri át a védelmi vonalat',
      NT: 'Nem töri át a védelmi vonalat: az átadás nem töri át belülről; kívülről kerüli meg'
    },
    obrType: {
      OL: 'Átfedés',
      UL: 'Alul Átfedés',
      RA: 'Előre Futás',
      RB: 'Hátra Futás',
      CR: 'Beadás Fogadó',
      SP: 'Támogatás',
      CS: 'Rövidre Jövés'
    },
    visualization: 'Visualizáció',
    points: 'Körök',
    zones: 'Hőtérkép',
    pressureIntensity: 'Nyomás Intenzitása',
    pressureOutcome: 'Passzok Eredménye',
    passesOutcome: 'Pass Eredmény',
    strong: 'Erős',
    light: 'Könnyű',
    normal: 'Normál',
    successful: 'Sikeres',
    unsuccessful: 'Nem sikeres',
    presses: 'Nyomások',
    passes: 'Pass',
    passUnder: 'Pass Under',
    successRate: 'Siker arány',
    pressureOn: 'Nyomás',
    pressureOf: 'Nyomása',
    pressure: 'Nyomás',
    totalLabel: 'összes',
    totalPasses: 'Összes Bérlet',
    unknown: 'ismeretlen',
    selectGameToViewMap: 'Játékot válasszon a nyomáskép megtekintéséhez',
    noEventsFoundForGame: 'Nincs nyomási esemény ehhez a játékhoz',
    noEventsFoundForTeamAndSeason: 'Nincs nyomási esemény ehhez a csapat és szezonhoz',
    noEventsFoundForPlayerAndSeason: 'Nincs nyomási esemény ehhez a játékos és szezonhoz',
    noEventsMatchFilters: 'Nincs nyomási esemény, amely megfelel a jelenlegi szűrőknek',
    totalEventsAvailable: 'összes nyomási esemény',
    passType: {
      P: 'Pass',
      A: 'Segít',
      KP: 'Key Pass',
      PiOB: 'Átmenni Opp. Doboz',
      PiFT: 'Tovább az utolsó harmadba',
      SoPP: 'Play Pass váltása'
    },
    minFrom: 'Min. Kezdő',
    minTo: 'Min To',
    secondFrom: 'Seg From',
    secondTo: 'Seg To',
    positionPlayed: 'Lejátszott pozíció',
    highlight: 'Jelölje ki',
    passTypeLabel: 'Pass Type',
    offBallRunSubtitle: 'Elemezze a labdafutásokat',
    insights: 'Insights',
    insightsSubtitle: 'A legjobb rangsor az Advanced Arrigo Analytics segítségével',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: 'Hogyan segíthetek ma?',
    chatSubtext: 'Kérdezz bármit a futballadatokkal kapcsolatban!',
    thinking: 'Gondolkodás...',
    giveFeedback: 'Visszajelzés küldése',
    disclaimer: 'A DriblabAI hibázhat. Kérjük, feltétlenül ellenőrizze az információkat.',
    recent: 'Legutóbbi',
    noConversations: 'Itt láthatja legutóbbi beszélgetéseit!',
    rename: 'Átnevezés',
    deleteConversation: 'Beszélgetés törlése',
    confirmDelete: 'Biztosan törli ezt a beszélgetést?',
    feedback: 'Visszacsatolás',
    feedbackQuestion: 'Hasznos volt ez a válasz?',
    feedbackComments: 'További megjegyzések',
    feedbackPlaceholder: 'Mondja el nekünk, mi volt hasznos, vagy min lehetne javítani...',
    errorMessage: 'Az üzenetet nem sikerült feldolgozni. Kérjük, próbálja újra.',
    newConversation: 'Új csevegés',
    write: 'Írj üzenetet...'
  },
  periodId: {
    1: 'Első félidő',
    2: 'Második Félidő',
    3: 'Hosszabbítás - 1º',
    4: 'Hosszabbítás - 2º',
    5: 'Büntetőpárbaj',
    6: 'Teljes munkaidőben',
    7: 'Meccs előtt',
    8: 'Elhagyatott',
    9: 'Élő',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': 'Más'
  }
};
